import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
export type Maybe<T> = T | null
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K]
}
export type MakeOptional<T, K extends keyof T> = Omit<T, K> &
  { [SubKey in K]?: Maybe<T[SubKey]> }
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> &
  { [SubKey in K]: Maybe<T[SubKey]> }
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string
  String: string
  Boolean: boolean
  Int: number
  Float: number
  AWSDate: any
  AWSDateTime: any
  AWSEmail: any
  AWSIPAddress: any
  AWSJSON: any
  AWSPhone: any
  AWSTime: any
  AWSTimestamp: any
  AWSURL: any
  Long: any
}

export type AddClubListingInput = {
  clubId: Scalars['ID']
  description?: Maybe<Scalars['String']>
  isSubstituteListing?: Maybe<Scalars['Boolean']>
  programs: Array<Scalars['String']>
  times?: Maybe<Array<TimePreferenceInput>>
}

export type AddClubListingResponse = ClubListingResult | ErrorResult

export type AddEmergencyContactResponse =
  | AddEmergencyContactResult
  | ErrorResult

export type AddEmergencyContactResult = {
  __typename?: 'AddEmergencyContactResult'
  result?: Maybe<EmergencyContact>
}

export type AddToShortlistInput = {
  userId: Scalars['String']
}

export type AddToShortlistResponse = AddToShortlistResult | ErrorResult

export type AddToShortlistResult = {
  __typename?: 'AddToShortlistResult'
  shortlist?: Maybe<Array<InstructorShortlist>>
}

export type AddTrainingOutcomeInput = {
  attendanceStatus: AttendedStatusEnum
  developmentSheet?: Maybe<DevelopmentSheetInput>
  outcomeStatus?: Maybe<OutcomeEnum>
  trainingJourneyId: Scalars['String']
}

export type AddTrainingOutcomeResponse = AddTrainingOutcomeResult | ErrorResult

export type AddTrainingOutcomeResult = {
  __typename?: 'AddTrainingOutcomeResult'
  developmentSheet?: Maybe<DevelopmentSheet>
  isSuccess?: Maybe<Scalars['Boolean']>
}

export type Address = {
  __typename?: 'Address'
  city?: Maybe<Scalars['String']>
  country?: Maybe<Scalars['String']>
  countryCode?: Maybe<Scalars['String']>
  location?: Maybe<GeoPoint>
  postalCode?: Maybe<Scalars['String']>
  state?: Maybe<Scalars['String']>
  stateCode?: Maybe<Scalars['String']>
  street?: Maybe<Scalars['String']>
  streetName?: Maybe<Scalars['String']>
  streetNumber?: Maybe<Scalars['String']>
}

export type AddressInput = {
  city?: Maybe<Scalars['String']>
  country?: Maybe<Scalars['String']>
  countryCode?: Maybe<Scalars['String']>
  location?: Maybe<GeoPointInput>
  postalCode?: Maybe<Scalars['String']>
  state?: Maybe<Scalars['String']>
  stateCode?: Maybe<Scalars['String']>
  street?: Maybe<Scalars['String']>
  streetName?: Maybe<Scalars['String']>
  streetNumber?: Maybe<Scalars['String']>
}

export type Affiliation = {
  __typename?: 'Affiliation'
  actionedDate?: Maybe<Scalars['AWSDateTime']>
  clubId: Scalars['ID']
  id: Scalars['ID']
  isDigitalOnly?: Maybe<Scalars['Boolean']>
  latestActionInitiator?: Maybe<UserRoleType>
  pendingStatus?: Maybe<AffiliationStatus>
  requestedBy: UserRoleType
  requestedDate: Scalars['AWSDateTime']
  role: AffiliationRole
  status: AffiliationStatus
  userId: Scalars['ID']
}

export type AffiliationAsyncResponse = AffiliationAsyncResult | ErrorResult

export type AffiliationAsyncResult = {
  __typename?: 'AffiliationAsyncResult'
  affilation?: Maybe<Affiliation>
  hasPendingAffiliations?: Maybe<Scalars['Boolean']>
  status: Scalars['String']
}

export type AffiliationInput = {
  actionedDate?: Maybe<Scalars['AWSDateTime']>
  clubId: Scalars['ID']
  id: Scalars['ID']
  requestedBy: UserRoleType
  requestedDate: Scalars['AWSDateTime']
  role: AffiliationRole
  status: AffiliationStatus
  userId: Scalars['ID']
}

export enum AffiliationRole {
  Gfm = 'GFM',
  Instructor = 'INSTRUCTOR',
}

export enum AffiliationStatus {
  Setup = 'SETUP',
  Pending = 'PENDING',
  Accepted = 'ACCEPTED',
  Declined = 'DECLINED',
  Removed = 'REMOVED',
}

export type AgreementDocument = {
  __typename?: 'AgreementDocument'
  content: Scalars['String']
  id: Scalars['ID']
  market: Scalars['String']
  type: AgreementType
  version: Scalars['String']
}

export type AgreementDocumentResponse = AgreementDocumentResult | ErrorResult

export type AgreementDocumentResult = {
  __typename?: 'AgreementDocumentResult'
  content?: Maybe<Scalars['String']>
  id: Scalars['ID']
  signedOn?: Maybe<Scalars['AWSDateTime']>
  type: AgreementType
  version: Scalars['String']
}

export enum AgreementType {
  DataPrivacy = 'DATA_PRIVACY',
}

export enum AnalyticsEvent {
  NavigationAssessments = 'NAVIGATION_ASSESSMENTS',
  NavigationCertifications = 'NAVIGATION_CERTIFICATIONS',
  NavigationEventsTraining = 'NAVIGATION_EVENTS_TRAINING',
  NavigationFindEventsAndTraining = 'NAVIGATION_FIND_EVENTS_AND_TRAINING',
  NavigationMyEventsAndTraining = 'NAVIGATION_MY_EVENTS_AND_TRAINING',
  NavigationHome = 'NAVIGATION_HOME',
  NavigationInstructorsFindInstructors = 'NAVIGATION_INSTRUCTORS_FIND_INSTRUCTORS',
  NavigationInstructorsYourClubProfile = 'NAVIGATION_INSTRUCTORS_YOUR_CLUB_PROFILE',
  NavigationInstructorsYourPeople = 'NAVIGATION_INSTRUCTORS_YOUR_PEOPLE',
  NavigationMoreContactSupport = 'NAVIGATION_MORE_CONTACT_SUPPORT',
  NavigationMoreEqualOpportunities = 'NAVIGATION_MORE_EQUAL_OPPORTUNITIES',
  NavigationMoreFaq = 'NAVIGATION_MORE_FAQ',
  NavigationMoreGiveFeedback = 'NAVIGATION_MORE_GIVE_FEEDBACK',
  NavigationMorePrivacyPolicy = 'NAVIGATION_MORE_PRIVACY_POLICY',
  NavigationMoreWebsiteTerms = 'NAVIGATION_MORE_WEBSITE_TERMS',
  NavigationProfileLogOut = 'NAVIGATION_PROFILE_LOG_OUT',
  NavigationProfileSwitchAccount = 'NAVIGATION_PROFILE_SWITCH_ACCOUNT',
  NavigationProfileYourAccount = 'NAVIGATION_PROFILE_YOUR_ACCOUNT',
  NavigationProfileViewProfile = 'NAVIGATION_PROFILE_VIEW_PROFILE',
  NavigationPrograms = 'NAVIGATION_PROGRAMS',
  NavigationReleases = 'NAVIGATION_RELEASES',
  NavigationTeachingFindClasses = 'NAVIGATION_TEACHING_FIND_CLASSES',
  NavigationTeachingMyFacilities = 'NAVIGATION_TEACHING_MY_FACILITIES',
  NavigationTeachingMyProfile = 'NAVIGATION_TEACHING_MY_PROFILE',
  NavigationTrainer = 'NAVIGATION_TRAINER',
  NavigationManageMyPartnership = 'NAVIGATION_MANAGE_MY_PARTNERSHIP',
  NavigationBuyReleases = 'NAVIGATION_BUY_RELEASES',
  NavigationMyReleases = 'NAVIGATION_MY_RELEASES',
}

export type AppMetadataResponse = AppMetadataResult | ErrorResult

export type AppMetadataResult = {
  __typename?: 'AppMetadataResult'
  isSuccess: Scalars['Boolean']
}

export type AssessmentVideo = {
  __typename?: 'AssessmentVideo'
  assessmentId: Scalars['ID']
  comment?: Maybe<Scalars['String']>
  extensionRequested: Scalars['Boolean']
  fileKey?: Maybe<Scalars['String']>
  playback?: Maybe<Playback>
  recordType: RecordType
  submitted: Scalars['Boolean']
  submittedDate?: Maybe<Scalars['String']>
  videoNotWorking: Scalars['Boolean']
}

export type AtHomeProductTile = {
  __typename?: 'AtHomeProductTile'
  buttons?: Maybe<Array<Link>>
  description?: Maybe<Scalars['String']>
  image: ImageSet
  onlineProgram: ClubOnlineProgram
  programs?: Maybe<Array<ClubProgram>>
  title: Scalars['String']
}

export enum AtHomeProgramNameEnum {
  Stretch = 'STRETCH',
  Mindfullness = 'MINDFULLNESS',
  Wellness = 'WELLNESS',
  TheTripImmersive = 'THE_TRIP_IMMERSIVE',
  LesMillsGritAthletic = 'LES_MILLS_GRIT_ATHLETIC',
  LesMillsGritStrength = 'LES_MILLS_GRIT_STRENGTH',
  LesMillsGritCardio = 'LES_MILLS_GRIT_CARDIO',
}

export enum AtHomeSpecificProgramCodeEnum {
  W = 'W',
  St = 'ST',
  Mf = 'MF',
  Gc = 'GC',
  Ga = 'GA',
  Gs = 'GS',
  Trv = 'TRV',
  Trl = 'TRL',
}

export type AttendTrainingStep = Step & {
  __typename?: 'AttendTrainingStep'
  activeStepName: Scalars['String']
  activeStepNumber: Scalars['Int']
  attended?: Maybe<AttendedStatusEnum>
  cancellationPolicy: Scalars['AWSJSON']
  contactUsEmail: Scalars['String']
  deliveryMethod: DeliveryMethodEnum
  details?: Maybe<Scalars['String']>
  dueDate?: Maybe<Scalars['String']>
  endDate: Scalars['String']
  eventName: Scalars['String']
  fulfillment?: Maybe<Scalars['String']>
  level?: Maybe<Scalars['String']>
  onlineTrainingLink?: Maybe<Scalars['String']>
  passPendingGuide: Scalars['AWSJSON']
  programName: Scalars['String']
  requirements?: Maybe<Scalars['String']>
  schedule?: Maybe<Scalars['String']>
  startDate: Scalars['String']
  stepName: Scalars['String']
  stepNumber: Scalars['Int']
  timezone: Scalars['String']
  trackAllocation?: Maybe<Scalars['String']>
  trainerEmail?: Maybe<Scalars['String']>
  trainerName?: Maybe<Scalars['String']>
  venueAddress?: Maybe<Scalars['String']>
}

export enum AttendedStatusEnum {
  Attended = 'ATTENDED',
  DidNotAttend = 'DID_NOT_ATTEND',
  Incomplete = 'INCOMPLETE',
}

export enum BilledCertificateActionEnum {
  Add = 'ADD',
  Remove = 'REMOVE',
}

export type BilledCertificationInput = {
  actionType: BilledCertificateActionEnum
  id: Scalars['ID']
}

export type BookEventInput = {
  eventId: Scalars['String']
  instructorIds: Array<Scalars['String']>
  ticketId: Scalars['String']
}

export type BookEventResponse = BookEventResult | ErrorResult

export type BookEventResult = {
  __typename?: 'BookEventResult'
  magentoLink: Scalars['String']
}

export type BookedEvent = {
  __typename?: 'BookedEvent'
  event: Event
  numberOfBookedInstructors: Scalars['Int']
}

export type BookedEventResponse = BookedEventResult | ErrorResult

export type BookedEventResult = {
  __typename?: 'BookedEventResult'
  bookedInstructors?: Maybe<Array<InstructorDetails>>
  eventDetails: EventDetailsResult
}

export type BookedEventsResponse = BookedEventsResult | ErrorResult

export type BookedEventsResult = {
  __typename?: 'BookedEventsResult'
  bookedEvents?: Maybe<Array<BookedEvent>>
}

export type BusinessSupportSection = {
  __typename?: 'BusinessSupportSection'
  id: Scalars['ID']
  sectionTiles?: Maybe<Array<BusinessSupportTile>>
  sectionTitle: Scalars['String']
}

export type BusinessSupportTile = {
  __typename?: 'BusinessSupportTile'
  id: Scalars['ID']
  image: Image
  subtitle: Scalars['String']
  title: Scalars['String']
  url: Url
}

export type CmsPaginationInput = {
  limit?: Maybe<Scalars['Int']>
  nextToken?: Maybe<Scalars['String']>
}

export type Certification = {
  __typename?: 'Certification'
  active: Scalars['Boolean']
  billedClubId?: Maybe<Scalars['String']>
  id: Scalars['ID']
  lastPurchase?: Maybe<Scalars['String']>
  link: Link
  lmqLevel: Scalars['Float']
  pricePerQuarter?: Maybe<CertificationPrice>
  program: Program
  releaseStatus?: Maybe<ReleaseStatusEnum>
  snapshotState?: Maybe<SnapshotStateEnum>
  status: CertificationStatusEnum
  steps?: Maybe<Array<CertificationStep>>
  transactionStatus?: Maybe<TransactionStatusEnum>
  transactionTimestamp?: Maybe<Scalars['Long']>
}

export type CertificationPrice = {
  __typename?: 'CertificationPrice'
  amount: Scalars['Float']
  currency: Currency
}

export enum CertificationStatusEnum {
  NotCertified = 'NOT_CERTIFIED',
  Certified = 'CERTIFIED',
  Advanced = 'ADVANCED',
  Elite = 'ELITE',
  Aim_1Complete = 'AIM_1_COMPLETE',
}

export type CertificationStep = {
  __typename?: 'CertificationStep'
  action?: Maybe<Link>
  id: Scalars['ID']
  label: Scalars['String']
  status: CertificationStepStatusEnum
}

export type CertificationStepInput = {
  action?: Maybe<LinkCertificationInput>
  id?: Maybe<Scalars['ID']>
  label?: Maybe<Scalars['String']>
  status?: Maybe<CertificationStepStatusEnum>
}

export enum CertificationStepStatusEnum {
  Todo = 'TODO',
  Done = 'DONE',
  InProgress = 'IN_PROGRESS',
}

export type CertifiedStep = {
  __typename?: 'CertifiedStep'
  activeStepName: Scalars['String']
  activeStepNumber: Scalars['Int']
  attended?: Maybe<AttendedStatusEnum>
  cancellationPolicy: Scalars['AWSJSON']
  contactUsEmail: Scalars['String']
  deliveryMethod: DeliveryMethodEnum
  details?: Maybe<Scalars['String']>
  dueDate?: Maybe<Scalars['String']>
  endDate: Scalars['String']
  eventName: Scalars['String']
  fulfillment?: Maybe<Scalars['String']>
  level?: Maybe<Scalars['String']>
  onlineTrainingLink?: Maybe<Scalars['String']>
  passPendingGuide: Scalars['AWSJSON']
  programName: Scalars['String']
  requirements?: Maybe<Scalars['String']>
  schedule?: Maybe<Scalars['String']>
  startDate: Scalars['String']
  stepName: Scalars['String']
  stepNumber: Scalars['Int']
  timezone: Scalars['String']
  trackAllocation?: Maybe<Scalars['String']>
  trainerEmail?: Maybe<Scalars['String']>
  trainerName?: Maybe<Scalars['String']>
  venueAddress?: Maybe<Scalars['String']>
}

export type ChainAffiliation = {
  __typename?: 'ChainAffiliation'
  actionedDate?: Maybe<Scalars['AWSDateTime']>
  clubId: Scalars['ID']
  clubName: Scalars['String']
  id: Scalars['ID']
  latestActionInitiator?: Maybe<UserRoleType>
  pendingStatus?: Maybe<AffiliationStatus>
  requestedBy: UserRoleType
  requestedDate: Scalars['AWSDateTime']
  role: AffiliationRole
  status: AffiliationStatus
  userId: Scalars['ID']
}

export type ChainAffiliationsRemoveResponse =
  | ChainAffiliationsRemoveRresult
  | ErrorResult

export type ChainAffiliationsRemoveRresult = {
  __typename?: 'ChainAffiliationsRemoveRresult'
  receivedAffiliationIds?: Maybe<Array<Scalars['ID']>>
  removedAffiliationIds?: Maybe<Array<Scalars['ID']>>
  removedUserId: Scalars['ID']
}

export type ChainAffiliationsResponse = ChainAffiliationsResult | ErrorResult

export type ChainAffiliationsResult = {
  __typename?: 'ChainAffiliationsResult'
  successfulAffiliations?: Maybe<Array<ChainAffiliation>>
}

export type ChainUserResponse = GetChainUser | ErrorResult

export type Club = {
  __typename?: 'Club'
  accountId: Scalars['ID']
  affiliations?: Maybe<Array<Affiliation>>
  createdAt: Scalars['AWSDateTime']
  currency?: Maybe<Currency>
  email?: Maybe<EmailClubType>
  id: Scalars['ID']
  market: Market
  name: Scalars['String']
  parent?: Maybe<Scalars['String']>
  phone?: Maybe<Scalars['String']>
  profile: UserProfileClub
}

export type ClubAffiliates = {
  __typename?: 'ClubAffiliates'
  actionedDate?: Maybe<Scalars['AWSDateTime']>
  clubId: Scalars['String']
  distance?: Maybe<Scalars['Float']>
  distanceUnit?: Maybe<LocationDistanceUnit>
  id: Scalars['ID']
  isDigitalOnly?: Maybe<Scalars['Boolean']>
  pendingStatus?: Maybe<AffiliationStatus>
  profile: UserProfileClub
  requestedBy: UserRoleType
  requestedDate: Scalars['AWSDateTime']
  status: AffiliationStatus
}

export type ClubAffiliationsResult = {
  __typename?: 'ClubAffiliationsResult'
  affiliations?: Maybe<Array<Affiliation>>
}

export type ClubAvailabilityOnListing = {
  __typename?: 'ClubAvailabilityOnListing'
  clubAddress?: Maybe<Address>
  clubId: Scalars['ID']
  clubName: Scalars['String']
  clubProfileImage?: Maybe<Image>
  isAlreadyListed?: Maybe<Scalars['Boolean']>
  isClubLicensed?: Maybe<Scalars['Boolean']>
}

export type ClubListing = ClubSingleListing | ClubMultiListing

export type ClubListingCommon = {
  clubInfo: UserProfileClub
  createdAt: Scalars['AWSDateTime']
  description?: Maybe<Scalars['String']>
  enquiries: Array<ClubListingEnquiry>
  enquiriesCount: Scalars['Int']
  expiringAt: Scalars['AWSDateTime']
  id: Scalars['ID']
  searchAppearances?: Maybe<Scalars['Int']>
  status: ClubListingStatus
  updatedAt?: Maybe<Scalars['AWSDateTime']>
  views: Scalars['Int']
}

export type ClubListingEnquiry = {
  __typename?: 'ClubListingEnquiry'
  club: UserProfileClub
  createdAt: Scalars['AWSDateTime']
  instructor: UserProfileTeaching
  listing: ClubListing
  message?: Maybe<Scalars['String']>
  program: Program
}

export type ClubListingResult = {
  __typename?: 'ClubListingResult'
  results?: Maybe<Array<ClubListing>>
}

export enum ClubListingStatus {
  Active = 'ACTIVE',
  Disabled = 'DISABLED',
  Expired = 'EXPIRED',
}

export type ClubListingUnknown = {
  __typename?: 'ClubListingUnknown'
  clubInfo: UserProfileClub
  createdAt?: Maybe<Scalars['AWSDateTime']>
  description?: Maybe<Scalars['String']>
  expiringAt?: Maybe<Scalars['AWSDateTime']>
  id: Scalars['ID']
  program?: Maybe<ClubProgram>
  searchAppearances?: Maybe<Scalars['Int']>
  status?: Maybe<ClubListingStatus>
  times?: Maybe<Array<TimePreference>>
  updatedAt?: Maybe<Scalars['AWSDateTime']>
  views?: Maybe<Scalars['Int']>
}

export type ClubMultiListing = ClubListingCommon & {
  __typename?: 'ClubMultiListing'
  clubInfo: UserProfileClub
  createdAt: Scalars['AWSDateTime']
  description?: Maybe<Scalars['String']>
  enquiries: Array<ClubListingEnquiry>
  enquiriesCount: Scalars['Int']
  expiringAt: Scalars['AWSDateTime']
  id: Scalars['ID']
  programs: Array<ClubProgram>
  searchAppearances?: Maybe<Scalars['Int']>
  status: ClubListingStatus
  times: Array<TimePreference>
  updatedAt?: Maybe<Scalars['AWSDateTime']>
  views: Scalars['Int']
}

export type ClubOnlineProgram = {
  __typename?: 'ClubOnlineProgram'
  activeSince?: Maybe<Scalars['AWSDateTime']>
  id: Scalars['ID']
  lastEnquiredOn?: Maybe<Scalars['AWSDateTime']>
}

export type ClubPartnershipBusinessSupportContent = {
  __typename?: 'ClubPartnershipBusinessSupportContent'
  description: Scalars['String']
  link: Link
  title: Scalars['String']
}

export type ClubPartnershipProgramStat = {
  __typename?: 'ClubPartnershipProgramStat'
  icon: Image
  total: Scalars['Int']
  type: ProgramTypeEnum
}

export type ClubPartnershipProgramStats = {
  __typename?: 'ClubPartnershipProgramStats'
  programsStats?: Maybe<Array<ClubPartnershipProgramStat>>
}

export type ClubPartnershipStandardContent = {
  __typename?: 'ClubPartnershipStandardContent'
  image: ImageSet
  link: Link
  subtitle: Scalars['String']
  title: Scalars['String']
}

export type ClubProfile = {
  __typename?: 'ClubProfile'
  bio?: Maybe<Scalars['String']>
  hiring?: Maybe<Scalars['Boolean']>
  id: Scalars['ID']
  links?: Maybe<Array<ProfileLink>>
  media?: Maybe<Array<Image>>
  profileImage?: Maybe<Image>
  programs?: Maybe<Array<ClubProgram>>
  shortlist?: Maybe<Array<InstructorShortlist>>
  strength?: Maybe<Scalars['Int']>
}

export type ClubProfileInput = {
  address: AddressInput
  bio?: Maybe<Scalars['String']>
  createdAt: Scalars['AWSDateTime']
  createdAtLabel?: Maybe<Scalars['String']>
  hiring: Scalars['Boolean']
  links?: Maybe<Array<ProfileLinkInput>>
  media?: Maybe<Array<ImageInput>>
  strength?: Maybe<Scalars['Int']>
}

export type ClubProgram = ProgramInterface & {
  __typename?: 'ClubProgram'
  code: Scalars['String']
  displayName?: Maybe<Scalars['String']>
  id: Scalars['ID']
  initials: Scalars['String']
  instructorCount?: Maybe<ProgramInstructorCount>
  name: Scalars['String']
  programType?: Maybe<ProgramTypeEnum>
  status?: Maybe<ProgramStatus>
}

export type ClubProgramContent = ClubProgram | ClubProgramInStudioEmptyState

export type ClubProgramInStudioEmptyState = {
  __typename?: 'ClubProgramInStudioEmptyState'
  content?: Maybe<InStudioEmptyState>
  programType?: Maybe<ProgramTypeEnum>
}

export type ClubSingleListing = ClubListingCommon & {
  __typename?: 'ClubSingleListing'
  clubInfo: UserProfileClub
  createdAt: Scalars['AWSDateTime']
  description?: Maybe<Scalars['String']>
  enquiries: Array<ClubListingEnquiry>
  enquiriesCount: Scalars['Int']
  expiringAt: Scalars['AWSDateTime']
  id: Scalars['ID']
  isSubstituteListing: Scalars['Boolean']
  program: ClubProgram
  searchAppearances?: Maybe<Scalars['Int']>
  status: ClubListingStatus
  times: Array<TimePreference>
  updatedAt?: Maybe<Scalars['AWSDateTime']>
  views: Scalars['Int']
}

export type ClubWithAffiliation = {
  __typename?: 'ClubWithAffiliation'
  clubId: Scalars['ID']
  clubName: Scalars['String']
  isDigitalOnly?: Maybe<Scalars['Boolean']>
  latestAffiliation?: Maybe<Affiliation>
}

export type ContactUsStep = {
  __typename?: 'ContactUsStep'
  activeStepName: Scalars['String']
  activeStepNumber: Scalars['Int']
  contactUsEmail: Scalars['String']
  stepName: Scalars['String']
  stepNumber: Scalars['Int']
}

export type ContentField = {
  __typename?: 'ContentField'
  contentText: Scalars['AWSJSON']
  subHeading: Scalars['String']
  title: Scalars['String']
}

export type Country = {
  __typename?: 'Country'
  currency: Currency
  locale: Locale
  name: Scalars['String']
}

export enum CountryEnum {
  UnitedKingdom = 'UNITED_KINGDOM',
  Ireland = 'IRELAND',
  Bahamas = 'BAHAMAS',
  Bermuda = 'BERMUDA',
  CarribeanIslands = 'CARRIBEAN_ISLANDS',
  PuertoRico = 'PUERTO_RICO',
  StLucia = 'ST_LUCIA',
  UnitedStates = 'UNITED_STATES',
  UsVirginIslands = 'US_VIRGIN_ISLANDS',
  Bulgaria = 'BULGARIA',
  CzechRepublic = 'CZECH_REPUBLIC',
  Denmark = 'DENMARK',
  Estonia = 'ESTONIA',
  Finland = 'FINLAND',
  Latvia = 'LATVIA',
  Lithuania = 'LITHUANIA',
  Moldova = 'MOLDOVA',
  Norway = 'NORWAY',
  Poland = 'POLAND',
  Romania = 'ROMANIA',
  Slovakia = 'SLOVAKIA',
  Sweden = 'SWEDEN',
  Austria = 'AUSTRIA',
  Germany = 'GERMANY',
  Switzerland = 'SWITZERLAND',
  Armenia = 'ARMENIA',
  Bahrain = 'BAHRAIN',
  Iraq = 'IRAQ',
  Iran = 'IRAN',
  Jordan = 'JORDAN',
  Kuwait = 'KUWAIT',
  Oman = 'OMAN',
  Pakistan = 'PAKISTAN',
  Qatar = 'QATAR',
  SaudiArabia = 'SAUDI_ARABIA',
  SouthAfrica = 'SOUTH_AFRICA',
  Syria = 'SYRIA',
  UnitedArabEmirates = 'UNITED_ARAB_EMIRATES',
  Zambia = 'ZAMBIA',
  Azerbaijan = 'AZERBAIJAN',
  Belarus = 'BELARUS',
  Georgia = 'GEORGIA',
  Kazakhstan = 'KAZAKHSTAN',
  Russia = 'RUSSIA',
  Uzbekistan = 'UZBEKISTAN',
  China = 'CHINA',
  Japan = 'JAPAN',
  Brazil = 'BRAZIL',
}

export type CountryInput = {
  currency: Currency
  locale: Locale
  name: Scalars['String']
}

export type CreateAffiliationInput = {
  clubId?: Maybe<Scalars['String']>
  message?: Maybe<Scalars['String']>
  userId?: Maybe<Scalars['String']>
}

export type CreateAffiliationsInput = {
  clubIds: Array<Scalars['ID']>
  userId: Scalars['ID']
}

export type CreateClubListingsInput = {
  clubIds: Array<Scalars['ID']>
  description?: Maybe<Scalars['String']>
  isSubstituteListing?: Maybe<Scalars['Boolean']>
  programName: Scalars['String']
  times: Array<TimePreferenceInput>
}

export type CreateClubListingsResponse = CreateClubListingsResult | ErrorResult

export type CreateClubListingsResult = {
  __typename?: 'CreateClubListingsResult'
  successfulListings?: Maybe<Array<ClubSingleListing>>
}

export type CreateInstructorAccountInput = {
  country?: Maybe<CountryEnum>
  email?: Maybe<Scalars['String']>
  eventId?: Maybe<Scalars['String']>
  firstName?: Maybe<Scalars['String']>
  isOptInCorrespondence?: Maybe<Scalars['Boolean']>
  lastName?: Maybe<Scalars['String']>
  phone?: Maybe<Scalars['String']>
  recaptchaToken?: Maybe<Scalars['String']>
  state?: Maybe<StatesEnum>
}

export type CreateInstructorAccountResponse =
  | CreateInstructorAccountResult
  | ErrorResult

export type CreateInstructorAccountResult = {
  __typename?: 'CreateInstructorAccountResult'
  success?: Maybe<Scalars['Boolean']>
}

export type CreateNotificationInput = {
  body: Scalars['String']
  link?: Maybe<LinkInput>
  recipient?: Maybe<CreateNotificationRecipientInput>
  title: Scalars['String']
  type: NotificationType
}

export type CreateNotificationRecipientInput = {
  id: Scalars['ID']
  type: UserRoleType
}

export enum Currency {
  Aed = 'AED',
  Brl = 'BRL',
  Cny = 'CNY',
  Czk = 'CZK',
  Dkk = 'DKK',
  Eur = 'EUR',
  Gbp = 'GBP',
  Inr = 'INR',
  Jpy = 'JPY',
  Nok = 'NOK',
  Nzd = 'NZD',
  Pln = 'PLN',
  Rub = 'RUB',
  Sek = 'SEK',
  Twd = 'TWD',
  Usd = 'USD',
  Zar = 'ZAR',
  Sar = 'SAR',
}

export type DashboardMyTools = {
  __typename?: 'DashboardMyTools'
  id: Scalars['ID']
  imageSet: ImageSet
  subtitle: Scalars['String']
  title: Scalars['String']
  url: Url
}

export type DashboardPageClubResponse = {
  __typename?: 'DashboardPageClubResponse'
  id: Scalars['ID']
  links?: Maybe<Array<LinkTile>>
  myTools?: Maybe<Array<DashboardMyTools>>
  partnership?: Maybe<Array<PartnershipContent>>
  promotions?: Maybe<Array<Promotion>>
}

export type DashboardPageInstructorResponse = {
  __typename?: 'DashboardPageInstructorResponse'
  certifications?: Maybe<Array<Certification>>
  id: Scalars['ID']
  links?: Maybe<Array<LinkTile>>
  promotions?: Maybe<Array<Promotion>>
  socialMedia: SocialMediaSection
  translation: DashboardPageTranslation
}

export type DashboardPageTranslation = {
  __typename?: 'DashboardPageTranslation'
  title: Scalars['String']
}

export type DateTimeFilter = {
  __typename?: 'DateTimeFilter'
  limit: Scalars['Int']
  type: DateTimeFilterType
  value: Scalars['AWSDateTime']
}

export type DateTimeFilterInput = {
  limit: Scalars['Int']
  type: DateTimeFilterType
  value: Scalars['String']
}

export enum DateTimeFilterType {
  Before = 'BEFORE',
  After = 'AFTER',
}

export type DateTimeFilteredResponse = {
  filter: DateTimeFilter
  totalCount: Scalars['Int']
}

export enum DayOfWeek {
  Monday = 'MONDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY',
  Thursday = 'THURSDAY',
  Friday = 'FRIDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
}

export type DeleteAffiliationInput = {
  id: Scalars['String']
}

export type DeleteAffiliationsInput = {
  affiliationIds: Array<Scalars['ID']>
  userId: Scalars['ID']
}

export type DeleteClubListingInput = {
  clubId: Scalars['ID']
  listingId: Scalars['ID']
}

export type DeleteClubListingResponse = DeleteClubListingResult | ErrorResult

export type DeleteClubListingResult = {
  __typename?: 'DeleteClubListingResult'
  clubId: Scalars['ID']
  listingId: Scalars['ID']
  results: Array<ClubListing>
  status: Scalars['String']
}

export type DeleteClubListingsInput = {
  clubIds?: Maybe<Array<Scalars['ID']>>
  isSubstituteListing?: Maybe<Scalars['Boolean']>
  programName?: Maybe<Scalars['String']>
}

export type DeleteClubListingsResponse = DeleteClubListingsResult | ErrorResult

export type DeleteClubListingsResult = {
  __typename?: 'DeleteClubListingsResult'
  success?: Maybe<Array<ClubSingleListing>>
}

export type DeleteCurrentUserPortfolioImageInput = {
  id: Scalars['ID']
}

export type DeleteCurrentUserPortfolioImageResponse =
  | DeleteCurrentUserPortfolioImageResult
  | ErrorResult

export type DeleteCurrentUserPortfolioImageResult = {
  __typename?: 'DeleteCurrentUserPortfolioImageResult'
  status: Scalars['String']
}

export type DeleteNotificationInput = {
  id: Scalars['ID']
}

export type DeleteNotificationResponse = DeleteNotificationResult | ErrorResult

export type DeleteNotificationResult = {
  __typename?: 'DeleteNotificationResult'
  id: Scalars['ID']
  result: Scalars['Boolean']
}

export enum DeliveryMethodEnum {
  Online = 'ONLINE',
  InPerson = 'IN_PERSON',
  InHouse = 'IN_HOUSE',
  Webinar = 'WEBINAR',
  All = 'ALL',
}

export type DevelopmentSheet = {
  __typename?: 'DevelopmentSheet'
  filename: Scalars['String']
  url: Scalars['String']
}

export type DevelopmentSheetInput = {
  contentType: Scalars['String']
  fileBase64String: Scalars['String']
  filename: Scalars['String']
}

export type DynamoMigrateInput = {
  requireFilter: RequireFilter
  schemaProperty: Scalars['String']
  showRecords: Scalars['Boolean']
  subProperty?: Maybe<Scalars['String']>
  tableName: Scalars['String']
  updateRecords: Scalars['Boolean']
}

export type DynamoMigrateResponse = DynamoMigrateResult | ErrorResult

export type DynamoMigrateResult = {
  __typename?: 'DynamoMigrateResult'
  numOfChangedRecords?: Maybe<Scalars['Int']>
  numOfTotalRecords?: Maybe<Scalars['Int']>
  report: Scalars['String']
  schema: Scalars['String']
  status: Scalars['String']
}

export enum Event_Sort_By {
  Soonest = 'SOONEST',
  Nearest = 'NEAREST',
}

export type EmailClubType = {
  __typename?: 'EmailClubType'
  affiliations?: Maybe<Scalars['AWSEmail']>
  jobListings?: Maybe<Scalars['AWSEmail']>
  main?: Maybe<Scalars['AWSEmail']>
}

export type EmailClubTypeInput = {
  affiliations?: Maybe<Scalars['AWSEmail']>
  jobListings?: Maybe<Scalars['AWSEmail']>
  main?: Maybe<Scalars['AWSEmail']>
}

export enum EmailStatusEnum {
  Available = 'AVAILABLE',
  EmailInUse = 'EMAIL_IN_USE',
  DeactivatedAccount = 'DEACTIVATED_ACCOUNT',
  GfmAccount = 'GFM_ACCOUNT',
}

export enum EmailTemplateEnum {
  InstructorAffiliationRequest = 'INSTRUCTOR_AFFILIATION_REQUEST',
  InstructorAffiliationApproved = 'INSTRUCTOR_AFFILIATION_APPROVED',
  InstructorAffiliationDeclined = 'INSTRUCTOR_AFFILIATION_DECLINED',
  InstructorAffiliationRemoved = 'INSTRUCTOR_AFFILIATION_REMOVED',
  InstructorClubListingAlert = 'INSTRUCTOR_CLUB_LISTING_ALERT',
  InstructorCreditCardExpiry = 'INSTRUCTOR_CREDIT_CARD_EXPIRY',
  InstructorClubMessage = 'INSTRUCTOR_CLUB_MESSAGE',
  InstructorClubPaymentStart = 'INSTRUCTOR_CLUB_PAYMENT_START',
  InstructorClubPaymentStop = 'INSTRUCTOR_CLUB_PAYMENT_STOP',
  InstructorEmailChangeFyi = 'INSTRUCTOR_EMAIL_CHANGE_FYI',
  ClubAffiliationRequest = 'CLUB_AFFILIATION_REQUEST',
  ClubAffiliationApproved = 'CLUB_AFFILIATION_APPROVED',
  ClubAffiliationDeclined = 'CLUB_AFFILIATION_DECLINED',
  ClubAffiliationRemoved = 'CLUB_AFFILIATION_REMOVED',
  ClubListingRenewalSingle = 'CLUB_LISTING_RENEWAL_SINGLE',
  ClubListingRenewalMulti = 'CLUB_LISTING_RENEWAL_MULTI',
  ClubListingEnquirySingle = 'CLUB_LISTING_ENQUIRY_SINGLE',
  ClubListingEnquiryMulti = 'CLUB_LISTING_ENQUIRY_MULTI',
  ReportJobListingSingleCx = 'REPORT_JOB_LISTING_SINGLE_CX',
  ReportJobListingMultiCx = 'REPORT_JOB_LISTING_MULTI_CX',
  UserEmailNotUpdated = 'USER_EMAIL_NOT_UPDATED',
  UnknownAffiliationRemoved = 'UNKNOWN_AFFILIATION_REMOVED',
  ReportListing = 'REPORT_LISTING',
  InstructorCertificateClubBillingAdd = 'INSTRUCTOR_CERTIFICATE_CLUB_BILLING_ADD',
  InstructorCertificateClubBillingRemove = 'INSTRUCTOR_CERTIFICATE_CLUB_BILLING_REMOVE',
  ReportClubProfile = 'REPORT_CLUB_PROFILE',
}

export type EmergencyContact = {
  __typename?: 'EmergencyContact'
  address?: Maybe<Scalars['String']>
  name: Scalars['String']
  phone: Scalars['String']
}

export type EmergencyContactInput = {
  address?: Maybe<Scalars['String']>
  name: Scalars['String']
  phone: Scalars['String']
  trainingId: Scalars['ID']
}

export type EnquireAboutExploreProgramsInput = {
  description?: Maybe<Scalars['String']>
  pickListValue: Scalars['String']
  programId: Scalars['String']
  programName: Scalars['String']
}

export type EnquireAboutExploreProgramsResponse =
  | EnquireAboutExploreProgramsResult
  | ErrorResult

export type EnquireAboutExploreProgramsResult = {
  __typename?: 'EnquireAboutExploreProgramsResult'
  lastEnquiredOn?: Maybe<Scalars['AWSDateTime']>
  programId: Scalars['String']
}

export type EnquireAboutInStudioProgramsInput = {
  description?: Maybe<Scalars['String']>
}

export type EnquireAboutInStudioProgramsResponse =
  | EnquireAboutInStudioProgramsResult
  | ErrorResult

export type EnquireAboutInStudioProgramsResult = {
  __typename?: 'EnquireAboutInStudioProgramsResult'
  isSuccess: Scalars['Boolean']
}

export type EnquireAboutOnlineProgramInput = {
  description?: Maybe<Scalars['String']>
  onlineProgramid: Scalars['String']
  pickListValue?: Maybe<Scalars['String']>
}

export type EnquireAboutOnlineProgramResponse =
  | EnquireAboutOnlineProgramResult
  | ErrorResult

export type EnquireAboutOnlineProgramResult = {
  __typename?: 'EnquireAboutOnlineProgramResult'
  lastEnquiredOn?: Maybe<Scalars['AWSDateTime']>
  onlineProgramid: Scalars['String']
}

export type EnquireAboutProgramInput = {
  description?: Maybe<Scalars['String']>
  pickListValue?: Maybe<Scalars['String']>
  programId: Scalars['String']
}

export type EnquireAboutProgramResponse =
  | EnquireAboutProgramResult
  | ErrorResult

export type EnquireAboutProgramResult = {
  __typename?: 'EnquireAboutProgramResult'
  lastEnquiredOn?: Maybe<Scalars['AWSDateTime']>
  programId: Scalars['String']
}

export enum EnquiryCategoryEnum {
  Manage = 'MANAGE',
  Enquire = 'ENQUIRE',
}

export type EnquiryClubListingSingleResult = SearchClubListingsResultCommon & {
  __typename?: 'EnquiryClubListingSingleResult'
  distance?: Maybe<Scalars['Float']>
  distanceUnit?: Maybe<LocationDistanceUnit>
  enquiredOn?: Maybe<Scalars['AWSDateTime']>
  hasBeenReported?: Maybe<Scalars['Boolean']>
  listing: EnquiryHistoryClubListing
  messageSentOn?: Maybe<Scalars['AWSDateTime']>
  onWatchlist?: Maybe<Scalars['Boolean']>
}

export type EnquiryHistoryClubListing =
  | ClubMultiListing
  | ClubSingleListing
  | ClubListingUnknown

export type EnquiryInput = {
  id: Scalars['String']
  syncId: Scalars['String']
}

export type EnsureUserProfileExistsInput = {
  id?: Maybe<Scalars['ID']>
  type: UserProfileType
}

export type EnsureUserProfileExistsResponse = UserResult | ErrorResult

export enum Error {
  NotificationNotFound = 'NOTIFICATION_NOT_FOUND',
  AuthHeaderMissing = 'AUTH_HEADER_MISSING',
  AuthInvalidHeader = 'AUTH_INVALID_HEADER',
  AuthMissingData = 'AUTH_MISSING_DATA',
  AuthExpiredToken = 'AUTH_EXPIRED_TOKEN',
  AuthInternalError = 'AUTH_INTERNAL_ERROR',
  AuthInvalidRole = 'AUTH_INVALID_ROLE',
  AuthUnverifiedEmail = 'AUTH_UNVERIFIED_EMAIL',
  UnauthorizedEmail = 'UNAUTHORIZED_EMAIL',
  AreaSearchGeoPointsValidation = 'AREA_SEARCH_GEO_POINTS_VALIDATION',
  S3SignedurlTokenNotFound = 'S3SIGNEDURL_TOKEN_NOT_FOUND',
  FileNotFound = 'FILE_NOT_FOUND',
  EventbridgeClientError = 'EVENTBRIDGE_CLIENT_ERROR',
  InvalidRequest = 'INVALID_REQUEST',
  ServerError = 'SERVER_ERROR',
  EmailAlreadyExists = 'EMAIL_ALREADY_EXISTS',
  InputParameterMissing = 'INPUT_PARAMETER_MISSING',
  UserNotFound = 'USER_NOT_FOUND',
  UserProfileNotFound = 'USER_PROFILE_NOT_FOUND',
  UserSettingsNotFound = 'USER_SETTINGS_NOT_FOUND',
  ConfigError = 'CONFIG_ERROR',
  EnquiryNotFound = 'ENQUIRY_NOT_FOUND',
  AssessmentNotFound = 'ASSESSMENT_NOT_FOUND',
  PreWorkContentNotFound = 'PRE_WORK_CONTENT_NOT_FOUND',
  VideoExisting = 'VIDEO_EXISTING',
  EventAssessmentNotFound = 'EVENT_ASSESSMENT_NOT_FOUND',
  AssessmentOutcomesNotFound = 'ASSESSMENT_OUTCOMES_NOT_FOUND',
  IntegrationApiError = 'INTEGRATION_API_ERROR',
  EventNotFound = 'EVENT_NOT_FOUND',
  TicketNotFound = 'TICKET_NOT_FOUND',
  TrainingNotFound = 'TRAINING_NOT_FOUND',
  SessionNotFound = 'SESSION_NOT_FOUND',
  PriceNotFound = 'PRICE_NOT_FOUND',
  ProgramNotFound = 'PROGRAM_NOT_FOUND',
  PrismicError = 'PRISMIC_ERROR',
  DashboardEdgesUndefined = 'DASHBOARD_EDGES_UNDEFINED',
  DashboardFieldsUndefined = 'DASHBOARD_FIELDS_UNDEFINED',
  ContentNotFound = 'CONTENT_NOT_FOUND',
  ClubListingNotFound = 'CLUB_LISTING_NOT_FOUND',
  ClubNotFound = 'CLUB_NOT_FOUND',
  AffiliationNotFound = 'AFFILIATION_NOT_FOUND',
  CertificationNotFound = 'CERTIFICATION_NOT_FOUND',
  NoAffiliations = 'NO_AFFILIATIONS',
  InvalidProgramListing = 'INVALID_PROGRAM_LISTING',
  BillingUpdateInProgress = 'BILLING_UPDATE_IN_PROGRESS',
  AffiliationValidation = 'AFFILIATION_VALIDATION',
  AffiliationExists = 'AFFILIATION_EXISTS',
  DuplicateAffiliationAction = 'DUPLICATE_AFFILIATION_ACTION',
  AffiliationActionNotAllowed = 'AFFILIATION_ACTION_NOT_ALLOWED',
}

export type ErrorResult = {
  __typename?: 'ErrorResult'
  component?: Maybe<Scalars['String']>
  logGroup?: Maybe<Scalars['String']>
  logStream?: Maybe<Scalars['String']>
  message?: Maybe<Scalars['String']>
  requestId?: Maybe<Scalars['String']>
  type: Error
}

export type Event = {
  __typename?: 'Event'
  deliveryMethod: DeliveryMethodEnum
  endDate: Scalars['String']
  eventId: Scalars['String']
  eventName: Scalars['String']
  programCode: ProgramCodeEnum
  programName: Scalars['String']
  spacesAvailable: Scalars['Int']
  startDate: Scalars['String']
  timezone: Scalars['String']
  venueAddress?: Maybe<Scalars['String']>
}

export type EventAssessments = {
  __typename?: 'EventAssessments'
  attended?: Maybe<AttendedStatusEnum>
  developmentSheet?: Maybe<DevelopmentSheet>
  emergencyContact?: Maybe<EmergencyContact>
  instructorInfo: InstructorInformation
  outcome?: Maybe<OutcomeEnum>
  outcomeTrack?: Maybe<OutcomeTrack>
  presentationTrack?: Maybe<PresentationTrack>
  sessionRegistrationId: Scalars['String']
  trackAllocation?: Maybe<Scalars['String']>
  trainingJourneyId: Scalars['String']
}

export type EventDetailsResponse = EventDetailsResult | ErrorResult

export type EventDetailsResult = {
  __typename?: 'EventDetailsResult'
  cancellationPolicy?: Maybe<Scalars['AWSJSON']>
  details?: Maybe<Scalars['String']>
  event: Event
  requirements?: Maybe<Scalars['String']>
  schedule?: Maybe<Scalars['String']>
  tickets: Array<Ticket>
  trainerDetails?: Maybe<TrainerDetails>
}

export type EventEdge = {
  __typename?: 'EventEdge'
  cursor: Scalars['String']
  node: Event
}

export type EventLocationFilter = {
  near?: Maybe<EventLocationNearInput>
  within?: Maybe<LocationWithinInput>
}

export type EventLocationNearInput = {
  coordinate: GeoPointInput
  distance: Scalars['Int']
  distanceUnit: LocationDistanceUnit
}

export enum EventStatusEnum {
  Draft = 'DRAFT',
  Published = 'PUBLISHED',
  InProgress = 'IN_PROGRESS',
  RegistrationClosed = 'REGISTRATION_CLOSED',
  AwaitingOutcomes = 'AWAITING_OUTCOMES',
  OutcomesCompleted = 'OUTCOMES_COMPLETED',
  Cancelled = 'CANCELLED',
}

export type EventSummary = {
  __typename?: 'EventSummary'
  deliveryMethod: DeliveryMethodEnum
  endDate: Scalars['AWSDate']
  eventId: Scalars['String']
  eventName: Scalars['String']
  eventStatus: EventStatusEnum
  programName: Scalars['String']
  startDate: Scalars['AWSDate']
  trainingJourneyCount: Scalars['Int']
  venueAddress?: Maybe<Scalars['String']>
}

export type EventsResult = {
  __typename?: 'EventsResult'
  edges: Array<Maybe<EventEdge>>
  pageInfo: PageInfo
}

export type ExploreProgramsPage = {
  __typename?: 'ExploreProgramsPage'
  products?: Maybe<Array<Maybe<InStudioExploreProgramsTile>>>
}

export type FeatureFlag = {
  __typename?: 'FeatureFlag'
  enabled: Scalars['Boolean']
  featureFlag: Scalars['String']
}

export type FeatureFlagQueryInput = {
  featureFlags: Array<Scalars['String']>
}

export type FeatureFlagResponse = FeatureFlagResult | ErrorResult

export type FeatureFlagResult = {
  __typename?: 'FeatureFlagResult'
  flags?: Maybe<Array<FeatureFlag>>
}

export type FilterBy = {
  deliveryMethod: DeliveryMethodEnum
  location: EventLocationFilter
  programCode: Array<ProgramCodeEnum>
  spacesAvailable?: Maybe<Scalars['Int']>
}

export type FilterEventsInput = {
  filterBy: FilterBy
  sort: Event_Sort_By
}

export type FinalizeUploadInput = {
  assessmentId: Scalars['String']
  comment?: Maybe<Scalars['String']>
  filename: Scalars['String']
  parts: Array<Part>
  trainingJourneyId: Scalars['String']
  uploadId: Scalars['String']
}

export type FinalizeUploadResponse = FinalizeUploadResult | ErrorResult

export type FinalizeUploadResult = {
  __typename?: 'FinalizeUploadResult'
  comment?: Maybe<Scalars['String']>
  isSuccess: Scalars['Boolean']
  playback: Playback
}

export type GeoPoint = {
  __typename?: 'GeoPoint'
  lat: Scalars['Float']
  lon: Scalars['Float']
}

export type GeoPointInput = {
  lat: Scalars['Float']
  lon: Scalars['Float']
}

export type GeoPolygon = {
  __typename?: 'GeoPolygon'
  points: Array<GeoPoint>
}

export type GeoPolygonInput = {
  points: Array<GeoPointInput>
}

export type GetAccountSettingsResponse = UserAccountSettingsResult | ErrorResult

export type GetAllTranslationsResponse = GetAllTranslationsResult | ErrorResult

export type GetAllTranslationsResult = {
  __typename?: 'GetAllTranslationsResult'
  locale?: Maybe<Locale>
  result?: Maybe<Scalars['AWSJSON']>
}

export type GetAtHomeProductTilesResult = {
  __typename?: 'GetAtHomeProductTilesResult'
  active?: Maybe<Array<AtHomeProductTile>>
  inactive?: Maybe<Array<AtHomeProductTile>>
}

export type GetChainAffiliationsInput = {
  userId: Scalars['ID']
}

export type GetChainAffiliationsResponse =
  | GetChainAffiliationsResult
  | ErrorResult

export type GetChainAffiliationsResult = {
  __typename?: 'GetChainAffiliationsResult'
  clubs?: Maybe<Array<ClubWithAffiliation>>
}

export type GetChainInstructorAffiliatesInput = {
  clubIds?: Maybe<Array<Scalars['ID']>>
}

export type GetChainInstructorAffiliatesResponse =
  | GetChainInstructorAffiliatesResult
  | ErrorResult

export type GetChainInstructorAffiliatesResult = {
  __typename?: 'GetChainInstructorAffiliatesResult'
  affiliates?: Maybe<Array<InstructorChainAffiliate>>
  hasPendingAffiliations?: Maybe<Scalars['Boolean']>
  requests?: Maybe<Array<Maybe<InstructorChainRequest>>>
}

export type GetChainUser = {
  __typename?: 'GetChainUser'
  chainLocations?: Maybe<Array<UserProfileClub>>
  isChainUser?: Maybe<Scalars['Boolean']>
}

export type GetChainUserClubListingsInput = {
  clubIds: Array<Scalars['ID']>
}

export type GetChainUserClubListingsResponse =
  | GetChainUserClubListingsResult
  | ErrorResult

export type GetChainUserClubListingsResult = {
  __typename?: 'GetChainUserClubListingsResult'
  multiListings?: Maybe<Array<ClubMultiListing>>
  singleListings?: Maybe<Array<ClubSingleListing>>
}

export type GetClubAffiliationsInput = {
  accountId: Scalars['ID']
}

export type GetClubAffiliationsResponse = ClubAffiliationsResult | ErrorResult

export type GetClubByIdInput = {
  id: Scalars['ID']
}

export type GetClubByIdResponse = UserProfileClub | ErrorResult

export type GetClubInstructorAffiliatesInput = {
  id: Scalars['ID']
}

export type GetClubInstructorAffiliatesResponse =
  | GetClubInstructorAffiliatesResult
  | ErrorResult

export type GetClubInstructorAffiliatesResult = {
  __typename?: 'GetClubInstructorAffiliatesResult'
  affiliates?: Maybe<Array<InstructorAffiliate>>
  requests?: Maybe<Array<InstructorRequest>>
}

export type GetClubListingByIdResponse =
  | SearchClubJobListingsSingleResult
  | ErrorResult

export type GetClubListingsByClubIdInput = {
  filters?: Maybe<GetClubListingsByClubIdInputFilters>
  id: Scalars['ID']
}

export type GetClubListingsByClubIdInputFilters = {
  programs?: Maybe<Array<Scalars['ID']>>
  status?: Maybe<ClubListingStatus>
}

export type GetClubListingsByClubIdResponse =
  | GetClubListingsByClubIdResult
  | ErrorResult

export type GetClubListingsByClubIdResult = {
  __typename?: 'GetClubListingsByClubIdResult'
  results: Array<ClubListing>
}

export type GetClubNotificationsFilter = {
  __typename?: 'GetClubNotificationsFilter'
  clubId: Scalars['ID']
  dateTimeFilter: DateTimeFilter
}

export type GetClubNotificationsInput = {
  clubId: Scalars['ID']
  dateTimeFilter: DateTimeFilterInput
}

export type GetClubNotificationsResponse =
  | GetClubNotificationsResult
  | ErrorResult

export type GetClubNotificationsResult = {
  __typename?: 'GetClubNotificationsResult'
  filter: GetClubNotificationsFilter
  items?: Maybe<Array<Notification>>
  totalCount: Scalars['Int']
  translation?: Maybe<GetNotificationTranslation>
}

export type GetClubSettingsInput = {
  id: Scalars['ID']
}

export type GetClubSettingsResponse = GetClubSettingsResult | ErrorResult

export type GetClubSettingsResult = {
  __typename?: 'GetClubSettingsResult'
  address?: Maybe<Address>
  email?: Maybe<EmailClubType>
  id: Scalars['ID']
  name: Scalars['String']
  phone?: Maybe<Scalars['String']>
}

export type GetClubsAvailabilityOnListingInput = {
  isSubstituteListing: Scalars['Boolean']
  programName: Scalars['String']
}

export type GetClubsAvailabilityOnListingResponse =
  | GetClubsAvailabilityOnListingResult
  | ErrorResult

export type GetClubsAvailabilityOnListingResult = {
  __typename?: 'GetClubsAvailabilityOnListingResult'
  allClubs?: Maybe<Array<ClubAvailabilityOnListing>>
  clubsWithExistingListing?: Maybe<Array<ClubAvailabilityOnListing>>
}

export type GetContactUsContentInput = {
  market: Scalars['String']
  userType: UserProfileType
}

export type GetContactUsContentResponse =
  | GetContactUsContentResult
  | ErrorResult

export type GetContactUsContentResult = {
  __typename?: 'GetContactUsContentResult'
  result: Array<SectionContentResult>
}

export type GetCurrentUserPhotoUploadDataResponse =
  | GetCurrentUserPhotoUploadDataResult
  | ErrorResult

export type GetCurrentUserPhotoUploadDataResult = {
  __typename?: 'GetCurrentUserPhotoUploadDataResult'
  token: Scalars['String']
  url: Scalars['String']
}

export type GetCurrentUserPortfolioUploadDataInput = {
  photoCount: Scalars['Int']
}

export type GetCurrentUserPortfolioUploadDataResponse =
  | GetCurrentUserPortfolioUploadDataResult
  | ErrorResult

export type GetCurrentUserPortfolioUploadDataResult = {
  __typename?: 'GetCurrentUserPortfolioUploadDataResult'
  items: Array<PortfolioUploadItem>
}

export type GetDashboardResponse =
  | DashboardPageInstructorResponse
  | DashboardPageClubResponse
  | ErrorResult

export type GetEqualOpportunitiesPolicyInput = {
  market: Scalars['String']
}

export type GetEqualOpportunitiesPolicyResponse =
  | GetEqualOpportunitiesPolicyResult
  | ErrorResult

export type GetEqualOpportunitiesPolicyResult = {
  __typename?: 'GetEqualOpportunitiesPolicyResult'
  result: Array<SectionContentResult>
}

export type GetExploreProgramsPageResult = ExploreProgramsPage | ErrorResult

export type GetFrequentlyAskedQuestionsInput = {
  market: Scalars['String']
  userType: UserProfileType
}

export type GetFrequentlyAskedQuestionsResponse =
  | GetFrequentlyAskedQuestionsResult
  | ErrorResult

export type GetFrequentlyAskedQuestionsResult = {
  __typename?: 'GetFrequentlyAskedQuestionsResult'
  result: Array<SectionContentResult>
}

export type GetHeaderInput = {
  keys?: Maybe<Array<Scalars['String']>>
}

export type GetHeaderResponse = GetHeaderResult | ErrorResult

export type GetHeaderResult = {
  __typename?: 'GetHeaderResult'
  results: Array<Header>
}

export type GetInStudioToolkitResult = {
  __typename?: 'GetInStudioToolkitResult'
  tiles?: Maybe<Array<Maybe<InStudioToolkitTile>>>
}

export type GetInstructorClubAffiliatesInput = {
  id: Scalars['ID']
}

export type GetInstructorClubAffiliatesResponse =
  | GetInstructorClubAffiliatesResult
  | ErrorResult

export type GetInstructorClubAffiliatesResult = {
  __typename?: 'GetInstructorClubAffiliatesResult'
  affiliations?: Maybe<Array<ClubAffiliates>>
}

export type GetNavigationInput = {
  market: Scalars['String']
  role: UserProfileType
  subroles?: Maybe<Array<InstructorRole>>
}

export type GetNavigationResponse = Navigation | ErrorResult

export type GetNotificationResponse = Notification | ErrorResult

export type GetNotificationTranslation = {
  __typename?: 'GetNotificationTranslation'
  footer: Scalars['String']
  title: Scalars['String']
  totalNew: Scalars['String']
}

export type GetNotificationsResponse = GetNotificationsResult | ErrorResult

export type GetNotificationsResult = DateTimeFilteredResponse & {
  __typename?: 'GetNotificationsResult'
  filter: DateTimeFilter
  items?: Maybe<Array<Notification>>
  totalCount: Scalars['Int']
  translation?: Maybe<GetNotificationTranslation>
}

export type GetPickListInput = {
  keys?: Maybe<Array<Scalars['String']>>
}

export type GetPickListResponse = GetPickListResult | ErrorResult

export type GetPickListResult = {
  __typename?: 'GetPickListResult'
  results: Array<PickList>
}

export type GetPresignedUrlInput = {
  assessmentId: Scalars['String']
  filename: Scalars['String']
  totalPartNumber: Scalars['Int']
  trainingJourneyId: Scalars['String']
  uploadId: Scalars['String']
}

export type GetPresignedUrlResponse = GetPresignedUrlResult | ErrorResult

export type GetPresignedUrlResult = {
  __typename?: 'GetPresignedUrlResult'
  partSignedUrlList: Array<PartSignedUrl>
}

export type GetPrivacySettingValueResult = {
  __typename?: 'GetPrivacySettingValueResult'
  description: Scalars['String']
  title: Scalars['String']
  value: PrivacySettingValue
}

export type GetPrivacySettingValuesResponse =
  | GetPrivacySettingValuesResult
  | ErrorResult

export type GetPrivacySettingValuesResult = {
  __typename?: 'GetPrivacySettingValuesResult'
  values: Array<GetPrivacySettingValueResult>
}

export type GetProfileByIdInput = {
  id: Scalars['ID']
  type: UserProfileType
}

export type GetProfileByIdResponse = GetProfileByIdResult | ErrorResult

export type GetProfileByIdResult = {
  __typename?: 'GetProfileByIdResult'
  hasBeenReported?: Maybe<Scalars['Boolean']>
  hasExistingAffiliation?: Maybe<Scalars['Boolean']>
  hasRecentlyDeclinedAffiliation?: Maybe<Scalars['Boolean']>
  instructorAffiliation?: Maybe<Affiliation>
  lastMessageIn48HoursSentAt?: Maybe<Scalars['AWSDateTime']>
  onWatchlist?: Maybe<Scalars['Boolean']>
  profile?: Maybe<UserProfile>
  profileUser?: Maybe<User>
  withinDistance?: Maybe<Scalars['Boolean']>
}

export type GetSavedInstructorSearchDataInput = {
  id?: Maybe<Scalars['ID']>
}

export type GetSavedInstructorSearchDataResponse =
  | GetSavedInstructorSearchDataResult
  | ErrorResult

export type GetSavedInstructorSearchDataResult = {
  __typename?: 'GetSavedInstructorSearchDataResult'
  results: Array<SavedInstructorSearch>
}

export type GetSharedNavigation = SharedNavigation | ErrorResult

export type GetSignedAgreementInput = {
  type: AgreementType
  version?: Maybe<Scalars['String']>
}

export type GetUserByAccountIdInput = {
  accountId: Scalars['ID']
}

export type GetUserByEmailInput = {
  email: Scalars['AWSEmail']
}

export type GetUserByIdInput = {
  id: Scalars['ID']
}

export type GetUserEnquiriesResponse = GetUserEnquiriesResult | ErrorResult

export type GetUserEnquiriesResult = {
  __typename?: 'GetUserEnquiriesResult'
  enquiries?: Maybe<Array<UserEnquiry>>
}

export type GetUserResponse = UserResult | ErrorResult

export type GetUserSessionResponse = GetUserSessionResult | ErrorResult

export type GetUserSessionResult = {
  __typename?: 'GetUserSessionResult'
  country?: Maybe<CountryEnum>
  eventId: Scalars['String']
  market?: Maybe<Scalars['String']>
  state?: Maybe<StatesEnum>
}

export type GetVideoGuidelinesResponse = GetVideoGuidelinesResult | ErrorResult

export type GetVideoGuidelinesResult = {
  __typename?: 'GetVideoGuidelinesResult'
  contactUsEmail: Scalars['String']
  result: Array<SectionContentResult>
}

export type GetWalkthroughResponse = Walkthrough | ErrorResult

export type Header = {
  __typename?: 'Header'
  image?: Maybe<ImageSet>
  key: Scalars['String']
  subHeading?: Maybe<Scalars['String']>
  title?: Maybe<Scalars['String']>
}

export type Image = {
  __typename?: 'Image'
  alt?: Maybe<Scalars['String']>
  bucket?: Maybe<Scalars['String']>
  height?: Maybe<Scalars['Int']>
  id: Scalars['ID']
  key?: Maybe<Scalars['String']>
  url: Scalars['String']
  width?: Maybe<Scalars['Int']>
}

export type ImageInput = {
  alt?: Maybe<Scalars['String']>
  height?: Maybe<Scalars['Int']>
  id?: Maybe<Scalars['ID']>
  url?: Maybe<Scalars['String']>
  width?: Maybe<Scalars['Int']>
}

export type ImageSet = {
  __typename?: 'ImageSet'
  desktop: Image
  id: Scalars['ID']
  mobile: Image
}

export type InStudioDetailsView = {
  __typename?: 'InStudioDetailsView'
  description: Scalars['String']
  moreURL?: Maybe<Url>
  typeInfo?: Maybe<Array<Maybe<ProgramTypeInfo>>>
  videoContentId?: Maybe<Scalars['String']>
}

export type InStudioEmptyState = {
  __typename?: 'InStudioEmptyState'
  link: Link
  subtitle: Scalars['String']
  title: Scalars['String']
}

export type InStudioExploreProgramsTile = {
  __typename?: 'InStudioExploreProgramsTile'
  detailView?: Maybe<InStudioDetailsView>
  enquirySent?: Maybe<Scalars['AWSDateTime']>
  genre?: Maybe<Scalars['String']>
  image?: Maybe<Image>
  name?: Maybe<Scalars['String']>
  numberOfCertifiedInstructors?: Maybe<Scalars['Int']>
  productCategories?: Maybe<Array<Maybe<ProgramTypeEnum>>>
  productId: Scalars['String']
}

export type InStudioExploreProgramsTileCardResult = {
  __typename?: 'InStudioExploreProgramsTileCardResult'
  image?: Maybe<Image>
}

export type InStudioToolkitTile = {
  __typename?: 'InStudioToolkitTile'
  image: Image
  link: Link
  subTitle: Scalars['String']
  title: Scalars['String']
}

export type IncrementViewClubListingCountInput = {
  clubId: Scalars['ID']
  listingId: Scalars['ID']
}

export type IncrementViewClubListingCountResponse =
  | ClubListingResult
  | ErrorResult

export type InitializeUploadInput = {
  assessmentId: Scalars['String']
  contentType: Scalars['String']
  filename: Scalars['String']
  trainingJourneyId: Scalars['String']
}

export type InitializeUploadResponse = InitializeUploadResult | ErrorResult

export type InitializeUploadResult = {
  __typename?: 'InitializeUploadResult'
  uploadId: Scalars['String']
}

export type InstructorAffiliate = {
  __typename?: 'InstructorAffiliate'
  actionedDate?: Maybe<Scalars['AWSDateTime']>
  clubId: Scalars['String']
  id: Scalars['ID']
  profile: UserProfileTeaching
  purchaseOrder?: Maybe<Scalars['String']>
  requestedBy: UserRoleType
  requestedDate: Scalars['AWSDateTime']
  status: AffiliationStatus
  user: User
}

export type InstructorAvailability = {
  __typename?: 'InstructorAvailability'
  availableToSubstitute: Scalars['Boolean']
  description: Scalars['String']
  title: Scalars['String']
  value: InstructorAvailabilityValue
}

export enum InstructorAvailabilityValue {
  Available = 'AVAILABLE',
  Open = 'OPEN',
  Unavailable = 'UNAVAILABLE',
}

export type InstructorCertificate = {
  __typename?: 'InstructorCertificate'
  certificate?: Maybe<Certification>
  instructorName?: Maybe<Scalars['String']>
  transactionStatus?: Maybe<TransactionStatusEnum>
}

export type InstructorCertificatesInput = {
  certificates?: Maybe<Array<BilledCertificationInput>>
  purchaseOrder?: Maybe<Scalars['String']>
  userId: Scalars['ID']
}

export type InstructorCertificationInput = {
  active: Scalars['Boolean']
  billedClubId?: Maybe<Scalars['String']>
  id: Scalars['ID']
  isBlockedFromAutoship?: Maybe<Scalars['Boolean']>
  lastPurchase?: Maybe<Scalars['String']>
  link: LinkCertificationInput
  lmqLevel: Scalars['Float']
  price?: Maybe<Scalars['String']>
  program: ProgramInput
  purchaseOrder?: Maybe<Scalars['String']>
  releaseActivityStatus?: Maybe<ReleaseActivityStatusEnum>
  snapshotState?: Maybe<SnapshotStateEnum>
  status: CertificationStatusEnum
  steps?: Maybe<Array<CertificationStepInput>>
  subscribed?: Maybe<Scalars['Boolean']>
}

export type InstructorChainAffiliate = {
  __typename?: 'InstructorChainAffiliate'
  clubAffiliates?: Maybe<Array<ClubAffiliates>>
  profile: UserProfileTeaching
  purchaseOrder?: Maybe<Scalars['String']>
  user: User
}

export type InstructorChainRequest = {
  __typename?: 'InstructorChainRequest'
  clubId: Scalars['String']
  clubName: Scalars['String']
  distance?: Maybe<Scalars['Float']>
  distanceUnit?: Maybe<LocationDistanceUnit>
  id: Scalars['ID']
  pendingStatus?: Maybe<AffiliationStatus>
  profile: UserProfileTeaching
  requestedBy: UserRoleType
  requestedDate: Scalars['AWSDateTime']
  status: AffiliationStatus
  user: User
}

export type InstructorDetails = {
  __typename?: 'InstructorDetails'
  name: Scalars['String']
  profileImage?: Maybe<Image>
}

export type InstructorInformation = {
  __typename?: 'InstructorInformation'
  address?: Maybe<Scalars['String']>
  email: Scalars['String']
  name: Scalars['String']
  phone: Scalars['String']
}

export type InstructorPreferences = {
  __typename?: 'InstructorPreferences'
  programs?: Maybe<Array<Program>>
  times?: Maybe<Array<TimePreference>>
  travel?: Maybe<TravelPreference>
}

export type InstructorPreferencesInput = {
  programs?: Maybe<Array<Scalars['ID']>>
  times?: Maybe<Array<TimePreferenceInput>>
  travel?: Maybe<TravelPreferenceInput>
}

export type InstructorRequest = {
  __typename?: 'InstructorRequest'
  clubId: Scalars['String']
  distance?: Maybe<Scalars['Float']>
  distanceUnit?: Maybe<LocationDistanceUnit>
  id: Scalars['ID']
  pendingStatus?: Maybe<AffiliationStatus>
  profile: UserProfileTeaching
  requestedBy: UserRoleType
  requestedDate: Scalars['AWSDateTime']
  status: AffiliationStatus
  user: User
}

export enum InstructorRole {
  Instructor = 'INSTRUCTOR',
  Assessor = 'ASSESSOR',
  Presenter = 'PRESENTER',
  Trainer = 'TRAINER',
}

export type InstructorShortlist = {
  __typename?: 'InstructorShortlist'
  distance?: Maybe<Scalars['Float']>
  distanceUnit?: Maybe<LocationDistanceUnit>
  hasExistingAffiliation?: Maybe<Scalars['Boolean']>
  hasRecentlyDeclinedAffiliation?: Maybe<Scalars['Boolean']>
  id: Scalars['ID']
  instructorAffiliation?: Maybe<Affiliation>
  lastMessageIn48HoursSentAt?: Maybe<Scalars['AWSDateTime']>
  profile: UserProfileTeaching
  user: User
}

export type InstructorWatchlist = {
  __typename?: 'InstructorWatchlist'
  watchlist?: Maybe<Array<InstructorWatchlistItem>>
}

export type InstructorWatchlistItem = {
  __typename?: 'InstructorWatchlistItem'
  clubId: Scalars['String']
  listingId?: Maybe<Scalars['String']>
}

export type InstructorWatchlistItemInput = {
  clubId: Scalars['String']
  listingId?: Maybe<Scalars['String']>
}

export enum LicenseTypeEnum {
  Licensed = 'LICENSED',
  Unlicensed = 'UNLICENSED',
}

export type Link = {
  __typename?: 'Link'
  id: Scalars['ID']
  isPrimary?: Maybe<Scalars['Boolean']>
  text: Scalars['String']
  url: Url
}

export type LinkCertificationInput = {
  id: Scalars['ID']
  text: Scalars['String']
  url: UrlInput
}

export type LinkInput = {
  text: Scalars['String']
  url: UrlInput
}

export type LinkTile = {
  __typename?: 'LinkTile'
  id: Scalars['ID']
  imageSet: ImageSet
  subtitle: Scalars['String']
  title: Scalars['String']
  url: Url
}

export enum LinkTypeIcon {
  Chevron = 'CHEVRON',
  ExternalLink = 'EXTERNAL_LINK',
}

export enum Locale {
  EnGb = 'en_GB',
  EnUs = 'en_US',
  EnUk = 'en_UK',
  EnPh = 'en_PH',
  RuRu = 'ru_RU',
  DeDe = 'de_DE',
  JaJp = 'ja_JP',
  ZhCn = 'zh_CN',
  PtBr = 'pt_BR',
}

export enum LocationDistanceUnit {
  Km = 'KM',
  Miles = 'MILES',
}

export type LocationFilter = {
  __typename?: 'LocationFilter'
  near?: Maybe<LocationNear>
  point?: Maybe<GeoPoint>
  within?: Maybe<LocationWithin>
}

export type LocationFilterInput = {
  near?: Maybe<LocationNearInput>
  point?: Maybe<GeoPointInput>
  within?: Maybe<LocationWithinInput>
}

export type LocationNear = {
  __typename?: 'LocationNear'
  address?: Maybe<Address>
  distance: Scalars['Int']
  distanceUnit: LocationDistanceUnit
}

export type LocationNearInput = {
  address?: Maybe<AddressInput>
  distance: Scalars['Int']
  distanceUnit: LocationDistanceUnit
}

export type LocationWithin = {
  __typename?: 'LocationWithin'
  address?: Maybe<Address>
  area: GeoPolygon
}

export type LocationWithinInput = {
  address?: Maybe<AddressInput>
  area: GeoPolygonInput
}

export enum LogoIcon {
  DigitalHubWhite = 'DIGITAL_HUB_WHITE',
  DigitalHubBlack = 'DIGITAL_HUB_BLACK',
}

export type MagentoStoreProfileInput = {
  customerId?: Maybe<Scalars['String']>
  storeName?: Maybe<Scalars['String']>
}

export type Market = {
  __typename?: 'Market'
  countries?: Maybe<Array<Country>>
  distanceUnit: LocationDistanceUnit
  isSupported?: Maybe<Scalars['Boolean']>
  locale: Locale
  name: Scalars['String']
  programs?: Maybe<Array<Program>>
}

export type MarketInput = {
  countries?: Maybe<Array<CountryInput>>
  distanceUnit: LocationDistanceUnit
  locale: Locale
  name: Scalars['String']
  programs?: Maybe<Array<ProgramInput>>
}

export type Menu = {
  __typename?: 'Menu'
  id: Scalars['ID']
  items: Array<RootMenuItem>
  name: Scalars['String']
}

export type MenuItem = {
  __typename?: 'MenuItem'
  analyticsEvent?: Maybe<AnalyticsEvent>
  id: Scalars['ID']
  label: Scalars['String']
  url: Url
}

export enum MenuItemIcon {
  Goals = 'GOALS',
  Home = 'HOME',
  More = 'MORE',
  Plans = 'PLANS',
  Profile = 'PROFILE',
  Releases = 'RELEASES',
  Trainer = 'TRAINER',
  Assessor = 'ASSESSOR',
  ManageMyPartnership = 'MANAGE_MY_PARTNERSHIP',
}

export type Message = {
  __typename?: 'Message'
  clubId: Scalars['ID']
  clubName: Scalars['String']
  id: Scalars['ID']
  listingId?: Maybe<Scalars['ID']>
  message: Scalars['String']
  profileId: Scalars['ID']
  readAt?: Maybe<Scalars['AWSDateTime']>
  requestedBy: UserRoleType
  sentAt: Scalars['AWSDateTime']
}

export enum MessageBusNotificationType {
  ClubNewAffiliationRequest = 'CLUB_NEW_AFFILIATION_REQUEST',
  ClubAffiliationRequestApproved = 'CLUB_AFFILIATION_REQUEST_APPROVED',
  ClubAffiliationRequestDeclined = 'CLUB_AFFILIATION_REQUEST_DECLINED',
  ClubAffiliationRemoved = 'CLUB_AFFILIATION_REMOVED',
  ClubJobListingEnquiry = 'CLUB_JOB_LISTING_ENQUIRY',
  ClubDataWarehouseSync = 'CLUB_DATA_WAREHOUSE_SYNC',
  InstructorNewAffiliationRequest = 'INSTRUCTOR_NEW_AFFILIATION_REQUEST',
  InstructorAffiliationRequestApproved = 'INSTRUCTOR_AFFILIATION_REQUEST_APPROVED',
  InstructorAffiliationRequestDeclined = 'INSTRUCTOR_AFFILIATION_REQUEST_DECLINED',
  InstructorAffiliationRemoved = 'INSTRUCTOR_AFFILIATION_REMOVED',
  InstructorJobListingClubHiring = 'INSTRUCTOR_JOB_LISTING_CLUB_HIRING',
  InstructorClubListingAlert = 'INSTRUCTOR_CLUB_LISTING_ALERT',
  InstructorCreditCardExpiry = 'INSTRUCTOR_CREDIT_CARD_EXPIRY',
  UnknownAffiliationRemoved = 'UNKNOWN_AFFILIATION_REMOVED',
  InstructorDataWarehouseSync = 'INSTRUCTOR_DATA_WAREHOUSE_SYNC',
  SystemGeneratedNotification = 'SYSTEM_GENERATED_NOTIFICATION',
}

export type Mutation = {
  __typename?: 'Mutation'
  _root?: Maybe<Scalars['String']>
  addClubListing?: Maybe<AddClubListingResponse>
  addEmergencyContact: AddEmergencyContactResponse
  addToShortlist?: Maybe<AddToShortlistResponse>
  addTrainingOutcome: AddTrainingOutcomeResponse
  bookEvent: BookEventResponse
  createAffiliation: AffiliationAsyncResponse
  createAffiliations: ChainAffiliationsResponse
  createClubListings?: Maybe<CreateClubListingsResponse>
  createInstructorAccount: CreateInstructorAccountResponse
  createNotification?: Maybe<GetNotificationResponse>
  deleteAffiliation: AffiliationAsyncResponse
  deleteClubListing?: Maybe<DeleteClubListingResponse>
  deleteClubListings?: Maybe<DeleteClubListingsResponse>
  deleteCurrentUserPortfolioImage: DeleteCurrentUserPortfolioImageResponse
  deleteNotification?: Maybe<DeleteNotificationResponse>
  enquireAboutInStudioPrograms?: Maybe<EnquireAboutInStudioProgramsResponse>
  enquireAboutOnlineProgram?: Maybe<EnquireAboutOnlineProgramResponse>
  enquireAboutProgram?: Maybe<EnquireAboutProgramResponse>
  enquireAboutProgramInExplorePrograms?: Maybe<EnquireAboutExploreProgramsResponse>
  finalizeUpload?: Maybe<FinalizeUploadResponse>
  incrementViewClubListingCount?: Maybe<IncrementViewClubListingCountResponse>
  initializeUpload?: Maybe<InitializeUploadResponse>
  payForCertification?: Maybe<PayForCertificationResponse>
  removeAffiliations: ChainAffiliationsRemoveResponse
  removeFromShortlist?: Maybe<RemoveFromShortlistResponse>
  reportClubListing?: Maybe<ReportClubListingResponse>
  reportClubProfile?: Maybe<ReportClubProfileResponse>
  requestForExtension: RequestForExtensionResponse
  resendPasswordResetEmail: ResendPasswordResetEmailResponse
  revertAppMetadata: AppMetadataResponse
  seedRandomAccounts?: Maybe<SeedRandomAccountsResponse>
  sendMessage?: Maybe<SendMessageResponse>
  setAppMetadata: AppMetadataResponse
  setClubSettings?: Maybe<SetClubSettingsResponse>
  setInstructorAvailability?: Maybe<SetInstructorAvailabilityResponse>
  setInstructorTravelPreferences?: Maybe<SetInstructorTravelPreferencesResponse>
  setInstructorWatchlist?: Maybe<SetInstructorWatchlistResponse>
  setPrivacySettings?: Maybe<SetPrivacySettingsResponse>
  setSavedInstructorSearchData?: Maybe<SetSavedInstructorSearchDataResponse>
  setSignedAgreementData?: Maybe<AgreementDocumentResponse>
  setWalkthroughToSeen?: Maybe<SetWalkthroughToSeenResponse>
  testPostUpsertClub?: Maybe<TestPostUpsertClubResponse>
  testPostUpsertUser?: Maybe<TestPostUpsertUserResponse>
  toggleNotificationsRead?: Maybe<ToggleNotificationReadResponse>
  updateAffiliation: AffiliationAsyncResponse
  updateClubListing?: Maybe<UpdateClubListingResponse>
  updateClubProfile: UpdateClubProfileResponse
  updateCurrentUserPortfolioUpload: UpdateCurrentUserPortfolioUploadResponse
  updateTeachingProfile: UpdateProfileResponse
  updateUserAccount: UpdateAccountSettingsResponse
  updateUserPhoto?: Maybe<UpdateUserPhotoResponse>
  upsertAgreement: UpsertAgreementResponse
  upsertClub: UpsertClubResponse
  upsertPricebook: UpsertPricebookResponse
  upsertUser: UpsertUserResponse
}

export type Mutation_RootArgs = {
  _cacheKey?: Maybe<Scalars['String']>
}

export type MutationAddClubListingArgs = {
  input: AddClubListingInput
  _cacheKey?: Maybe<Scalars['String']>
}

export type MutationAddEmergencyContactArgs = {
  input: EmergencyContactInput
  _cacheKey?: Maybe<Scalars['String']>
}

export type MutationAddToShortlistArgs = {
  input: AddToShortlistInput
  role: UserRoleInput
  _cacheKey?: Maybe<Scalars['String']>
}

export type MutationAddTrainingOutcomeArgs = {
  input: AddTrainingOutcomeInput
  _cacheKey?: Maybe<Scalars['String']>
}

export type MutationBookEventArgs = {
  input: BookEventInput
  role: UserRoleInput
  _cacheKey?: Maybe<Scalars['String']>
}

export type MutationCreateAffiliationArgs = {
  input: CreateAffiliationInput
  role: UserRoleInput
  _cacheKey?: Maybe<Scalars['String']>
}

export type MutationCreateAffiliationsArgs = {
  input: CreateAffiliationsInput
  _cacheKey?: Maybe<Scalars['String']>
}

export type MutationCreateClubListingsArgs = {
  input: CreateClubListingsInput
  _cacheKey?: Maybe<Scalars['String']>
}

export type MutationCreateInstructorAccountArgs = {
  input: CreateInstructorAccountInput
  _cacheKey?: Maybe<Scalars['String']>
}

export type MutationCreateNotificationArgs = {
  input: CreateNotificationInput
  _cacheKey?: Maybe<Scalars['String']>
}

export type MutationDeleteAffiliationArgs = {
  input: DeleteAffiliationInput
  role: UserRoleInput
  _cacheKey?: Maybe<Scalars['String']>
}

export type MutationDeleteClubListingArgs = {
  input: DeleteClubListingInput
  _cacheKey?: Maybe<Scalars['String']>
}

export type MutationDeleteClubListingsArgs = {
  input: DeleteClubListingsInput
  _cacheKey?: Maybe<Scalars['String']>
}

export type MutationDeleteCurrentUserPortfolioImageArgs = {
  input: DeleteCurrentUserPortfolioImageInput
  role: UserRoleInput
  _cacheKey?: Maybe<Scalars['String']>
}

export type MutationDeleteNotificationArgs = {
  input: DeleteNotificationInput
  _cacheKey?: Maybe<Scalars['String']>
}

export type MutationEnquireAboutInStudioProgramsArgs = {
  input: EnquireAboutInStudioProgramsInput
  role: UserRoleInput
  _cacheKey?: Maybe<Scalars['String']>
}

export type MutationEnquireAboutOnlineProgramArgs = {
  input: EnquireAboutOnlineProgramInput
  role: UserRoleInput
  _cacheKey?: Maybe<Scalars['String']>
}

export type MutationEnquireAboutProgramArgs = {
  input: EnquireAboutProgramInput
  role: UserRoleInput
  _cacheKey?: Maybe<Scalars['String']>
}

export type MutationEnquireAboutProgramInExploreProgramsArgs = {
  input: EnquireAboutExploreProgramsInput
  role: UserRoleInput
  _cacheKey?: Maybe<Scalars['String']>
}

export type MutationFinalizeUploadArgs = {
  input?: Maybe<FinalizeUploadInput>
  _cacheKey?: Maybe<Scalars['String']>
}

export type MutationIncrementViewClubListingCountArgs = {
  input: IncrementViewClubListingCountInput
  _cacheKey?: Maybe<Scalars['String']>
}

export type MutationInitializeUploadArgs = {
  input?: Maybe<InitializeUploadInput>
  _cacheKey?: Maybe<Scalars['String']>
}

export type MutationPayForCertificationArgs = {
  input: PayForCertificationInput
  _cacheKey?: Maybe<Scalars['String']>
}

export type MutationRemoveAffiliationsArgs = {
  input: DeleteAffiliationsInput
  _cacheKey?: Maybe<Scalars['String']>
}

export type MutationRemoveFromShortlistArgs = {
  input: RemoveFromShortlistInput
  role: UserRoleInput
  _cacheKey?: Maybe<Scalars['String']>
}

export type MutationReportClubListingArgs = {
  input: ReportClubListingInput
  _cacheKey?: Maybe<Scalars['String']>
}

export type MutationReportClubProfileArgs = {
  input: ReportClubProfileInput
  _cacheKey?: Maybe<Scalars['String']>
}

export type MutationRequestForExtensionArgs = {
  input: RequestForExtensionInput
  _cacheKey?: Maybe<Scalars['String']>
}

export type MutationResendPasswordResetEmailArgs = {
  input: ResendPasswordResetEmailInput
  _cacheKey?: Maybe<Scalars['String']>
}

export type MutationRevertAppMetadataArgs = {
  input: RevertAppMetadataInput
  _cacheKey?: Maybe<Scalars['String']>
}

export type MutationSeedRandomAccountsArgs = {
  input: SeedRandomAccountsInput
  _cacheKey?: Maybe<Scalars['String']>
}

export type MutationSendMessageArgs = {
  input: SendMessageInput
  _cacheKey?: Maybe<Scalars['String']>
}

export type MutationSetAppMetadataArgs = {
  input: SetAppMetadataInput
  _cacheKey?: Maybe<Scalars['String']>
}

export type MutationSetClubSettingsArgs = {
  input: SetClubSettingsInput
  _cacheKey?: Maybe<Scalars['String']>
}

export type MutationSetInstructorAvailabilityArgs = {
  input: SetInstructorAvailabilityInput
  _cacheKey?: Maybe<Scalars['String']>
}

export type MutationSetInstructorTravelPreferencesArgs = {
  input: SetInstructorTravelPreferencesInput
  _cacheKey?: Maybe<Scalars['String']>
}

export type MutationSetInstructorWatchlistArgs = {
  input: SetInstructorWatchlistInput
  role: UserRoleInput
  _cacheKey?: Maybe<Scalars['String']>
}

export type MutationSetPrivacySettingsArgs = {
  input: SetPrivacySettingsInput
  _cacheKey?: Maybe<Scalars['String']>
}

export type MutationSetSavedInstructorSearchDataArgs = {
  input: SetSavedInstructorSearchDataInput
  _cacheKey?: Maybe<Scalars['String']>
}

export type MutationSetSignedAgreementDataArgs = {
  input: SetSignedAgreementDataInput
  _cacheKey?: Maybe<Scalars['String']>
}

export type MutationSetWalkthroughToSeenArgs = {
  role: UserRoleInput
  _cacheKey?: Maybe<Scalars['String']>
}

export type MutationTestPostUpsertClubArgs = {
  input: TestPostUpsertClubInput
  _cacheKey?: Maybe<Scalars['String']>
}

export type MutationTestPostUpsertUserArgs = {
  input: TestPostUpsertUserInput
  _cacheKey?: Maybe<Scalars['String']>
}

export type MutationToggleNotificationsReadArgs = {
  input: ToggleNotificationReadInput
  role: UserRoleInput
  _cacheKey?: Maybe<Scalars['String']>
}

export type MutationUpdateAffiliationArgs = {
  input: UpdateAffiliationInput
  role: UserRoleInput
  _cacheKey?: Maybe<Scalars['String']>
}

export type MutationUpdateClubListingArgs = {
  input: UpdateClubListingInput
  _cacheKey?: Maybe<Scalars['String']>
}

export type MutationUpdateClubProfileArgs = {
  input: UpdateClubProfileInput
  _cacheKey?: Maybe<Scalars['String']>
}

export type MutationUpdateCurrentUserPortfolioUploadArgs = {
  input: UpdateCurrentUserPortfolioUploadInput
  role: UserRoleInput
  _cacheKey?: Maybe<Scalars['String']>
}

export type MutationUpdateTeachingProfileArgs = {
  input: UpdateTeachingProfileInput
  _cacheKey?: Maybe<Scalars['String']>
}

export type MutationUpdateUserAccountArgs = {
  input: UpdateUserAccountInput
  _cacheKey?: Maybe<Scalars['String']>
}

export type MutationUpdateUserPhotoArgs = {
  input: UpdateUserPhotoInput
  _cacheKey?: Maybe<Scalars['String']>
}

export type MutationUpsertAgreementArgs = {
  input: UpsertAgreementInput
  _cacheKey?: Maybe<Scalars['String']>
}

export type MutationUpsertClubArgs = {
  input: UpsertClubInput
  metadata?: Maybe<SyncMetadata>
  _cacheKey?: Maybe<Scalars['String']>
}

export type MutationUpsertPricebookArgs = {
  input: UpsertPricebookInput
  _cacheKey?: Maybe<Scalars['String']>
}

export type MutationUpsertUserArgs = {
  input: UpsertUserInput
  metadata?: Maybe<SyncMetadata>
  _cacheKey?: Maybe<Scalars['String']>
}

export type NavItem = {
  __typename?: 'NavItem'
  description: Scalars['String']
  image?: Maybe<Image>
  key?: Maybe<NavKey>
  title?: Maybe<Scalars['String']>
  url: Url
}

export enum NavKey {
  InstructorPortal = 'INSTRUCTOR_PORTAL',
  LesmillsPlus = 'LESMILLS_PLUS',
  LesmillsEquipmentClub = 'LESMILLS_EQUIPMENT_CLUB',
  ClubPortal = 'CLUB_PORTAL',
  LearningStudio = 'LEARNING_STUDIO',
  MarketingStudio = 'MARKETING_STUDIO',
  LesmillsEquipmentInstructor = 'LESMILLS_EQUIPMENT_INSTRUCTOR',
}

export type Navigation = {
  __typename?: 'Navigation'
  appMenu: Menu
  userMenu: RootMenuItem
}

export type Notification = {
  __typename?: 'Notification'
  body: Scalars['String']
  createdAt: Scalars['String']
  createdAtLabel: Scalars['String']
  createdAtTs: Scalars['Long']
  id: Scalars['ID']
  link?: Maybe<Link>
  readAt?: Maybe<Scalars['String']>
  title: Scalars['String']
  type: NotificationType
  updatedAt: Scalars['String']
  updatedAtTs: Scalars['Long']
}

export enum NotificationType {
  Plans = 'PLANS',
  Releases = 'RELEASES',
  Positions = 'POSITIONS',
}

export type OutLink = {
  __typename?: 'OutLink'
  _metadata?: Maybe<OutlinkMetedata>
  title: Scalars['String']
  url: Scalars['String']
}

export enum OutcomeEnum {
  Pass = 'PASS',
  SendNewVideo = 'SEND_NEW_VIDEO',
  ReTrain = 'RE_TRAIN',
  ReSubmitRequired = 'RE_SUBMIT_REQUIRED',
  PassPending = 'PASS_PENDING',
}

export type OutcomeTrack = {
  __typename?: 'OutcomeTrack'
  comment?: Maybe<Scalars['String']>
  playback: Playback
  submittedAt?: Maybe<Scalars['String']>
}

export type OutlinkMetedata = {
  __typename?: 'OutlinkMetedata'
  urlSource?: Maybe<OutlinkSourceEnum>
}

export enum OutlinkSourceEnum {
  Prismic = 'PRISMIC',
  Magento = 'MAGENTO',
}

export type PageInfo = {
  __typename?: 'PageInfo'
  endCursor?: Maybe<SearchAfter>
  hasNextPage: Scalars['Boolean']
}

export type Part = {
  eTag: Scalars['String']
  partNumber: Scalars['Int']
}

export type PartSignedUrl = {
  __typename?: 'PartSignedUrl'
  partNumber: Scalars['Int']
  url: Scalars['String']
}

export type PartnershipContent =
  | ClubPartnershipProgramStats
  | ClubPartnershipStandardContent
  | ClubPartnershipBusinessSupportContent

export type PayForCertificationInput = {
  billedClubId: Scalars['ID']
  instructors: Array<InstructorCertificatesInput>
}

export type PayForCertificationResponse =
  | PayForCertificationResult
  | ErrorResult

export type PayForCertificationResult = {
  __typename?: 'PayForCertificationResult'
  results?: Maybe<Array<InstructorCertificate>>
}

export type PickList = {
  __typename?: 'PickList'
  items: Array<Scalars['String']>
  key: Scalars['String']
}

export type Playback = {
  __typename?: 'Playback'
  playbackUrl: Scalars['String']
  token: Scalars['String']
}

export type PortfolioUploadItem = {
  __typename?: 'PortfolioUploadItem'
  token: Scalars['String']
  url: Scalars['String']
}

export type PresentationTrack = {
  __typename?: 'PresentationTrack'
  comment?: Maybe<Scalars['String']>
  playback: Playback
  submittedAt?: Maybe<Scalars['String']>
}

export type PreworkContent = {
  __typename?: 'PreworkContent'
  contentList?: Maybe<Array<PreworkContentItem>>
}

export type PreworkContentItem = {
  __typename?: 'PreworkContentItem'
  title: Scalars['String']
  type: PreworkContentType
  url: Url
}

export enum PreworkContentType {
  Link = 'LINK',
  Pdf = 'PDF',
  Video = 'VIDEO',
}

export type PreworkStep = Step & {
  __typename?: 'PreworkStep'
  activeStepName: Scalars['String']
  activeStepNumber: Scalars['Int']
  assessmentVideo?: Maybe<AssessmentVideo>
  attended?: Maybe<AttendedStatusEnum>
  cancellationPolicy: Scalars['AWSJSON']
  contactUsEmail: Scalars['String']
  deliveryMethod: DeliveryMethodEnum
  details?: Maybe<Scalars['String']>
  dueDate?: Maybe<Scalars['String']>
  endDate: Scalars['String']
  eventName: Scalars['String']
  fulfillment?: Maybe<Scalars['String']>
  level?: Maybe<Scalars['String']>
  onlineTrainingLink?: Maybe<Scalars['String']>
  passPendingGuide: Scalars['AWSJSON']
  preworkContent?: Maybe<PreworkContent>
  programName: Scalars['String']
  releaseUrl?: Maybe<Link>
  requirements?: Maybe<Scalars['String']>
  schedule?: Maybe<Scalars['String']>
  startDate: Scalars['String']
  stepName: Scalars['String']
  stepNumber: Scalars['Int']
  timezone: Scalars['String']
  trackAllocation?: Maybe<Scalars['String']>
  trainerEmail?: Maybe<Scalars['String']>
  trainerName?: Maybe<Scalars['String']>
  venueAddress?: Maybe<Scalars['String']>
}

export enum PrivacySettingTypeValueInstructor {
  Email = 'EMAIL',
  PhoneNumber = 'PHONE_NUMBER',
  ProfilePhoto = 'PROFILE_PHOTO',
  SocialLinks = 'SOCIAL_LINKS',
  LmqLevel = 'LMQ_LEVEL',
}

export enum PrivacySettingValue {
  Public = 'PUBLIC',
  Restricted = 'RESTRICTED',
  Private = 'PRIVATE',
}

export type PrivacySettingsInstructor = {
  __typename?: 'PrivacySettingsInstructor'
  EMAIL: PrivacySettingValue
  HIDDEN: Scalars['Boolean']
  LMQ_LEVEL: PrivacySettingValue
  PHONE_NUMBER: PrivacySettingValue
  PROFILE_PHOTO: PrivacySettingValue
  SOCIAL_LINKS: PrivacySettingValue
}

export type PrivacySettingsInstructorInput = {
  EMAIL?: Maybe<PrivacySettingValue>
  HIDDEN?: Maybe<Scalars['Boolean']>
  LMQ_LEVEL?: Maybe<PrivacySettingValue>
  PHONE_NUMBER?: Maybe<PrivacySettingValue>
  PROFILE_PHOTO?: Maybe<PrivacySettingValue>
  SOCIAL_LINKS?: Maybe<PrivacySettingValue>
}

export type ProfileLink = {
  __typename?: 'ProfileLink'
  type: ProfileLinkType
  url: Scalars['String']
}

export type ProfileLinkInput = {
  type: ProfileLinkType
  url: Scalars['String']
}

export enum ProfileLinkType {
  Facebook = 'FACEBOOK',
  Youtube = 'YOUTUBE',
  Instagram = 'INSTAGRAM',
  Tiktok = 'TIKTOK',
  PersonalWebsite = 'PERSONAL_WEBSITE',
}

export type Program = ProgramInterface & {
  __typename?: 'Program'
  code: Scalars['String']
  displayName?: Maybe<Scalars['String']>
  id: Scalars['ID']
  initials: Scalars['String']
  name: Scalars['String']
  programType?: Maybe<ProgramTypeEnum>
}

export enum ProgramCodeEnum {
  Ba = 'BA',
  Bb = 'BB',
  Bc = 'BC',
  Bf = 'BF',
  Bj = 'BJ',
  Bp = 'BP',
  Bs = 'BS',
  Bm = 'BM',
  Bme = 'BME',
  Bms = 'BMS',
  Br = 'BR',
  Cr = 'CR',
  Gr = 'GR',
  Tn = 'TN',
  Ls = 'LS',
  Rp = 'RP',
  Sb = 'SB',
  Sp = 'SP',
  Tr = 'TR',
}

export type ProgramInput = {
  code?: Maybe<Scalars['String']>
  icon?: Maybe<Scalars['String']>
  id: Scalars['String']
  initials?: Maybe<Scalars['String']>
  name?: Maybe<Scalars['String']>
}

export type ProgramInstructorCount = {
  __typename?: 'ProgramInstructorCount'
  belowRecommendedAmount?: Maybe<Scalars['Boolean']>
  lastEnquiredOn?: Maybe<Scalars['AWSDateTime']>
  numberOfInstructors?: Maybe<Scalars['Int']>
}

export type ProgramInterface = {
  code: Scalars['String']
  displayName?: Maybe<Scalars['String']>
  id: Scalars['ID']
  initials: Scalars['String']
  name: Scalars['String']
  programType?: Maybe<ProgramTypeEnum>
}

export enum ProgramName {
  Bodyattack = 'BODYATTACK',
  Bodybalance = 'BODYBALANCE',
  Bodycombat = 'BODYCOMBAT',
  Bodyflow = 'BODYFLOW',
  Bodyjam = 'BODYJAM',
  Bodypump = 'BODYPUMP',
  Bodystep = 'BODYSTEP',
  BtmEarlyYears = 'BTM_EARLY_YEARS',
  BtmSchoolYears = 'BTM_SCHOOL_YEARS',
  LesMillsBarre = 'LES_MILLS_BARRE',
  LesMillsCore = 'LES_MILLS_CORE',
  LesMillsGrit = 'LES_MILLS_GRIT',
  LesMillsTone = 'LES_MILLS_TONE',
  LmiStep = 'LMI_STEP',
  Rpm = 'RPM',
  Shbam = 'SHBAM',
  Sprint = 'SPRINT',
  TheTrip = 'THE_TRIP',
  BornToMove = 'BORN_TO_MOVE',
}

export enum ProgramStatus {
  InProgress = 'IN_PROGRESS',
  Active = 'ACTIVE',
  InCancellation = 'IN_CANCELLATION',
  Cancelled = 'CANCELLED',
  NotMapped = 'NOT_MAPPED',
}

export enum ProgramTypeEnum {
  Live = 'LIVE',
  Virtual = 'VIRTUAL',
  AtHome = 'AT_HOME',
}

export type ProgramTypeInfo = {
  __typename?: 'ProgramTypeInfo'
  description?: Maybe<Scalars['String']>
  title: Scalars['String']
}

export type Promotion = {
  __typename?: 'Promotion'
  description?: Maybe<Scalars['String']>
  id: Scalars['ID']
  image: ImageSet
  link?: Maybe<Link>
  title: Scalars['String']
}

export type Query = {
  __typename?: 'Query'
  _root?: Maybe<Scalars['String']>
  bookedEvent: BookedEventResponse
  bookedEvents: BookedEventsResponse
  dynamoMigrate: DynamoMigrateResponse
  eventDetails: EventDetailsResponse
  getAgreementDocument: AgreementDocumentResponse
  getAllTranslations?: Maybe<GetAllTranslationsResponse>
  getChainAffiliations: GetChainAffiliationsResponse
  getChainInstructorAffiliates: GetChainInstructorAffiliatesResponse
  getChainUser?: Maybe<ChainUserResponse>
  getChainUserClubListings?: Maybe<GetChainUserClubListingsResponse>
  getClubAffiliations?: Maybe<GetClubAffiliationsResponse>
  getClubById?: Maybe<GetClubByIdResponse>
  getClubInstructorAffiliates?: Maybe<GetClubInstructorAffiliatesResponse>
  getClubListingById: GetClubListingByIdResponse
  getClubListingsByClubId?: Maybe<GetClubListingsByClubIdResponse>
  getClubNotifications?: Maybe<GetClubNotificationsResponse>
  getClubSettings: GetClubSettingsResponse
  getClubsAvailabilityOnListing?: Maybe<GetClubsAvailabilityOnListingResponse>
  getContactUsContent: GetContactUsContentResponse
  getCurrentUser?: Maybe<GetUserResponse>
  getCurrentUserPhotoUploadData?: Maybe<GetCurrentUserPhotoUploadDataResponse>
  getCurrentUserPortfolioUploadData: GetCurrentUserPortfolioUploadDataResponse
  getDashboard?: Maybe<GetDashboardResponse>
  getEqualOpportunitiesPolicy: GetEqualOpportunitiesPolicyResponse
  getExploreProgramsPage?: Maybe<GetExploreProgramsPageResult>
  getFeatureFlag?: Maybe<FeatureFlagResponse>
  getFrequentlyAskedQuestions: GetFrequentlyAskedQuestionsResponse
  getHeaders?: Maybe<GetHeaderResponse>
  getInstructorClubAffiliates: GetInstructorClubAffiliatesResponse
  getInstructorWatchlist?: Maybe<SearchClubListingsResponse>
  getNavigation?: Maybe<GetNavigationResponse>
  getNotifications?: Maybe<GetNotificationsResponse>
  getPickLists?: Maybe<GetPickListResponse>
  getPresignedUrl?: Maybe<GetPresignedUrlResponse>
  getPrivacySettingValues?: Maybe<GetPrivacySettingValuesResponse>
  getProfileById?: Maybe<GetProfileByIdResponse>
  getSavedInstructorSearchData?: Maybe<GetSavedInstructorSearchDataResponse>
  getSharedNavigation?: Maybe<GetSharedNavigation>
  getUserAccount: GetAccountSettingsResponse
  getUserEnquiries?: Maybe<GetUserEnquiriesResponse>
  getUserSession: GetUserSessionResponse
  getVideoGuidelines: GetVideoGuidelinesResponse
  getWalkthrough?: Maybe<GetWalkthroughResponse>
  searchClubListings?: Maybe<SearchClubListingsResponse>
  searchClubs?: Maybe<SearchClubsResponse>
  searchEvents: SearchEventsResponse
  searchInstructors?: Maybe<SearchInstructorsResponse>
  trainerBooking: TrainerBookingResponse
  trainerBookings: TrainerBookingsResponse
  trainingJourney: TrainingJourneyResponse
  trainingJourneys: TrainingJourneysResponse
}

export type Query_RootArgs = {
  _cacheKey?: Maybe<Scalars['String']>
}

export type QueryBookedEventArgs = {
  eventId: Scalars['String']
  role: UserRoleInput
  _cacheKey?: Maybe<Scalars['String']>
}

export type QueryBookedEventsArgs = {
  clubId: Scalars['String']
  _cacheKey?: Maybe<Scalars['String']>
}

export type QueryDynamoMigrateArgs = {
  input: DynamoMigrateInput
  _cacheKey?: Maybe<Scalars['String']>
}

export type QueryEventDetailsArgs = {
  eventId: Scalars['String']
  role: UserRoleInput
  _cacheKey?: Maybe<Scalars['String']>
}

export type QueryGetAgreementDocumentArgs = {
  input: GetSignedAgreementInput
  _cacheKey?: Maybe<Scalars['String']>
}

export type QueryGetAllTranslationsArgs = {
  _cacheKey?: Maybe<Scalars['String']>
}

export type QueryGetChainAffiliationsArgs = {
  input: GetChainAffiliationsInput
  _cacheKey?: Maybe<Scalars['String']>
}

export type QueryGetChainInstructorAffiliatesArgs = {
  input?: Maybe<GetChainInstructorAffiliatesInput>
  _cacheKey?: Maybe<Scalars['String']>
}

export type QueryGetChainUserArgs = {
  _cacheKey?: Maybe<Scalars['String']>
}

export type QueryGetChainUserClubListingsArgs = {
  input: GetChainUserClubListingsInput
  _cacheKey?: Maybe<Scalars['String']>
}

export type QueryGetClubAffiliationsArgs = {
  input: GetClubAffiliationsInput
  _cacheKey?: Maybe<Scalars['String']>
}

export type QueryGetClubByIdArgs = {
  input: GetClubByIdInput
  _cacheKey?: Maybe<Scalars['String']>
}

export type QueryGetClubInstructorAffiliatesArgs = {
  input: GetClubInstructorAffiliatesInput
  _cacheKey?: Maybe<Scalars['String']>
}

export type QueryGetClubListingByIdArgs = {
  listingId: Scalars['String']
  _cacheKey?: Maybe<Scalars['String']>
}

export type QueryGetClubListingsByClubIdArgs = {
  input: GetClubListingsByClubIdInput
  _cacheKey?: Maybe<Scalars['String']>
}

export type QueryGetClubNotificationsArgs = {
  filter: GetClubNotificationsInput
  _cacheKey?: Maybe<Scalars['String']>
}

export type QueryGetClubSettingsArgs = {
  input: GetClubSettingsInput
  _cacheKey?: Maybe<Scalars['String']>
}

export type QueryGetClubsAvailabilityOnListingArgs = {
  input: GetClubsAvailabilityOnListingInput
  _cacheKey?: Maybe<Scalars['String']>
}

export type QueryGetContactUsContentArgs = {
  input: GetContactUsContentInput
  _cacheKey?: Maybe<Scalars['String']>
}

export type QueryGetCurrentUserArgs = {
  _cacheKey?: Maybe<Scalars['String']>
}

export type QueryGetCurrentUserPhotoUploadDataArgs = {
  _cacheKey?: Maybe<Scalars['String']>
}

export type QueryGetCurrentUserPortfolioUploadDataArgs = {
  input: GetCurrentUserPortfolioUploadDataInput
  _cacheKey?: Maybe<Scalars['String']>
}

export type QueryGetDashboardArgs = {
  role: UserRoleInput
  _cacheKey?: Maybe<Scalars['String']>
}

export type QueryGetEqualOpportunitiesPolicyArgs = {
  input: GetEqualOpportunitiesPolicyInput
  _cacheKey?: Maybe<Scalars['String']>
}

export type QueryGetExploreProgramsPageArgs = {
  role: UserRoleInput
  programName?: Maybe<ProgramName>
  _cacheKey?: Maybe<Scalars['String']>
}

export type QueryGetFeatureFlagArgs = {
  input: FeatureFlagQueryInput
  _cacheKey?: Maybe<Scalars['String']>
}

export type QueryGetFrequentlyAskedQuestionsArgs = {
  input: GetFrequentlyAskedQuestionsInput
  _cacheKey?: Maybe<Scalars['String']>
}

export type QueryGetHeadersArgs = {
  input: GetHeaderInput
  _cacheKey?: Maybe<Scalars['String']>
}

export type QueryGetInstructorClubAffiliatesArgs = {
  input: GetInstructorClubAffiliatesInput
  _cacheKey?: Maybe<Scalars['String']>
}

export type QueryGetInstructorWatchlistArgs = {
  role: UserRoleInput
  _cacheKey?: Maybe<Scalars['String']>
}

export type QueryGetNavigationArgs = {
  input?: Maybe<GetNavigationInput>
  _cacheKey?: Maybe<Scalars['String']>
}

export type QueryGetNotificationsArgs = {
  filter: DateTimeFilterInput
  role: UserRoleInput
  _cacheKey?: Maybe<Scalars['String']>
}

export type QueryGetPickListsArgs = {
  input: GetPickListInput
  _cacheKey?: Maybe<Scalars['String']>
}

export type QueryGetPresignedUrlArgs = {
  input?: Maybe<GetPresignedUrlInput>
  _cacheKey?: Maybe<Scalars['String']>
}

export type QueryGetPrivacySettingValuesArgs = {
  _cacheKey?: Maybe<Scalars['String']>
}

export type QueryGetProfileByIdArgs = {
  input: GetProfileByIdInput
  role: UserRoleInput
  _cacheKey?: Maybe<Scalars['String']>
}

export type QueryGetSavedInstructorSearchDataArgs = {
  input: GetSavedInstructorSearchDataInput
  _cacheKey?: Maybe<Scalars['String']>
}

export type QueryGetSharedNavigationArgs = {
  _cacheKey?: Maybe<Scalars['String']>
}

export type QueryGetUserAccountArgs = {
  input: GetUserByIdInput
  role: UserRoleInput
  _cacheKey?: Maybe<Scalars['String']>
}

export type QueryGetUserEnquiriesArgs = {
  role: UserRoleInput
  filter: UserEnquiriesFilter
  _cacheKey?: Maybe<Scalars['String']>
}

export type QueryGetUserSessionArgs = {
  _cacheKey?: Maybe<Scalars['String']>
}

export type QueryGetVideoGuidelinesArgs = {
  _cacheKey?: Maybe<Scalars['String']>
}

export type QueryGetWalkthroughArgs = {
  role: UserRoleInput
  _cacheKey?: Maybe<Scalars['String']>
}

export type QuerySearchClubListingsArgs = {
  filter: SearchClubListingsFilter
  options?: Maybe<SearchClubListingsOptions>
  _cacheKey?: Maybe<Scalars['String']>
}

export type QuerySearchClubsArgs = {
  filter: SearchClubsFilter
  options?: Maybe<SearchClubsOptions>
  _cacheKey?: Maybe<Scalars['String']>
}

export type QuerySearchEventsArgs = {
  searchInfo: SearchEventsInput
  filterInfo: FilterEventsInput
  _cacheKey?: Maybe<Scalars['String']>
}

export type QuerySearchInstructorsArgs = {
  filter: SearchInstructorsFilter
  options?: Maybe<SearchInstructorsOptions>
  role: UserRoleInput
  _cacheKey?: Maybe<Scalars['String']>
}

export type QueryTrainerBookingArgs = {
  input: TrainerBookingInput
  _cacheKey?: Maybe<Scalars['String']>
}

export type QueryTrainerBookingsArgs = {
  _cacheKey?: Maybe<Scalars['String']>
}

export type QueryTrainingJourneyArgs = {
  input: TrainingJourneyInput
  role?: Maybe<UserRoleInput>
  _cacheKey?: Maybe<Scalars['String']>
}

export type QueryTrainingJourneysArgs = {
  _cacheKey?: Maybe<Scalars['String']>
}

export type ReceivedCertificationOutcomeStep = Step & {
  __typename?: 'ReceivedCertificationOutcomeStep'
  activeStepName: Scalars['String']
  activeStepNumber: Scalars['Int']
  attended?: Maybe<AttendedStatusEnum>
  cancellationPolicy: Scalars['AWSJSON']
  certificationOutcomes?: Maybe<Array<TrainingOutcome>>
  certificationUrl?: Maybe<Scalars['String']>
  contactUsEmail: Scalars['String']
  deliveryMethod: DeliveryMethodEnum
  details?: Maybe<Scalars['String']>
  dueDate?: Maybe<Scalars['String']>
  endDate: Scalars['String']
  eventName: Scalars['String']
  fulfillment?: Maybe<Scalars['String']>
  level?: Maybe<Scalars['String']>
  onlineTrainingLink?: Maybe<Scalars['String']>
  passPendingGuide: Scalars['AWSJSON']
  programName: Scalars['String']
  requirements?: Maybe<Scalars['String']>
  resubmitDueDate?: Maybe<Scalars['String']>
  schedule?: Maybe<Scalars['String']>
  startDate: Scalars['String']
  stepName: Scalars['String']
  stepNumber: Scalars['Int']
  timezone: Scalars['String']
  trackAllocation?: Maybe<Scalars['String']>
  trainerEmail?: Maybe<Scalars['String']>
  trainerName?: Maybe<Scalars['String']>
  venueAddress?: Maybe<Scalars['String']>
}

export type ReceivedTrainingOutcomeStep = Step & {
  __typename?: 'ReceivedTrainingOutcomeStep'
  activeStepName: Scalars['String']
  activeStepNumber: Scalars['Int']
  assessmentOutcomes?: Maybe<Array<TrainingOutcome>>
  attended?: Maybe<AttendedStatusEnum>
  cancellationPolicy: Scalars['AWSJSON']
  cecCertificationUrl?: Maybe<Scalars['String']>
  contactUsEmail: Scalars['String']
  deliveryMethod: DeliveryMethodEnum
  details?: Maybe<Scalars['String']>
  dueDate?: Maybe<Scalars['String']>
  endDate: Scalars['String']
  eventName: Scalars['String']
  extendedDueDate?: Maybe<Scalars['String']>
  fulfillment?: Maybe<Scalars['String']>
  level?: Maybe<Scalars['String']>
  onlineTrainingLink?: Maybe<Scalars['String']>
  passPendingGuide: Scalars['AWSJSON']
  programName: Scalars['String']
  requirements?: Maybe<Scalars['String']>
  schedule?: Maybe<Scalars['String']>
  startDate: Scalars['String']
  stepName: Scalars['String']
  stepNumber: Scalars['Int']
  timezone: Scalars['String']
  trackAllocation?: Maybe<Scalars['String']>
  trainerEmail?: Maybe<Scalars['String']>
  trainerName?: Maybe<Scalars['String']>
  venueAddress?: Maybe<Scalars['String']>
}

export enum RecordType {
  PresentationTrack = 'PRESENTATION_TRACK',
  OutcomeTrack = 'OUTCOME_TRACK',
  OneTrack = 'ONE_TRACK',
  Initial = 'INITIAL',
}

export enum ReleaseActivityStatusEnum {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Na = 'NA',
}

export enum ReleaseBundleTypeEnum {
  Standard = 'STANDARD',
  Discounted = 'DISCOUNTED',
  DiscountedChain = 'DISCOUNTED_CHAIN',
  Sunflower = 'SUNFLOWER',
  Nomura = 'NOMURA',
  OgSport = 'OG_SPORT',
  Oasis = 'OASIS',
  Super = 'SUPER',
  Mega = 'MEGA',
  Plus = 'PLUS',
  Shine = 'SHINE',
}

export enum ReleaseStatusEnum {
  Subscribed = 'SUBSCRIBED',
  Unsubscribed = 'UNSUBSCRIBED',
  OnHold = 'ON_HOLD',
}

export type RemoveFromShortlistInput = {
  userId: Scalars['String']
}

export type RemoveFromShortlistResponse =
  | RemoveFromShortlistResult
  | ErrorResult

export type RemoveFromShortlistResult = {
  __typename?: 'RemoveFromShortlistResult'
  shortlist?: Maybe<Array<InstructorShortlist>>
}

export type ReportClubListingInput = {
  clubId: Scalars['ID']
  listingId: Scalars['ID']
  message: Scalars['String']
  reason: ReportClubListingReasonEnum
}

export enum ReportClubListingReasonEnum {
  InappropriateContent = 'INAPPROPRIATE_CONTENT',
  MisleadingFalseInformation = 'MISLEADING_FALSE_INFORMATION',
  BullyingDiscriminationHarassment = 'BULLYING_DISCRIMINATION_HARASSMENT',
}

export type ReportClubListingResponse =
  | ClubSingleListing
  | ClubMultiListing
  | ErrorResult

export type ReportClubProfileInput = {
  clubId: Scalars['ID']
  message: Scalars['String']
  reason: ReportClubProfileReasonEnum
}

export enum ReportClubProfileReasonEnum {
  InappropriateContent = 'INAPPROPRIATE_CONTENT',
  MisleadingFalseInformation = 'MISLEADING_FALSE_INFORMATION',
  BullyingDiscriminationHarassment = 'BULLYING_DISCRIMINATION_HARASSMENT',
}

export type ReportClubProfileResponse = ClubProfile | ErrorResult

export type RequestForExtensionInput = {
  assessmentId: Scalars['String']
  reason: Scalars['String']
  trainingJourneyId: Scalars['String']
}

export type RequestForExtensionResponse =
  | RequestForExtensionResult
  | ErrorResult

export type RequestForExtensionResult = {
  __typename?: 'RequestForExtensionResult'
  isSuccess?: Maybe<Scalars['Boolean']>
}

export enum RequireFilter {
  Default = 'DEFAULT',
  Only = 'ONLY',
  All = 'ALL',
}

export type ResendPasswordResetEmailInput = {
  email: Scalars['String']
}

export type ResendPasswordResetEmailResponse =
  | ResendPasswordResetEmailResult
  | ErrorResult

export type ResendPasswordResetEmailResult = {
  __typename?: 'ResendPasswordResetEmailResult'
  success?: Maybe<Scalars['Boolean']>
}

export type RevertAppMetadataInput = {
  email: Scalars['String']
}

export enum Role {
  Instructor = 'INSTRUCTOR',
  Club = 'CLUB',
}

export type RootMenuItem = {
  __typename?: 'RootMenuItem'
  analyticsEvent?: Maybe<AnalyticsEvent>
  icon: MenuItemIcon
  id: Scalars['ID']
  items?: Maybe<Array<MenuItem>>
  label: Scalars['String']
  url?: Maybe<Url>
}

export type SavedClubSearch = {
  __typename?: 'SavedClubSearch'
  filter?: Maybe<SavedClubSearchFilter>
  sort?: Maybe<SearchClubsSort>
}

export type SavedClubSearchFilter = {
  __typename?: 'SavedClubSearchFilter'
  name?: Maybe<Scalars['String']>
  programs?: Maybe<Array<Scalars['ID']>>
}

export type SavedInstructorSearch = {
  __typename?: 'SavedInstructorSearch'
  filter?: Maybe<SavedSearchClubListingsFilter>
  sort?: Maybe<SearchClubListingsSort>
}

export type SavedSearchClubListingsFilter = {
  __typename?: 'SavedSearchClubListingsFilter'
  location?: Maybe<LocationFilter>
  name?: Maybe<Scalars['String']>
  programs?: Maybe<Array<Scalars['ID']>>
  status?: Maybe<ClubListingStatus>
  substituteListingFilter?: Maybe<SearchClubListingsSubstitute>
}

export type SearchClubJobListingsSingleResult =
  SearchClubListingsResultCommon & {
    __typename?: 'SearchClubJobListingsSingleResult'
    distance?: Maybe<Scalars['Float']>
    distanceUnit?: Maybe<LocationDistanceUnit>
    enquiredOn?: Maybe<Scalars['AWSDateTime']>
    hasBeenReported?: Maybe<Scalars['Boolean']>
    listing: ClubListing
    messageSentOn?: Maybe<Scalars['AWSDateTime']>
    onWatchlist?: Maybe<Scalars['Boolean']>
  }

export type SearchClubListingsFilter = {
  location?: Maybe<LocationFilterInput>
  name?: Maybe<Scalars['String']>
  programs?: Maybe<Array<Scalars['ID']>>
  status?: Maybe<ClubListingStatus>
  substituteListingFilter?: Maybe<SearchClubListingsSubstitute>
}

export type SearchClubListingsOptions = {
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  sort?: Maybe<SearchClubListingsSort>
}

export type SearchClubListingsResponse = SearchClubListingsResult | ErrorResult

export type SearchClubListingsResult = {
  __typename?: 'SearchClubListingsResult'
  results?: Maybe<Array<SearchClubListingsSingleResult>>
  total: Scalars['Int']
}

export type SearchClubListingsResultCommon = {
  distance?: Maybe<Scalars['Float']>
  distanceUnit?: Maybe<LocationDistanceUnit>
  hasBeenReported?: Maybe<Scalars['Boolean']>
  onWatchlist?: Maybe<Scalars['Boolean']>
}

export type SearchClubListingsSingleResult =
  | SearchClubJobListingsSingleResult
  | SearchClubProfileSingleResult

export enum SearchClubListingsSort {
  Nearest = 'NEAREST',
  MostRecent = 'MOST_RECENT',
  Relevance = 'RELEVANCE',
}

export enum SearchClubListingsSubstitute {
  OnlySubstitute = 'ONLY_SUBSTITUTE',
  OnlyNonSubstitute = 'ONLY_NON_SUBSTITUTE',
  All = 'ALL',
}

export type SearchClubProfileSingleResult = SearchClubListingsResultCommon & {
  __typename?: 'SearchClubProfileSingleResult'
  distance?: Maybe<Scalars['Float']>
  distanceUnit?: Maybe<LocationDistanceUnit>
  hasBeenReported?: Maybe<Scalars['Boolean']>
  onWatchlist?: Maybe<Scalars['Boolean']>
  profile: UserProfileClub
}

export type SearchClubsFilter = {
  location?: Maybe<LocationFilterInput>
  name?: Maybe<Scalars['String']>
  programs?: Maybe<Array<Scalars['ID']>>
  status?: Maybe<ClubListingStatus>
}

export type SearchClubsOptions = {
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  sort?: Maybe<SearchClubsSort>
}

export type SearchClubsResponse = SearchClubsResult | ErrorResult

export type SearchClubsResult = {
  __typename?: 'SearchClubsResult'
  results: Array<SearchClubsSingleResult>
  total: Scalars['Int']
}

export type SearchClubsSingleResult = {
  __typename?: 'SearchClubsSingleResult'
  clubId: Scalars['String']
  distance?: Maybe<Scalars['Float']>
  distanceUnit?: Maybe<LocationDistanceUnit>
  hasBeenReported?: Maybe<Scalars['Boolean']>
  instructorAffiliation?: Maybe<Affiliation>
  onWatchlist?: Maybe<Scalars['Boolean']>
  profile: UserProfileClub
}

export enum SearchClubsSort {
  Nearest = 'NEAREST',
  Alphabetical = 'ALPHABETICAL',
  Relevance = 'RELEVANCE',
}

export type SearchEventsInput = {
  after?: Maybe<SearchAfterInput>
  limit: Scalars['Int']
}

export type SearchEventsResponse = EventsResult | ErrorResult

export type SearchInstructorsFilter = {
  location?: Maybe<LocationFilterInput>
  name?: Maybe<Scalars['String']>
  onlyAvailableToSubstitute?: Maybe<Scalars['Boolean']>
  programs?: Maybe<Array<Scalars['ID']>>
}

export type SearchInstructorsOptions = {
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  sort?: Maybe<SearchInstructorsSort>
}

export type SearchInstructorsResponse = SearchInstructorsResult | ErrorResult

export type SearchInstructorsResult = {
  __typename?: 'SearchInstructorsResult'
  isMatchingFilter?: Maybe<Scalars['Boolean']>
  results?: Maybe<Array<SearchInstructorsSingleResult>>
  total: Scalars['Int']
}

export type SearchInstructorsSingleResult = {
  __typename?: 'SearchInstructorsSingleResult'
  distance?: Maybe<Scalars['Float']>
  distanceUnit?: Maybe<LocationDistanceUnit>
  hasExistingAffiliation?: Maybe<Scalars['Boolean']>
  hasRecentlyDeclinedAffiliation?: Maybe<Scalars['Boolean']>
  instructorAffiliation?: Maybe<Affiliation>
  inTravelZone?: Maybe<Scalars['Boolean']>
  lastMessageIn48HoursSentAt?: Maybe<Scalars['AWSDateTime']>
  messageSentOn?: Maybe<Scalars['AWSDateTime']>
  profile: UserProfileTeaching
  user: User
}

export enum SearchInstructorsSort {
  Nearest = 'NEAREST',
  Alphabetical = 'ALPHABETICAL',
  Relevance = 'RELEVANCE',
}

export type SectionContentResult = {
  __typename?: 'SectionContentResult'
  content: Array<ContentField>
  section: Scalars['String']
}

export type SeedRandomAccountsInput = {
  number?: Maybe<Scalars['Int']>
}

export type SeedRandomAccountsResponse = SeedRandomAccountsResult | ErrorResult

export type SeedRandomAccountsResult = {
  __typename?: 'SeedRandomAccountsResult'
  results: Array<UserResult>
  total: Scalars['Int']
}

export type SendMessageInput = {
  clubId: Scalars['ID']
  listingId?: Maybe<Scalars['ID']>
  message: Scalars['String']
  profileId: Scalars['ID']
  requestedBy: UserRoleType
}

export type SendMessageResponse = SendMessageResult | ErrorResult

export type SendMessageResult = {
  __typename?: 'SendMessageResult'
  readAt?: Maybe<Scalars['AWSDateTime']>
  sentAt: Scalars['AWSDateTime']
}

export type SetAppMetadataInput = {
  email: Scalars['String']
}

export type SetClubSettingsInput = {
  address?: Maybe<AddressInput>
  email?: Maybe<EmailClubTypeInput>
  id: Scalars['ID']
  name?: Maybe<Scalars['String']>
  phone?: Maybe<Scalars['String']>
}

export type SetClubSettingsResponse = SetClubSettingsResult | ErrorResult

export type SetClubSettingsResult = {
  __typename?: 'SetClubSettingsResult'
  address?: Maybe<Address>
  email?: Maybe<EmailClubType>
  id: Scalars['ID']
  name?: Maybe<Scalars['String']>
  phone?: Maybe<Scalars['String']>
}

export type SetInstructorAvailabilityInput = {
  availability: InstructorAvailabilityValue
  availableToSubstitute: Scalars['Boolean']
}

export type SetInstructorAvailabilityResponse =
  | InstructorAvailability
  | ErrorResult

export type SetInstructorTravelPreferencesInput = {
  address?: Maybe<AddressInput>
  distance?: Maybe<Scalars['Int']>
  distanceUnit?: Maybe<LocationDistanceUnit>
  id?: Maybe<Scalars['ID']>
}

export type SetInstructorTravelPreferencesResponse =
  | InstructorPreferences
  | ErrorResult

export type SetInstructorWatchlistInput = {
  watchlist: Array<InstructorWatchlistItemInput>
}

export type SetInstructorWatchlistResponse = InstructorWatchlist | ErrorResult

export type SetPrivacySettingInput = {
  name: PrivacySettingTypeValueInstructor
  value: PrivacySettingValue
}

export type SetPrivacySettingsInput = {
  hidden?: Maybe<Scalars['Boolean']>
  id?: Maybe<Scalars['ID']>
  settings: Array<SetPrivacySettingInput>
  type: UserProfileType
}

export type SetPrivacySettingsResponse = SetPrivacySettingsResult | ErrorResult

export type SetPrivacySettingsResult = {
  __typename?: 'SetPrivacySettingsResult'
  settings: PrivacySettingsInstructor
}

export type SetSavedClubSearchDataInput = {
  searches: Array<SetSavedClubSearchDataSingleInput>
}

export type SetSavedClubSearchDataResponse =
  | SetSavedClubSearchDataResult
  | ErrorResult

export type SetSavedClubSearchDataResult = {
  __typename?: 'SetSavedClubSearchDataResult'
  results: Array<SavedClubSearch>
}

export type SetSavedClubSearchDataSingleInput = {
  filter: SearchClubsFilter
  sort?: Maybe<SearchClubsSort>
}

export type SetSavedInstructorSearchDataInput = {
  searches: Array<SetSavedInstructorSearchDataSingleInput>
}

export type SetSavedInstructorSearchDataResponse =
  | SetSavedInstructorSearchDataResult
  | ErrorResult

export type SetSavedInstructorSearchDataResult = {
  __typename?: 'SetSavedInstructorSearchDataResult'
  results: Array<SavedInstructorSearch>
}

export type SetSavedInstructorSearchDataSingleInput = {
  filter: SearchClubListingsFilter
  sort?: Maybe<SearchClubListingsSort>
}

export type SetSignedAgreementDataInput = {
  type: AgreementType
  version: Scalars['String']
}

export type SetWalkthroughToSeenResponse =
  | SetWalkthroughToSeenResult
  | ErrorResult

export type SetWalkthroughToSeenResult = {
  __typename?: 'SetWalkthroughToSeenResult'
  success?: Maybe<Scalars['Boolean']>
}

export type SharedNavItem = {
  __typename?: 'SharedNavItem'
  navItems?: Maybe<Array<Maybe<NavItem>>>
  role?: Maybe<Role>
}

export type SharedNavigation = {
  __typename?: 'SharedNavigation'
  clubNav?: Maybe<SharedNavItem>
  instructorNav?: Maybe<SharedNavItem>
  websiteLink: Url
}

export type SignedAgreement = {
  __typename?: 'SignedAgreement'
  signedOn: Scalars['AWSDateTime']
  type: AgreementType
  version: Scalars['String']
}

export enum SnapshotStateEnum {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
}

export type SocialMediaContent = {
  __typename?: 'SocialMediaContent'
  type: SocialMediaContentType
  value: Scalars['String']
}

export enum SocialMediaContentType {
  Video = 'VIDEO',
  Image = 'IMAGE',
  Text = 'TEXT',
}

export type SocialMediaPost = {
  __typename?: 'SocialMediaPost'
  content: SocialMediaContent
  createdAt: Scalars['AWSDateTime']
  createdAtLabel: Scalars['String']
  id: Scalars['ID']
  type: SocialMediaType
  url: Scalars['String']
}

export type SocialMediaSection = {
  __typename?: 'SocialMediaSection'
  items?: Maybe<Array<SocialMediaPost>>
  title: Scalars['String']
}

export enum SocialMediaType {
  Youtube = 'YOUTUBE',
  Instagram = 'INSTAGRAM',
  Tiktok = 'TIKTOK',
  Facebook = 'FACEBOOK',
}

export enum StatesEnum {
  Alabama = 'ALABAMA',
  Alaska = 'ALASKA',
  Arizona = 'ARIZONA',
  Arkansas = 'ARKANSAS',
  California = 'CALIFORNIA',
  Colorado = 'COLORADO',
  Connecticut = 'CONNECTICUT',
  Delaware = 'DELAWARE',
  DistrictOfColumbia = 'DISTRICT_OF_COLUMBIA',
  Florida = 'FLORIDA',
  Georgia = 'GEORGIA',
  Hawaii = 'HAWAII',
  Idaho = 'IDAHO',
  Illinois = 'ILLINOIS',
  Indiana = 'INDIANA',
  Iowa = 'IOWA',
  Kansas = 'KANSAS',
  Kentucky = 'KENTUCKY',
  Louisiana = 'LOUISIANA',
  Maine = 'MAINE',
  Maryland = 'MARYLAND',
  Massachusetts = 'MASSACHUSETTS',
  Michigan = 'MICHIGAN',
  Minnesota = 'MINNESOTA',
  Mississippi = 'MISSISSIPPI',
  Missouri = 'MISSOURI',
  Montana = 'MONTANA',
  Nebraska = 'NEBRASKA',
  Nevada = 'NEVADA',
  NewHampshire = 'NEW_HAMPSHIRE',
  NewJersey = 'NEW_JERSEY',
  NewMexico = 'NEW_MEXICO',
  NewYork = 'NEW_YORK',
  NorthCarolina = 'NORTH_CAROLINA',
  NorthDakota = 'NORTH_DAKOTA',
  Ohio = 'OHIO',
  Oklahoma = 'OKLAHOMA',
  Oregon = 'OREGON',
  Pennsylvania = 'PENNSYLVANIA',
  RhodeIsland = 'RHODE_ISLAND',
  SouthCarolina = 'SOUTH_CAROLINA',
  SouthDakota = 'SOUTH_DAKOTA',
  Tennessee = 'TENNESSEE',
  Texas = 'TEXAS',
  Utah = 'UTAH',
  Vermont = 'VERMONT',
  Virginia = 'VIRGINIA',
  Washington = 'WASHINGTON',
  WestVirginia = 'WEST_VIRGINIA',
  Wisconsin = 'WISCONSIN',
  Wyoming = 'WYOMING',
}

export type Step = {
  activeStepName: Scalars['String']
  activeStepNumber: Scalars['Int']
  attended?: Maybe<AttendedStatusEnum>
  cancellationPolicy: Scalars['AWSJSON']
  contactUsEmail: Scalars['String']
  deliveryMethod: DeliveryMethodEnum
  details?: Maybe<Scalars['String']>
  dueDate?: Maybe<Scalars['String']>
  endDate: Scalars['String']
  eventName: Scalars['String']
  fulfillment?: Maybe<Scalars['String']>
  level?: Maybe<Scalars['String']>
  onlineTrainingLink?: Maybe<Scalars['String']>
  passPendingGuide: Scalars['AWSJSON']
  programName: Scalars['String']
  requirements?: Maybe<Scalars['String']>
  schedule?: Maybe<Scalars['String']>
  startDate: Scalars['String']
  stepName: Scalars['String']
  stepNumber: Scalars['Int']
  timezone: Scalars['String']
  trackAllocation?: Maybe<Scalars['String']>
  trainerEmail?: Maybe<Scalars['String']>
  trainerName?: Maybe<Scalars['String']>
  venueAddress?: Maybe<Scalars['String']>
}

export type SubmitCertificationVideoStep = Step & {
  __typename?: 'SubmitCertificationVideoStep'
  activeStepName: Scalars['String']
  activeStepNumber: Scalars['Int']
  assessmentVideo?: Maybe<AssessmentVideo>
  attended?: Maybe<AttendedStatusEnum>
  cancellationPolicy: Scalars['AWSJSON']
  contactUsEmail: Scalars['String']
  deliveryMethod: DeliveryMethodEnum
  details?: Maybe<Scalars['String']>
  dueDate?: Maybe<Scalars['String']>
  endDate: Scalars['String']
  eventName: Scalars['String']
  extendedDueDate?: Maybe<Scalars['String']>
  fulfillment?: Maybe<Scalars['String']>
  level?: Maybe<Scalars['String']>
  onlineTrainingLink?: Maybe<Scalars['String']>
  passPendingGuide: Scalars['AWSJSON']
  programName: Scalars['String']
  requirements?: Maybe<Scalars['String']>
  schedule?: Maybe<Scalars['String']>
  startDate: Scalars['String']
  stepName: Scalars['String']
  stepNumber: Scalars['Int']
  timezone: Scalars['String']
  trackAllocation?: Maybe<Scalars['String']>
  trainerEmail?: Maybe<Scalars['String']>
  trainerName?: Maybe<Scalars['String']>
  venueAddress?: Maybe<Scalars['String']>
}

export type SubmitOutcomeTrackStep = Step & {
  __typename?: 'SubmitOutcomeTrackStep'
  activeStepName: Scalars['String']
  activeStepNumber: Scalars['Int']
  assessmentVideo?: Maybe<AssessmentVideo>
  attended?: Maybe<AttendedStatusEnum>
  cancellationPolicy: Scalars['AWSJSON']
  contactUsEmail: Scalars['String']
  deliveryMethod: DeliveryMethodEnum
  details?: Maybe<Scalars['String']>
  dueDate?: Maybe<Scalars['String']>
  endDate: Scalars['String']
  eventName: Scalars['String']
  extendedDueDate?: Maybe<Scalars['String']>
  fulfillment?: Maybe<Scalars['String']>
  level?: Maybe<Scalars['String']>
  onlineTrainingLink?: Maybe<Scalars['String']>
  passPendingGuide: Scalars['AWSJSON']
  programName: Scalars['String']
  requirements?: Maybe<Scalars['String']>
  schedule?: Maybe<Scalars['String']>
  startDate: Scalars['String']
  stepName: Scalars['String']
  stepNumber: Scalars['Int']
  timezone: Scalars['String']
  trackAllocation?: Maybe<Scalars['String']>
  trainerEmail?: Maybe<Scalars['String']>
  trainerName?: Maybe<Scalars['String']>
  venueAddress?: Maybe<Scalars['String']>
}

export type Subscription = {
  __typename?: 'Subscription'
  _root?: Maybe<Scalars['String']>
}

export type SyncMetadata = {
  force_sync?: Maybe<Scalars['Boolean']>
}

export type TestPostUpsertClubFilterInput = {
  ids?: Maybe<Array<Scalars['ID']>>
}

export type TestPostUpsertClubInput = {
  filter?: Maybe<TestPostUpsertClubFilterInput>
}

export type TestPostUpsertClubResponse = TestPostUpsertClubResult | ErrorResult

export type TestPostUpsertClubResult = {
  __typename?: 'TestPostUpsertClubResult'
  done: Array<Scalars['String']>
  failed: Array<Scalars['String']>
}

export type TestPostUpsertUserFilterInput = {
  emails?: Maybe<Array<Scalars['String']>>
  ids?: Maybe<Array<Scalars['ID']>>
}

export type TestPostUpsertUserInput = {
  filter?: Maybe<TestPostUpsertUserFilterInput>
}

export type TestPostUpsertUserResponse = TestPostUpsertUserResult | ErrorResult

export type TestPostUpsertUserResult = {
  __typename?: 'TestPostUpsertUserResult'
  done: Array<Scalars['String']>
  failed: Array<Scalars['String']>
}

export type Ticket = {
  __typename?: 'Ticket'
  canBeUsedWithDiscountCode: Scalars['Boolean']
  currencyIsoCode: Scalars['String']
  endDate: Scalars['String']
  isDefaultTicket: Scalars['Boolean']
  name: Scalars['String']
  price: Scalars['String']
  startDate: Scalars['String']
  ticketId: Scalars['String']
}

export type TimePreference = {
  __typename?: 'TimePreference'
  afternoon?: Maybe<Scalars['Boolean']>
  evening?: Maybe<Scalars['Boolean']>
  morning?: Maybe<Scalars['Boolean']>
}

export type TimePreferenceInput = {
  afternoon?: Maybe<Scalars['Boolean']>
  evening?: Maybe<Scalars['Boolean']>
  morning?: Maybe<Scalars['Boolean']>
}

export type TimeSlot = {
  __typename?: 'TimeSlot'
  day: DayOfWeek
  slots: Array<TimeSlotValue>
}

export type TimeSlotInput = {
  day: DayOfWeek
  slots: Array<TimeSlotValue>
}

export enum TimeSlotValue {
  Morning = 'MORNING',
  Afternoon = 'AFTERNOON',
  Evening = 'EVENING',
}

export type ToggleNotificationReadInput = {
  id: Array<Scalars['ID']>
  read: Scalars['Boolean']
}

export type ToggleNotificationReadResponse =
  | ToggleNotificationReadResult
  | ErrorResult

export type ToggleNotificationReadResult = {
  __typename?: 'ToggleNotificationReadResult'
  failure: Array<Scalars['ID']>
  success: Array<Scalars['ID']>
}

export type TrainerBookingInput = {
  eventId: Scalars['String']
}

export type TrainerBookingResponse = TrainerBookingResult | ErrorResult

export type TrainerBookingResult = {
  __typename?: 'TrainerBookingResult'
  eventAssessments: Array<EventAssessments>
  eventSummary: EventSummary
}

export type TrainerBookingsResponse = TrainerBookingsResult | ErrorResult

export type TrainerBookingsResult = {
  __typename?: 'TrainerBookingsResult'
  result: Array<EventSummary>
}

export type TrainerDetails = {
  __typename?: 'TrainerDetails'
  email: Scalars['String']
  name: Scalars['String']
}

export type TrainingBookedStep = Step & {
  __typename?: 'TrainingBookedStep'
  activeStepName: Scalars['String']
  activeStepNumber: Scalars['Int']
  attended?: Maybe<AttendedStatusEnum>
  cancellationPolicy: Scalars['AWSJSON']
  contactUsEmail: Scalars['String']
  deliveryMethod: DeliveryMethodEnum
  details?: Maybe<Scalars['String']>
  dueDate?: Maybe<Scalars['String']>
  emergencyContact?: Maybe<EmergencyContact>
  endDate: Scalars['String']
  eventName: Scalars['String']
  fulfillment?: Maybe<Scalars['String']>
  level?: Maybe<Scalars['String']>
  onlineTrainingLink?: Maybe<Scalars['String']>
  parqForm?: Maybe<Scalars['String']>
  passPendingGuide: Scalars['AWSJSON']
  programName: Scalars['String']
  requirements?: Maybe<Scalars['String']>
  schedule?: Maybe<Scalars['String']>
  startDate: Scalars['String']
  stepName: Scalars['String']
  stepNumber: Scalars['Int']
  timezone: Scalars['String']
  trackAllocation?: Maybe<Scalars['String']>
  trainerEmail?: Maybe<Scalars['String']>
  trainerName?: Maybe<Scalars['String']>
  venueAddress?: Maybe<Scalars['String']>
}

export type TrainingJourney = {
  __typename?: 'TrainingJourney'
  steps?: Maybe<Array<TrainingStep>>
}

export type TrainingJourneyInput = {
  trainingId: Scalars['ID']
}

export type TrainingJourneyResponse = TrainingJourneyResult | ErrorResult

export type TrainingJourneyResult = {
  __typename?: 'TrainingJourneyResult'
  result?: Maybe<TrainingJourney>
}

export type TrainingJourneysResponse = TrainingJourneysResult | ErrorResult

export type TrainingJourneysResult = {
  __typename?: 'TrainingJourneysResult'
  eventsAndTrainingUrl: Scalars['String']
  trainings?: Maybe<Array<TrainingSummary>>
}

export type TrainingOutcome = {
  __typename?: 'TrainingOutcome'
  assessmentVideo?: Maybe<AssessmentVideo>
  developmentSheet?: Maybe<Scalars['String']>
  outcome?: Maybe<OutcomeEnum>
  submitDate?: Maybe<Scalars['String']>
  trainingNotes?: Maybe<Scalars['String']>
}

export type TrainingStep =
  | TrainingBookedStep
  | PreworkStep
  | AttendTrainingStep
  | SubmitOutcomeTrackStep
  | ReceivedTrainingOutcomeStep
  | SubmitCertificationVideoStep
  | ReceivedCertificationOutcomeStep
  | CertifiedStep
  | ContactUsStep

export type TrainingSummary = {
  __typename?: 'TrainingSummary'
  activeStepName: Scalars['String']
  activeStepNumber: Scalars['Int']
  cecCertificationUrl?: Maybe<Scalars['String']>
  dateCertified?: Maybe<Scalars['String']>
  deliveryMethod: DeliveryMethodEnum
  dueDate?: Maybe<Scalars['String']>
  endDate: Scalars['String']
  eventName: Scalars['String']
  id: Scalars['ID']
  isContactUs: Scalars['Boolean']
  programName: Scalars['String']
  startDate: Scalars['String']
  timezone?: Maybe<Scalars['String']>
  venueAddress?: Maybe<Scalars['String']>
}

export enum TransactionStatusEnum {
  InProgress = 'IN_PROGRESS',
  Done = 'DONE',
  Failed = 'FAILED',
}

export type TravelPreference = {
  __typename?: 'TravelPreference'
  address?: Maybe<Address>
  distance?: Maybe<Scalars['Int']>
  distanceUnit?: Maybe<LocationDistanceUnit>
}

export type TravelPreferenceInput = {
  address?: Maybe<AddressInput>
  distance?: Maybe<Scalars['Int']>
}

export type Url = {
  __typename?: 'URL'
  type: UrlType
  value: Scalars['String']
}

export type UrlInput = {
  type: UrlType
  value: Scalars['String']
}

export enum UrlType {
  Internal = 'INTERNAL',
  External = 'EXTERNAL',
}

export type UpdateAccountSettingsResponse =
  | UserAccountSettingsResult
  | ErrorResult

export type UpdateAffiliationInput = {
  id: Scalars['String']
  status: AffiliationStatus
}

export type UpdateClubListingInput = {
  clubId: Scalars['ID']
  description?: Maybe<Scalars['String']>
  expiringAt?: Maybe<Scalars['AWSDateTime']>
  id: Scalars['ID']
  programs?: Maybe<Array<Scalars['String']>>
  status?: Maybe<ClubListingStatus>
  times?: Maybe<Array<TimePreferenceInput>>
}

export type UpdateClubListingResponse = ClubListingResult | ErrorResult

export type UpdateClubProfileInput = {
  address?: Maybe<AddressInput>
  bio?: Maybe<Scalars['String']>
  hidden?: Maybe<Scalars['Boolean']>
  hiring?: Maybe<Scalars['Boolean']>
  id: Scalars['ID']
  links?: Maybe<Array<ProfileLinkInput>>
  media?: Maybe<Array<ImageInput>>
}

export type UpdateClubProfileResponse = UserResult | ErrorResult

export type UpdateCurrentUserPortfolioUploadInput = {
  cancelTokens?: Maybe<Array<Scalars['String']>>
  confirmTokens?: Maybe<Array<Scalars['String']>>
  removeImages?: Maybe<Array<Scalars['ID']>>
}

export type UpdateCurrentUserPortfolioUploadResponse =
  | UpdateCurrentUserPortfolioUploadResult
  | ErrorResult

export type UpdateCurrentUserPortfolioUploadResult = {
  __typename?: 'UpdateCurrentUserPortfolioUploadResult'
  profile: UserProfile
  url: Array<Scalars['String']>
}

export type UpdateProfileResponse = UserResult | ErrorResult

export type UpdateTeachingProfileInput = {
  address?: Maybe<AddressInput>
  availability?: Maybe<InstructorAvailabilityValue>
  availableToSubstitute?: Maybe<Scalars['Boolean']>
  bio?: Maybe<Scalars['String']>
  interests?: Maybe<Array<Scalars['String']>>
  links?: Maybe<Array<ProfileLinkInput>>
  media?: Maybe<Array<ImageInput>>
  preferences?: Maybe<InstructorPreferencesInput>
  privacySettings?: Maybe<PrivacySettingsInstructorInput>
}

export type UpdateTeachingProfileResponse = UserResult | ErrorResult

export type UpdateUserAccountInput = {
  address?: Maybe<AddressInput>
  email?: Maybe<Scalars['String']>
  firstName?: Maybe<Scalars['String']>
  id: Scalars['ID']
  lastName?: Maybe<Scalars['String']>
  phone?: Maybe<Scalars['String']>
}

export type UpdateUserPhotoInput = {
  profileId: Scalars['ID']
  profileType: UserProfileType
  token: Scalars['String']
}

export type UpdateUserPhotoResponse = UpdateUserPhotoResult | ErrorResult

export type UpdateUserPhotoResult = {
  __typename?: 'UpdateUserPhotoResult'
  profile: UserProfile
  url: Scalars['AWSURL']
}

export type UpsertAgreementInput = {
  content: Scalars['String']
  market: Scalars['String']
  type: AgreementType
  version: Scalars['String']
}

export type UpsertAgreementResponse = UpsertAgreementResult | ErrorResult

export type UpsertAgreementResult = {
  __typename?: 'UpsertAgreementResult'
  result: AgreementDocument
}

export type UpsertClubInput = {
  accountId: Scalars['ID']
  address: AddressInput
  affiliations: Array<AffiliationInput>
  currency: Currency
  customerId?: Maybe<Scalars['String']>
  email?: Maybe<EmailClubTypeInput>
  enquiries?: Maybe<Array<EnquiryInput>>
  hiring?: Maybe<Scalars['Boolean']>
  location: GeoPointInput
  market: Scalars['String']
  name: Scalars['String']
  parent?: Maybe<Scalars['String']>
  phone?: Maybe<Scalars['String']>
  products?: Maybe<Array<UpsertClubProductsInput>>
  programs?: Maybe<Array<UpsertClubProgramsInput>>
  releaseBundleType?: Maybe<ReleaseBundleTypeEnum>
}

export type UpsertClubProductsInput = {
  category?: Maybe<ProgramTypeEnum>
  displayName: Scalars['String']
  id?: Maybe<Scalars['ID']>
  name: Scalars['String']
  startDate: Scalars['AWSDateTime']
  status: ProgramStatus
}

export type UpsertClubProgramsInput = {
  category?: Maybe<ProgramTypeEnum>
  displayName: Scalars['String']
  id?: Maybe<Scalars['ID']>
  name: Scalars['String']
  startDate?: Maybe<Scalars['AWSDateTime']>
  status: ProgramStatus
}

export type UpsertClubResponse = UpsertClubResult | ErrorResult

export type UpsertClubResult = {
  __typename?: 'UpsertClubResult'
  club: Club
}

export type UpsertPricebookInput = {
  filename: Scalars['String']
}

export type UpsertPricebookResponse = UpsertPricebookResult | ErrorResult

export type UpsertPricebookResult = {
  __typename?: 'UpsertPricebookResult'
  success?: Maybe<Scalars['Boolean']>
}

export type UpsertUserInput = {
  accountId: Scalars['String']
  address: AddressInput
  affiliations: Array<AffiliationInput>
  billing?: Maybe<UserBillingInput>
  certifications?: Maybe<Array<InstructorCertificationInput>>
  email: Scalars['AWSEmail']
  firstName: Scalars['String']
  lastName: Scalars['String']
  location?: Maybe<GeoPointInput>
  magentoStoreProfile?: Maybe<MagentoStoreProfileInput>
  market: Scalars['String']
  personContactId: Scalars['String']
  phone?: Maybe<Scalars['String']>
  roles?: Maybe<Array<InstructorRole>>
}

export type UpsertUserResponse = UpsertUserResult | ErrorResult

export type UpsertUserResult = {
  __typename?: 'UpsertUserResult'
  user: User
}

export type User = {
  __typename?: 'User'
  accountId: Scalars['ID']
  affiliations?: Maybe<Array<Affiliation>>
  email?: Maybe<Scalars['AWSEmail']>
  external?: Maybe<UserExternalInfo>
  firstName: Scalars['String']
  id: Scalars['ID']
  instructorProfile?: Maybe<UserProfileTeaching>
  lastName: Scalars['String']
  market: Market
  phone?: Maybe<Scalars['String']>
  signedAgreements?: Maybe<Array<SignedAgreement>>
  userMetaData?: Maybe<UserMetadata>
}

export type UserAccountSettingsResult = {
  __typename?: 'UserAccountSettingsResult'
  address?: Maybe<Address>
  email?: Maybe<Scalars['String']>
  firstName?: Maybe<Scalars['String']>
  id: Scalars['ID']
  lastName?: Maybe<Scalars['String']>
  outlinks?: Maybe<Array<OutLink>>
  phone?: Maybe<Scalars['String']>
}

export type UserBillingInput = {
  creditCardExpiry?: Maybe<Scalars['String']>
  creditCardExpiryDate?: Maybe<Scalars['AWSDateTime']>
  paymentMethod?: Maybe<Scalars['String']>
}

export type UserEnquiriesFilter = {
  programs?: Maybe<Array<Scalars['String']>>
  sortBy?: Maybe<UserEnquiriesSort>
  status?: Maybe<Array<ClubListingStatus>>
}

export enum UserEnquiriesSort {
  ClubName = 'CLUB_NAME',
  MostRecent = 'MOST_RECENT',
}

export type UserEnquiry = {
  __typename?: 'UserEnquiry'
  listing: EnquiryClubListingSingleResult
  message: Message
}

export type UserExternalInfo = {
  __typename?: 'UserExternalInfo'
  accountId: Scalars['ID']
  contactId?: Maybe<Scalars['String']>
}

export type UserMetadata = {
  __typename?: 'UserMetadata'
  walkthroughRequired: WalkthroughRequired
}

export type UserProfile = UserProfileTeaching | UserProfileClub

export type UserProfileClub = {
  __typename?: 'UserProfileClub'
  address: Address
  atHomeProducts?: Maybe<GetAtHomeProductTilesResult>
  bio?: Maybe<Scalars['String']>
  businessSupport?: Maybe<Array<BusinessSupportSection>>
  createdAt: Scalars['AWSDateTime']
  createdAtLabel?: Maybe<Scalars['String']>
  email?: Maybe<Scalars['AWSEmail']>
  enquiries?: Maybe<Array<ClubListingEnquiry>>
  exploreProgramsCard?: Maybe<InStudioExploreProgramsTileCardResult>
  hiring?: Maybe<Scalars['Boolean']>
  id: Scalars['ID']
  inStudioToolkit?: Maybe<GetInStudioToolkitResult>
  isDigitalOnly?: Maybe<Scalars['Boolean']>
  links?: Maybe<Array<ProfileLink>>
  listings?: Maybe<Array<ClubListing>>
  media?: Maybe<Array<Image>>
  name: Scalars['String']
  phone?: Maybe<Scalars['String']>
  profileImage?: Maybe<Image>
  programs?: Maybe<Array<ClubProgramContent>>
  shortlist?: Maybe<Array<InstructorShortlist>>
  strength?: Maybe<Scalars['Int']>
}

export type UserProfileTeaching = {
  __typename?: 'UserProfileTeaching'
  address: Address
  availability?: Maybe<InstructorAvailabilityValue>
  availableToSubstitute?: Maybe<Scalars['Boolean']>
  bio?: Maybe<Scalars['String']>
  certifications?: Maybe<Array<Certification>>
  createdAt: Scalars['AWSDateTime']
  createdAtLabel?: Maybe<Scalars['String']>
  enquiries?: Maybe<Array<ClubListingEnquiry>>
  id: Scalars['ID']
  interests?: Maybe<Array<Scalars['String']>>
  links?: Maybe<Array<ProfileLink>>
  media?: Maybe<Array<Image>>
  preferences?: Maybe<InstructorPreferences>
  privacySettings?: Maybe<PrivacySettingsInstructor>
  profileImage?: Maybe<Image>
  roles?: Maybe<Array<InstructorRole>>
  savedSearches?: Maybe<Array<SavedClubSearch>>
  strength?: Maybe<Scalars['Int']>
  watchlist?: Maybe<Array<InstructorWatchlistItem>>
}

export enum UserProfileType {
  Instructor = 'INSTRUCTOR',
  Unknown = 'UNKNOWN',
  Club = 'CLUB',
}

export type UserResult = {
  __typename?: 'UserResult'
  distance?: Maybe<Scalars['Float']>
  distanceUnit?: Maybe<LocationDistanceUnit>
  id: Scalars['ID']
  profiles: Array<UserProfile>
  settings: UserSettings
  user: User
}

export type UserRoleInput = {
  id: Scalars['String']
  roleType: UserRoleType
}

export enum UserRoleType {
  Instructor = 'INSTRUCTOR',
  Club = 'CLUB',
  Unknown = 'UNKNOWN',
}

export type UserSettings = {
  __typename?: 'UserSettings'
  _debugIsAdmin?: Maybe<Scalars['Boolean']>
  _debugIsAffiliated?: Maybe<Scalars['Boolean']>
  locale: Locale
}

export type Walkthrough = {
  __typename?: 'Walkthrough'
  pages: Array<WalkthroughPage>
  totalPages: Scalars['Int']
}

export type WalkthroughPage = {
  __typename?: 'WalkthroughPage'
  body: Array<Maybe<Scalars['AWSJSON']>>
  image: ImageSet
  pageNumber: Scalars['Int']
  title: Scalars['String']
}

export type WalkthroughRequired = {
  __typename?: 'WalkthroughRequired'
  club: Scalars['Boolean']
  instructor: Scalars['Boolean']
}

export type SearchAfter = {
  __typename?: 'searchAfter'
  eventId: Scalars['String']
  sortValues: Array<Scalars['String']>
}

export type SearchAfterInput = {
  eventId: Scalars['String']
  sortValues: Array<Scalars['String']>
}

export type InStudioClubProgramFragment = { __typename?: 'ClubProgram' } & Pick<
  ClubProgram,
  'id' | 'code' | 'name' | 'status' | 'initials' | 'programType'
> & {
    instructorCount?: Maybe<
      { __typename?: 'ProgramInstructorCount' } & Pick<
        ProgramInstructorCount,
        'numberOfInstructors' | 'belowRecommendedAmount' | 'lastEnquiredOn'
      >
    >
  }

export type InStudioEmptyStateFragment = {
  __typename?: 'ClubProgramInStudioEmptyState'
} & Pick<ClubProgramInStudioEmptyState, 'programType'> & {
    content?: Maybe<
      { __typename?: 'InStudioEmptyState' } & Pick<
        InStudioEmptyState,
        'subtitle' | 'title'
      > & { link: { __typename?: 'Link' } & LinkFieldsFragment }
    >
  }

export type InStudioToolkitTileFragment = {
  __typename?: 'InStudioToolkitTile'
} & Pick<InStudioToolkitTile, 'subTitle' | 'title'> & {
    image: { __typename?: 'Image' } & ImageFieldsFragment
    link: { __typename?: 'Link' } & LinkFieldsFragment
  }

export type GetClubProgramsForInStudioPageQueryVariables = Exact<{
  input: GetClubByIdInput
  _cacheKey?: Maybe<Scalars['String']>
}>

export type GetClubProgramsForInStudioPageQuery = { __typename?: 'Query' } & {
  getClubById?: Maybe<
    | ({ __typename?: 'UserProfileClub' } & {
        programs?: Maybe<
          Array<
            | ({ __typename?: 'ClubProgram' } & InStudioClubProgramFragment)
            | ({
                __typename?: 'ClubProgramInStudioEmptyState'
              } & InStudioEmptyStateFragment)
          >
        >
        inStudioToolkit?: Maybe<
          { __typename?: 'GetInStudioToolkitResult' } & {
            tiles?: Maybe<
              Array<
                Maybe<
                  {
                    __typename?: 'InStudioToolkitTile'
                  } & InStudioToolkitTileFragment
                >
              >
            >
          }
        >
        exploreProgramsCard?: Maybe<
          { __typename?: 'InStudioExploreProgramsTileCardResult' } & {
            image?: Maybe<{ __typename?: 'Image' } & ImageFieldsFragment>
          }
        >
      })
    | ({ __typename?: 'ErrorResult' } & Pick<ErrorResult, 'type' | 'message'>)
  >
}

export type AddTrainingOutcomeMutationVariables = Exact<{
  input: AddTrainingOutcomeInput
  _cacheKey?: Maybe<Scalars['String']>
}>

export type AddTrainingOutcomeMutation = { __typename?: 'Mutation' } & {
  addTrainingOutcome:
    | ({ __typename?: 'AddTrainingOutcomeResult' } & Pick<
        AddTrainingOutcomeResult,
        'isSuccess'
      > & {
          developmentSheet?: Maybe<
            { __typename?: 'DevelopmentSheet' } & Pick<
              DevelopmentSheet,
              'filename' | 'url'
            >
          >
        })
    | ({ __typename?: 'ErrorResult' } & ErrorResultFieldsFragment)
}

export type BookEventMutationVariables = Exact<{
  input: BookEventInput
  role: UserRoleInput
}>

export type BookEventMutation = { __typename?: 'Mutation' } & {
  bookEvent:
    | ({ __typename?: 'BookEventResult' } & Pick<
        BookEventResult,
        'magentoLink'
      >)
    | ({ __typename?: 'ErrorResult' } & ErrorResultFieldsFragment)
}

export type BookedEventQueryVariables = Exact<{
  eventId: Scalars['String']
  role: UserRoleInput
  _cacheKey?: Maybe<Scalars['String']>
}>

export type BookedEventQuery = { __typename?: 'Query' } & {
  bookedEvent:
    | ({ __typename?: 'BookedEventResult' } & {
        eventDetails: { __typename?: 'EventDetailsResult' } & Pick<
          EventDetailsResult,
          'schedule' | 'details' | 'requirements' | 'cancellationPolicy'
        > & {
            event: { __typename?: 'Event' } & Pick<
              Event,
              | 'eventId'
              | 'eventName'
              | 'startDate'
              | 'endDate'
              | 'deliveryMethod'
              | 'spacesAvailable'
              | 'venueAddress'
              | 'programName'
              | 'timezone'
            >
            trainerDetails?: Maybe<
              { __typename?: 'TrainerDetails' } & Pick<
                TrainerDetails,
                'name' | 'email'
              >
            >
          }
        bookedInstructors?: Maybe<
          Array<
            { __typename?: 'InstructorDetails' } & Pick<
              InstructorDetails,
              'name'
            > & {
                profileImage?: Maybe<
                  { __typename?: 'Image' } & Pick<Image, 'url'>
                >
              }
          >
        >
      })
    | ({ __typename?: 'ErrorResult' } & ErrorResultFieldsFragment)
}

export type BookedEventsQueryVariables = Exact<{
  clubId: Scalars['String']
  _cacheKey?: Maybe<Scalars['String']>
}>

export type BookedEventsQuery = { __typename?: 'Query' } & {
  bookedEvents:
    | ({ __typename?: 'BookedEventsResult' } & {
        bookedEvents?: Maybe<
          Array<
            { __typename?: 'BookedEvent' } & Pick<
              BookedEvent,
              'numberOfBookedInstructors'
            > & {
                event: { __typename?: 'Event' } & Pick<
                  Event,
                  | 'eventId'
                  | 'eventName'
                  | 'startDate'
                  | 'endDate'
                  | 'deliveryMethod'
                  | 'spacesAvailable'
                  | 'venueAddress'
                  | 'programName'
                >
              }
          >
        >
      })
    | ({ __typename?: 'ErrorResult' } & ErrorResultFieldsFragment)
}

export type EventDetailsQueryVariables = Exact<{
  eventId: Scalars['String']
  role: UserRoleInput
  _cacheKey?: Maybe<Scalars['String']>
}>

export type EventDetailsQuery = { __typename?: 'Query' } & {
  eventDetails:
    | ({ __typename?: 'EventDetailsResult' } & Pick<
        EventDetailsResult,
        'schedule' | 'details' | 'requirements' | 'cancellationPolicy'
      > & {
          event: { __typename?: 'Event' } & Pick<
            Event,
            | 'eventId'
            | 'eventName'
            | 'startDate'
            | 'endDate'
            | 'deliveryMethod'
            | 'spacesAvailable'
            | 'venueAddress'
            | 'programName'
            | 'timezone'
          >
          trainerDetails?: Maybe<
            { __typename?: 'TrainerDetails' } & Pick<
              TrainerDetails,
              'name' | 'email'
            >
          >
          tickets: Array<
            { __typename?: 'Ticket' } & Pick<
              Ticket,
              | 'ticketId'
              | 'name'
              | 'currencyIsoCode'
              | 'price'
              | 'startDate'
              | 'endDate'
              | 'isDefaultTicket'
              | 'canBeUsedWithDiscountCode'
            >
          >
        })
    | ({ __typename?: 'ErrorResult' } & ErrorResultFieldsFragment)
}

export type InstructorInfoFieldsFragment = {
  __typename?: 'InstructorInformation'
} & Pick<InstructorInformation, 'address' | 'email' | 'name' | 'phone'>

export type DevelopmentSheetFieldsFragment = {
  __typename?: 'DevelopmentSheet'
} & Pick<DevelopmentSheet, 'filename' | 'url'>

export type OutcomeTrackFieldsFragment = { __typename?: 'OutcomeTrack' } & Pick<
  OutcomeTrack,
  'comment' | 'submittedAt'
> & { playback: { __typename?: 'Playback' } & PlaybackFieldsFragment }

export type PresentationTrackFieldsFragment = {
  __typename?: 'PresentationTrack'
} & Pick<PresentationTrack, 'comment' | 'submittedAt'> & {
    playback: { __typename?: 'Playback' } & PlaybackFieldsFragment
  }

export type EventSummaryFieldsFragment = { __typename?: 'EventSummary' } & Pick<
  EventSummary,
  | 'deliveryMethod'
  | 'endDate'
  | 'eventId'
  | 'eventName'
  | 'eventStatus'
  | 'programName'
  | 'startDate'
  | 'trainingJourneyCount'
  | 'venueAddress'
>

export type EventAssessmentFieldsFragment = {
  __typename?: 'EventAssessments'
} & Pick<
  EventAssessments,
  | 'attended'
  | 'outcome'
  | 'sessionRegistrationId'
  | 'trainingJourneyId'
  | 'trackAllocation'
> & {
    developmentSheet?: Maybe<
      { __typename?: 'DevelopmentSheet' } & DevelopmentSheetFieldsFragment
    >
    emergencyContact?: Maybe<
      { __typename?: 'EmergencyContact' } & EmergencyContactFieldsFragment
    >
    instructorInfo: {
      __typename?: 'InstructorInformation'
    } & InstructorInfoFieldsFragment
    outcomeTrack?: Maybe<
      { __typename?: 'OutcomeTrack' } & OutcomeTrackFieldsFragment
    >
    presentationTrack?: Maybe<
      { __typename?: 'PresentationTrack' } & PresentationTrackFieldsFragment
    >
  }

export type TrainerBookingQueryVariables = Exact<{
  input: TrainerBookingInput
  _cacheKey?: Maybe<Scalars['String']>
}>

export type TrainerBookingQuery = { __typename?: 'Query' } & {
  trainerBooking:
    | ({ __typename?: 'TrainerBookingResult' } & {
        eventAssessments: Array<
          { __typename?: 'EventAssessments' } & EventAssessmentFieldsFragment
        >
        eventSummary: {
          __typename?: 'EventSummary'
        } & EventSummaryFieldsFragment
      })
    | ({ __typename?: 'ErrorResult' } & ErrorResultFieldsFragment)
}

export type TrainerBookingsQueryVariables = Exact<{
  _cacheKey?: Maybe<Scalars['String']>
}>

export type TrainerBookingsQuery = { __typename?: 'Query' } & {
  trainerBookings:
    | ({ __typename?: 'TrainerBookingsResult' } & {
        result: Array<
          { __typename?: 'EventSummary' } & Pick<
            EventSummary,
            | 'deliveryMethod'
            | 'endDate'
            | 'eventId'
            | 'eventName'
            | 'programName'
            | 'startDate'
            | 'eventStatus'
            | 'trainingJourneyCount'
            | 'venueAddress'
          >
        >
      })
    | ({ __typename?: 'ErrorResult' } & ErrorResultFieldsFragment)
}

export type PlaybackFieldsFragment = { __typename?: 'Playback' } & Pick<
  Playback,
  'playbackUrl' | 'token'
>

export type AssessmentVideoFieldsFragment = {
  __typename?: 'AssessmentVideo'
} & Pick<
  AssessmentVideo,
  | 'assessmentId'
  | 'comment'
  | 'fileKey'
  | 'submitted'
  | 'submittedDate'
  | 'recordType'
  | 'videoNotWorking'
  | 'extensionRequested'
> & { playback?: Maybe<{ __typename?: 'Playback' } & PlaybackFieldsFragment> }

export type EmergencyContactFieldsFragment = {
  __typename?: 'EmergencyContact'
} & Pick<EmergencyContact, 'address' | 'name' | 'phone'>

export type TrainingOutcomeFieldsFragment = {
  __typename?: 'TrainingOutcome'
} & Pick<
  TrainingOutcome,
  'developmentSheet' | 'outcome' | 'submitDate' | 'trainingNotes'
> & {
    assessmentVideo?: Maybe<
      { __typename?: 'AssessmentVideo' } & AssessmentVideoFieldsFragment
    >
  }

type StepFields_AttendTrainingStep_Fragment = {
  __typename?: 'AttendTrainingStep'
} & Pick<
  AttendTrainingStep,
  | 'activeStepName'
  | 'activeStepNumber'
  | 'attended'
  | 'cancellationPolicy'
  | 'passPendingGuide'
  | 'deliveryMethod'
  | 'details'
  | 'dueDate'
  | 'endDate'
  | 'eventName'
  | 'fulfillment'
  | 'level'
  | 'onlineTrainingLink'
  | 'programName'
  | 'requirements'
  | 'schedule'
  | 'startDate'
  | 'stepName'
  | 'stepNumber'
  | 'timezone'
  | 'trackAllocation'
  | 'trainerEmail'
  | 'trainerName'
  | 'venueAddress'
  | 'contactUsEmail'
>

type StepFields_PreworkStep_Fragment = { __typename?: 'PreworkStep' } & Pick<
  PreworkStep,
  | 'activeStepName'
  | 'activeStepNumber'
  | 'attended'
  | 'cancellationPolicy'
  | 'passPendingGuide'
  | 'deliveryMethod'
  | 'details'
  | 'dueDate'
  | 'endDate'
  | 'eventName'
  | 'fulfillment'
  | 'level'
  | 'onlineTrainingLink'
  | 'programName'
  | 'requirements'
  | 'schedule'
  | 'startDate'
  | 'stepName'
  | 'stepNumber'
  | 'timezone'
  | 'trackAllocation'
  | 'trainerEmail'
  | 'trainerName'
  | 'venueAddress'
  | 'contactUsEmail'
>

type StepFields_ReceivedCertificationOutcomeStep_Fragment = {
  __typename?: 'ReceivedCertificationOutcomeStep'
} & Pick<
  ReceivedCertificationOutcomeStep,
  | 'activeStepName'
  | 'activeStepNumber'
  | 'attended'
  | 'cancellationPolicy'
  | 'passPendingGuide'
  | 'deliveryMethod'
  | 'details'
  | 'dueDate'
  | 'endDate'
  | 'eventName'
  | 'fulfillment'
  | 'level'
  | 'onlineTrainingLink'
  | 'programName'
  | 'requirements'
  | 'schedule'
  | 'startDate'
  | 'stepName'
  | 'stepNumber'
  | 'timezone'
  | 'trackAllocation'
  | 'trainerEmail'
  | 'trainerName'
  | 'venueAddress'
  | 'contactUsEmail'
>

type StepFields_ReceivedTrainingOutcomeStep_Fragment = {
  __typename?: 'ReceivedTrainingOutcomeStep'
} & Pick<
  ReceivedTrainingOutcomeStep,
  | 'activeStepName'
  | 'activeStepNumber'
  | 'attended'
  | 'cancellationPolicy'
  | 'passPendingGuide'
  | 'deliveryMethod'
  | 'details'
  | 'dueDate'
  | 'endDate'
  | 'eventName'
  | 'fulfillment'
  | 'level'
  | 'onlineTrainingLink'
  | 'programName'
  | 'requirements'
  | 'schedule'
  | 'startDate'
  | 'stepName'
  | 'stepNumber'
  | 'timezone'
  | 'trackAllocation'
  | 'trainerEmail'
  | 'trainerName'
  | 'venueAddress'
  | 'contactUsEmail'
>

type StepFields_SubmitCertificationVideoStep_Fragment = {
  __typename?: 'SubmitCertificationVideoStep'
} & Pick<
  SubmitCertificationVideoStep,
  | 'activeStepName'
  | 'activeStepNumber'
  | 'attended'
  | 'cancellationPolicy'
  | 'passPendingGuide'
  | 'deliveryMethod'
  | 'details'
  | 'dueDate'
  | 'endDate'
  | 'eventName'
  | 'fulfillment'
  | 'level'
  | 'onlineTrainingLink'
  | 'programName'
  | 'requirements'
  | 'schedule'
  | 'startDate'
  | 'stepName'
  | 'stepNumber'
  | 'timezone'
  | 'trackAllocation'
  | 'trainerEmail'
  | 'trainerName'
  | 'venueAddress'
  | 'contactUsEmail'
>

type StepFields_SubmitOutcomeTrackStep_Fragment = {
  __typename?: 'SubmitOutcomeTrackStep'
} & Pick<
  SubmitOutcomeTrackStep,
  | 'activeStepName'
  | 'activeStepNumber'
  | 'attended'
  | 'cancellationPolicy'
  | 'passPendingGuide'
  | 'deliveryMethod'
  | 'details'
  | 'dueDate'
  | 'endDate'
  | 'eventName'
  | 'fulfillment'
  | 'level'
  | 'onlineTrainingLink'
  | 'programName'
  | 'requirements'
  | 'schedule'
  | 'startDate'
  | 'stepName'
  | 'stepNumber'
  | 'timezone'
  | 'trackAllocation'
  | 'trainerEmail'
  | 'trainerName'
  | 'venueAddress'
  | 'contactUsEmail'
>

type StepFields_TrainingBookedStep_Fragment = {
  __typename?: 'TrainingBookedStep'
} & Pick<
  TrainingBookedStep,
  | 'activeStepName'
  | 'activeStepNumber'
  | 'attended'
  | 'cancellationPolicy'
  | 'passPendingGuide'
  | 'deliveryMethod'
  | 'details'
  | 'dueDate'
  | 'endDate'
  | 'eventName'
  | 'fulfillment'
  | 'level'
  | 'onlineTrainingLink'
  | 'programName'
  | 'requirements'
  | 'schedule'
  | 'startDate'
  | 'stepName'
  | 'stepNumber'
  | 'timezone'
  | 'trackAllocation'
  | 'trainerEmail'
  | 'trainerName'
  | 'venueAddress'
  | 'contactUsEmail'
>

export type StepFieldsFragment =
  | StepFields_AttendTrainingStep_Fragment
  | StepFields_PreworkStep_Fragment
  | StepFields_ReceivedCertificationOutcomeStep_Fragment
  | StepFields_ReceivedTrainingOutcomeStep_Fragment
  | StepFields_SubmitCertificationVideoStep_Fragment
  | StepFields_SubmitOutcomeTrackStep_Fragment
  | StepFields_TrainingBookedStep_Fragment

export type TrainingBookedStepFieldsFragment = {
  __typename?: 'TrainingBookedStep'
} & Pick<
  TrainingBookedStep,
  | 'activeStepName'
  | 'activeStepNumber'
  | 'attended'
  | 'cancellationPolicy'
  | 'passPendingGuide'
  | 'deliveryMethod'
  | 'details'
  | 'dueDate'
  | 'endDate'
  | 'eventName'
  | 'fulfillment'
  | 'level'
  | 'onlineTrainingLink'
  | 'programName'
  | 'requirements'
  | 'schedule'
  | 'startDate'
  | 'stepName'
  | 'stepNumber'
  | 'timezone'
  | 'trackAllocation'
  | 'trainerEmail'
  | 'trainerName'
  | 'parqForm'
  | 'venueAddress'
  | 'contactUsEmail'
> & {
    emergencyContact?: Maybe<
      { __typename?: 'EmergencyContact' } & EmergencyContactFieldsFragment
    >
  }

export type UrlFieldsFragment = { __typename?: 'URL' } & Pick<
  Url,
  'type' | 'value'
>

export type PreworkContentItemFieldsFragment = {
  __typename?: 'PreworkContentItem'
} & Pick<PreworkContentItem, 'title' | 'type'> & {
    url: { __typename?: 'URL' } & UrlFieldsFragment
  }

export type PreworkContentFieldsFragment = { __typename?: 'PreworkContent' } & {
  contentList?: Maybe<
    Array<
      { __typename?: 'PreworkContentItem' } & PreworkContentItemFieldsFragment
    >
  >
}

export type PreworkStepFieldsFragment = { __typename?: 'PreworkStep' } & Pick<
  PreworkStep,
  | 'activeStepName'
  | 'activeStepNumber'
  | 'attended'
  | 'cancellationPolicy'
  | 'passPendingGuide'
  | 'deliveryMethod'
  | 'details'
  | 'dueDate'
  | 'endDate'
  | 'eventName'
  | 'fulfillment'
  | 'level'
  | 'onlineTrainingLink'
  | 'programName'
  | 'requirements'
  | 'schedule'
  | 'startDate'
  | 'stepName'
  | 'stepNumber'
  | 'timezone'
  | 'trackAllocation'
  | 'trainerEmail'
  | 'trainerName'
  | 'venueAddress'
  | 'contactUsEmail'
> & {
    assessmentVideo?: Maybe<
      { __typename?: 'AssessmentVideo' } & AssessmentVideoFieldsFragment
    >
    preworkContent?: Maybe<
      { __typename?: 'PreworkContent' } & PreworkContentFieldsFragment
    >
    releaseUrl?: Maybe<{ __typename?: 'Link' } & LinkFieldsFragment>
  }

export type AttendTrainingStepFieldsFragment = {
  __typename?: 'AttendTrainingStep'
} & Pick<
  AttendTrainingStep,
  | 'activeStepName'
  | 'activeStepNumber'
  | 'attended'
  | 'cancellationPolicy'
  | 'passPendingGuide'
  | 'deliveryMethod'
  | 'details'
  | 'dueDate'
  | 'endDate'
  | 'eventName'
  | 'fulfillment'
  | 'level'
  | 'onlineTrainingLink'
  | 'programName'
  | 'requirements'
  | 'schedule'
  | 'startDate'
  | 'stepName'
  | 'stepNumber'
  | 'timezone'
  | 'trackAllocation'
  | 'trainerEmail'
  | 'trainerName'
  | 'venueAddress'
  | 'contactUsEmail'
>

export type SubmitOutcomeTrackStepFieldsFragment = {
  __typename?: 'SubmitOutcomeTrackStep'
} & Pick<
  SubmitOutcomeTrackStep,
  | 'activeStepName'
  | 'activeStepNumber'
  | 'attended'
  | 'cancellationPolicy'
  | 'passPendingGuide'
  | 'deliveryMethod'
  | 'details'
  | 'dueDate'
  | 'endDate'
  | 'eventName'
  | 'fulfillment'
  | 'level'
  | 'onlineTrainingLink'
  | 'programName'
  | 'requirements'
  | 'schedule'
  | 'startDate'
  | 'stepName'
  | 'stepNumber'
  | 'timezone'
  | 'trackAllocation'
  | 'trainerEmail'
  | 'trainerName'
  | 'extendedDueDate'
  | 'venueAddress'
  | 'contactUsEmail'
> & {
    assessmentVideo?: Maybe<
      { __typename?: 'AssessmentVideo' } & AssessmentVideoFieldsFragment
    >
  }

export type ReceivedTrainingOutcomeStepFieldsFragment = {
  __typename?: 'ReceivedTrainingOutcomeStep'
} & Pick<
  ReceivedTrainingOutcomeStep,
  | 'activeStepName'
  | 'activeStepNumber'
  | 'attended'
  | 'cancellationPolicy'
  | 'passPendingGuide'
  | 'deliveryMethod'
  | 'details'
  | 'dueDate'
  | 'endDate'
  | 'eventName'
  | 'fulfillment'
  | 'level'
  | 'onlineTrainingLink'
  | 'programName'
  | 'requirements'
  | 'schedule'
  | 'startDate'
  | 'stepName'
  | 'stepNumber'
  | 'timezone'
  | 'trackAllocation'
  | 'trainerEmail'
  | 'trainerName'
  | 'cecCertificationUrl'
  | 'extendedDueDate'
  | 'venueAddress'
  | 'contactUsEmail'
> & {
    assessmentOutcomes?: Maybe<
      Array<{ __typename?: 'TrainingOutcome' } & TrainingOutcomeFieldsFragment>
    >
  }

export type SubmitCertificationVideoStepFieldsFragment = {
  __typename?: 'SubmitCertificationVideoStep'
} & Pick<
  SubmitCertificationVideoStep,
  | 'activeStepName'
  | 'activeStepNumber'
  | 'attended'
  | 'cancellationPolicy'
  | 'passPendingGuide'
  | 'deliveryMethod'
  | 'details'
  | 'dueDate'
  | 'endDate'
  | 'eventName'
  | 'fulfillment'
  | 'level'
  | 'onlineTrainingLink'
  | 'programName'
  | 'requirements'
  | 'schedule'
  | 'startDate'
  | 'stepName'
  | 'stepNumber'
  | 'timezone'
  | 'trackAllocation'
  | 'trainerEmail'
  | 'trainerName'
  | 'extendedDueDate'
  | 'venueAddress'
  | 'contactUsEmail'
> & {
    assessmentVideo?: Maybe<
      { __typename?: 'AssessmentVideo' } & AssessmentVideoFieldsFragment
    >
  }

export type ReceivedCertificationOutcomeStepFieldsFragment = {
  __typename?: 'ReceivedCertificationOutcomeStep'
} & Pick<
  ReceivedCertificationOutcomeStep,
  | 'activeStepName'
  | 'activeStepNumber'
  | 'attended'
  | 'cancellationPolicy'
  | 'passPendingGuide'
  | 'deliveryMethod'
  | 'details'
  | 'dueDate'
  | 'endDate'
  | 'eventName'
  | 'fulfillment'
  | 'level'
  | 'onlineTrainingLink'
  | 'programName'
  | 'requirements'
  | 'schedule'
  | 'startDate'
  | 'stepName'
  | 'stepNumber'
  | 'timezone'
  | 'trackAllocation'
  | 'trainerEmail'
  | 'trainerName'
  | 'resubmitDueDate'
  | 'certificationUrl'
  | 'venueAddress'
  | 'contactUsEmail'
> & {
    certificationOutcomes?: Maybe<
      Array<{ __typename?: 'TrainingOutcome' } & TrainingOutcomeFieldsFragment>
    >
  }

export type CertifiedStepFieldsFragment = {
  __typename?: 'CertifiedStep'
} & Pick<
  CertifiedStep,
  | 'activeStepName'
  | 'activeStepNumber'
  | 'attended'
  | 'cancellationPolicy'
  | 'deliveryMethod'
  | 'details'
  | 'dueDate'
  | 'endDate'
  | 'eventName'
  | 'fulfillment'
  | 'level'
  | 'onlineTrainingLink'
  | 'passPendingGuide'
  | 'programName'
  | 'requirements'
  | 'schedule'
  | 'startDate'
  | 'stepName'
  | 'stepNumber'
  | 'timezone'
  | 'trackAllocation'
  | 'trainerEmail'
  | 'trainerName'
  | 'contactUsEmail'
  | 'venueAddress'
>

export type TrainingJourneyQueryVariables = Exact<{
  input: TrainingJourneyInput
  role?: Maybe<UserRoleInput>
  _cacheKey?: Maybe<Scalars['String']>
}>

export type TrainingJourneyQuery = { __typename?: 'Query' } & {
  trainingJourney:
    | ({ __typename?: 'TrainingJourneyResult' } & {
        result?: Maybe<
          { __typename?: 'TrainingJourney' } & {
            steps?: Maybe<
              Array<
                | ({
                    __typename?: 'TrainingBookedStep'
                  } & TrainingBookedStepFieldsFragment)
                | ({ __typename?: 'PreworkStep' } & PreworkStepFieldsFragment)
                | ({
                    __typename?: 'AttendTrainingStep'
                  } & AttendTrainingStepFieldsFragment)
                | ({
                    __typename?: 'SubmitOutcomeTrackStep'
                  } & SubmitOutcomeTrackStepFieldsFragment)
                | ({
                    __typename?: 'ReceivedTrainingOutcomeStep'
                  } & ReceivedTrainingOutcomeStepFieldsFragment)
                | ({
                    __typename?: 'SubmitCertificationVideoStep'
                  } & SubmitCertificationVideoStepFieldsFragment)
                | ({
                    __typename?: 'ReceivedCertificationOutcomeStep'
                  } & ReceivedCertificationOutcomeStepFieldsFragment)
                | ({
                    __typename?: 'CertifiedStep'
                  } & CertifiedStepFieldsFragment)
                | ({ __typename?: 'ContactUsStep' } & Pick<
                    ContactUsStep,
                    | 'activeStepName'
                    | 'activeStepNumber'
                    | 'stepName'
                    | 'stepNumber'
                    | 'contactUsEmail'
                  >)
              >
            >
          }
        >
      })
    | ({ __typename?: 'ErrorResult' } & ErrorResultFieldsFragment)
}

export type TrainingJourneysQueryVariables = Exact<{
  _cacheKey?: Maybe<Scalars['String']>
}>

export type TrainingJourneysQuery = { __typename?: 'Query' } & {
  trainingJourneys:
    | ({ __typename?: 'TrainingJourneysResult' } & Pick<
        TrainingJourneysResult,
        'eventsAndTrainingUrl'
      > & {
          trainings?: Maybe<
            Array<
              { __typename?: 'TrainingSummary' } & Pick<
                TrainingSummary,
                | 'id'
                | 'eventName'
                | 'deliveryMethod'
                | 'startDate'
                | 'endDate'
                | 'timezone'
                | 'cecCertificationUrl'
                | 'venueAddress'
                | 'activeStepName'
                | 'activeStepNumber'
                | 'dueDate'
                | 'programName'
                | 'isContactUs'
                | 'dateCertified'
              >
            >
          >
        })
    | ({ __typename?: 'ErrorResult' } & ErrorResultFieldsFragment)
}

export type RequestForExtensionMutationVariables = Exact<{
  input: RequestForExtensionInput
  _cacheKey?: Maybe<Scalars['String']>
}>

export type RequestForExtensionMutation = { __typename?: 'Mutation' } & {
  requestForExtension:
    | ({ __typename?: 'RequestForExtensionResult' } & Pick<
        RequestForExtensionResult,
        'isSuccess'
      >)
    | ({ __typename?: 'ErrorResult' } & ErrorResultFieldsFragment)
}

export type SearchEventsQueryVariables = Exact<{
  searchInfo: SearchEventsInput
  filterInfo: FilterEventsInput
  _cacheKey?: Maybe<Scalars['String']>
}>

export type SearchEventsQuery = { __typename?: 'Query' } & {
  searchEvents:
    | ({ __typename?: 'EventsResult' } & {
        edges: Array<
          Maybe<
            { __typename?: 'EventEdge' } & Pick<EventEdge, 'cursor'> & {
                node: { __typename?: 'Event' } & Pick<
                  Event,
                  | 'eventId'
                  | 'eventName'
                  | 'startDate'
                  | 'endDate'
                  | 'deliveryMethod'
                  | 'spacesAvailable'
                  | 'venueAddress'
                  | 'programName'
                  | 'programCode'
                >
              }
          >
        >
        pageInfo: { __typename?: 'PageInfo' } & Pick<
          PageInfo,
          'hasNextPage'
        > & {
            endCursor?: Maybe<
              { __typename?: 'searchAfter' } & Pick<
                SearchAfter,
                'eventId' | 'sortValues'
              >
            >
          }
      })
    | ({ __typename?: 'ErrorResult' } & ErrorResultFieldsFragment)
}

export type AddClubListingMutationVariables = Exact<{
  input: AddClubListingInput
  _cacheKey?: Maybe<Scalars['String']>
}>

export type AddClubListingMutation = { __typename?: 'Mutation' } & {
  addClubListing?: Maybe<
    | ({ __typename?: 'ClubListingResult' } & {
        results?: Maybe<
          Array<
            | ({
                __typename?: 'ClubSingleListing'
              } & SingleListingFieldsFragment)
            | ({ __typename?: 'ClubMultiListing' } & MultiListingFieldsFragment)
          >
        >
      })
    | ({ __typename?: 'ErrorResult' } & ErrorResultFieldsFragment)
  >
}

export type AddEmergencyContactMutationVariables = Exact<{
  input: EmergencyContactInput
  _cacheKey?: Maybe<Scalars['String']>
}>

export type AddEmergencyContactMutation = { __typename?: 'Mutation' } & {
  addEmergencyContact:
    | ({ __typename?: 'AddEmergencyContactResult' } & {
        result?: Maybe<
          { __typename?: 'EmergencyContact' } & Pick<
            EmergencyContact,
            'address' | 'name' | 'phone'
          >
        >
      })
    | ({ __typename?: 'ErrorResult' } & ErrorResultFieldsFragment)
}

export type AddToShortlistMutationVariables = Exact<{
  input: AddToShortlistInput
  role: UserRoleInput
  _cacheKey?: Maybe<Scalars['String']>
}>

export type AddToShortlistMutation = { __typename?: 'Mutation' } & {
  addToShortlist?: Maybe<
    | ({ __typename?: 'AddToShortlistResult' } & {
        shortlist?: Maybe<
          Array<
            { __typename?: 'InstructorShortlist' } & Pick<
              InstructorShortlist,
              'id' | 'lastMessageIn48HoursSentAt' | 'distanceUnit' | 'distance'
            > & {
                profile: {
                  __typename?: 'UserProfileTeaching'
                } & InstructorProfileFieldsFragment
                user: { __typename?: 'User' } & Pick<
                  User,
                  'id' | 'lastName' | 'firstName'
                >
              }
          >
        >
      })
    | ({ __typename?: 'ErrorResult' } & ErrorResultFieldsFragment)
  >
}

export type CreateAffiliationMutationVariables = Exact<{
  input: CreateAffiliationInput
  role: UserRoleInput
  _cacheKey?: Maybe<Scalars['String']>
}>

export type CreateAffiliationMutation = { __typename?: 'Mutation' } & {
  createAffiliation:
    | ({ __typename?: 'AffiliationAsyncResult' } & Pick<
        AffiliationAsyncResult,
        'status'
      > & {
          affilation?: Maybe<
            { __typename: 'Affiliation' } & Pick<
              Affiliation,
              | 'actionedDate'
              | 'clubId'
              | 'id'
              | 'latestActionInitiator'
              | 'pendingStatus'
              | 'requestedBy'
              | 'requestedDate'
              | 'role'
              | 'status'
              | 'userId'
            >
          >
        })
    | ({ __typename?: 'ErrorResult' } & ErrorResultFieldsFragment)
}

export type CreateClubListingsMutationVariables = Exact<{
  input: CreateClubListingsInput
  _cacheKey?: Maybe<Scalars['String']>
}>

export type CreateClubListingsMutation = { __typename?: 'Mutation' } & {
  createClubListings?: Maybe<
    | ({ __typename?: 'CreateClubListingsResult' } & {
        successfulListings?: Maybe<
          Array<
            { __typename?: 'ClubSingleListing' } & SingleListingFieldsFragment
          >
        >
      })
    | ({ __typename?: 'ErrorResult' } & ErrorResultFieldsFragment)
  >
}

export type DeleteAffiliationMutationVariables = Exact<{
  input: DeleteAffiliationInput
  role: UserRoleInput
  _cacheKey?: Maybe<Scalars['String']>
}>

export type DeleteAffiliationMutation = { __typename?: 'Mutation' } & {
  deleteAffiliation:
    | ({ __typename?: 'AffiliationAsyncResult' } & Pick<
        AffiliationAsyncResult,
        'status'
      >)
    | ({ __typename?: 'ErrorResult' } & ErrorResultFieldsFragment)
}

export type DeleteClubListingMutationVariables = Exact<{
  input: DeleteClubListingInput
  _cacheKey?: Maybe<Scalars['String']>
}>

export type DeleteClubListingMutation = { __typename?: 'Mutation' } & {
  deleteClubListing?: Maybe<
    | ({ __typename?: 'DeleteClubListingResult' } & Pick<
        DeleteClubListingResult,
        'clubId' | 'status' | 'listingId'
      > & {
          results: Array<
            | ({
                __typename?: 'ClubSingleListing'
              } & SingleListingFieldsFragment)
            | ({ __typename?: 'ClubMultiListing' } & MultiListingFieldsFragment)
          >
        })
    | ({ __typename?: 'ErrorResult' } & ErrorResultFieldsFragment)
  >
}

export type DeleteCurrentUserPortfolioImageMutationVariables = Exact<{
  input: DeleteCurrentUserPortfolioImageInput
  role: UserRoleInput
  _cacheKey?: Maybe<Scalars['String']>
}>

export type DeleteCurrentUserPortfolioImageMutation = {
  __typename?: 'Mutation'
} & {
  deleteCurrentUserPortfolioImage:
    | ({ __typename?: 'DeleteCurrentUserPortfolioImageResult' } & Pick<
        DeleteCurrentUserPortfolioImageResult,
        'status'
      >)
    | ({ __typename?: 'ErrorResult' } & ErrorResultFieldsFragment)
}

export type DeleteMultipleJobListingsMutationVariables = Exact<{
  input: DeleteClubListingsInput
  _cacheKey?: Maybe<Scalars['String']>
}>

export type DeleteMultipleJobListingsMutation = { __typename?: 'Mutation' } & {
  deleteClubListings?: Maybe<
    | ({ __typename?: 'DeleteClubListingsResult' } & {
        success?: Maybe<
          Array<
            { __typename?: 'ClubSingleListing' } & SingleListingFieldsFragment
          >
        >
      })
    | ({ __typename?: 'ErrorResult' } & ErrorResultFieldsFragment)
  >
}

export type DigitalOnlyInStudioEnquireMutationVariables = Exact<{
  input: EnquireAboutInStudioProgramsInput
  role: UserRoleInput
  _cacheKey?: Maybe<Scalars['String']>
}>

export type DigitalOnlyInStudioEnquireMutation = { __typename?: 'Mutation' } & {
  enquireAboutInStudioPrograms?: Maybe<
    | ({ __typename?: 'EnquireAboutInStudioProgramsResult' } & Pick<
        EnquireAboutInStudioProgramsResult,
        'isSuccess'
      >)
    | ({ __typename?: 'ErrorResult' } & ErrorResultFieldsFragment)
  >
}

export type EnquireAboutOfferingMutationVariables = Exact<{
  input: EnquireAboutOnlineProgramInput
  role: UserRoleInput
  _cacheKey?: Maybe<Scalars['String']>
}>

export type EnquireAboutOfferingMutation = { __typename?: 'Mutation' } & {
  enquireAboutOnlineProgram?: Maybe<
    | ({ __typename?: 'EnquireAboutOnlineProgramResult' } & Pick<
        EnquireAboutOnlineProgramResult,
        'lastEnquiredOn' | 'onlineProgramid'
      >)
    | ({ __typename?: 'ErrorResult' } & ErrorResultFieldsFragment)
  >
}

export type EnquireAboutProgramMutationVariables = Exact<{
  input: EnquireAboutProgramInput
  role: UserRoleInput
  _cacheKey?: Maybe<Scalars['String']>
}>

export type EnquireAboutProgramMutation = { __typename?: 'Mutation' } & {
  enquireAboutProgram?: Maybe<
    | ({ __typename?: 'EnquireAboutProgramResult' } & Pick<
        EnquireAboutProgramResult,
        'lastEnquiredOn' | 'programId'
      >)
    | ({ __typename?: 'ErrorResult' } & ErrorResultFieldsFragment)
  >
}

export type EnquireAboutProgramInExploreProgramsMutationVariables = Exact<{
  input: EnquireAboutExploreProgramsInput
  role: UserRoleInput
  _cacheKey?: Maybe<Scalars['String']>
}>

export type EnquireAboutProgramInExploreProgramsMutation = {
  __typename?: 'Mutation'
} & {
  enquireAboutProgramInExplorePrograms?: Maybe<
    | ({ __typename?: 'EnquireAboutExploreProgramsResult' } & Pick<
        EnquireAboutExploreProgramsResult,
        'lastEnquiredOn' | 'programId'
      >)
    | ({ __typename?: 'ErrorResult' } & ErrorResultFieldsFragment)
  >
}

export type LinkFieldsFragment = { __typename?: 'Link' } & Pick<
  Link,
  'id' | 'text'
> & { url: { __typename?: 'URL' } & UrlFieldsFragment }

export type InstructorAvailabilityFieldsFragment = {
  __typename?: 'InstructorAvailability'
} & Pick<InstructorAvailability, 'description' | 'title' | 'value'>

export type ImageFieldsFragment = { __typename: 'Image' } & Pick<
  Image,
  'id' | 'url' | 'alt' | 'height' | 'width'
>

export type TimePreferencesFragment = { __typename?: 'TimePreference' } & Pick<
  TimePreference,
  'morning' | 'afternoon' | 'evening'
>

export type TravelPreferencesFragment = {
  __typename?: 'TravelPreference'
} & Pick<TravelPreference, 'distance' | 'distanceUnit'> & {
    address?: Maybe<{ __typename?: 'Address' } & AddressFieldsFragment>
  }

export type ProgramFieldsFragment = { __typename?: 'Program' } & Pick<
  Program,
  'code' | 'id' | 'initials' | 'name'
>

export type PreferenceFieldsFragment = {
  __typename?: 'InstructorPreferences'
} & {
  programs?: Maybe<Array<{ __typename?: 'Program' } & ProgramFieldsFragment>>
  times?: Maybe<
    Array<{ __typename?: 'TimePreference' } & TimePreferencesFragment>
  >
  travel?: Maybe<
    { __typename?: 'TravelPreference' } & TravelPreferencesFragment
  >
}

export type PrivacyFieldsFragment = {
  __typename?: 'PrivacySettingsInstructor'
} & Pick<
  PrivacySettingsInstructor,
  | 'EMAIL'
  | 'PHONE_NUMBER'
  | 'PROFILE_PHOTO'
  | 'SOCIAL_LINKS'
  | 'LMQ_LEVEL'
  | 'HIDDEN'
>

export type InstructorProfileFieldsFragment = {
  __typename: 'UserProfileTeaching'
} & Pick<
  UserProfileTeaching,
  | 'id'
  | 'bio'
  | 'roles'
  | 'strength'
  | 'interests'
  | 'createdAt'
  | 'availability'
  | 'createdAtLabel'
  | 'availableToSubstitute'
> & {
    address: { __typename?: 'Address' } & AddressFieldsFragment
    preferences?: Maybe<
      { __typename?: 'InstructorPreferences' } & PreferenceFieldsFragment
    >
    privacySettings?: Maybe<
      { __typename?: 'PrivacySettingsInstructor' } & PrivacyFieldsFragment
    >
    media?: Maybe<Array<{ __typename?: 'Image' } & ImageFieldsFragment>>
    profileImage?: Maybe<{ __typename?: 'Image' } & ImageFieldsFragment>
    links?: Maybe<
      Array<{ __typename?: 'ProfileLink' } & Pick<ProfileLink, 'url' | 'type'>>
    >
    certifications?: Maybe<
      Array<
        { __typename?: 'Certification' } & Pick<
          Certification,
          | 'id'
          | 'lastPurchase'
          | 'transactionStatus'
          | 'transactionTimestamp'
          | 'billedClubId'
          | 'releaseStatus'
          | 'status'
          | 'active'
          | 'lmqLevel'
        > & {
            pricePerQuarter?: Maybe<
              { __typename?: 'CertificationPrice' } & Pick<
                CertificationPrice,
                'amount' | 'currency'
              >
            >
            link: { __typename?: 'Link' } & LinkFieldsFragment
            program: { __typename?: 'Program' } & Pick<
              Program,
              'id' | 'name' | 'code' | 'initials'
            >
          }
      >
    >
    watchlist?: Maybe<
      Array<
        { __typename?: 'InstructorWatchlistItem' } & Pick<
          InstructorWatchlistItem,
          'clubId' | 'listingId'
        >
      >
    >
  }

export type ClubProfileFieldsFragment = {
  __typename: 'UserProfileClub'
} & Pick<
  UserProfileClub,
  | 'id'
  | 'bio'
  | 'name'
  | 'email'
  | 'phone'
  | 'hiring'
  | 'strength'
  | 'createdAt'
  | 'createdAtLabel'
  | 'isDigitalOnly'
> & {
    address: { __typename?: 'Address' } & AddressFieldsFragment
    programs?: Maybe<
      Array<
        | ({ __typename: 'ClubProgram' } & Pick<
            ClubProgram,
            'id' | 'name' | 'code' | 'initials' | 'programType'
          >)
        | { __typename?: 'ClubProgramInStudioEmptyState' }
      >
    >
    media?: Maybe<Array<{ __typename?: 'Image' } & ImageFieldsFragment>>
    profileImage?: Maybe<{ __typename?: 'Image' } & ImageFieldsFragment>
    links?: Maybe<
      Array<{ __typename?: 'ProfileLink' } & Pick<ProfileLink, 'url' | 'type'>>
    >
  }

export type FullUserFieldFragment = { __typename: 'UserResult' } & Pick<
  UserResult,
  'id' | 'distance' | 'distanceUnit'
> & {
    user: { __typename?: 'User' } & Pick<
      User,
      'id' | 'email' | 'lastName' | 'firstName' | 'accountId' | 'phone'
    > & {
        market: { __typename?: 'Market' } & Pick<
          Market,
          'isSupported' | 'name' | 'locale' | 'distanceUnit'
        > & {
            programs?: Maybe<
              Array<
                { __typename?: 'Program' } & Pick<
                  Program,
                  'id' | 'name' | 'code' | 'initials'
                >
              >
            >
          }
        signedAgreements?: Maybe<
          Array<
            { __typename?: 'SignedAgreement' } & Pick<
              SignedAgreement,
              'type' | 'signedOn' | 'version'
            >
          >
        >
        userMetaData?: Maybe<
          { __typename?: 'UserMetadata' } & {
            walkthroughRequired: { __typename?: 'WalkthroughRequired' } & Pick<
              WalkthroughRequired,
              'club' | 'instructor'
            >
          }
        >
      }
    profiles: Array<
      | ({
          __typename?: 'UserProfileTeaching'
        } & InstructorProfileFieldsFragment)
      | ({ __typename?: 'UserProfileClub' } & ClubProfileFieldsFragment)
    >
    settings: { __typename?: 'UserSettings' } & Pick<UserSettings, 'locale'>
  }

export type SingleListingFieldsFragment = {
  __typename?: 'ClubSingleListing'
} & Pick<
  ClubSingleListing,
  | 'createdAt'
  | 'description'
  | 'expiringAt'
  | 'id'
  | 'searchAppearances'
  | 'updatedAt'
  | 'views'
  | 'isSubstituteListing'
  | 'status'
  | 'enquiriesCount'
> & {
    clubInfo: { __typename?: 'UserProfileClub' } & Pick<
      UserProfileClub,
      'id' | 'name' | 'hiring'
    > & {
        address: { __typename?: 'Address' } & AddressFieldsFragment
        profileImage?: Maybe<{ __typename?: 'Image' } & Pick<Image, 'url'>>
        programs?: Maybe<
          Array<
            | ({ __typename?: 'ClubProgram' } & Pick<ClubProgram, 'name'>)
            | { __typename?: 'ClubProgramInStudioEmptyState' }
          >
        >
      }
    program: { __typename?: 'ClubProgram' } & Pick<
      ClubProgram,
      'code' | 'id' | 'initials' | 'name'
    >
    times: Array<{ __typename?: 'TimePreference' } & TimePreferencesFragment>
  }

export type MultiListingFieldsFragment = {
  __typename?: 'ClubMultiListing'
} & Pick<
  ClubMultiListing,
  | 'createdAt'
  | 'description'
  | 'expiringAt'
  | 'id'
  | 'searchAppearances'
  | 'status'
  | 'updatedAt'
  | 'views'
  | 'enquiriesCount'
> & {
    clubInfo: { __typename?: 'UserProfileClub' } & Pick<
      UserProfileClub,
      'id' | 'name'
    > & {
        address: { __typename?: 'Address' } & AddressFieldsFragment
        profileImage?: Maybe<{ __typename?: 'Image' } & Pick<Image, 'url'>>
        programs?: Maybe<
          Array<
            | ({ __typename?: 'ClubProgram' } & Pick<ClubProgram, 'name'>)
            | { __typename?: 'ClubProgramInStudioEmptyState' }
          >
        >
      }
    programs: Array<
      { __typename?: 'ClubProgram' } & Pick<
        ClubProgram,
        'code' | 'id' | 'initials' | 'name'
      >
    >
  }

export type SavedInstructorSearchFragment = {
  __typename?: 'SavedInstructorSearch'
} & Pick<SavedInstructorSearch, 'sort'> & {
    filter?: Maybe<
      { __typename?: 'SavedSearchClubListingsFilter' } & Pick<
        SavedSearchClubListingsFilter,
        'name' | 'programs' | 'substituteListingFilter'
      > & {
          location?: Maybe<
            { __typename?: 'LocationFilter' } & {
              within?: Maybe<
                { __typename?: 'LocationWithin' } & {
                  address?: Maybe<
                    { __typename?: 'Address' } & AddressFieldsFragment
                  >
                  area: { __typename?: 'GeoPolygon' } & {
                    points: Array<
                      { __typename?: 'GeoPoint' } & Pick<
                        GeoPoint,
                        'lat' | 'lon'
                      >
                    >
                  }
                }
              >
              near?: Maybe<
                { __typename?: 'LocationNear' } & Pick<
                  LocationNear,
                  'distance' | 'distanceUnit'
                > & {
                    address?: Maybe<
                      { __typename?: 'Address' } & AddressFieldsFragment
                    >
                  }
              >
              point?: Maybe<
                { __typename?: 'GeoPoint' } & Pick<GeoPoint, 'lat' | 'lon'>
              >
            }
          >
        }
    >
  }

export type AddressFieldsFragment = { __typename?: 'Address' } & Pick<
  Address,
  | 'city'
  | 'state'
  | 'street'
  | 'country'
  | 'stateCode'
  | 'postalCode'
  | 'streetName'
  | 'countryCode'
  | 'streetNumber'
> & {
    location?: Maybe<
      { __typename?: 'GeoPoint' } & Pick<GeoPoint, 'lat' | 'lon'>
    >
  }

export type ErrorResultFieldsFragment = { __typename: 'ErrorResult' } & Pick<
  ErrorResult,
  'type' | 'message' | 'requestId' | 'logGroup' | 'logStream'
>

export type ClubFieldsFragment = { __typename?: 'Club' } & Pick<
  Club,
  'accountId' | 'createdAt' | 'currency' | 'id' | 'name' | 'parent' | 'phone'
> & {
    email?: Maybe<
      { __typename?: 'EmailClubType' } & Pick<
        EmailClubType,
        'affiliations' | 'jobListings' | 'main'
      >
    >
    market: { __typename?: 'Market' } & Pick<
      Market,
      'name' | 'locale' | 'distanceUnit'
    > & {
        programs?: Maybe<
          Array<
            { __typename?: 'Program' } & Pick<
              Program,
              'id' | 'name' | 'code' | 'initials'
            >
          >
        >
      }
    profile: { __typename?: 'UserProfileClub' } & ClubProfileFieldsFragment
  }

export type AffiliationFieldsFragment = { __typename?: 'Affiliation' } & Pick<
  Affiliation,
  | 'actionedDate'
  | 'clubId'
  | 'id'
  | 'latestActionInitiator'
  | 'pendingStatus'
  | 'requestedBy'
  | 'requestedDate'
  | 'role'
  | 'status'
  | 'userId'
>

export type ManagePeopleUserAffiliateFieldsFragment = {
  __typename?: 'User'
} & Pick<
  User,
  'id' | 'phone' | 'email' | 'accountId' | 'lastName' | 'firstName'
> & {
    market: { __typename?: 'Market' } & Pick<
      Market,
      'name' | 'locale' | 'distanceUnit'
    >
  }

export type GetAgreementDocumentQueryVariables = Exact<{
  input: GetSignedAgreementInput
  _cacheKey?: Maybe<Scalars['String']>
  versionOnly?: Maybe<Scalars['Boolean']>
}>

export type GetAgreementDocumentQuery = { __typename?: 'Query' } & {
  getAgreementDocument:
    | ({ __typename?: 'AgreementDocumentResult' } & MakeOptional<
        Pick<AgreementDocumentResult, 'version' | 'content'>,
        'content'
      >)
    | ({ __typename?: 'ErrorResult' } & ErrorResultFieldsFragment)
}

export type ClubWithAffiliationFragment = {
  __typename?: 'ClubWithAffiliation'
} & Pick<ClubWithAffiliation, 'clubId' | 'clubName' | 'isDigitalOnly'> & {
    latestAffiliation?: Maybe<
      { __typename?: 'Affiliation' } & AffiliationFieldsFragment
    >
  }

export type GetChainAffiliationQueryVariables = Exact<{
  input: GetChainAffiliationsInput
  _cacheKey?: Maybe<Scalars['String']>
}>

export type GetChainAffiliationQuery = { __typename?: 'Query' } & {
  getChainAffiliations:
    | ({ __typename?: 'GetChainAffiliationsResult' } & {
        clubs?: Maybe<
          Array<
            { __typename?: 'ClubWithAffiliation' } & ClubWithAffiliationFragment
          >
        >
      })
    | ({ __typename?: 'ErrorResult' } & Pick<ErrorResult, 'type' | 'message'>)
}

export type ManagePeopleClubAffiliatesFieldsFragment = {
  __typename?: 'ClubAffiliates'
} & Pick<
  ClubAffiliates,
  | 'actionedDate'
  | 'clubId'
  | 'distance'
  | 'distanceUnit'
  | 'id'
  | 'pendingStatus'
  | 'requestedBy'
  | 'requestedDate'
  | 'status'
> & { profile: { __typename?: 'UserProfileClub' } & ClubProfileFieldsFragment }

export type GetChainAffiliatedInstructorQueryVariables = Exact<{
  input?: Maybe<GetChainInstructorAffiliatesInput>
  _cacheKey?: Maybe<Scalars['String']>
}>

export type GetChainAffiliatedInstructorQuery = { __typename?: 'Query' } & {
  getChainInstructorAffiliates:
    | ({ __typename: 'GetChainInstructorAffiliatesResult' } & Pick<
        GetChainInstructorAffiliatesResult,
        'hasPendingAffiliations'
      > & {
          affiliates?: Maybe<
            Array<
              { __typename?: 'InstructorChainAffiliate' } & Pick<
                InstructorChainAffiliate,
                'purchaseOrder'
              > & {
                  clubAffiliates?: Maybe<
                    Array<
                      {
                        __typename?: 'ClubAffiliates'
                      } & ManagePeopleClubAffiliatesFieldsFragment
                    >
                  >
                  profile: {
                    __typename?: 'UserProfileTeaching'
                  } & InstructorProfileFieldsFragment
                  user: {
                    __typename?: 'User'
                  } & ManagePeopleUserAffiliateFieldsFragment
                }
            >
          >
        })
    | ({ __typename?: 'ErrorResult' } & ErrorResultFieldsFragment)
}

export type GetChainInstructorRequestsQueryVariables = Exact<{
  input: GetChainInstructorAffiliatesInput
  _cacheKey?: Maybe<Scalars['String']>
}>

export type GetChainInstructorRequestsQuery = { __typename?: 'Query' } & {
  getChainInstructorAffiliates:
    | ({ __typename: 'GetChainInstructorAffiliatesResult' } & Pick<
        GetChainInstructorAffiliatesResult,
        'hasPendingAffiliations'
      > & {
          requests?: Maybe<
            Array<
              Maybe<
                { __typename?: 'InstructorChainRequest' } & Pick<
                  InstructorChainRequest,
                  | 'clubId'
                  | 'clubName'
                  | 'distance'
                  | 'distanceUnit'
                  | 'id'
                  | 'pendingStatus'
                  | 'requestedBy'
                  | 'requestedDate'
                  | 'status'
                > & {
                    profile: {
                      __typename?: 'UserProfileTeaching'
                    } & InstructorProfileFieldsFragment
                    user: {
                      __typename?: 'User'
                    } & ManagePeopleUserAffiliateFieldsFragment
                  }
              >
            >
          >
        })
    | ({ __typename?: 'ErrorResult' } & ErrorResultFieldsFragment)
}

export type GetChainUserQueryVariables = Exact<{
  _cacheKey?: Maybe<Scalars['String']>
}>

export type GetChainUserQuery = { __typename?: 'Query' } & {
  getChainUser?: Maybe<
    | ({ __typename?: 'GetChainUser' } & Pick<GetChainUser, 'isChainUser'> & {
          chainLocations?: Maybe<
            Array<
              { __typename?: 'UserProfileClub' } & ClubProfileFieldsFragment
            >
          >
        })
    | ({ __typename?: 'ErrorResult' } & Pick<ErrorResult, 'type' | 'message'>)
  >
}

export type GetChainUserClubListingsQueryVariables = Exact<{
  input: GetChainUserClubListingsInput
  _cacheKey?: Maybe<Scalars['String']>
}>

export type GetChainUserClubListingsQuery = { __typename?: 'Query' } & {
  getChainUserClubListings?: Maybe<
    | ({ __typename?: 'GetChainUserClubListingsResult' } & {
        singleListings?: Maybe<
          Array<
            { __typename?: 'ClubSingleListing' } & SingleListingFieldsFragment
          >
        >
        multiListings?: Maybe<
          Array<
            { __typename?: 'ClubMultiListing' } & MultiListingFieldsFragment
          >
        >
      })
    | ({ __typename?: 'ErrorResult' } & ErrorResultFieldsFragment)
  >
}

export type BusinessSupportSectionContentFragment = {
  __typename?: 'BusinessSupportSection'
} & Pick<BusinessSupportSection, 'id' | 'sectionTitle'> & {
    sectionTiles?: Maybe<
      Array<
        { __typename?: 'BusinessSupportTile' } & Pick<
          BusinessSupportTile,
          'id' | 'title' | 'subtitle'
        > & {
            image: { __typename?: 'Image' } & Pick<Image, 'id' | 'alt' | 'url'>
            url: { __typename?: 'URL' } & Pick<Url, 'type' | 'value'>
          }
      >
    >
  }

export type GetClubBusinessSupportContentQueryVariables = Exact<{
  input: GetClubByIdInput
}>

export type GetClubBusinessSupportContentQuery = { __typename?: 'Query' } & {
  getClubById?: Maybe<
    | ({ __typename?: 'UserProfileClub' } & {
        businessSupport?: Maybe<
          Array<
            {
              __typename?: 'BusinessSupportSection'
            } & BusinessSupportSectionContentFragment
          >
        >
      })
    | ({ __typename?: 'ErrorResult' } & Pick<ErrorResult, 'type' | 'message'>)
  >
}

export type GetClubInstructorAffiliatesQueryVariables = Exact<{
  input: GetClubInstructorAffiliatesInput
  _cacheKey?: Maybe<Scalars['String']>
}>

export type GetClubInstructorAffiliatesQuery = { __typename?: 'Query' } & {
  getClubInstructorAffiliates?: Maybe<
    | ({ __typename: 'GetClubInstructorAffiliatesResult' } & {
        affiliates?: Maybe<
          Array<
            { __typename?: 'InstructorAffiliate' } & Pick<
              InstructorAffiliate,
              | 'purchaseOrder'
              | 'actionedDate'
              | 'id'
              | 'requestedBy'
              | 'requestedDate'
              | 'status'
              | 'clubId'
            > & {
                user: { __typename?: 'User' } & Pick<
                  User,
                  | 'id'
                  | 'phone'
                  | 'email'
                  | 'accountId'
                  | 'lastName'
                  | 'firstName'
                > & {
                    market: { __typename?: 'Market' } & Pick<
                      Market,
                      'name' | 'locale' | 'distanceUnit'
                    >
                  }
                profile: {
                  __typename?: 'UserProfileTeaching'
                } & InstructorProfileFieldsFragment
              }
          >
        >
        requests?: Maybe<
          Array<
            { __typename?: 'InstructorRequest' } & Pick<
              InstructorRequest,
              | 'id'
              | 'distance'
              | 'distanceUnit'
              | 'requestedDate'
              | 'requestedBy'
              | 'status'
              | 'pendingStatus'
              | 'clubId'
            > & {
                user: { __typename?: 'User' } & Pick<
                  User,
                  | 'id'
                  | 'phone'
                  | 'email'
                  | 'accountId'
                  | 'lastName'
                  | 'firstName'
                > & {
                    market: { __typename?: 'Market' } & Pick<
                      Market,
                      'name' | 'locale' | 'distanceUnit'
                    >
                  }
                profile: {
                  __typename?: 'UserProfileTeaching'
                } & InstructorProfileFieldsFragment
              }
          >
        >
      })
    | ({ __typename?: 'ErrorResult' } & ErrorResultFieldsFragment)
  >
}

export type GetClubListingByIdQueryVariables = Exact<{
  listingId: Scalars['String']
}>

export type GetClubListingByIdQuery = { __typename?: 'Query' } & {
  getClubListingById:
    | ({ __typename?: 'SearchClubJobListingsSingleResult' } & Pick<
        SearchClubJobListingsSingleResult,
        | 'distance'
        | 'distanceUnit'
        | 'messageSentOn'
        | 'enquiredOn'
        | 'onWatchlist'
        | 'hasBeenReported'
      > & {
          listing:
            | ({
                __typename?: 'ClubSingleListing'
              } & SingleListingFieldsFragment)
            | ({ __typename?: 'ClubMultiListing' } & MultiListingFieldsFragment)
        })
    | ({ __typename?: 'ErrorResult' } & ErrorResultFieldsFragment)
}

export type GetClubListingsByClubIdQueryVariables = Exact<{
  input: GetClubListingsByClubIdInput
  _cacheKey?: Maybe<Scalars['String']>
}>

export type GetClubListingsByClubIdQuery = { __typename?: 'Query' } & {
  getClubListingsByClubId?: Maybe<
    | ({ __typename?: 'GetClubListingsByClubIdResult' } & {
        results: Array<
          | ({ __typename?: 'ClubSingleListing' } & SingleListingFieldsFragment)
          | ({ __typename?: 'ClubMultiListing' } & MultiListingFieldsFragment)
        >
      })
    | ({ __typename?: 'ErrorResult' } & ErrorResultFieldsFragment)
  >
}

export type GetClubSettingsQueryVariables = Exact<{
  input: GetClubSettingsInput
  _cacheKey?: Maybe<Scalars['String']>
}>

export type GetClubSettingsQuery = { __typename?: 'Query' } & {
  getClubSettings:
    | ({ __typename?: 'GetClubSettingsResult' } & Pick<
        GetClubSettingsResult,
        'id' | 'name' | 'phone'
      > & {
          address?: Maybe<
            { __typename?: 'Address' } & Pick<
              Address,
              | 'city'
              | 'state'
              | 'street'
              | 'country'
              | 'stateCode'
              | 'postalCode'
              | 'countryCode'
            > & {
                location?: Maybe<
                  { __typename?: 'GeoPoint' } & Pick<GeoPoint, 'lat' | 'lon'>
                >
              }
          >
          email?: Maybe<
            { __typename?: 'EmailClubType' } & Pick<
              EmailClubType,
              'main' | 'affiliations' | 'jobListings'
            >
          >
        })
    | ({ __typename?: 'ErrorResult' } & ErrorResultFieldsFragment)
}

export type GetContactUsContentQueryVariables = Exact<{
  input: GetContactUsContentInput
  _cacheKey?: Maybe<Scalars['String']>
}>

export type GetContactUsContentQuery = { __typename?: 'Query' } & {
  getContactUsContent:
    | ({ __typename?: 'GetContactUsContentResult' } & {
        result: Array<
          { __typename?: 'SectionContentResult' } & Pick<
            SectionContentResult,
            'section'
          > & {
              content: Array<
                { __typename?: 'ContentField' } & Pick<
                  ContentField,
                  'title' | 'subHeading' | 'contentText'
                >
              >
            }
        >
      })
    | ({ __typename?: 'ErrorResult' } & ErrorResultFieldsFragment)
}

export type GetCurrentUserQueryVariables = Exact<{
  _cacheKey?: Maybe<Scalars['String']>
}>

export type GetCurrentUserQuery = { __typename?: 'Query' } & {
  getCurrentUser?: Maybe<
    | ({ __typename?: 'UserResult' } & FullUserFieldFragment)
    | ({ __typename?: 'ErrorResult' } & ErrorResultFieldsFragment)
  >
}

export type GetCurrentUserPhotoUploadDataQueryVariables = Exact<{
  _cacheKey?: Maybe<Scalars['String']>
}>

export type GetCurrentUserPhotoUploadDataQuery = { __typename?: 'Query' } & {
  getCurrentUserPhotoUploadData?: Maybe<
    | ({ __typename: 'GetCurrentUserPhotoUploadDataResult' } & Pick<
        GetCurrentUserPhotoUploadDataResult,
        'url' | 'token'
      >)
    | ({ __typename?: 'ErrorResult' } & ErrorResultFieldsFragment)
  >
}

export type GetCurrentUserPortfolioUploadDataQueryVariables = Exact<{
  input: GetCurrentUserPortfolioUploadDataInput
  _cacheKey?: Maybe<Scalars['String']>
}>

export type GetCurrentUserPortfolioUploadDataQuery = {
  __typename?: 'Query'
} & {
  getCurrentUserPortfolioUploadData:
    | ({ __typename?: 'GetCurrentUserPortfolioUploadDataResult' } & {
        items: Array<
          { __typename?: 'PortfolioUploadItem' } & Pick<
            PortfolioUploadItem,
            'url' | 'token'
          >
        >
      })
    | ({ __typename?: 'ErrorResult' } & ErrorResultFieldsFragment)
}

export type ClubDashboardBusinessSupportContentFragment = {
  __typename?: 'ClubPartnershipBusinessSupportContent'
} & Pick<ClubPartnershipBusinessSupportContent, 'title' | 'description'> & {
    link: { __typename?: 'Link' } & Pick<Link, 'text'> & {
        url: { __typename?: 'URL' } & Pick<Url, 'type' | 'value'>
      }
  }

export type ClubDashboardStandardContentFragment = {
  __typename?: 'ClubPartnershipStandardContent'
} & Pick<ClubPartnershipStandardContent, 'title' | 'subtitle'> & {
    link: { __typename?: 'Link' } & Pick<Link, 'text'> & {
        url: { __typename?: 'URL' } & Pick<Url, 'type' | 'value'>
      }
    image: { __typename?: 'ImageSet' } & {
      mobile: { __typename?: 'Image' } & Pick<Image, 'alt' | 'url'>
      desktop: { __typename?: 'Image' } & Pick<Image, 'alt' | 'url'>
    }
  }

export type ClubDashboardProgramInfoFragment = {
  __typename?: 'ClubPartnershipProgramStat'
} & Pick<ClubPartnershipProgramStat, 'total' | 'type'> & {
    icon: { __typename?: 'Image' } & Pick<Image, 'alt' | 'url'>
  }

export type ClubDashboardProgramStatsFragment = {
  __typename?: 'ClubPartnershipProgramStats'
} & {
  programsStats?: Maybe<
    Array<
      {
        __typename?: 'ClubPartnershipProgramStat'
      } & ClubDashboardProgramInfoFragment
    >
  >
}

export type GetDashboardQueryVariables = Exact<{
  role: UserRoleInput
  _cacheKey?: Maybe<Scalars['String']>
}>

export type GetDashboardQuery = { __typename: 'Query' } & {
  getDashboard?: Maybe<
    | ({ __typename: 'DashboardPageInstructorResponse' } & Pick<
        DashboardPageInstructorResponse,
        'id'
      > & {
          translation: { __typename?: 'DashboardPageTranslation' } & Pick<
            DashboardPageTranslation,
            'title'
          >
          socialMedia: { __typename?: 'SocialMediaSection' } & Pick<
            SocialMediaSection,
            'title'
          > & {
              items?: Maybe<
                Array<
                  { __typename?: 'SocialMediaPost' } & Pick<
                    SocialMediaPost,
                    'id' | 'url' | 'type' | 'createdAt' | 'createdAtLabel'
                  > & {
                      content: { __typename?: 'SocialMediaContent' } & Pick<
                        SocialMediaContent,
                        'type' | 'value'
                      >
                    }
                >
              >
            }
          links?: Maybe<
            Array<
              { __typename?: 'LinkTile' } & Pick<
                LinkTile,
                'id' | 'title' | 'subtitle'
              > & {
                  imageSet: { __typename?: 'ImageSet' } & Pick<
                    ImageSet,
                    'id'
                  > & {
                      desktop: { __typename?: 'Image' } & Pick<
                        Image,
                        'id' | 'alt' | 'url'
                      >
                      mobile: { __typename?: 'Image' } & Pick<
                        Image,
                        'id' | 'alt' | 'url'
                      >
                    }
                  url: { __typename?: 'URL' } & Pick<Url, 'type' | 'value'>
                }
            >
          >
          certifications?: Maybe<
            Array<
              { __typename?: 'Certification' } & Pick<
                Certification,
                'id' | 'status' | 'active' | 'lmqLevel'
              > & {
                  link: { __typename?: 'Link' } & Pick<Link, 'id' | 'text'> & {
                      url: { __typename?: 'URL' } & Pick<Url, 'type' | 'value'>
                    }
                  steps?: Maybe<
                    Array<
                      { __typename?: 'CertificationStep' } & Pick<
                        CertificationStep,
                        'id' | 'label' | 'status'
                      > & {
                          action?: Maybe<
                            { __typename?: 'Link' } & Pick<
                              Link,
                              'id' | 'text'
                            > & {
                                url: { __typename?: 'URL' } & Pick<
                                  Url,
                                  'value' | 'type'
                                >
                              }
                          >
                        }
                    >
                  >
                  program: { __typename?: 'Program' } & Pick<
                    Program,
                    'id' | 'name' | 'code' | 'initials'
                  >
                }
            >
          >
          promotions?: Maybe<
            Array<
              { __typename?: 'Promotion' } & Pick<
                Promotion,
                'id' | 'title' | 'description'
              > & {
                  image: { __typename?: 'ImageSet' } & Pick<ImageSet, 'id'> & {
                      desktop: { __typename?: 'Image' } & Pick<
                        Image,
                        'id' | 'alt' | 'url' | 'width' | 'height'
                      >
                      mobile: { __typename?: 'Image' } & Pick<
                        Image,
                        'id' | 'alt' | 'url' | 'width' | 'height'
                      >
                    }
                  link?: Maybe<
                    { __typename?: 'Link' } & Pick<Link, 'id' | 'text'> & {
                        url: { __typename?: 'URL' } & Pick<
                          Url,
                          'value' | 'type'
                        >
                      }
                  >
                }
            >
          >
        })
    | ({ __typename: 'DashboardPageClubResponse' } & Pick<
        DashboardPageClubResponse,
        'id'
      > & {
          links?: Maybe<
            Array<
              { __typename?: 'LinkTile' } & Pick<
                LinkTile,
                'id' | 'title' | 'subtitle'
              > & {
                  imageSet: { __typename?: 'ImageSet' } & Pick<
                    ImageSet,
                    'id'
                  > & {
                      desktop: { __typename?: 'Image' } & Pick<
                        Image,
                        'id' | 'alt' | 'url'
                      >
                      mobile: { __typename?: 'Image' } & Pick<
                        Image,
                        'id' | 'alt' | 'url'
                      >
                    }
                  url: { __typename?: 'URL' } & Pick<Url, 'type' | 'value'>
                }
            >
          >
          promotions?: Maybe<
            Array<
              { __typename?: 'Promotion' } & Pick<
                Promotion,
                'id' | 'title' | 'description'
              > & {
                  image: { __typename?: 'ImageSet' } & Pick<ImageSet, 'id'> & {
                      desktop: { __typename?: 'Image' } & Pick<
                        Image,
                        'id' | 'alt' | 'url' | 'width' | 'height'
                      >
                      mobile: { __typename?: 'Image' } & Pick<
                        Image,
                        'id' | 'alt' | 'url' | 'width' | 'height'
                      >
                    }
                  link?: Maybe<
                    { __typename?: 'Link' } & Pick<Link, 'id' | 'text'> & {
                        url: { __typename?: 'URL' } & Pick<
                          Url,
                          'value' | 'type'
                        >
                      }
                  >
                }
            >
          >
          partnership?: Maybe<
            Array<
              | ({
                  __typename?: 'ClubPartnershipProgramStats'
                } & ClubDashboardProgramStatsFragment)
              | ({
                  __typename?: 'ClubPartnershipStandardContent'
                } & ClubDashboardStandardContentFragment)
              | ({
                  __typename?: 'ClubPartnershipBusinessSupportContent'
                } & ClubDashboardBusinessSupportContentFragment &
                  ClubDashboardBusinessSupportContentFragment)
            >
          >
          myTools?: Maybe<
            Array<
              { __typename?: 'DashboardMyTools' } & Pick<
                DashboardMyTools,
                'id' | 'title' | 'subtitle'
              > & {
                  imageSet: { __typename?: 'ImageSet' } & Pick<
                    ImageSet,
                    'id'
                  > & {
                      desktop: { __typename?: 'Image' } & Pick<
                        Image,
                        'id' | 'alt' | 'url'
                      >
                      mobile: { __typename?: 'Image' } & Pick<
                        Image,
                        'id' | 'alt' | 'url'
                      >
                    }
                  url: { __typename?: 'URL' } & Pick<Url, 'type' | 'value'>
                }
            >
          >
        })
    | ({ __typename: 'ErrorResult' } & ErrorResultFieldsFragment)
  >
}

export type GetEqualOpportunitiesPolicyQueryVariables = Exact<{
  input: GetEqualOpportunitiesPolicyInput
  _cacheKey?: Maybe<Scalars['String']>
}>

export type GetEqualOpportunitiesPolicyQuery = { __typename?: 'Query' } & {
  getEqualOpportunitiesPolicy:
    | ({ __typename?: 'GetEqualOpportunitiesPolicyResult' } & {
        result: Array<
          { __typename?: 'SectionContentResult' } & Pick<
            SectionContentResult,
            'section'
          > & {
              content: Array<
                { __typename?: 'ContentField' } & Pick<
                  ContentField,
                  'title' | 'subHeading' | 'contentText'
                >
              >
            }
        >
      })
    | ({ __typename?: 'ErrorResult' } & ErrorResultFieldsFragment)
}

export type GetFrequentlyAskedQuestionsQueryVariables = Exact<{
  input: GetFrequentlyAskedQuestionsInput
  _cacheKey?: Maybe<Scalars['String']>
}>

export type GetFrequentlyAskedQuestionsQuery = { __typename?: 'Query' } & {
  getFrequentlyAskedQuestions:
    | ({ __typename?: 'GetFrequentlyAskedQuestionsResult' } & {
        result: Array<
          { __typename?: 'SectionContentResult' } & Pick<
            SectionContentResult,
            'section'
          > & {
              content: Array<
                { __typename?: 'ContentField' } & Pick<
                  ContentField,
                  'title' | 'subHeading' | 'contentText'
                >
              >
            }
        >
      })
    | ({ __typename?: 'ErrorResult' } & ErrorResultFieldsFragment)
}

export type GetHeaderContentQueryVariables = Exact<{
  input: GetHeaderInput
  _cacheKey?: Maybe<Scalars['String']>
}>

export type GetHeaderContentQuery = { __typename?: 'Query' } & {
  getHeaders?: Maybe<
    | ({ __typename: 'GetHeaderResult' } & {
        results: Array<
          { __typename?: 'Header' } & Pick<
            Header,
            'key' | 'title' | 'subHeading'
          > & {
              image?: Maybe<
                { __typename?: 'ImageSet' } & Pick<ImageSet, 'id'> & {
                    desktop: { __typename?: 'Image' } & Pick<
                      Image,
                      'id' | 'alt' | 'url'
                    >
                    mobile: { __typename?: 'Image' } & Pick<
                      Image,
                      'id' | 'alt' | 'url'
                    >
                  }
              >
            }
        >
      })
    | ({ __typename?: 'ErrorResult' } & ErrorResultFieldsFragment)
  >
}

export type InStudioManageOptionsFragment = {
  __typename?: 'GetPickListResult'
} & {
  results: Array<{ __typename?: 'PickList' } & Pick<PickList, 'items' | 'key'>>
}

export type GetInStudioManageOptionsQueryVariables = Exact<{
  input: GetPickListInput
}>

export type GetInStudioManageOptionsQuery = { __typename?: 'Query' } & {
  getPickLists?: Maybe<
    | ({ __typename: 'GetPickListResult' } & InStudioManageOptionsFragment)
    | ({ __typename: 'ErrorResult' } & ErrorResultFieldsFragment)
  >
}

export type GetUserAccountQueryVariables = Exact<{
  input: GetUserByIdInput
  role: UserRoleInput
  _cacheKey?: Maybe<Scalars['String']>
}>

export type GetUserAccountQuery = { __typename: 'Query' } & {
  getUserAccount:
    | ({ __typename: 'UserAccountSettingsResult' } & Pick<
        UserAccountSettingsResult,
        'id' | 'email' | 'firstName' | 'lastName' | 'phone'
      > & {
          address?: Maybe<{ __typename?: 'Address' } & AddressFieldsFragment>
          outlinks?: Maybe<
            Array<
              { __typename?: 'OutLink' } & Pick<OutLink, 'url' | 'title'> & {
                  _metadata?: Maybe<
                    { __typename?: 'OutlinkMetedata' } & Pick<
                      OutlinkMetedata,
                      'urlSource'
                    >
                  >
                }
            >
          >
        })
    | ({ __typename: 'ErrorResult' } & ErrorResultFieldsFragment)
}

export type GetInstructorEnquiriesQueryVariables = Exact<{
  role: UserRoleInput
  filter: UserEnquiriesFilter
  _cacheKey?: Maybe<Scalars['String']>
}>

export type GetInstructorEnquiriesQuery = { __typename?: 'Query' } & {
  getUserEnquiries?: Maybe<
    | ({ __typename?: 'GetUserEnquiriesResult' } & {
        enquiries?: Maybe<
          Array<
            { __typename?: 'UserEnquiry' } & {
              listing: { __typename?: 'EnquiryClubListingSingleResult' } & Pick<
                EnquiryClubListingSingleResult,
                | 'distance'
                | 'distanceUnit'
                | 'messageSentOn'
                | 'enquiredOn'
                | 'onWatchlist'
                | 'hasBeenReported'
              > & {
                  listing:
                    | ({ __typename: 'ClubMultiListing' } & {
                        clubInfo: { __typename?: 'UserProfileClub' } & Pick<
                          UserProfileClub,
                          'id' | 'name' | 'hiring'
                        > & {
                            address: {
                              __typename?: 'Address'
                            } & AddressFieldsFragment
                            profileImage?: Maybe<
                              { __typename?: 'Image' } & Pick<Image, 'url'>
                            >
                            programs?: Maybe<
                              Array<
                                | ({ __typename?: 'ClubProgram' } & Pick<
                                    ClubProgram,
                                    'name'
                                  >)
                                | {
                                    __typename?: 'ClubProgramInStudioEmptyState'
                                  }
                              >
                            >
                          }
                      } & MultiListingFieldsFragment)
                    | ({ __typename: 'ClubSingleListing' } & {
                        clubInfo: { __typename?: 'UserProfileClub' } & Pick<
                          UserProfileClub,
                          'id' | 'name' | 'hiring'
                        > & {
                            address: {
                              __typename?: 'Address'
                            } & AddressFieldsFragment
                            profileImage?: Maybe<
                              { __typename?: 'Image' } & Pick<Image, 'url'>
                            >
                            programs?: Maybe<
                              Array<
                                | ({ __typename?: 'ClubProgram' } & Pick<
                                    ClubProgram,
                                    'name'
                                  >)
                                | {
                                    __typename?: 'ClubProgramInStudioEmptyState'
                                  }
                              >
                            >
                          }
                      } & SingleListingFieldsFragment)
                    | ({ __typename: 'ClubListingUnknown' } & Pick<
                        ClubListingUnknown,
                        'id'
                      > & {
                          clubInfo: { __typename?: 'UserProfileClub' } & Pick<
                            UserProfileClub,
                            'id' | 'name' | 'hiring'
                          > & {
                              address: {
                                __typename?: 'Address'
                              } & AddressFieldsFragment
                              profileImage?: Maybe<
                                { __typename?: 'Image' } & Pick<Image, 'url'>
                              >
                              programs?: Maybe<
                                Array<
                                  | ({ __typename?: 'ClubProgram' } & Pick<
                                      ClubProgram,
                                      'name'
                                    >)
                                  | {
                                      __typename?: 'ClubProgramInStudioEmptyState'
                                    }
                                >
                              >
                            }
                        })
                }
              message: { __typename?: 'Message' } & Pick<
                Message,
                | 'clubId'
                | 'clubName'
                | 'id'
                | 'listingId'
                | 'message'
                | 'profileId'
                | 'readAt'
                | 'requestedBy'
                | 'sentAt'
              >
            }
          >
        >
      })
    | ({ __typename?: 'ErrorResult' } & ErrorResultFieldsFragment)
  >
}

export type GetInstructorFacilitiesQueryVariables = Exact<{
  input: GetInstructorClubAffiliatesInput
  _cacheKey?: Maybe<Scalars['String']>
}>

export type GetInstructorFacilitiesQuery = { __typename?: 'Query' } & {
  getInstructorClubAffiliates:
    | ({ __typename: 'GetInstructorClubAffiliatesResult' } & {
        affiliations?: Maybe<
          Array<
            { __typename?: 'ClubAffiliates' } & Pick<
              ClubAffiliates,
              | 'actionedDate'
              | 'clubId'
              | 'distance'
              | 'distanceUnit'
              | 'id'
              | 'requestedDate'
              | 'requestedBy'
              | 'status'
              | 'pendingStatus'
              | 'isDigitalOnly'
            > & {
                profile: {
                  __typename?: 'UserProfileClub'
                } & ClubProfileFieldsFragment
              }
          >
        >
      })
    | ({ __typename?: 'ErrorResult' } & ErrorResultFieldsFragment)
}

export type GetInstructorPortfolioQueryVariables = Exact<{
  _cacheKey?: Maybe<Scalars['String']>
}>

export type GetInstructorPortfolioQuery = { __typename?: 'Query' } & {
  getCurrentUser?: Maybe<
    | ({ __typename: 'UserResult' } & {
        profiles: Array<
          | ({ __typename?: 'UserProfileTeaching' } & {
              media?: Maybe<
                Array<{ __typename?: 'Image' } & Pick<Image, 'id' | 'url'>>
              >
            })
          | ({ __typename?: 'UserProfileClub' } & {
              media?: Maybe<
                Array<{ __typename?: 'Image' } & Pick<Image, 'id' | 'url'>>
              >
            })
        >
      })
    | ({ __typename?: 'ErrorResult' } & ErrorResultFieldsFragment)
  >
}

export type GetInstructorWatchlistQueryVariables = Exact<{
  role: UserRoleInput
  _cacheKey?: Maybe<Scalars['String']>
}>

export type GetInstructorWatchlistQuery = { __typename?: 'Query' } & {
  getInstructorWatchlist?: Maybe<
    | ({ __typename?: 'SearchClubListingsResult' } & Pick<
        SearchClubListingsResult,
        'total'
      > & {
          results?: Maybe<
            Array<
              | ({ __typename?: 'SearchClubJobListingsSingleResult' } & Pick<
                  SearchClubJobListingsSingleResult,
                  | 'distance'
                  | 'distanceUnit'
                  | 'messageSentOn'
                  | 'enquiredOn'
                  | 'onWatchlist'
                  | 'hasBeenReported'
                > & {
                    listing:
                      | ({
                          __typename?: 'ClubSingleListing'
                        } & SingleListingFieldsFragment)
                      | ({
                          __typename?: 'ClubMultiListing'
                        } & MultiListingFieldsFragment)
                  })
              | ({ __typename?: 'SearchClubProfileSingleResult' } & Pick<
                  SearchClubProfileSingleResult,
                  | 'distance'
                  | 'distanceUnit'
                  | 'onWatchlist'
                  | 'hasBeenReported'
                > & {
                    profile: {
                      __typename?: 'UserProfileClub'
                    } & ClubProfileFieldsFragment
                  })
            >
          >
        })
    | ({ __typename?: 'ErrorResult' } & ErrorResultFieldsFragment)
  >
}

export type LocationsFragment = {
  __typename?: 'ClubAvailabilityOnListing'
} & Pick<
  ClubAvailabilityOnListing,
  'clubId' | 'clubName' | 'isAlreadyListed' | 'isClubLicensed'
> & {
    clubProfileImage?: Maybe<{ __typename?: 'Image' } & ImageFieldsFragment>
    clubAddress?: Maybe<{ __typename?: 'Address' } & AddressFieldsFragment>
  }

export type GetJobListingAvailableLocationsQueryVariables = Exact<{
  input: GetClubsAvailabilityOnListingInput
  _cacheKey?: Maybe<Scalars['String']>
}>

export type GetJobListingAvailableLocationsQuery = { __typename?: 'Query' } & {
  getClubsAvailabilityOnListing?: Maybe<
    | ({ __typename?: 'GetClubsAvailabilityOnListingResult' } & {
        clubsWithExistingListing?: Maybe<
          Array<
            { __typename?: 'ClubAvailabilityOnListing' } & LocationsFragment
          >
        >
        allClubs?: Maybe<
          Array<
            { __typename?: 'ClubAvailabilityOnListing' } & LocationsFragment
          >
        >
      })
    | ({ __typename?: 'ErrorResult' } & Pick<ErrorResult, 'type' | 'message'>)
  >
}

export type GetNavigationQueryVariables = Exact<{
  input: GetNavigationInput
  _cacheKey?: Maybe<Scalars['String']>
}>

export type GetNavigationQuery = { __typename?: 'Query' } & {
  getNavigation?: Maybe<
    | ({ __typename: 'Navigation' } & {
        appMenu: { __typename?: 'Menu' } & Pick<Menu, 'id' | 'name'> & {
            items: Array<
              { __typename?: 'RootMenuItem' } & Pick<
                RootMenuItem,
                'icon' | 'id' | 'label' | 'analyticsEvent'
              > & {
                  url?: Maybe<
                    { __typename?: 'URL' } & Pick<Url, 'type' | 'value'>
                  >
                  items?: Maybe<
                    Array<
                      { __typename?: 'MenuItem' } & Pick<
                        MenuItem,
                        'id' | 'label' | 'analyticsEvent'
                      > & {
                          url: { __typename?: 'URL' } & Pick<
                            Url,
                            'type' | 'value'
                          >
                        }
                    >
                  >
                }
            >
          }
        userMenu: { __typename?: 'RootMenuItem' } & Pick<
          RootMenuItem,
          'icon' | 'id' | 'label' | 'analyticsEvent'
        > & {
            url?: Maybe<{ __typename?: 'URL' } & Pick<Url, 'type' | 'value'>>
            items?: Maybe<
              Array<
                { __typename?: 'MenuItem' } & Pick<
                  MenuItem,
                  'id' | 'label' | 'analyticsEvent'
                > & {
                    url: { __typename?: 'URL' } & Pick<Url, 'type' | 'value'>
                  }
              >
            >
          }
      })
    | ({ __typename: 'ErrorResult' } & ErrorResultFieldsFragment)
  >
}

export type NotificationItemFragment = { __typename?: 'Notification' } & Pick<
  Notification,
  'id' | 'type' | 'body' | 'title' | 'createdAt' | 'createdAtLabel' | 'readAt'
> & {
    link?: Maybe<
      { __typename?: 'Link' } & Pick<Link, 'id' | 'text'> & {
          url: { __typename?: 'URL' } & Pick<Url, 'type' | 'value'>
        }
    >
  }

export type NotificationsResultFragment = {
  __typename?: 'GetNotificationsResult'
} & Pick<GetNotificationsResult, 'totalCount'> & {
    filter: { __typename?: 'DateTimeFilter' } & Pick<
      DateTimeFilter,
      'type' | 'value' | 'limit'
    >
    items?: Maybe<
      Array<{ __typename?: 'Notification' } & NotificationItemFragment>
    >
  }

export type GetNotificationsQueryVariables = Exact<{
  filter: DateTimeFilterInput
  role: UserRoleInput
  _cacheKey?: Maybe<Scalars['String']>
}>

export type GetNotificationsQuery = { __typename?: 'Query' } & {
  getNotifications?: Maybe<
    | ({ __typename?: 'GetNotificationsResult' } & NotificationsResultFragment)
    | ({ __typename?: 'ErrorResult' } & ErrorResultFieldsFragment)
  >
}

export type GetProfileQueryVariables = Exact<{
  input: GetProfileByIdInput
  role: UserRoleInput
  _cacheKey?: Maybe<Scalars['String']>
}>

export type GetProfileQuery = { __typename?: 'Query' } & {
  getProfileById?: Maybe<
    | ({ __typename?: 'GetProfileByIdResult' } & Pick<
        GetProfileByIdResult,
        | 'hasBeenReported'
        | 'withinDistance'
        | 'lastMessageIn48HoursSentAt'
        | 'hasRecentlyDeclinedAffiliation'
        | 'hasExistingAffiliation'
        | 'onWatchlist'
      > & {
          profile?: Maybe<
            | ({
                __typename?: 'UserProfileTeaching'
              } & InstructorProfileFieldsFragment)
            | ({ __typename?: 'UserProfileClub' } & ClubProfileFieldsFragment)
          >
          instructorAffiliation?: Maybe<
            { __typename?: 'Affiliation' } & Pick<
              Affiliation,
              | 'id'
              | 'clubId'
              | 'pendingStatus'
              | 'actionedDate'
              | 'requestedDate'
              | 'requestedBy'
              | 'role'
              | 'userId'
              | 'status'
            >
          >
          profileUser?: Maybe<
            { __typename?: 'User' } & Pick<
              User,
              'id' | 'email' | 'lastName' | 'firstName' | 'accountId' | 'phone'
            > & {
                market: { __typename?: 'Market' } & Pick<
                  Market,
                  'name' | 'locale' | 'distanceUnit'
                > & {
                    programs?: Maybe<
                      Array<
                        { __typename?: 'Program' } & Pick<
                          Program,
                          'id' | 'name' | 'code' | 'initials'
                        >
                      >
                    >
                  }
              }
          >
        })
    | ({ __typename?: 'ErrorResult' } & ErrorResultFieldsFragment)
  >
}

export type GetProfileMediaQueryVariables = Exact<{
  input: GetProfileByIdInput
  role: UserRoleInput
  _cacheKey?: Maybe<Scalars['String']>
}>

export type GetProfileMediaQuery = { __typename?: 'Query' } & {
  getProfileById?: Maybe<
    | ({ __typename?: 'GetProfileByIdResult' } & {
        profile?: Maybe<
          | ({ __typename?: 'UserProfileTeaching' } & {
              media?: Maybe<
                Array<{ __typename?: 'Image' } & ImageFieldsFragment>
              >
            })
          | ({ __typename?: 'UserProfileClub' } & {
              media?: Maybe<
                Array<{ __typename?: 'Image' } & ImageFieldsFragment>
              >
            })
        >
      })
    | ({ __typename?: 'ErrorResult' } & ErrorResultFieldsFragment)
  >
}

export type GetProfilesQueryVariables = Exact<{
  _cacheKey?: Maybe<Scalars['String']>
}>

export type GetProfilesQuery = { __typename?: 'Query' } & {
  getCurrentUser?: Maybe<
    | ({ __typename: 'UserResult' } & Pick<UserResult, 'id'> & {
          profiles: Array<
            | ({
                __typename?: 'UserProfileTeaching'
              } & InstructorProfileFieldsFragment)
            | ({ __typename?: 'UserProfileClub' } & ClubProfileFieldsFragment)
          >
        })
    | ({ __typename?: 'ErrorResult' } & ErrorResultFieldsFragment)
  >
}

export type GetSavedInstructorSearchDataQueryVariables = Exact<{
  input: GetSavedInstructorSearchDataInput
  _cacheKey?: Maybe<Scalars['String']>
}>

export type GetSavedInstructorSearchDataQuery = { __typename?: 'Query' } & {
  getSavedInstructorSearchData?: Maybe<
    | ({ __typename?: 'GetSavedInstructorSearchDataResult' } & {
        results: Array<
          {
            __typename?: 'SavedInstructorSearch'
          } & SavedInstructorSearchFragment
        >
      })
    | ({ __typename?: 'ErrorResult' } & ErrorResultFieldsFragment)
  >
}

export type GetSharedNavigationQueryVariables = Exact<{
  _cacheKey?: Maybe<Scalars['String']>
}>

export type GetSharedNavigationQuery = { __typename?: 'Query' } & {
  getSharedNavigation?: Maybe<
    | ({ __typename?: 'SharedNavigation' } & {
        instructorNav?: Maybe<
          { __typename?: 'SharedNavItem' } & Pick<SharedNavItem, 'role'> & {
              navItems?: Maybe<
                Array<
                  Maybe<
                    { __typename?: 'NavItem' } & Pick<
                      NavItem,
                      'key' | 'title' | 'description'
                    > & {
                        url: { __typename?: 'URL' } & Pick<
                          Url,
                          'type' | 'value'
                        >
                        image?: Maybe<
                          { __typename?: 'Image' } & Pick<
                            Image,
                            'id' | 'url' | 'alt' | 'height' | 'width'
                          >
                        >
                      }
                  >
                >
              >
            }
        >
        clubNav?: Maybe<
          { __typename?: 'SharedNavItem' } & Pick<SharedNavItem, 'role'> & {
              navItems?: Maybe<
                Array<
                  Maybe<
                    { __typename?: 'NavItem' } & Pick<
                      NavItem,
                      'key' | 'title' | 'description'
                    > & {
                        url: { __typename?: 'URL' } & Pick<
                          Url,
                          'type' | 'value'
                        >
                        image?: Maybe<
                          { __typename?: 'Image' } & Pick<
                            Image,
                            'id' | 'url' | 'alt' | 'height' | 'width'
                          >
                        >
                      }
                  >
                >
              >
            }
        >
        websiteLink: { __typename?: 'URL' } & Pick<Url, 'type' | 'value'>
      })
    | ({ __typename?: 'ErrorResult' } & ErrorResultFieldsFragment)
  >
}

export type GetClubInstructorShortlistQueryVariables = Exact<{
  input: GetProfileByIdInput
  role: UserRoleInput
  _cacheKey?: Maybe<Scalars['String']>
}>

export type GetClubInstructorShortlistQuery = { __typename?: 'Query' } & {
  getProfileById?: Maybe<
    | ({ __typename?: 'GetProfileByIdResult' } & {
        profile?: Maybe<
          | { __typename?: 'UserProfileTeaching' }
          | ({ __typename?: 'UserProfileClub' } & {
              shortlist?: Maybe<
                Array<
                  { __typename?: 'InstructorShortlist' } & Pick<
                    InstructorShortlist,
                    | 'id'
                    | 'lastMessageIn48HoursSentAt'
                    | 'distanceUnit'
                    | 'distance'
                    | 'hasExistingAffiliation'
                    | 'hasRecentlyDeclinedAffiliation'
                  > & {
                      profile: {
                        __typename?: 'UserProfileTeaching'
                      } & InstructorProfileFieldsFragment
                      user: { __typename?: 'User' } & Pick<
                        User,
                        'id' | 'lastName' | 'firstName'
                      >
                      instructorAffiliation?: Maybe<
                        { __typename?: 'Affiliation' } & Pick<
                          Affiliation,
                          | 'id'
                          | 'clubId'
                          | 'pendingStatus'
                          | 'actionedDate'
                          | 'requestedDate'
                          | 'requestedBy'
                          | 'role'
                          | 'userId'
                          | 'status'
                        >
                      >
                    }
                >
              >
            })
        >
      })
    | ({ __typename?: 'ErrorResult' } & ErrorResultFieldsFragment)
  >
}

export type GetTranslationsQueryVariables = Exact<{
  _cacheKey?: Maybe<Scalars['String']>
}>

export type GetTranslationsQuery = { __typename?: 'Query' } & {
  getAllTranslations?: Maybe<
    | ({ __typename?: 'GetAllTranslationsResult' } & Pick<
        GetAllTranslationsResult,
        'result'
      >)
    | ({ __typename?: 'ErrorResult' } & ErrorResultFieldsFragment)
  >
}

export type GetUserQueryVariables = Exact<{
  _cacheKey?: Maybe<Scalars['String']>
}>

export type GetUserQuery = { __typename?: 'Query' } & {
  getCurrentUser?: Maybe<
    | ({ __typename: 'UserResult' } & Pick<
        UserResult,
        'id' | 'distance' | 'distanceUnit'
      > & {
          user: { __typename?: 'User' } & Pick<
            User,
            'id' | 'email' | 'lastName' | 'firstName' | 'accountId' | 'phone'
          > & {
              market: { __typename?: 'Market' } & Pick<
                Market,
                'name' | 'locale' | 'distanceUnit'
              > & {
                  programs?: Maybe<
                    Array<
                      { __typename?: 'Program' } & Pick<
                        Program,
                        'id' | 'name' | 'code' | 'initials'
                      >
                    >
                  >
                }
              signedAgreements?: Maybe<
                Array<
                  { __typename?: 'SignedAgreement' } & Pick<
                    SignedAgreement,
                    'type' | 'signedOn' | 'version'
                  >
                >
              >
            }
          settings: { __typename?: 'UserSettings' } & Pick<
            UserSettings,
            'locale'
          >
          profiles: Array<
            | ({ __typename: 'UserProfileTeaching' } & Pick<
                UserProfileTeaching,
                'id'
              >)
            | ({ __typename: 'UserProfileClub' } & Pick<UserProfileClub, 'id'>)
          >
        })
    | ({ __typename?: 'ErrorResult' } & ErrorResultFieldsFragment)
  >
}

export type GetVideoGuidelinesQueryVariables = Exact<{
  _cacheKey?: Maybe<Scalars['String']>
}>

export type GetVideoGuidelinesQuery = { __typename?: 'Query' } & {
  getVideoGuidelines:
    | ({ __typename?: 'GetVideoGuidelinesResult' } & Pick<
        GetVideoGuidelinesResult,
        'contactUsEmail'
      > & {
          result: Array<
            { __typename?: 'SectionContentResult' } & Pick<
              SectionContentResult,
              'section'
            > & {
                content: Array<
                  { __typename?: 'ContentField' } & Pick<
                    ContentField,
                    'title' | 'subHeading' | 'contentText'
                  >
                >
              }
          >
        })
    | ({ __typename?: 'ErrorResult' } & ErrorResultFieldsFragment)
}

export type GetWalkthroughContentQueryVariables = Exact<{
  role: UserRoleInput
  _cacheKey?: Maybe<Scalars['String']>
}>

export type GetWalkthroughContentQuery = { __typename?: 'Query' } & {
  getWalkthrough?: Maybe<
    | ({ __typename?: 'Walkthrough' } & {
        pages: Array<
          { __typename?: 'WalkthroughPage' } & Pick<
            WalkthroughPage,
            'title' | 'body'
          > & {
              image: { __typename?: 'ImageSet' } & {
                desktop: { __typename?: 'Image' } & ImageFieldsFragment
                mobile: { __typename?: 'Image' } & ImageFieldsFragment
              }
            }
        >
      })
    | ({ __typename?: 'ErrorResult' } & ErrorResultFieldsFragment)
  >
}

export type IncrementViewClubListingCountMutationVariables = Exact<{
  input: IncrementViewClubListingCountInput
  _cacheKey?: Maybe<Scalars['String']>
}>

export type IncrementViewClubListingCountMutation = {
  __typename?: 'Mutation'
} & {
  incrementViewClubListingCount?: Maybe<
    | ({ __typename?: 'ClubListingResult' } & {
        results?: Maybe<
          Array<
            | ({
                __typename?: 'ClubSingleListing'
              } & SingleListingFieldsFragment)
            | ({ __typename?: 'ClubMultiListing' } & MultiListingFieldsFragment)
          >
        >
      })
    | ({ __typename?: 'ErrorResult' } & ErrorResultFieldsFragment)
  >
}

export type InitApplicationQueryVariables = Exact<{
  featureFlags: Array<Scalars['String']> | Scalars['String']
  _cacheKey?: Maybe<Scalars['String']>
}>

export type InitApplicationQuery = { __typename?: 'Query' } & {
  getUser?: Maybe<
    | ({ __typename?: 'UserResult' } & FullUserFieldFragment)
    | ({ __typename?: 'ErrorResult' } & ErrorResultFieldsFragment)
  >
  getAllTranslations?: Maybe<
    | ({ __typename?: 'GetAllTranslationsResult' } & Pick<
        GetAllTranslationsResult,
        'result' | 'locale'
      >)
    | ({ __typename?: 'ErrorResult' } & ErrorResultFieldsFragment)
  >
  getFeatureFlag?: Maybe<
    | ({ __typename?: 'FeatureFlagResult' } & {
        flags?: Maybe<
          Array<
            { __typename?: 'FeatureFlag' } & Pick<
              FeatureFlag,
              'featureFlag' | 'enabled'
            >
          >
        >
      })
    | ({ __typename?: 'ErrorResult' } & ErrorResultFieldsFragment)
  >
}

export type ManagePeopleCreateAffiliationsMutationVariables = Exact<{
  input: CreateAffiliationsInput
  _cacheKey?: Maybe<Scalars['String']>
}>

export type ManagePeopleCreateAffiliationsMutation = {
  __typename?: 'Mutation'
} & {
  createAffiliations:
    | ({ __typename?: 'ChainAffiliationsResult' } & {
        successfulAffiliations?: Maybe<
          Array<
            { __typename?: 'ChainAffiliation' } & Pick<
              ChainAffiliation,
              | 'actionedDate'
              | 'clubId'
              | 'id'
              | 'latestActionInitiator'
              | 'pendingStatus'
              | 'requestedBy'
              | 'requestedDate'
              | 'role'
              | 'status'
              | 'userId'
            >
          >
        >
      })
    | ({ __typename?: 'ErrorResult' } & ErrorResultFieldsFragment)
}

export type ManagePeopleRemoveAffiliationsMutationVariables = Exact<{
  input: DeleteAffiliationsInput
  _cacheKey?: Maybe<Scalars['String']>
}>

export type ManagePeopleRemoveAffiliationsMutation = {
  __typename?: 'Mutation'
} & {
  removeAffiliations:
    | ({ __typename?: 'ChainAffiliationsRemoveRresult' } & Pick<
        ChainAffiliationsRemoveRresult,
        'receivedAffiliationIds' | 'removedAffiliationIds' | 'removedUserId'
      >)
    | ({ __typename?: 'ErrorResult' } & ErrorResultFieldsFragment)
}

export type MarkNotificationsAsReadMutationVariables = Exact<{
  id: Array<Scalars['ID']> | Scalars['ID']
  role: UserRoleInput
  _cacheKey?: Maybe<Scalars['String']>
}>

export type MarkNotificationsAsReadMutation = { __typename?: 'Mutation' } & {
  toggleNotificationsRead?: Maybe<
    | ({ __typename: 'ToggleNotificationReadResult' } & Pick<
        ToggleNotificationReadResult,
        'success' | 'failure'
      >)
    | ({ __typename: 'ErrorResult' } & ErrorResultFieldsFragment)
  >
}

export type MarkNotificationsAsUnreadMutationVariables = Exact<{
  id: Array<Scalars['ID']> | Scalars['ID']
  role: UserRoleInput
  _cacheKey?: Maybe<Scalars['String']>
}>

export type MarkNotificationsAsUnreadMutation = { __typename?: 'Mutation' } & {
  toggleNotificationsRead?: Maybe<
    | ({ __typename: 'ToggleNotificationReadResult' } & Pick<
        ToggleNotificationReadResult,
        'success' | 'failure'
      >)
    | ({ __typename?: 'ErrorResult' } & ErrorResultFieldsFragment)
  >
}

export type AtHomeProductTileFragment = {
  __typename?: 'AtHomeProductTile'
} & Pick<AtHomeProductTile, 'title' | 'description'> & {
    onlineProgram: { __typename?: 'ClubOnlineProgram' } & Pick<
      ClubOnlineProgram,
      'id' | 'activeSince' | 'lastEnquiredOn'
    >
    buttons?: Maybe<
      Array<
        { __typename?: 'Link' } & Pick<Link, 'isPrimary' | 'id' | 'text'> & {
            url: { __typename?: 'URL' } & Pick<Url, 'type' | 'value'>
          }
      >
    >
    image: { __typename?: 'ImageSet' } & Pick<ImageSet, 'id'> & {
        desktop: { __typename?: 'Image' } & Pick<Image, 'id' | 'alt' | 'url'>
        mobile: { __typename?: 'Image' } & Pick<Image, 'id' | 'alt' | 'url'>
      }
    programs?: Maybe<
      Array<
        { __typename?: 'ClubProgram' } & Pick<
          ClubProgram,
          'id' | 'code' | 'name'
        >
      >
    >
  }

export type GetAtHomeItemsQueryVariables = Exact<{
  input: GetClubByIdInput
  _cacheKey?: Maybe<Scalars['String']>
}>

export type GetAtHomeItemsQuery = { __typename?: 'Query' } & {
  getClubById?: Maybe<
    | ({ __typename?: 'UserProfileClub' } & {
        atHomeProducts?: Maybe<
          { __typename?: 'GetAtHomeProductTilesResult' } & {
            active?: Maybe<
              Array<
                { __typename?: 'AtHomeProductTile' } & AtHomeProductTileFragment
              >
            >
            inactive?: Maybe<
              Array<
                { __typename?: 'AtHomeProductTile' } & AtHomeProductTileFragment
              >
            >
          }
        >
      })
    | ({ __typename?: 'ErrorResult' } & Pick<ErrorResult, 'type' | 'message'>)
  >
}

export type ExploreProgramTileFragment = {
  __typename?: 'InStudioExploreProgramsTile'
} & Pick<
  InStudioExploreProgramsTile,
  | 'productId'
  | 'name'
  | 'genre'
  | 'productCategories'
  | 'numberOfCertifiedInstructors'
  | 'enquirySent'
> & {
    image?: Maybe<{ __typename?: 'Image' } & Pick<Image, 'id' | 'alt' | 'url'>>
  }

export type GetExploreProgramsPageQueryVariables = Exact<{
  role: UserRoleInput
  _cacheKey?: Maybe<Scalars['String']>
}>

export type GetExploreProgramsPageQuery = { __typename?: 'Query' } & {
  getExploreProgramsPage?: Maybe<
    | ({ __typename?: 'ExploreProgramsPage' } & {
        products?: Maybe<
          Array<
            Maybe<
              {
                __typename?: 'InStudioExploreProgramsTile'
              } & ExploreProgramTileFragment
            >
          >
        >
      })
    | ({ __typename?: 'ErrorResult' } & Pick<ErrorResult, 'type' | 'message'>)
  >
}

export type InStudioDetailsViewFragment = {
  __typename?: 'InStudioDetailsView'
} & Pick<InStudioDetailsView, 'description' | 'videoContentId'> & {
    typeInfo?: Maybe<
      Array<
        Maybe<
          { __typename?: 'ProgramTypeInfo' } & Pick<
            ProgramTypeInfo,
            'description' | 'title'
          >
        >
      >
    >
    moreURL?: Maybe<{ __typename?: 'URL' } & Pick<Url, 'type' | 'value'>>
  }

export type DetailedExploreProgramTileFragment = {
  __typename?: 'InStudioExploreProgramsTile'
} & Pick<
  InStudioExploreProgramsTile,
  | 'productId'
  | 'name'
  | 'genre'
  | 'productCategories'
  | 'numberOfCertifiedInstructors'
  | 'enquirySent'
> & {
    image?: Maybe<{ __typename?: 'Image' } & Pick<Image, 'id' | 'alt' | 'url'>>
    detailView?: Maybe<
      { __typename?: 'InStudioDetailsView' } & InStudioDetailsViewFragment
    >
  }

export type GetExploreProgramsPageDetailedProgramQueryVariables = Exact<{
  role: UserRoleInput
  programName?: Maybe<ProgramName>
  _cacheKey?: Maybe<Scalars['String']>
}>

export type GetExploreProgramsPageDetailedProgramQuery = {
  __typename?: 'Query'
} & {
  getExploreProgramsPage?: Maybe<
    | ({ __typename?: 'ExploreProgramsPage' } & {
        products?: Maybe<
          Array<
            Maybe<
              {
                __typename?: 'InStudioExploreProgramsTile'
              } & DetailedExploreProgramTileFragment
            >
          >
        >
      })
    | ({ __typename?: 'ErrorResult' } & Pick<ErrorResult, 'type' | 'message'>)
  >
}

export type RemoveFromShortlistMutationVariables = Exact<{
  input: RemoveFromShortlistInput
  role: UserRoleInput
  _cacheKey?: Maybe<Scalars['String']>
}>

export type RemoveFromShortlistMutation = { __typename?: 'Mutation' } & {
  removeFromShortlist?: Maybe<
    | ({ __typename?: 'RemoveFromShortlistResult' } & {
        shortlist?: Maybe<
          Array<
            { __typename?: 'InstructorShortlist' } & Pick<
              InstructorShortlist,
              'id' | 'lastMessageIn48HoursSentAt' | 'distanceUnit' | 'distance'
            > & {
                profile: {
                  __typename?: 'UserProfileTeaching'
                } & InstructorProfileFieldsFragment
                user: { __typename?: 'User' } & Pick<
                  User,
                  'id' | 'lastName' | 'firstName'
                >
              }
          >
        >
      })
    | ({ __typename?: 'ErrorResult' } & ErrorResultFieldsFragment)
  >
}

export type ReportClubListingMutationVariables = Exact<{
  input: ReportClubListingInput
  _cacheKey?: Maybe<Scalars['String']>
}>

export type ReportClubListingMutation = { __typename?: 'Mutation' } & {
  reportClubListing?: Maybe<
    | { __typename: 'ClubSingleListing' }
    | { __typename: 'ClubMultiListing' }
    | ({ __typename: 'ErrorResult' } & ErrorResultFieldsFragment)
  >
}

export type ReportClubProfileMutationVariables = Exact<{
  input: ReportClubProfileInput
  _cacheKey?: Maybe<Scalars['String']>
}>

export type ReportClubProfileMutation = { __typename?: 'Mutation' } & {
  reportClubProfile?: Maybe<
    | { __typename: 'ClubProfile' }
    | ({ __typename: 'ErrorResult' } & ErrorResultFieldsFragment)
  >
}

export type RevertAppMetadataMutationVariables = Exact<{
  input: RevertAppMetadataInput
  _cacheKey?: Maybe<Scalars['String']>
}>

export type RevertAppMetadataMutation = { __typename?: 'Mutation' } & {
  revertAppMetadata:
    | ({ __typename?: 'AppMetadataResult' } & Pick<
        AppMetadataResult,
        'isSuccess'
      >)
    | ({ __typename?: 'ErrorResult' } & ErrorResultFieldsFragment)
}

export type SearchClubListingsQueryVariables = Exact<{
  filter: SearchClubListingsFilter
  options?: Maybe<SearchClubListingsOptions>
  _cacheKey?: Maybe<Scalars['String']>
}>

export type SearchClubListingsQuery = { __typename?: 'Query' } & {
  searchClubListings?: Maybe<
    | ({ __typename?: 'SearchClubListingsResult' } & Pick<
        SearchClubListingsResult,
        'total'
      > & {
          results?: Maybe<
            Array<
              | ({ __typename?: 'SearchClubJobListingsSingleResult' } & Pick<
                  SearchClubJobListingsSingleResult,
                  | 'distance'
                  | 'distanceUnit'
                  | 'messageSentOn'
                  | 'enquiredOn'
                  | 'onWatchlist'
                  | 'hasBeenReported'
                > & {
                    listing:
                      | ({
                          __typename?: 'ClubSingleListing'
                        } & SingleListingFieldsFragment)
                      | ({
                          __typename?: 'ClubMultiListing'
                        } & MultiListingFieldsFragment)
                  })
              | ({ __typename?: 'SearchClubProfileSingleResult' } & Pick<
                  SearchClubProfileSingleResult,
                  | 'distance'
                  | 'distanceUnit'
                  | 'onWatchlist'
                  | 'hasBeenReported'
                > & {
                    profile: {
                      __typename?: 'UserProfileClub'
                    } & ClubProfileFieldsFragment
                  })
            >
          >
        })
    | ({ __typename?: 'ErrorResult' } & ErrorResultFieldsFragment)
  >
}

export type SearchClubsQueryVariables = Exact<{
  filter: SearchClubsFilter
  options?: Maybe<SearchClubsOptions>
  _cacheKey?: Maybe<Scalars['String']>
}>

export type SearchClubsQuery = { __typename?: 'Query' } & {
  searchClubs?: Maybe<
    | ({ __typename?: 'SearchClubsResult' } & Pick<
        SearchClubsResult,
        'total'
      > & {
          results: Array<
            { __typename?: 'SearchClubsSingleResult' } & Pick<
              SearchClubsSingleResult,
              'clubId' | 'distance' | 'distanceUnit'
            > & {
                profile: {
                  __typename?: 'UserProfileClub'
                } & ClubProfileFieldsFragment
                instructorAffiliation?: Maybe<
                  { __typename?: 'Affiliation' } & Pick<
                    Affiliation,
                    | 'id'
                    | 'userId'
                    | 'clubId'
                    | 'requestedBy'
                    | 'actionedDate'
                    | 'status'
                    | 'pendingStatus'
                    | 'requestedDate'
                    | 'latestActionInitiator'
                  >
                >
              }
          >
        })
    | ({ __typename?: 'ErrorResult' } & ErrorResultFieldsFragment)
  >
}

export type SearchInstructorsSingleResultFragment = {
  __typename?: 'SearchInstructorsSingleResult'
} & Pick<
  SearchInstructorsSingleResult,
  | 'distance'
  | 'messageSentOn'
  | 'inTravelZone'
  | 'hasExistingAffiliation'
  | 'hasRecentlyDeclinedAffiliation'
  | 'lastMessageIn48HoursSentAt'
> & {
    instructorAffiliation?: Maybe<
      { __typename?: 'Affiliation' } & Pick<
        Affiliation,
        | 'id'
        | 'clubId'
        | 'pendingStatus'
        | 'actionedDate'
        | 'requestedDate'
        | 'requestedBy'
        | 'role'
        | 'userId'
        | 'status'
      >
    >
    profile: {
      __typename?: 'UserProfileTeaching'
    } & InstructorProfileFieldsFragment
    user: { __typename?: 'User' } & Pick<
      User,
      'id' | 'email' | 'lastName' | 'firstName' | 'accountId'
    > & {
        market: { __typename?: 'Market' } & Pick<
          Market,
          'name' | 'locale' | 'distanceUnit'
        >
      }
  }

export type SearchInstructorsResultFragment = {
  __typename?: 'SearchInstructorsResult'
} & Pick<SearchInstructorsResult, 'isMatchingFilter' | 'total'> & {
    results?: Maybe<
      Array<
        {
          __typename?: 'SearchInstructorsSingleResult'
        } & SearchInstructorsSingleResultFragment
      >
    >
  }

export type SearchInstructorsQueryVariables = Exact<{
  filter: SearchInstructorsFilter
  options?: Maybe<SearchInstructorsOptions>
  role: UserRoleInput
  _cacheKey?: Maybe<Scalars['String']>
}>

export type SearchInstructorsQuery = { __typename?: 'Query' } & {
  searchInstructors?: Maybe<
    | ({
        __typename?: 'SearchInstructorsResult'
      } & SearchInstructorsResultFragment)
    | ({ __typename?: 'ErrorResult' } & ErrorResultFieldsFragment)
  >
}

export type SendMessageMutationVariables = Exact<{
  input: SendMessageInput
  _cacheKey?: Maybe<Scalars['String']>
}>

export type SendMessageMutation = { __typename?: 'Mutation' } & {
  sendMessage?: Maybe<
    | ({ __typename?: 'SendMessageResult' } & Pick<SendMessageResult, 'sentAt'>)
    | ({ __typename?: 'ErrorResult' } & ErrorResultFieldsFragment)
  >
}

export type SetClubSettingsMutationVariables = Exact<{
  input: SetClubSettingsInput
  _cacheKey?: Maybe<Scalars['String']>
}>

export type SetClubSettingsMutation = { __typename?: 'Mutation' } & {
  setClubSettings?: Maybe<
    | ({ __typename?: 'SetClubSettingsResult' } & Pick<
        SetClubSettingsResult,
        'id' | 'name' | 'phone'
      > & {
          address?: Maybe<{ __typename?: 'Address' } & AddressFieldsFragment>
          email?: Maybe<
            { __typename?: 'EmailClubType' } & Pick<
              EmailClubType,
              'main' | 'affiliations' | 'jobListings'
            >
          >
        })
    | ({ __typename?: 'ErrorResult' } & ErrorResultFieldsFragment)
  >
}

export type SetInstructorAvailabilityMutationVariables = Exact<{
  input: SetInstructorAvailabilityInput
  _cacheKey?: Maybe<Scalars['String']>
}>

export type SetInstructorAvailabilityMutation = { __typename?: 'Mutation' } & {
  setInstructorAvailability?: Maybe<
    | ({ __typename?: 'InstructorAvailability' } & Pick<
        InstructorAvailability,
        'value' | 'availableToSubstitute'
      >)
    | ({ __typename?: 'ErrorResult' } & ErrorResultFieldsFragment)
  >
}

export type SetInstructorWatchlistMutationVariables = Exact<{
  input: SetInstructorWatchlistInput
  role: UserRoleInput
  _cacheKey?: Maybe<Scalars['String']>
}>

export type SetInstructorWatchlistMutation = { __typename?: 'Mutation' } & {
  setInstructorWatchlist?: Maybe<
    | ({ __typename?: 'InstructorWatchlist' } & {
        watchlist?: Maybe<
          Array<
            { __typename?: 'InstructorWatchlistItem' } & Pick<
              InstructorWatchlistItem,
              'clubId' | 'listingId'
            >
          >
        >
      })
    | ({ __typename?: 'ErrorResult' } & ErrorResultFieldsFragment)
  >
}

export type SetSavedInstructorSearchDataMutationVariables = Exact<{
  input: SetSavedInstructorSearchDataInput
  _cacheKey?: Maybe<Scalars['String']>
}>

export type SetSavedInstructorSearchDataMutation = {
  __typename?: 'Mutation'
} & {
  setSavedInstructorSearchData?: Maybe<
    | ({ __typename?: 'SetSavedInstructorSearchDataResult' } & {
        results: Array<
          {
            __typename?: 'SavedInstructorSearch'
          } & SavedInstructorSearchFragment
        >
      })
    | ({ __typename?: 'ErrorResult' } & ErrorResultFieldsFragment)
  >
}

export type SetSignedAgreementDataMutationVariables = Exact<{
  input: SetSignedAgreementDataInput
  _cacheKey?: Maybe<Scalars['String']>
}>

export type SetSignedAgreementDataMutation = { __typename?: 'Mutation' } & {
  setSignedAgreementData?: Maybe<
    | ({ __typename?: 'AgreementDocumentResult' } & Pick<
        AgreementDocumentResult,
        'signedOn' | 'version'
      > & { agreementType: AgreementDocumentResult['type'] })
    | ({ __typename?: 'ErrorResult' } & ErrorResultFieldsFragment)
  >
}

export type SetWalkthroughToSeenMutationVariables = Exact<{
  role: UserRoleInput
  _cacheKey?: Maybe<Scalars['String']>
}>

export type SetWalkthroughToSeenMutation = { __typename?: 'Mutation' } & {
  setWalkthroughToSeen?: Maybe<
    | ({ __typename?: 'SetWalkthroughToSeenResult' } & Pick<
        SetWalkthroughToSeenResult,
        'success'
      >)
    | ({ __typename?: 'ErrorResult' } & ErrorResultFieldsFragment)
  >
}

export type UpdateAffiliateBillingMutationVariables = Exact<{
  input: PayForCertificationInput
  _cacheKey?: Maybe<Scalars['String']>
}>

export type UpdateAffiliateBillingMutation = { __typename?: 'Mutation' } & {
  payForCertification?: Maybe<
    | ({ __typename?: 'PayForCertificationResult' } & {
        results?: Maybe<
          Array<
            { __typename?: 'InstructorCertificate' } & Pick<
              InstructorCertificate,
              'instructorName'
            > & {
                certificate?: Maybe<
                  { __typename?: 'Certification' } & Pick<
                    Certification,
                    | 'active'
                    | 'billedClubId'
                    | 'id'
                    | 'lastPurchase'
                    | 'lmqLevel'
                    | 'transactionStatus'
                    | 'releaseStatus'
                    | 'status'
                  > & {
                      pricePerQuarter?: Maybe<
                        { __typename?: 'CertificationPrice' } & Pick<
                          CertificationPrice,
                          'amount' | 'currency'
                        >
                      >
                      program: { __typename?: 'Program' } & Pick<
                        Program,
                        'code' | 'id' | 'initials' | 'name'
                      >
                    }
                >
              }
          >
        >
      })
    | ({ __typename?: 'ErrorResult' } & ErrorResultFieldsFragment)
  >
}

export type UpdateAffiliationMutationVariables = Exact<{
  input: UpdateAffiliationInput
  role: UserRoleInput
  _cacheKey?: Maybe<Scalars['String']>
}>

export type UpdateAffiliationMutation = { __typename?: 'Mutation' } & {
  updateAffiliation:
    | ({ __typename?: 'AffiliationAsyncResult' } & Pick<
        AffiliationAsyncResult,
        'status' | 'hasPendingAffiliations'
      >)
    | ({ __typename?: 'ErrorResult' } & ErrorResultFieldsFragment)
}

export type UpdateClubListingMutationVariables = Exact<{
  input: UpdateClubListingInput
  _cacheKey?: Maybe<Scalars['String']>
}>

export type UpdateClubListingMutation = { __typename?: 'Mutation' } & {
  updateClubListing?: Maybe<
    | ({ __typename?: 'ClubListingResult' } & {
        results?: Maybe<
          Array<
            | ({
                __typename?: 'ClubSingleListing'
              } & SingleListingFieldsFragment)
            | ({ __typename?: 'ClubMultiListing' } & MultiListingFieldsFragment)
          >
        >
      })
    | ({ __typename?: 'ErrorResult' } & ErrorResultFieldsFragment)
  >
}

export type UpdateClubProfileMutationVariables = Exact<{
  input: UpdateClubProfileInput
  _cacheKey?: Maybe<Scalars['String']>
}>

export type UpdateClubProfileMutation = { __typename?: 'Mutation' } & {
  updateClubProfile:
    | ({ __typename?: 'UserResult' } & FullUserFieldFragment)
    | ({ __typename?: 'ErrorResult' } & ErrorResultFieldsFragment)
}

export type FinishPortfolioUpdateMutationVariables = Exact<{
  input: UpdateCurrentUserPortfolioUploadInput
  role: UserRoleInput
  _cacheKey?: Maybe<Scalars['String']>
}>

export type FinishPortfolioUpdateMutation = { __typename?: 'Mutation' } & {
  updateCurrentUserPortfolioUpload:
    | ({ __typename?: 'UpdateCurrentUserPortfolioUploadResult' } & Pick<
        UpdateCurrentUserPortfolioUploadResult,
        'url'
      > & {
          profile:
            | ({
                __typename?: 'UserProfileTeaching'
              } & InstructorProfileFieldsFragment)
            | ({ __typename?: 'UserProfileClub' } & ClubProfileFieldsFragment)
        })
    | ({ __typename?: 'ErrorResult' } & ErrorResultFieldsFragment)
}

export type UpdateTeachingProfileMutationVariables = Exact<{
  input: UpdateTeachingProfileInput
  _cacheKey?: Maybe<Scalars['String']>
}>

export type UpdateTeachingProfileMutation = { __typename?: 'Mutation' } & {
  updateTeachingProfile:
    | ({ __typename?: 'UserResult' } & FullUserFieldFragment)
    | ({ __typename?: 'ErrorResult' } & ErrorResultFieldsFragment)
}

export type UpdateUserAccountMutationVariables = Exact<{
  input: UpdateUserAccountInput
  _cacheKey?: Maybe<Scalars['String']>
}>

export type UpdateUserAccountMutation = { __typename?: 'Mutation' } & {
  updateUserAccount:
    | ({ __typename?: 'UserAccountSettingsResult' } & Pick<
        UserAccountSettingsResult,
        'email' | 'firstName' | 'id' | 'lastName' | 'phone'
      > & {
          address?: Maybe<{ __typename?: 'Address' } & AddressFieldsFragment>
          outlinks?: Maybe<
            Array<{ __typename?: 'OutLink' } & Pick<OutLink, 'url' | 'title'>>
          >
        })
    | ({ __typename?: 'ErrorResult' } & ErrorResultFieldsFragment)
}

export type UpdateUserPhotoMutationVariables = Exact<{
  input: UpdateUserPhotoInput
  _cacheKey?: Maybe<Scalars['String']>
}>

export type UpdateUserPhotoMutation = { __typename?: 'Mutation' } & {
  updateUserPhoto?: Maybe<
    | ({ __typename?: 'UpdateUserPhotoResult' } & Pick<
        UpdateUserPhotoResult,
        'url'
      > & {
          profile:
            | ({
                __typename?: 'UserProfileTeaching'
              } & InstructorProfileFieldsFragment)
            | ({ __typename?: 'UserProfileClub' } & ClubProfileFieldsFragment)
        })
    | ({ __typename?: 'ErrorResult' } & ErrorResultFieldsFragment)
  >
}

export type FinalizeUploadMutationVariables = Exact<{
  input: FinalizeUploadInput
  _cacheKey?: Maybe<Scalars['String']>
}>

export type FinalizeUploadMutation = { __typename?: 'Mutation' } & {
  finalizeUpload?: Maybe<
    | ({ __typename?: 'FinalizeUploadResult' } & Pick<
        FinalizeUploadResult,
        'isSuccess' | 'comment'
      > & {
          playback: { __typename?: 'Playback' } & Pick<
            Playback,
            'playbackUrl' | 'token'
          >
        })
    | ({ __typename?: 'ErrorResult' } & Pick<ErrorResult, 'message'>)
  >
}

export type GetPresignedUrlQueryVariables = Exact<{
  input: GetPresignedUrlInput
  _cacheKey?: Maybe<Scalars['String']>
}>

export type GetPresignedUrlQuery = { __typename?: 'Query' } & {
  getPresignedUrl?: Maybe<
    | ({ __typename?: 'GetPresignedUrlResult' } & {
        partSignedUrlList: Array<
          { __typename?: 'PartSignedUrl' } & Pick<
            PartSignedUrl,
            'partNumber' | 'url'
          >
        >
      })
    | ({ __typename?: 'ErrorResult' } & Pick<ErrorResult, 'message'>)
  >
}

export type InitializeUploadMutationVariables = Exact<{
  input: InitializeUploadInput
  _cacheKey?: Maybe<Scalars['String']>
}>

export type InitializeUploadMutation = { __typename?: 'Mutation' } & {
  initializeUpload?: Maybe<
    | ({ __typename?: 'InitializeUploadResult' } & Pick<
        InitializeUploadResult,
        'uploadId'
      >)
    | ({ __typename?: 'ErrorResult' } & Pick<ErrorResult, 'message'>)
  >
}

export const InStudioClubProgramFragmentDoc = gql`
  fragment InStudioClubProgram on ClubProgram {
    id
    code
    name
    status
    initials
    programType
    instructorCount {
      numberOfInstructors
      belowRecommendedAmount
      lastEnquiredOn
    }
  }
`
export const UrlFieldsFragmentDoc = gql`
  fragment urlFields on URL {
    type
    value
  }
`
export const LinkFieldsFragmentDoc = gql`
  fragment linkFields on Link {
    id
    text
    url {
      ...urlFields
    }
  }
  ${UrlFieldsFragmentDoc}
`
export const InStudioEmptyStateFragmentDoc = gql`
  fragment InStudioEmptyState on ClubProgramInStudioEmptyState {
    programType
    content {
      subtitle
      title
      link {
        ...linkFields
      }
    }
  }
  ${LinkFieldsFragmentDoc}
`
export const ImageFieldsFragmentDoc = gql`
  fragment imageFields on Image {
    __typename
    id
    url
    alt
    height
    width
  }
`
export const InStudioToolkitTileFragmentDoc = gql`
  fragment InStudioToolkitTile on InStudioToolkitTile {
    image {
      ...imageFields
    }
    link {
      ...linkFields
    }
    subTitle
    title
  }
  ${ImageFieldsFragmentDoc}
  ${LinkFieldsFragmentDoc}
`
export const EventSummaryFieldsFragmentDoc = gql`
  fragment eventSummaryFields on EventSummary {
    deliveryMethod
    endDate
    eventId
    eventName
    eventStatus
    programName
    startDate
    trainingJourneyCount
    venueAddress
  }
`
export const DevelopmentSheetFieldsFragmentDoc = gql`
  fragment developmentSheetFields on DevelopmentSheet {
    filename
    url
  }
`
export const EmergencyContactFieldsFragmentDoc = gql`
  fragment emergencyContactFields on EmergencyContact {
    address
    name
    phone
  }
`
export const InstructorInfoFieldsFragmentDoc = gql`
  fragment instructorInfoFields on InstructorInformation {
    address
    email
    name
    phone
  }
`
export const PlaybackFieldsFragmentDoc = gql`
  fragment playbackFields on Playback {
    playbackUrl
    token
  }
`
export const OutcomeTrackFieldsFragmentDoc = gql`
  fragment outcomeTrackFields on OutcomeTrack {
    comment
    submittedAt
    playback {
      ...playbackFields
    }
  }
  ${PlaybackFieldsFragmentDoc}
`
export const PresentationTrackFieldsFragmentDoc = gql`
  fragment presentationTrackFields on PresentationTrack {
    comment
    submittedAt
    playback {
      ...playbackFields
    }
  }
  ${PlaybackFieldsFragmentDoc}
`
export const EventAssessmentFieldsFragmentDoc = gql`
  fragment eventAssessmentFields on EventAssessments {
    attended
    developmentSheet {
      ...developmentSheetFields
    }
    emergencyContact {
      ...emergencyContactFields
    }
    instructorInfo {
      ...instructorInfoFields
    }
    outcome
    outcomeTrack {
      ...outcomeTrackFields
    }
    presentationTrack {
      ...presentationTrackFields
    }
    sessionRegistrationId
    trainingJourneyId
    trackAllocation
  }
  ${DevelopmentSheetFieldsFragmentDoc}
  ${EmergencyContactFieldsFragmentDoc}
  ${InstructorInfoFieldsFragmentDoc}
  ${OutcomeTrackFieldsFragmentDoc}
  ${PresentationTrackFieldsFragmentDoc}
`
export const StepFieldsFragmentDoc = gql`
  fragment stepFields on Step {
    activeStepName
    activeStepNumber
    attended
    cancellationPolicy
    passPendingGuide
    deliveryMethod
    details
    dueDate
    endDate
    eventName
    fulfillment
    level
    onlineTrainingLink
    programName
    requirements
    schedule
    startDate
    stepName
    stepNumber
    timezone
    trackAllocation
    trainerEmail
    trainerName
    venueAddress
    contactUsEmail
  }
`
export const TrainingBookedStepFieldsFragmentDoc = gql`
  fragment trainingBookedStepFields on TrainingBookedStep {
    activeStepName
    activeStepNumber
    attended
    cancellationPolicy
    passPendingGuide
    deliveryMethod
    details
    dueDate
    endDate
    eventName
    fulfillment
    level
    onlineTrainingLink
    programName
    requirements
    schedule
    startDate
    stepName
    stepNumber
    timezone
    trackAllocation
    trainerEmail
    trainerName
    parqForm
    venueAddress
    contactUsEmail
    emergencyContact {
      ...emergencyContactFields
    }
  }
  ${EmergencyContactFieldsFragmentDoc}
`
export const AssessmentVideoFieldsFragmentDoc = gql`
  fragment assessmentVideoFields on AssessmentVideo {
    assessmentId
    comment
    fileKey
    submitted
    submittedDate
    recordType
    videoNotWorking
    playback {
      ...playbackFields
    }
    extensionRequested
  }
  ${PlaybackFieldsFragmentDoc}
`
export const PreworkContentItemFieldsFragmentDoc = gql`
  fragment PreworkContentItemFields on PreworkContentItem {
    title
    type
    url {
      ...urlFields
    }
  }
  ${UrlFieldsFragmentDoc}
`
export const PreworkContentFieldsFragmentDoc = gql`
  fragment preworkContentFields on PreworkContent {
    contentList {
      ...PreworkContentItemFields
    }
  }
  ${PreworkContentItemFieldsFragmentDoc}
`
export const PreworkStepFieldsFragmentDoc = gql`
  fragment preworkStepFields on PreworkStep {
    activeStepName
    activeStepNumber
    assessmentVideo {
      ...assessmentVideoFields
    }
    attended
    cancellationPolicy
    passPendingGuide
    preworkContent {
      ...preworkContentFields
    }
    deliveryMethod
    details
    dueDate
    endDate
    eventName
    fulfillment
    level
    onlineTrainingLink
    programName
    releaseUrl {
      ...linkFields
    }
    requirements
    schedule
    startDate
    stepName
    stepNumber
    timezone
    trackAllocation
    trainerEmail
    trainerName
    venueAddress
    contactUsEmail
  }
  ${AssessmentVideoFieldsFragmentDoc}
  ${PreworkContentFieldsFragmentDoc}
  ${LinkFieldsFragmentDoc}
`
export const AttendTrainingStepFieldsFragmentDoc = gql`
  fragment attendTrainingStepFields on AttendTrainingStep {
    activeStepName
    activeStepNumber
    attended
    cancellationPolicy
    passPendingGuide
    deliveryMethod
    details
    dueDate
    endDate
    eventName
    fulfillment
    level
    onlineTrainingLink
    programName
    requirements
    schedule
    startDate
    stepName
    stepNumber
    timezone
    trackAllocation
    trainerEmail
    trainerName
    venueAddress
    contactUsEmail
  }
`
export const SubmitOutcomeTrackStepFieldsFragmentDoc = gql`
  fragment submitOutcomeTrackStepFields on SubmitOutcomeTrackStep {
    activeStepName
    activeStepNumber
    attended
    cancellationPolicy
    passPendingGuide
    deliveryMethod
    details
    dueDate
    endDate
    eventName
    fulfillment
    level
    onlineTrainingLink
    programName
    requirements
    schedule
    startDate
    stepName
    stepNumber
    timezone
    trackAllocation
    trainerEmail
    trainerName
    extendedDueDate
    venueAddress
    contactUsEmail
    assessmentVideo {
      ...assessmentVideoFields
    }
  }
  ${AssessmentVideoFieldsFragmentDoc}
`
export const TrainingOutcomeFieldsFragmentDoc = gql`
  fragment trainingOutcomeFields on TrainingOutcome {
    developmentSheet
    outcome
    submitDate
    trainingNotes
    assessmentVideo {
      ...assessmentVideoFields
    }
  }
  ${AssessmentVideoFieldsFragmentDoc}
`
export const ReceivedTrainingOutcomeStepFieldsFragmentDoc = gql`
  fragment receivedTrainingOutcomeStepFields on ReceivedTrainingOutcomeStep {
    activeStepName
    activeStepNumber
    attended
    cancellationPolicy
    passPendingGuide
    deliveryMethod
    details
    dueDate
    endDate
    eventName
    fulfillment
    level
    onlineTrainingLink
    programName
    requirements
    schedule
    startDate
    stepName
    stepNumber
    timezone
    trackAllocation
    trainerEmail
    trainerName
    cecCertificationUrl
    extendedDueDate
    venueAddress
    contactUsEmail
    assessmentOutcomes {
      ...trainingOutcomeFields
    }
  }
  ${TrainingOutcomeFieldsFragmentDoc}
`
export const SubmitCertificationVideoStepFieldsFragmentDoc = gql`
  fragment submitCertificationVideoStepFields on SubmitCertificationVideoStep {
    activeStepName
    activeStepNumber
    attended
    cancellationPolicy
    passPendingGuide
    deliveryMethod
    details
    dueDate
    endDate
    eventName
    fulfillment
    level
    onlineTrainingLink
    programName
    requirements
    schedule
    startDate
    stepName
    stepNumber
    timezone
    trackAllocation
    trainerEmail
    trainerName
    extendedDueDate
    venueAddress
    contactUsEmail
    assessmentVideo {
      ...assessmentVideoFields
    }
  }
  ${AssessmentVideoFieldsFragmentDoc}
`
export const ReceivedCertificationOutcomeStepFieldsFragmentDoc = gql`
  fragment receivedCertificationOutcomeStepFields on ReceivedCertificationOutcomeStep {
    activeStepName
    activeStepNumber
    attended
    cancellationPolicy
    passPendingGuide
    deliveryMethod
    details
    dueDate
    endDate
    eventName
    fulfillment
    level
    onlineTrainingLink
    programName
    requirements
    schedule
    startDate
    stepName
    stepNumber
    timezone
    trackAllocation
    trainerEmail
    trainerName
    resubmitDueDate
    certificationUrl
    venueAddress
    contactUsEmail
    certificationOutcomes {
      ...trainingOutcomeFields
    }
  }
  ${TrainingOutcomeFieldsFragmentDoc}
`
export const CertifiedStepFieldsFragmentDoc = gql`
  fragment certifiedStepFields on CertifiedStep {
    activeStepName
    activeStepNumber
    attended
    cancellationPolicy
    deliveryMethod
    details
    dueDate
    endDate
    eventName
    fulfillment
    level
    onlineTrainingLink
    passPendingGuide
    programName
    requirements
    schedule
    startDate
    stepName
    stepNumber
    timezone
    trackAllocation
    trainerEmail
    trainerName
    contactUsEmail
    venueAddress
  }
`
export const InstructorAvailabilityFieldsFragmentDoc = gql`
  fragment instructorAvailabilityFields on InstructorAvailability {
    description
    title
    value
  }
`
export const AddressFieldsFragmentDoc = gql`
  fragment addressFields on Address {
    city
    state
    street
    country
    stateCode
    postalCode
    streetName
    countryCode
    streetNumber
    location {
      lat
      lon
    }
  }
`
export const ProgramFieldsFragmentDoc = gql`
  fragment programFields on Program {
    code
    id
    initials
    name
  }
`
export const TimePreferencesFragmentDoc = gql`
  fragment timePreferences on TimePreference {
    morning
    afternoon
    evening
  }
`
export const TravelPreferencesFragmentDoc = gql`
  fragment travelPreferences on TravelPreference {
    address {
      ...addressFields
    }
    distance
    distanceUnit
  }
  ${AddressFieldsFragmentDoc}
`
export const PreferenceFieldsFragmentDoc = gql`
  fragment preferenceFields on InstructorPreferences {
    programs {
      ...programFields
    }
    times {
      ...timePreferences
    }
    travel {
      ...travelPreferences
    }
  }
  ${ProgramFieldsFragmentDoc}
  ${TimePreferencesFragmentDoc}
  ${TravelPreferencesFragmentDoc}
`
export const PrivacyFieldsFragmentDoc = gql`
  fragment privacyFields on PrivacySettingsInstructor {
    EMAIL
    PHONE_NUMBER
    PROFILE_PHOTO
    SOCIAL_LINKS
    LMQ_LEVEL
    HIDDEN
  }
`
export const InstructorProfileFieldsFragmentDoc = gql`
  fragment instructorProfileFields on UserProfileTeaching {
    id
    __typename
    id
    bio
    address {
      ...addressFields
    }
    roles
    strength
    interests
    createdAt
    availability
    createdAtLabel
    availableToSubstitute
    preferences {
      ...preferenceFields
    }
    privacySettings {
      ...privacyFields
    }
    media {
      ...imageFields
    }
    profileImage {
      ...imageFields
    }
    links {
      url
      type
    }
    certifications {
      id
      lastPurchase
      pricePerQuarter {
        amount
        currency
      }
      transactionStatus
      transactionTimestamp
      billedClubId
      releaseStatus
      status
      active
      lmqLevel
      link {
        ...linkFields
      }
      program {
        id
        name
        code
        initials
      }
    }
    watchlist {
      clubId
      listingId
    }
  }
  ${AddressFieldsFragmentDoc}
  ${PreferenceFieldsFragmentDoc}
  ${PrivacyFieldsFragmentDoc}
  ${ImageFieldsFragmentDoc}
  ${LinkFieldsFragmentDoc}
`
export const ClubProfileFieldsFragmentDoc = gql`
  fragment clubProfileFields on UserProfileClub {
    id
    __typename
    bio
    name
    email
    phone
    hiring
    address {
      ...addressFields
    }
    strength
    createdAt
    createdAtLabel
    programs {
      ... on ClubProgram {
        __typename
        id
        name
        code
        initials
        programType
      }
    }
    media {
      ...imageFields
    }
    profileImage {
      ...imageFields
    }
    links {
      url
      type
    }
    isDigitalOnly
  }
  ${AddressFieldsFragmentDoc}
  ${ImageFieldsFragmentDoc}
`
export const FullUserFieldFragmentDoc = gql`
  fragment fullUserField on UserResult {
    __typename
    id
    distance
    distanceUnit
    user {
      id
      email
      market {
        isSupported
        name
        locale
        distanceUnit
        programs {
          id
          name
          code
          initials
        }
      }
      lastName
      firstName
      accountId
      phone
      signedAgreements {
        type
        signedOn
        version
      }
      userMetaData {
        walkthroughRequired {
          club
          instructor
        }
      }
    }
    profiles {
      ... on UserProfileTeaching {
        ...instructorProfileFields
      }
      ... on UserProfileClub {
        ...clubProfileFields
      }
    }
    settings {
      locale
    }
  }
  ${InstructorProfileFieldsFragmentDoc}
  ${ClubProfileFieldsFragmentDoc}
`
export const SingleListingFieldsFragmentDoc = gql`
  fragment singleListingFields on ClubSingleListing {
    clubInfo {
      id
      name
      address {
        ...addressFields
      }
      profileImage {
        url
      }
      programs {
        ... on ClubProgram {
          name
        }
      }
      hiring
    }
    createdAt
    description
    expiringAt
    id
    searchAppearances
    updatedAt
    views
    isSubstituteListing
    program {
      code
      id
      initials
      name
    }
    status
    times {
      ...timePreferences
    }
    enquiriesCount
  }
  ${AddressFieldsFragmentDoc}
  ${TimePreferencesFragmentDoc}
`
export const MultiListingFieldsFragmentDoc = gql`
  fragment multiListingFields on ClubMultiListing {
    clubInfo {
      id
      name
      address {
        ...addressFields
      }
      profileImage {
        url
      }
      programs {
        ... on ClubProgram {
          name
        }
      }
    }
    createdAt
    description
    expiringAt
    id
    searchAppearances
    programs {
      code
      id
      initials
      name
    }
    status
    updatedAt
    views
    enquiriesCount
  }
  ${AddressFieldsFragmentDoc}
`
export const SavedInstructorSearchFragmentDoc = gql`
  fragment savedInstructorSearch on SavedInstructorSearch {
    filter {
      name
      programs
      substituteListingFilter
      location {
        within {
          address {
            ...addressFields
          }
          area {
            points {
              lat
              lon
            }
          }
        }
        near {
          address {
            ...addressFields
          }
          distance
          distanceUnit
        }
        point {
          lat
          lon
        }
      }
    }
    sort
  }
  ${AddressFieldsFragmentDoc}
`
export const ErrorResultFieldsFragmentDoc = gql`
  fragment errorResultFields on ErrorResult {
    type
    message
    requestId
    logGroup
    logStream
    __typename
  }
`
export const ClubFieldsFragmentDoc = gql`
  fragment clubFields on Club {
    accountId
    createdAt
    currency
    email {
      affiliations
      jobListings
      main
    }
    id
    market {
      name
      locale
      distanceUnit
      programs {
        id
        name
        code
        initials
      }
    }
    name
    parent
    phone
    profile {
      ... on UserProfileClub {
        ...clubProfileFields
      }
    }
  }
  ${ClubProfileFieldsFragmentDoc}
`
export const ManagePeopleUserAffiliateFieldsFragmentDoc = gql`
  fragment managePeopleUserAffiliateFields on User {
    id
    phone
    email
    accountId
    market {
      name
      locale
      distanceUnit
    }
    lastName
    firstName
  }
`
export const AffiliationFieldsFragmentDoc = gql`
  fragment affiliationFields on Affiliation {
    actionedDate
    clubId
    id
    latestActionInitiator
    pendingStatus
    requestedBy
    requestedDate
    role
    status
    userId
  }
`
export const ClubWithAffiliationFragmentDoc = gql`
  fragment clubWithAffiliation on ClubWithAffiliation {
    clubId
    clubName
    latestAffiliation {
      ...affiliationFields
    }
    isDigitalOnly
  }
  ${AffiliationFieldsFragmentDoc}
`
export const ManagePeopleClubAffiliatesFieldsFragmentDoc = gql`
  fragment managePeopleClubAffiliatesFields on ClubAffiliates {
    actionedDate
    clubId
    distance
    distanceUnit
    id
    pendingStatus
    profile {
      ... on UserProfileClub {
        ...clubProfileFields
      }
    }
    requestedBy
    requestedDate
    status
  }
  ${ClubProfileFieldsFragmentDoc}
`
export const BusinessSupportSectionContentFragmentDoc = gql`
  fragment BusinessSupportSectionContent on BusinessSupportSection {
    id
    sectionTitle
    sectionTiles {
      id
      title
      subtitle
      image {
        id
        alt
        url
      }
      url {
        type
        value
      }
    }
  }
`
export const ClubDashboardBusinessSupportContentFragmentDoc = gql`
  fragment ClubDashboardBusinessSupportContent on ClubPartnershipBusinessSupportContent {
    link {
      text
      url {
        type
        value
      }
    }
    title
    description
  }
`
export const ClubDashboardStandardContentFragmentDoc = gql`
  fragment ClubDashboardStandardContent on ClubPartnershipStandardContent {
    title
    subtitle
    link {
      url {
        type
        value
      }
      text
    }
    image {
      mobile {
        alt
        url
      }
      desktop {
        alt
        url
      }
    }
  }
`
export const ClubDashboardProgramInfoFragmentDoc = gql`
  fragment ClubDashboardProgramInfo on ClubPartnershipProgramStat {
    total
    type
    icon {
      alt
      url
    }
  }
`
export const ClubDashboardProgramStatsFragmentDoc = gql`
  fragment ClubDashboardProgramStats on ClubPartnershipProgramStats {
    programsStats {
      ...ClubDashboardProgramInfo
    }
  }
  ${ClubDashboardProgramInfoFragmentDoc}
`
export const InStudioManageOptionsFragmentDoc = gql`
  fragment InStudioManageOptions on GetPickListResult {
    results {
      items
      key
    }
  }
`
export const LocationsFragmentDoc = gql`
  fragment locations on ClubAvailabilityOnListing {
    clubId
    clubName
    isAlreadyListed
    isClubLicensed
    clubProfileImage {
      ...imageFields
    }
    clubAddress {
      ...addressFields
    }
  }
  ${ImageFieldsFragmentDoc}
  ${AddressFieldsFragmentDoc}
`
export const NotificationItemFragmentDoc = gql`
  fragment notificationItem on Notification {
    id
    type
    body
    title
    createdAt
    createdAtLabel
    readAt
    link {
      id
      text
      url {
        type
        value
      }
    }
  }
`
export const NotificationsResultFragmentDoc = gql`
  fragment notificationsResult on GetNotificationsResult {
    filter {
      type
      value
      limit
    }
    totalCount
    items {
      ...notificationItem
    }
  }
  ${NotificationItemFragmentDoc}
`
export const AtHomeProductTileFragmentDoc = gql`
  fragment AtHomeProductTile on AtHomeProductTile {
    title
    description
    onlineProgram {
      id
      activeSince
      lastEnquiredOn
    }
    buttons {
      isPrimary
      id
      text
      url {
        type
        value
      }
    }
    image {
      id
      desktop {
        id
        alt
        url
      }
      mobile {
        id
        alt
        url
      }
    }
    programs {
      id
      code
      name
    }
  }
`
export const ExploreProgramTileFragmentDoc = gql`
  fragment ExploreProgramTile on InStudioExploreProgramsTile {
    productId
    name
    genre
    productCategories
    numberOfCertifiedInstructors
    enquirySent
    image {
      id
      alt
      url
    }
  }
`
export const InStudioDetailsViewFragmentDoc = gql`
  fragment InStudioDetailsView on InStudioDetailsView {
    typeInfo {
      description
      title
    }
    description
    videoContentId
    moreURL {
      type
      value
    }
  }
`
export const DetailedExploreProgramTileFragmentDoc = gql`
  fragment DetailedExploreProgramTile on InStudioExploreProgramsTile {
    productId
    name
    genre
    productCategories
    numberOfCertifiedInstructors
    enquirySent
    image {
      id
      alt
      url
    }
    detailView {
      ...InStudioDetailsView
    }
  }
  ${InStudioDetailsViewFragmentDoc}
`
export const SearchInstructorsSingleResultFragmentDoc = gql`
  fragment searchInstructorsSingleResult on SearchInstructorsSingleResult {
    distance
    messageSentOn
    inTravelZone
    hasExistingAffiliation
    hasRecentlyDeclinedAffiliation
    lastMessageIn48HoursSentAt
    instructorAffiliation {
      id
      clubId
      pendingStatus
      actionedDate
      requestedDate
      requestedBy
      role
      userId
      status
    }
    profile {
      ... on UserProfileTeaching {
        ...instructorProfileFields
      }
    }
    user {
      id
      email
      lastName
      firstName
      accountId
      market {
        name
        locale
        distanceUnit
      }
    }
  }
  ${InstructorProfileFieldsFragmentDoc}
`
export const SearchInstructorsResultFragmentDoc = gql`
  fragment searchInstructorsResult on SearchInstructorsResult {
    isMatchingFilter
    total
    results {
      ...searchInstructorsSingleResult
    }
  }
  ${SearchInstructorsSingleResultFragmentDoc}
`
export const GetClubProgramsForInStudioPageDocument = gql`
  query getClubProgramsForInStudioPage(
    $input: GetClubByIdInput!
    $_cacheKey: String
  ) {
    getClubById(input: $input, _cacheKey: $_cacheKey) {
      ... on UserProfileClub {
        programs {
          ... on ClubProgram {
            ...InStudioClubProgram
          }
          ... on ClubProgramInStudioEmptyState {
            ...InStudioEmptyState
          }
        }
        inStudioToolkit {
          tiles {
            ...InStudioToolkitTile
          }
        }
        exploreProgramsCard {
          image {
            ...imageFields
          }
        }
      }
      ... on ErrorResult {
        type
        message
      }
    }
  }
  ${InStudioClubProgramFragmentDoc}
  ${InStudioEmptyStateFragmentDoc}
  ${InStudioToolkitTileFragmentDoc}
  ${ImageFieldsFragmentDoc}
`

/**
 * __useGetClubProgramsForInStudioPageQuery__
 *
 * To run a query within a React component, call `useGetClubProgramsForInStudioPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClubProgramsForInStudioPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClubProgramsForInStudioPageQuery({
 *   variables: {
 *      input: // value for 'input'
 *      _cacheKey: // value for '_cacheKey'
 *   },
 * });
 */
export function useGetClubProgramsForInStudioPageQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetClubProgramsForInStudioPageQuery,
    GetClubProgramsForInStudioPageQueryVariables
  >
) {
  return Apollo.useQuery<
    GetClubProgramsForInStudioPageQuery,
    GetClubProgramsForInStudioPageQueryVariables
  >(GetClubProgramsForInStudioPageDocument, baseOptions)
}
export function useGetClubProgramsForInStudioPageLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetClubProgramsForInStudioPageQuery,
    GetClubProgramsForInStudioPageQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    GetClubProgramsForInStudioPageQuery,
    GetClubProgramsForInStudioPageQueryVariables
  >(GetClubProgramsForInStudioPageDocument, baseOptions)
}
export type GetClubProgramsForInStudioPageQueryHookResult = ReturnType<
  typeof useGetClubProgramsForInStudioPageQuery
>
export type GetClubProgramsForInStudioPageLazyQueryHookResult = ReturnType<
  typeof useGetClubProgramsForInStudioPageLazyQuery
>
export type GetClubProgramsForInStudioPageQueryResult = Apollo.QueryResult<
  GetClubProgramsForInStudioPageQuery,
  GetClubProgramsForInStudioPageQueryVariables
>
export const AddTrainingOutcomeDocument = gql`
  mutation addTrainingOutcome(
    $input: AddTrainingOutcomeInput!
    $_cacheKey: String
  ) {
    addTrainingOutcome(input: $input, _cacheKey: $_cacheKey) {
      ... on AddTrainingOutcomeResult {
        isSuccess
        developmentSheet {
          filename
          url
        }
      }
      ... on ErrorResult {
        ...errorResultFields
      }
    }
  }
  ${ErrorResultFieldsFragmentDoc}
`
export type AddTrainingOutcomeMutationFn = Apollo.MutationFunction<
  AddTrainingOutcomeMutation,
  AddTrainingOutcomeMutationVariables
>

/**
 * __useAddTrainingOutcomeMutation__
 *
 * To run a mutation, you first call `useAddTrainingOutcomeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTrainingOutcomeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTrainingOutcomeMutation, { data, loading, error }] = useAddTrainingOutcomeMutation({
 *   variables: {
 *      input: // value for 'input'
 *      _cacheKey: // value for '_cacheKey'
 *   },
 * });
 */
export function useAddTrainingOutcomeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddTrainingOutcomeMutation,
    AddTrainingOutcomeMutationVariables
  >
) {
  return Apollo.useMutation<
    AddTrainingOutcomeMutation,
    AddTrainingOutcomeMutationVariables
  >(AddTrainingOutcomeDocument, baseOptions)
}
export type AddTrainingOutcomeMutationHookResult = ReturnType<
  typeof useAddTrainingOutcomeMutation
>
export type AddTrainingOutcomeMutationResult =
  Apollo.MutationResult<AddTrainingOutcomeMutation>
export type AddTrainingOutcomeMutationOptions = Apollo.BaseMutationOptions<
  AddTrainingOutcomeMutation,
  AddTrainingOutcomeMutationVariables
>
export const BookEventDocument = gql`
  mutation bookEvent($input: BookEventInput!, $role: UserRoleInput!) {
    bookEvent(input: $input, role: $role) {
      ... on BookEventResult {
        magentoLink
      }
      ... on ErrorResult {
        ...errorResultFields
      }
    }
  }
  ${ErrorResultFieldsFragmentDoc}
`
export type BookEventMutationFn = Apollo.MutationFunction<
  BookEventMutation,
  BookEventMutationVariables
>

/**
 * __useBookEventMutation__
 *
 * To run a mutation, you first call `useBookEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBookEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bookEventMutation, { data, loading, error }] = useBookEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useBookEventMutation(
  baseOptions?: Apollo.MutationHookOptions<
    BookEventMutation,
    BookEventMutationVariables
  >
) {
  return Apollo.useMutation<BookEventMutation, BookEventMutationVariables>(
    BookEventDocument,
    baseOptions
  )
}
export type BookEventMutationHookResult = ReturnType<
  typeof useBookEventMutation
>
export type BookEventMutationResult = Apollo.MutationResult<BookEventMutation>
export type BookEventMutationOptions = Apollo.BaseMutationOptions<
  BookEventMutation,
  BookEventMutationVariables
>
export const BookedEventDocument = gql`
  query bookedEvent(
    $eventId: String!
    $role: UserRoleInput!
    $_cacheKey: String
  ) {
    bookedEvent(eventId: $eventId, role: $role, _cacheKey: $_cacheKey) {
      ... on BookedEventResult {
        eventDetails {
          event {
            eventId
            eventName
            startDate
            endDate
            deliveryMethod
            spacesAvailable
            venueAddress
            programName
            timezone
          }
          trainerDetails {
            name
            email
          }
          schedule
          details
          requirements
          cancellationPolicy
        }
        bookedInstructors {
          name
          profileImage {
            url
          }
        }
      }
      ... on ErrorResult {
        ...errorResultFields
      }
    }
  }
  ${ErrorResultFieldsFragmentDoc}
`

/**
 * __useBookedEventQuery__
 *
 * To run a query within a React component, call `useBookedEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookedEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookedEventQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      role: // value for 'role'
 *      _cacheKey: // value for '_cacheKey'
 *   },
 * });
 */
export function useBookedEventQuery(
  baseOptions: Apollo.QueryHookOptions<
    BookedEventQuery,
    BookedEventQueryVariables
  >
) {
  return Apollo.useQuery<BookedEventQuery, BookedEventQueryVariables>(
    BookedEventDocument,
    baseOptions
  )
}
export function useBookedEventLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BookedEventQuery,
    BookedEventQueryVariables
  >
) {
  return Apollo.useLazyQuery<BookedEventQuery, BookedEventQueryVariables>(
    BookedEventDocument,
    baseOptions
  )
}
export type BookedEventQueryHookResult = ReturnType<typeof useBookedEventQuery>
export type BookedEventLazyQueryHookResult = ReturnType<
  typeof useBookedEventLazyQuery
>
export type BookedEventQueryResult = Apollo.QueryResult<
  BookedEventQuery,
  BookedEventQueryVariables
>
export const BookedEventsDocument = gql`
  query bookedEvents($clubId: String!, $_cacheKey: String) {
    bookedEvents(clubId: $clubId, _cacheKey: $_cacheKey) {
      ... on BookedEventsResult {
        bookedEvents {
          event {
            eventId
            eventName
            startDate
            endDate
            deliveryMethod
            spacesAvailable
            venueAddress
            programName
          }
          numberOfBookedInstructors
        }
      }
      ... on ErrorResult {
        ...errorResultFields
      }
    }
  }
  ${ErrorResultFieldsFragmentDoc}
`

/**
 * __useBookedEventsQuery__
 *
 * To run a query within a React component, call `useBookedEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookedEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookedEventsQuery({
 *   variables: {
 *      clubId: // value for 'clubId'
 *      _cacheKey: // value for '_cacheKey'
 *   },
 * });
 */
export function useBookedEventsQuery(
  baseOptions: Apollo.QueryHookOptions<
    BookedEventsQuery,
    BookedEventsQueryVariables
  >
) {
  return Apollo.useQuery<BookedEventsQuery, BookedEventsQueryVariables>(
    BookedEventsDocument,
    baseOptions
  )
}
export function useBookedEventsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BookedEventsQuery,
    BookedEventsQueryVariables
  >
) {
  return Apollo.useLazyQuery<BookedEventsQuery, BookedEventsQueryVariables>(
    BookedEventsDocument,
    baseOptions
  )
}
export type BookedEventsQueryHookResult = ReturnType<
  typeof useBookedEventsQuery
>
export type BookedEventsLazyQueryHookResult = ReturnType<
  typeof useBookedEventsLazyQuery
>
export type BookedEventsQueryResult = Apollo.QueryResult<
  BookedEventsQuery,
  BookedEventsQueryVariables
>
export const EventDetailsDocument = gql`
  query eventDetails(
    $eventId: String!
    $role: UserRoleInput!
    $_cacheKey: String
  ) {
    eventDetails(eventId: $eventId, role: $role, _cacheKey: $_cacheKey) {
      ... on EventDetailsResult {
        event {
          eventId
          eventName
          startDate
          endDate
          deliveryMethod
          spacesAvailable
          venueAddress
          programName
          timezone
        }
        trainerDetails {
          name
          email
        }
        schedule
        details
        requirements
        cancellationPolicy
        tickets {
          ticketId
          name
          currencyIsoCode
          price
          startDate
          endDate
          isDefaultTicket
          canBeUsedWithDiscountCode
        }
      }
      ... on ErrorResult {
        ...errorResultFields
      }
    }
  }
  ${ErrorResultFieldsFragmentDoc}
`

/**
 * __useEventDetailsQuery__
 *
 * To run a query within a React component, call `useEventDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventDetailsQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      role: // value for 'role'
 *      _cacheKey: // value for '_cacheKey'
 *   },
 * });
 */
export function useEventDetailsQuery(
  baseOptions: Apollo.QueryHookOptions<
    EventDetailsQuery,
    EventDetailsQueryVariables
  >
) {
  return Apollo.useQuery<EventDetailsQuery, EventDetailsQueryVariables>(
    EventDetailsDocument,
    baseOptions
  )
}
export function useEventDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    EventDetailsQuery,
    EventDetailsQueryVariables
  >
) {
  return Apollo.useLazyQuery<EventDetailsQuery, EventDetailsQueryVariables>(
    EventDetailsDocument,
    baseOptions
  )
}
export type EventDetailsQueryHookResult = ReturnType<
  typeof useEventDetailsQuery
>
export type EventDetailsLazyQueryHookResult = ReturnType<
  typeof useEventDetailsLazyQuery
>
export type EventDetailsQueryResult = Apollo.QueryResult<
  EventDetailsQuery,
  EventDetailsQueryVariables
>
export const TrainerBookingDocument = gql`
  query trainerBooking($input: TrainerBookingInput!, $_cacheKey: String) {
    trainerBooking(input: $input, _cacheKey: $_cacheKey) {
      ... on TrainerBookingResult {
        eventAssessments {
          ...eventAssessmentFields
        }
        eventSummary {
          ...eventSummaryFields
        }
      }
      ... on ErrorResult {
        ...errorResultFields
      }
    }
  }
  ${EventAssessmentFieldsFragmentDoc}
  ${EventSummaryFieldsFragmentDoc}
  ${ErrorResultFieldsFragmentDoc}
`

/**
 * __useTrainerBookingQuery__
 *
 * To run a query within a React component, call `useTrainerBookingQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrainerBookingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrainerBookingQuery({
 *   variables: {
 *      input: // value for 'input'
 *      _cacheKey: // value for '_cacheKey'
 *   },
 * });
 */
export function useTrainerBookingQuery(
  baseOptions: Apollo.QueryHookOptions<
    TrainerBookingQuery,
    TrainerBookingQueryVariables
  >
) {
  return Apollo.useQuery<TrainerBookingQuery, TrainerBookingQueryVariables>(
    TrainerBookingDocument,
    baseOptions
  )
}
export function useTrainerBookingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TrainerBookingQuery,
    TrainerBookingQueryVariables
  >
) {
  return Apollo.useLazyQuery<TrainerBookingQuery, TrainerBookingQueryVariables>(
    TrainerBookingDocument,
    baseOptions
  )
}
export type TrainerBookingQueryHookResult = ReturnType<
  typeof useTrainerBookingQuery
>
export type TrainerBookingLazyQueryHookResult = ReturnType<
  typeof useTrainerBookingLazyQuery
>
export type TrainerBookingQueryResult = Apollo.QueryResult<
  TrainerBookingQuery,
  TrainerBookingQueryVariables
>
export const TrainerBookingsDocument = gql`
  query trainerBookings($_cacheKey: String) {
    trainerBookings(_cacheKey: $_cacheKey) {
      ... on TrainerBookingsResult {
        result {
          deliveryMethod
          endDate
          eventId
          eventName
          programName
          startDate
          eventStatus
          trainingJourneyCount
          venueAddress
        }
      }
      ... on ErrorResult {
        ...errorResultFields
      }
    }
  }
  ${ErrorResultFieldsFragmentDoc}
`

/**
 * __useTrainerBookingsQuery__
 *
 * To run a query within a React component, call `useTrainerBookingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrainerBookingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrainerBookingsQuery({
 *   variables: {
 *      _cacheKey: // value for '_cacheKey'
 *   },
 * });
 */
export function useTrainerBookingsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    TrainerBookingsQuery,
    TrainerBookingsQueryVariables
  >
) {
  return Apollo.useQuery<TrainerBookingsQuery, TrainerBookingsQueryVariables>(
    TrainerBookingsDocument,
    baseOptions
  )
}
export function useTrainerBookingsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TrainerBookingsQuery,
    TrainerBookingsQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    TrainerBookingsQuery,
    TrainerBookingsQueryVariables
  >(TrainerBookingsDocument, baseOptions)
}
export type TrainerBookingsQueryHookResult = ReturnType<
  typeof useTrainerBookingsQuery
>
export type TrainerBookingsLazyQueryHookResult = ReturnType<
  typeof useTrainerBookingsLazyQuery
>
export type TrainerBookingsQueryResult = Apollo.QueryResult<
  TrainerBookingsQuery,
  TrainerBookingsQueryVariables
>
export const TrainingJourneyDocument = gql`
  query trainingJourney(
    $input: TrainingJourneyInput!
    $role: UserRoleInput
    $_cacheKey: String
  ) {
    trainingJourney(input: $input, role: $role, _cacheKey: $_cacheKey) {
      ... on TrainingJourneyResult {
        result {
          steps {
            ... on TrainingBookedStep {
              ...trainingBookedStepFields
            }
            ... on PreworkStep {
              ...preworkStepFields
            }
            ... on AttendTrainingStep {
              ...attendTrainingStepFields
            }
            ... on SubmitOutcomeTrackStep {
              ...submitOutcomeTrackStepFields
            }
            ... on ReceivedTrainingOutcomeStep {
              ...receivedTrainingOutcomeStepFields
            }
            ... on SubmitCertificationVideoStep {
              ...submitCertificationVideoStepFields
            }
            ... on ReceivedCertificationOutcomeStep {
              ...receivedCertificationOutcomeStepFields
            }
            ... on CertifiedStep {
              ...certifiedStepFields
            }
            ... on ContactUsStep {
              activeStepName
              activeStepNumber
              stepName
              stepNumber
              contactUsEmail
            }
          }
        }
      }
      ... on ErrorResult {
        ...errorResultFields
      }
    }
  }
  ${TrainingBookedStepFieldsFragmentDoc}
  ${PreworkStepFieldsFragmentDoc}
  ${AttendTrainingStepFieldsFragmentDoc}
  ${SubmitOutcomeTrackStepFieldsFragmentDoc}
  ${ReceivedTrainingOutcomeStepFieldsFragmentDoc}
  ${SubmitCertificationVideoStepFieldsFragmentDoc}
  ${ReceivedCertificationOutcomeStepFieldsFragmentDoc}
  ${CertifiedStepFieldsFragmentDoc}
  ${ErrorResultFieldsFragmentDoc}
`

/**
 * __useTrainingJourneyQuery__
 *
 * To run a query within a React component, call `useTrainingJourneyQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrainingJourneyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrainingJourneyQuery({
 *   variables: {
 *      input: // value for 'input'
 *      role: // value for 'role'
 *      _cacheKey: // value for '_cacheKey'
 *   },
 * });
 */
export function useTrainingJourneyQuery(
  baseOptions: Apollo.QueryHookOptions<
    TrainingJourneyQuery,
    TrainingJourneyQueryVariables
  >
) {
  return Apollo.useQuery<TrainingJourneyQuery, TrainingJourneyQueryVariables>(
    TrainingJourneyDocument,
    baseOptions
  )
}
export function useTrainingJourneyLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TrainingJourneyQuery,
    TrainingJourneyQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    TrainingJourneyQuery,
    TrainingJourneyQueryVariables
  >(TrainingJourneyDocument, baseOptions)
}
export type TrainingJourneyQueryHookResult = ReturnType<
  typeof useTrainingJourneyQuery
>
export type TrainingJourneyLazyQueryHookResult = ReturnType<
  typeof useTrainingJourneyLazyQuery
>
export type TrainingJourneyQueryResult = Apollo.QueryResult<
  TrainingJourneyQuery,
  TrainingJourneyQueryVariables
>
export const TrainingJourneysDocument = gql`
  query trainingJourneys($_cacheKey: String) {
    trainingJourneys(_cacheKey: $_cacheKey) {
      ... on TrainingJourneysResult {
        trainings {
          id
          eventName
          deliveryMethod
          startDate
          endDate
          timezone
          cecCertificationUrl
          venueAddress
          activeStepName
          activeStepNumber
          dueDate
          programName
          isContactUs
          dateCertified
        }
        eventsAndTrainingUrl
      }
      ... on ErrorResult {
        ...errorResultFields
      }
    }
  }
  ${ErrorResultFieldsFragmentDoc}
`

/**
 * __useTrainingJourneysQuery__
 *
 * To run a query within a React component, call `useTrainingJourneysQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrainingJourneysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrainingJourneysQuery({
 *   variables: {
 *      _cacheKey: // value for '_cacheKey'
 *   },
 * });
 */
export function useTrainingJourneysQuery(
  baseOptions?: Apollo.QueryHookOptions<
    TrainingJourneysQuery,
    TrainingJourneysQueryVariables
  >
) {
  return Apollo.useQuery<TrainingJourneysQuery, TrainingJourneysQueryVariables>(
    TrainingJourneysDocument,
    baseOptions
  )
}
export function useTrainingJourneysLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TrainingJourneysQuery,
    TrainingJourneysQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    TrainingJourneysQuery,
    TrainingJourneysQueryVariables
  >(TrainingJourneysDocument, baseOptions)
}
export type TrainingJourneysQueryHookResult = ReturnType<
  typeof useTrainingJourneysQuery
>
export type TrainingJourneysLazyQueryHookResult = ReturnType<
  typeof useTrainingJourneysLazyQuery
>
export type TrainingJourneysQueryResult = Apollo.QueryResult<
  TrainingJourneysQuery,
  TrainingJourneysQueryVariables
>
export const RequestForExtensionDocument = gql`
  mutation requestForExtension(
    $input: RequestForExtensionInput!
    $_cacheKey: String
  ) {
    requestForExtension(input: $input, _cacheKey: $_cacheKey) {
      ... on RequestForExtensionResult {
        isSuccess
      }
      ... on ErrorResult {
        ...errorResultFields
      }
    }
  }
  ${ErrorResultFieldsFragmentDoc}
`
export type RequestForExtensionMutationFn = Apollo.MutationFunction<
  RequestForExtensionMutation,
  RequestForExtensionMutationVariables
>

/**
 * __useRequestForExtensionMutation__
 *
 * To run a mutation, you first call `useRequestForExtensionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestForExtensionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestForExtensionMutation, { data, loading, error }] = useRequestForExtensionMutation({
 *   variables: {
 *      input: // value for 'input'
 *      _cacheKey: // value for '_cacheKey'
 *   },
 * });
 */
export function useRequestForExtensionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RequestForExtensionMutation,
    RequestForExtensionMutationVariables
  >
) {
  return Apollo.useMutation<
    RequestForExtensionMutation,
    RequestForExtensionMutationVariables
  >(RequestForExtensionDocument, baseOptions)
}
export type RequestForExtensionMutationHookResult = ReturnType<
  typeof useRequestForExtensionMutation
>
export type RequestForExtensionMutationResult =
  Apollo.MutationResult<RequestForExtensionMutation>
export type RequestForExtensionMutationOptions = Apollo.BaseMutationOptions<
  RequestForExtensionMutation,
  RequestForExtensionMutationVariables
>
export const SearchEventsDocument = gql`
  query searchEvents(
    $searchInfo: SearchEventsInput!
    $filterInfo: FilterEventsInput!
    $_cacheKey: String
  ) {
    searchEvents(
      searchInfo: $searchInfo
      filterInfo: $filterInfo
      _cacheKey: $_cacheKey
    ) {
      ... on EventsResult {
        edges {
          cursor
          node {
            eventId
            eventName
            startDate
            endDate
            deliveryMethod
            spacesAvailable
            venueAddress
            programName
            programCode
          }
        }
        pageInfo {
          endCursor {
            eventId
            sortValues
          }
          hasNextPage
        }
      }
      ... on ErrorResult {
        ...errorResultFields
      }
    }
  }
  ${ErrorResultFieldsFragmentDoc}
`

/**
 * __useSearchEventsQuery__
 *
 * To run a query within a React component, call `useSearchEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchEventsQuery({
 *   variables: {
 *      searchInfo: // value for 'searchInfo'
 *      filterInfo: // value for 'filterInfo'
 *      _cacheKey: // value for '_cacheKey'
 *   },
 * });
 */
export function useSearchEventsQuery(
  baseOptions: Apollo.QueryHookOptions<
    SearchEventsQuery,
    SearchEventsQueryVariables
  >
) {
  return Apollo.useQuery<SearchEventsQuery, SearchEventsQueryVariables>(
    SearchEventsDocument,
    baseOptions
  )
}
export function useSearchEventsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SearchEventsQuery,
    SearchEventsQueryVariables
  >
) {
  return Apollo.useLazyQuery<SearchEventsQuery, SearchEventsQueryVariables>(
    SearchEventsDocument,
    baseOptions
  )
}
export type SearchEventsQueryHookResult = ReturnType<
  typeof useSearchEventsQuery
>
export type SearchEventsLazyQueryHookResult = ReturnType<
  typeof useSearchEventsLazyQuery
>
export type SearchEventsQueryResult = Apollo.QueryResult<
  SearchEventsQuery,
  SearchEventsQueryVariables
>
export const AddClubListingDocument = gql`
  mutation addClubListing($input: AddClubListingInput!, $_cacheKey: String) {
    addClubListing(input: $input, _cacheKey: $_cacheKey) {
      ... on ClubListingResult {
        results {
          ... on ClubSingleListing {
            ...singleListingFields
          }
          ... on ClubMultiListing {
            ...multiListingFields
          }
        }
      }
      ... on ErrorResult {
        ...errorResultFields
      }
    }
  }
  ${SingleListingFieldsFragmentDoc}
  ${MultiListingFieldsFragmentDoc}
  ${ErrorResultFieldsFragmentDoc}
`
export type AddClubListingMutationFn = Apollo.MutationFunction<
  AddClubListingMutation,
  AddClubListingMutationVariables
>

/**
 * __useAddClubListingMutation__
 *
 * To run a mutation, you first call `useAddClubListingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddClubListingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addClubListingMutation, { data, loading, error }] = useAddClubListingMutation({
 *   variables: {
 *      input: // value for 'input'
 *      _cacheKey: // value for '_cacheKey'
 *   },
 * });
 */
export function useAddClubListingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddClubListingMutation,
    AddClubListingMutationVariables
  >
) {
  return Apollo.useMutation<
    AddClubListingMutation,
    AddClubListingMutationVariables
  >(AddClubListingDocument, baseOptions)
}
export type AddClubListingMutationHookResult = ReturnType<
  typeof useAddClubListingMutation
>
export type AddClubListingMutationResult =
  Apollo.MutationResult<AddClubListingMutation>
export type AddClubListingMutationOptions = Apollo.BaseMutationOptions<
  AddClubListingMutation,
  AddClubListingMutationVariables
>
export const AddEmergencyContactDocument = gql`
  mutation addEmergencyContact(
    $input: EmergencyContactInput!
    $_cacheKey: String
  ) {
    addEmergencyContact(input: $input, _cacheKey: $_cacheKey) {
      ... on AddEmergencyContactResult {
        result {
          address
          name
          phone
        }
      }
      ... on ErrorResult {
        ...errorResultFields
      }
    }
  }
  ${ErrorResultFieldsFragmentDoc}
`
export type AddEmergencyContactMutationFn = Apollo.MutationFunction<
  AddEmergencyContactMutation,
  AddEmergencyContactMutationVariables
>

/**
 * __useAddEmergencyContactMutation__
 *
 * To run a mutation, you first call `useAddEmergencyContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddEmergencyContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addEmergencyContactMutation, { data, loading, error }] = useAddEmergencyContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *      _cacheKey: // value for '_cacheKey'
 *   },
 * });
 */
export function useAddEmergencyContactMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddEmergencyContactMutation,
    AddEmergencyContactMutationVariables
  >
) {
  return Apollo.useMutation<
    AddEmergencyContactMutation,
    AddEmergencyContactMutationVariables
  >(AddEmergencyContactDocument, baseOptions)
}
export type AddEmergencyContactMutationHookResult = ReturnType<
  typeof useAddEmergencyContactMutation
>
export type AddEmergencyContactMutationResult =
  Apollo.MutationResult<AddEmergencyContactMutation>
export type AddEmergencyContactMutationOptions = Apollo.BaseMutationOptions<
  AddEmergencyContactMutation,
  AddEmergencyContactMutationVariables
>
export const AddToShortlistDocument = gql`
  mutation addToShortlist(
    $input: AddToShortlistInput!
    $role: UserRoleInput!
    $_cacheKey: String
  ) {
    addToShortlist(input: $input, role: $role, _cacheKey: $_cacheKey) {
      ... on AddToShortlistResult {
        shortlist {
          id
          profile {
            ...instructorProfileFields
          }
          user {
            id
            lastName
            firstName
          }
          lastMessageIn48HoursSentAt
          distanceUnit
          distance
        }
      }
      ... on ErrorResult {
        ...errorResultFields
      }
    }
  }
  ${InstructorProfileFieldsFragmentDoc}
  ${ErrorResultFieldsFragmentDoc}
`
export type AddToShortlistMutationFn = Apollo.MutationFunction<
  AddToShortlistMutation,
  AddToShortlistMutationVariables
>

/**
 * __useAddToShortlistMutation__
 *
 * To run a mutation, you first call `useAddToShortlistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddToShortlistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addToShortlistMutation, { data, loading, error }] = useAddToShortlistMutation({
 *   variables: {
 *      input: // value for 'input'
 *      role: // value for 'role'
 *      _cacheKey: // value for '_cacheKey'
 *   },
 * });
 */
export function useAddToShortlistMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddToShortlistMutation,
    AddToShortlistMutationVariables
  >
) {
  return Apollo.useMutation<
    AddToShortlistMutation,
    AddToShortlistMutationVariables
  >(AddToShortlistDocument, baseOptions)
}
export type AddToShortlistMutationHookResult = ReturnType<
  typeof useAddToShortlistMutation
>
export type AddToShortlistMutationResult =
  Apollo.MutationResult<AddToShortlistMutation>
export type AddToShortlistMutationOptions = Apollo.BaseMutationOptions<
  AddToShortlistMutation,
  AddToShortlistMutationVariables
>
export const CreateAffiliationDocument = gql`
  mutation createAffiliation(
    $input: CreateAffiliationInput!
    $role: UserRoleInput!
    $_cacheKey: String
  ) {
    createAffiliation(input: $input, role: $role, _cacheKey: $_cacheKey) {
      ... on AffiliationAsyncResult {
        status
        affilation {
          __typename
          actionedDate
          clubId
          id
          latestActionInitiator
          pendingStatus
          requestedBy
          requestedDate
          role
          status
          userId
        }
      }
      ... on ErrorResult {
        ...errorResultFields
      }
    }
  }
  ${ErrorResultFieldsFragmentDoc}
`
export type CreateAffiliationMutationFn = Apollo.MutationFunction<
  CreateAffiliationMutation,
  CreateAffiliationMutationVariables
>

/**
 * __useCreateAffiliationMutation__
 *
 * To run a mutation, you first call `useCreateAffiliationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAffiliationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAffiliationMutation, { data, loading, error }] = useCreateAffiliationMutation({
 *   variables: {
 *      input: // value for 'input'
 *      role: // value for 'role'
 *      _cacheKey: // value for '_cacheKey'
 *   },
 * });
 */
export function useCreateAffiliationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateAffiliationMutation,
    CreateAffiliationMutationVariables
  >
) {
  return Apollo.useMutation<
    CreateAffiliationMutation,
    CreateAffiliationMutationVariables
  >(CreateAffiliationDocument, baseOptions)
}
export type CreateAffiliationMutationHookResult = ReturnType<
  typeof useCreateAffiliationMutation
>
export type CreateAffiliationMutationResult =
  Apollo.MutationResult<CreateAffiliationMutation>
export type CreateAffiliationMutationOptions = Apollo.BaseMutationOptions<
  CreateAffiliationMutation,
  CreateAffiliationMutationVariables
>
export const CreateClubListingsDocument = gql`
  mutation createClubListings(
    $input: CreateClubListingsInput!
    $_cacheKey: String
  ) {
    createClubListings(input: $input, _cacheKey: $_cacheKey) {
      ... on CreateClubListingsResult {
        successfulListings {
          ... on ClubSingleListing {
            ...singleListingFields
          }
        }
      }
      ... on ErrorResult {
        ...errorResultFields
      }
    }
  }
  ${SingleListingFieldsFragmentDoc}
  ${ErrorResultFieldsFragmentDoc}
`
export type CreateClubListingsMutationFn = Apollo.MutationFunction<
  CreateClubListingsMutation,
  CreateClubListingsMutationVariables
>

/**
 * __useCreateClubListingsMutation__
 *
 * To run a mutation, you first call `useCreateClubListingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClubListingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClubListingsMutation, { data, loading, error }] = useCreateClubListingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *      _cacheKey: // value for '_cacheKey'
 *   },
 * });
 */
export function useCreateClubListingsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateClubListingsMutation,
    CreateClubListingsMutationVariables
  >
) {
  return Apollo.useMutation<
    CreateClubListingsMutation,
    CreateClubListingsMutationVariables
  >(CreateClubListingsDocument, baseOptions)
}
export type CreateClubListingsMutationHookResult = ReturnType<
  typeof useCreateClubListingsMutation
>
export type CreateClubListingsMutationResult =
  Apollo.MutationResult<CreateClubListingsMutation>
export type CreateClubListingsMutationOptions = Apollo.BaseMutationOptions<
  CreateClubListingsMutation,
  CreateClubListingsMutationVariables
>
export const DeleteAffiliationDocument = gql`
  mutation deleteAffiliation(
    $input: DeleteAffiliationInput!
    $role: UserRoleInput!
    $_cacheKey: String
  ) {
    deleteAffiliation(input: $input, role: $role, _cacheKey: $_cacheKey) {
      ... on AffiliationAsyncResult {
        status
      }
      ... on ErrorResult {
        ...errorResultFields
      }
    }
  }
  ${ErrorResultFieldsFragmentDoc}
`
export type DeleteAffiliationMutationFn = Apollo.MutationFunction<
  DeleteAffiliationMutation,
  DeleteAffiliationMutationVariables
>

/**
 * __useDeleteAffiliationMutation__
 *
 * To run a mutation, you first call `useDeleteAffiliationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAffiliationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAffiliationMutation, { data, loading, error }] = useDeleteAffiliationMutation({
 *   variables: {
 *      input: // value for 'input'
 *      role: // value for 'role'
 *      _cacheKey: // value for '_cacheKey'
 *   },
 * });
 */
export function useDeleteAffiliationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteAffiliationMutation,
    DeleteAffiliationMutationVariables
  >
) {
  return Apollo.useMutation<
    DeleteAffiliationMutation,
    DeleteAffiliationMutationVariables
  >(DeleteAffiliationDocument, baseOptions)
}
export type DeleteAffiliationMutationHookResult = ReturnType<
  typeof useDeleteAffiliationMutation
>
export type DeleteAffiliationMutationResult =
  Apollo.MutationResult<DeleteAffiliationMutation>
export type DeleteAffiliationMutationOptions = Apollo.BaseMutationOptions<
  DeleteAffiliationMutation,
  DeleteAffiliationMutationVariables
>
export const DeleteClubListingDocument = gql`
  mutation deleteClubListing(
    $input: DeleteClubListingInput!
    $_cacheKey: String
  ) {
    deleteClubListing(input: $input, _cacheKey: $_cacheKey) {
      ... on DeleteClubListingResult {
        clubId
        status
        listingId
        results {
          ... on ClubSingleListing {
            ...singleListingFields
          }
          ... on ClubMultiListing {
            ...multiListingFields
          }
        }
      }
      ... on ErrorResult {
        ...errorResultFields
      }
    }
  }
  ${SingleListingFieldsFragmentDoc}
  ${MultiListingFieldsFragmentDoc}
  ${ErrorResultFieldsFragmentDoc}
`
export type DeleteClubListingMutationFn = Apollo.MutationFunction<
  DeleteClubListingMutation,
  DeleteClubListingMutationVariables
>

/**
 * __useDeleteClubListingMutation__
 *
 * To run a mutation, you first call `useDeleteClubListingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteClubListingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteClubListingMutation, { data, loading, error }] = useDeleteClubListingMutation({
 *   variables: {
 *      input: // value for 'input'
 *      _cacheKey: // value for '_cacheKey'
 *   },
 * });
 */
export function useDeleteClubListingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteClubListingMutation,
    DeleteClubListingMutationVariables
  >
) {
  return Apollo.useMutation<
    DeleteClubListingMutation,
    DeleteClubListingMutationVariables
  >(DeleteClubListingDocument, baseOptions)
}
export type DeleteClubListingMutationHookResult = ReturnType<
  typeof useDeleteClubListingMutation
>
export type DeleteClubListingMutationResult =
  Apollo.MutationResult<DeleteClubListingMutation>
export type DeleteClubListingMutationOptions = Apollo.BaseMutationOptions<
  DeleteClubListingMutation,
  DeleteClubListingMutationVariables
>
export const DeleteCurrentUserPortfolioImageDocument = gql`
  mutation deleteCurrentUserPortfolioImage(
    $input: DeleteCurrentUserPortfolioImageInput!
    $role: UserRoleInput!
    $_cacheKey: String
  ) {
    deleteCurrentUserPortfolioImage(
      input: $input
      role: $role
      _cacheKey: $_cacheKey
    ) {
      ... on DeleteCurrentUserPortfolioImageResult {
        status
      }
      ... on ErrorResult {
        ...errorResultFields
      }
    }
  }
  ${ErrorResultFieldsFragmentDoc}
`
export type DeleteCurrentUserPortfolioImageMutationFn = Apollo.MutationFunction<
  DeleteCurrentUserPortfolioImageMutation,
  DeleteCurrentUserPortfolioImageMutationVariables
>

/**
 * __useDeleteCurrentUserPortfolioImageMutation__
 *
 * To run a mutation, you first call `useDeleteCurrentUserPortfolioImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCurrentUserPortfolioImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCurrentUserPortfolioImageMutation, { data, loading, error }] = useDeleteCurrentUserPortfolioImageMutation({
 *   variables: {
 *      input: // value for 'input'
 *      role: // value for 'role'
 *      _cacheKey: // value for '_cacheKey'
 *   },
 * });
 */
export function useDeleteCurrentUserPortfolioImageMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteCurrentUserPortfolioImageMutation,
    DeleteCurrentUserPortfolioImageMutationVariables
  >
) {
  return Apollo.useMutation<
    DeleteCurrentUserPortfolioImageMutation,
    DeleteCurrentUserPortfolioImageMutationVariables
  >(DeleteCurrentUserPortfolioImageDocument, baseOptions)
}
export type DeleteCurrentUserPortfolioImageMutationHookResult = ReturnType<
  typeof useDeleteCurrentUserPortfolioImageMutation
>
export type DeleteCurrentUserPortfolioImageMutationResult =
  Apollo.MutationResult<DeleteCurrentUserPortfolioImageMutation>
export type DeleteCurrentUserPortfolioImageMutationOptions =
  Apollo.BaseMutationOptions<
    DeleteCurrentUserPortfolioImageMutation,
    DeleteCurrentUserPortfolioImageMutationVariables
  >
export const DeleteMultipleJobListingsDocument = gql`
  mutation deleteMultipleJobListings(
    $input: DeleteClubListingsInput!
    $_cacheKey: String
  ) {
    deleteClubListings(input: $input, _cacheKey: $_cacheKey) {
      ... on DeleteClubListingsResult {
        success {
          ... on ClubSingleListing {
            ...singleListingFields
          }
        }
      }
      ... on ErrorResult {
        ...errorResultFields
      }
    }
  }
  ${SingleListingFieldsFragmentDoc}
  ${ErrorResultFieldsFragmentDoc}
`
export type DeleteMultipleJobListingsMutationFn = Apollo.MutationFunction<
  DeleteMultipleJobListingsMutation,
  DeleteMultipleJobListingsMutationVariables
>

/**
 * __useDeleteMultipleJobListingsMutation__
 *
 * To run a mutation, you first call `useDeleteMultipleJobListingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMultipleJobListingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMultipleJobListingsMutation, { data, loading, error }] = useDeleteMultipleJobListingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *      _cacheKey: // value for '_cacheKey'
 *   },
 * });
 */
export function useDeleteMultipleJobListingsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteMultipleJobListingsMutation,
    DeleteMultipleJobListingsMutationVariables
  >
) {
  return Apollo.useMutation<
    DeleteMultipleJobListingsMutation,
    DeleteMultipleJobListingsMutationVariables
  >(DeleteMultipleJobListingsDocument, baseOptions)
}
export type DeleteMultipleJobListingsMutationHookResult = ReturnType<
  typeof useDeleteMultipleJobListingsMutation
>
export type DeleteMultipleJobListingsMutationResult =
  Apollo.MutationResult<DeleteMultipleJobListingsMutation>
export type DeleteMultipleJobListingsMutationOptions =
  Apollo.BaseMutationOptions<
    DeleteMultipleJobListingsMutation,
    DeleteMultipleJobListingsMutationVariables
  >
export const DigitalOnlyInStudioEnquireDocument = gql`
  mutation digitalOnlyInStudioEnquire(
    $input: EnquireAboutInStudioProgramsInput!
    $role: UserRoleInput!
    $_cacheKey: String
  ) {
    enquireAboutInStudioPrograms(
      input: $input
      role: $role
      _cacheKey: $_cacheKey
    ) {
      ... on EnquireAboutInStudioProgramsResult {
        isSuccess
      }
      ... on ErrorResult {
        ...errorResultFields
      }
    }
  }
  ${ErrorResultFieldsFragmentDoc}
`
export type DigitalOnlyInStudioEnquireMutationFn = Apollo.MutationFunction<
  DigitalOnlyInStudioEnquireMutation,
  DigitalOnlyInStudioEnquireMutationVariables
>

/**
 * __useDigitalOnlyInStudioEnquireMutation__
 *
 * To run a mutation, you first call `useDigitalOnlyInStudioEnquireMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDigitalOnlyInStudioEnquireMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [digitalOnlyInStudioEnquireMutation, { data, loading, error }] = useDigitalOnlyInStudioEnquireMutation({
 *   variables: {
 *      input: // value for 'input'
 *      role: // value for 'role'
 *      _cacheKey: // value for '_cacheKey'
 *   },
 * });
 */
export function useDigitalOnlyInStudioEnquireMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DigitalOnlyInStudioEnquireMutation,
    DigitalOnlyInStudioEnquireMutationVariables
  >
) {
  return Apollo.useMutation<
    DigitalOnlyInStudioEnquireMutation,
    DigitalOnlyInStudioEnquireMutationVariables
  >(DigitalOnlyInStudioEnquireDocument, baseOptions)
}
export type DigitalOnlyInStudioEnquireMutationHookResult = ReturnType<
  typeof useDigitalOnlyInStudioEnquireMutation
>
export type DigitalOnlyInStudioEnquireMutationResult =
  Apollo.MutationResult<DigitalOnlyInStudioEnquireMutation>
export type DigitalOnlyInStudioEnquireMutationOptions =
  Apollo.BaseMutationOptions<
    DigitalOnlyInStudioEnquireMutation,
    DigitalOnlyInStudioEnquireMutationVariables
  >
export const EnquireAboutOfferingDocument = gql`
  mutation enquireAboutOffering(
    $input: EnquireAboutOnlineProgramInput!
    $role: UserRoleInput!
    $_cacheKey: String
  ) {
    enquireAboutOnlineProgram(
      input: $input
      role: $role
      _cacheKey: $_cacheKey
    ) {
      ... on EnquireAboutOnlineProgramResult {
        lastEnquiredOn
        onlineProgramid
      }
      ... on ErrorResult {
        ...errorResultFields
      }
    }
  }
  ${ErrorResultFieldsFragmentDoc}
`
export type EnquireAboutOfferingMutationFn = Apollo.MutationFunction<
  EnquireAboutOfferingMutation,
  EnquireAboutOfferingMutationVariables
>

/**
 * __useEnquireAboutOfferingMutation__
 *
 * To run a mutation, you first call `useEnquireAboutOfferingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnquireAboutOfferingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enquireAboutOfferingMutation, { data, loading, error }] = useEnquireAboutOfferingMutation({
 *   variables: {
 *      input: // value for 'input'
 *      role: // value for 'role'
 *      _cacheKey: // value for '_cacheKey'
 *   },
 * });
 */
export function useEnquireAboutOfferingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    EnquireAboutOfferingMutation,
    EnquireAboutOfferingMutationVariables
  >
) {
  return Apollo.useMutation<
    EnquireAboutOfferingMutation,
    EnquireAboutOfferingMutationVariables
  >(EnquireAboutOfferingDocument, baseOptions)
}
export type EnquireAboutOfferingMutationHookResult = ReturnType<
  typeof useEnquireAboutOfferingMutation
>
export type EnquireAboutOfferingMutationResult =
  Apollo.MutationResult<EnquireAboutOfferingMutation>
export type EnquireAboutOfferingMutationOptions = Apollo.BaseMutationOptions<
  EnquireAboutOfferingMutation,
  EnquireAboutOfferingMutationVariables
>
export const EnquireAboutProgramDocument = gql`
  mutation enquireAboutProgram(
    $input: EnquireAboutProgramInput!
    $role: UserRoleInput!
    $_cacheKey: String
  ) {
    enquireAboutProgram(input: $input, role: $role, _cacheKey: $_cacheKey) {
      ... on EnquireAboutProgramResult {
        lastEnquiredOn
        programId
      }
      ... on ErrorResult {
        ...errorResultFields
      }
    }
  }
  ${ErrorResultFieldsFragmentDoc}
`
export type EnquireAboutProgramMutationFn = Apollo.MutationFunction<
  EnquireAboutProgramMutation,
  EnquireAboutProgramMutationVariables
>

/**
 * __useEnquireAboutProgramMutation__
 *
 * To run a mutation, you first call `useEnquireAboutProgramMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnquireAboutProgramMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enquireAboutProgramMutation, { data, loading, error }] = useEnquireAboutProgramMutation({
 *   variables: {
 *      input: // value for 'input'
 *      role: // value for 'role'
 *      _cacheKey: // value for '_cacheKey'
 *   },
 * });
 */
export function useEnquireAboutProgramMutation(
  baseOptions?: Apollo.MutationHookOptions<
    EnquireAboutProgramMutation,
    EnquireAboutProgramMutationVariables
  >
) {
  return Apollo.useMutation<
    EnquireAboutProgramMutation,
    EnquireAboutProgramMutationVariables
  >(EnquireAboutProgramDocument, baseOptions)
}
export type EnquireAboutProgramMutationHookResult = ReturnType<
  typeof useEnquireAboutProgramMutation
>
export type EnquireAboutProgramMutationResult =
  Apollo.MutationResult<EnquireAboutProgramMutation>
export type EnquireAboutProgramMutationOptions = Apollo.BaseMutationOptions<
  EnquireAboutProgramMutation,
  EnquireAboutProgramMutationVariables
>
export const EnquireAboutProgramInExploreProgramsDocument = gql`
  mutation enquireAboutProgramInExplorePrograms(
    $input: EnquireAboutExploreProgramsInput!
    $role: UserRoleInput!
    $_cacheKey: String
  ) {
    enquireAboutProgramInExplorePrograms(
      input: $input
      role: $role
      _cacheKey: $_cacheKey
    ) {
      ... on EnquireAboutExploreProgramsResult {
        lastEnquiredOn
        programId
      }
      ... on ErrorResult {
        ...errorResultFields
      }
    }
  }
  ${ErrorResultFieldsFragmentDoc}
`
export type EnquireAboutProgramInExploreProgramsMutationFn =
  Apollo.MutationFunction<
    EnquireAboutProgramInExploreProgramsMutation,
    EnquireAboutProgramInExploreProgramsMutationVariables
  >

/**
 * __useEnquireAboutProgramInExploreProgramsMutation__
 *
 * To run a mutation, you first call `useEnquireAboutProgramInExploreProgramsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnquireAboutProgramInExploreProgramsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enquireAboutProgramInExploreProgramsMutation, { data, loading, error }] = useEnquireAboutProgramInExploreProgramsMutation({
 *   variables: {
 *      input: // value for 'input'
 *      role: // value for 'role'
 *      _cacheKey: // value for '_cacheKey'
 *   },
 * });
 */
export function useEnquireAboutProgramInExploreProgramsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    EnquireAboutProgramInExploreProgramsMutation,
    EnquireAboutProgramInExploreProgramsMutationVariables
  >
) {
  return Apollo.useMutation<
    EnquireAboutProgramInExploreProgramsMutation,
    EnquireAboutProgramInExploreProgramsMutationVariables
  >(EnquireAboutProgramInExploreProgramsDocument, baseOptions)
}
export type EnquireAboutProgramInExploreProgramsMutationHookResult = ReturnType<
  typeof useEnquireAboutProgramInExploreProgramsMutation
>
export type EnquireAboutProgramInExploreProgramsMutationResult =
  Apollo.MutationResult<EnquireAboutProgramInExploreProgramsMutation>
export type EnquireAboutProgramInExploreProgramsMutationOptions =
  Apollo.BaseMutationOptions<
    EnquireAboutProgramInExploreProgramsMutation,
    EnquireAboutProgramInExploreProgramsMutationVariables
  >
export const GetAgreementDocumentDocument = gql`
  query getAgreementDocument(
    $input: GetSignedAgreementInput!
    $_cacheKey: String
    $versionOnly: Boolean = false
  ) {
    getAgreementDocument(input: $input, _cacheKey: $_cacheKey) {
      ... on AgreementDocumentResult {
        version
        content @skip(if: $versionOnly)
      }
      ... on ErrorResult {
        ...errorResultFields
      }
    }
  }
  ${ErrorResultFieldsFragmentDoc}
`

/**
 * __useGetAgreementDocumentQuery__
 *
 * To run a query within a React component, call `useGetAgreementDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgreementDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgreementDocumentQuery({
 *   variables: {
 *      input: // value for 'input'
 *      _cacheKey: // value for '_cacheKey'
 *      versionOnly: // value for 'versionOnly'
 *   },
 * });
 */
export function useGetAgreementDocumentQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAgreementDocumentQuery,
    GetAgreementDocumentQueryVariables
  >
) {
  return Apollo.useQuery<
    GetAgreementDocumentQuery,
    GetAgreementDocumentQueryVariables
  >(GetAgreementDocumentDocument, baseOptions)
}
export function useGetAgreementDocumentLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAgreementDocumentQuery,
    GetAgreementDocumentQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    GetAgreementDocumentQuery,
    GetAgreementDocumentQueryVariables
  >(GetAgreementDocumentDocument, baseOptions)
}
export type GetAgreementDocumentQueryHookResult = ReturnType<
  typeof useGetAgreementDocumentQuery
>
export type GetAgreementDocumentLazyQueryHookResult = ReturnType<
  typeof useGetAgreementDocumentLazyQuery
>
export type GetAgreementDocumentQueryResult = Apollo.QueryResult<
  GetAgreementDocumentQuery,
  GetAgreementDocumentQueryVariables
>
export const GetChainAffiliationDocument = gql`
  query getChainAffiliation(
    $input: GetChainAffiliationsInput!
    $_cacheKey: String
  ) {
    getChainAffiliations(input: $input, _cacheKey: $_cacheKey) {
      ... on GetChainAffiliationsResult {
        clubs {
          ...clubWithAffiliation
        }
      }
      ... on ErrorResult {
        type
        message
      }
    }
  }
  ${ClubWithAffiliationFragmentDoc}
`

/**
 * __useGetChainAffiliationQuery__
 *
 * To run a query within a React component, call `useGetChainAffiliationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChainAffiliationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChainAffiliationQuery({
 *   variables: {
 *      input: // value for 'input'
 *      _cacheKey: // value for '_cacheKey'
 *   },
 * });
 */
export function useGetChainAffiliationQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetChainAffiliationQuery,
    GetChainAffiliationQueryVariables
  >
) {
  return Apollo.useQuery<
    GetChainAffiliationQuery,
    GetChainAffiliationQueryVariables
  >(GetChainAffiliationDocument, baseOptions)
}
export function useGetChainAffiliationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetChainAffiliationQuery,
    GetChainAffiliationQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    GetChainAffiliationQuery,
    GetChainAffiliationQueryVariables
  >(GetChainAffiliationDocument, baseOptions)
}
export type GetChainAffiliationQueryHookResult = ReturnType<
  typeof useGetChainAffiliationQuery
>
export type GetChainAffiliationLazyQueryHookResult = ReturnType<
  typeof useGetChainAffiliationLazyQuery
>
export type GetChainAffiliationQueryResult = Apollo.QueryResult<
  GetChainAffiliationQuery,
  GetChainAffiliationQueryVariables
>
export const GetChainAffiliatedInstructorDocument = gql`
  query getChainAffiliatedInstructor(
    $input: GetChainInstructorAffiliatesInput
    $_cacheKey: String
  ) {
    getChainInstructorAffiliates(input: $input, _cacheKey: $_cacheKey) {
      ... on GetChainInstructorAffiliatesResult {
        __typename
        affiliates {
          clubAffiliates {
            ... on ClubAffiliates {
              ...managePeopleClubAffiliatesFields
            }
          }
          profile {
            ... on UserProfileTeaching {
              ...instructorProfileFields
            }
          }
          purchaseOrder
          user {
            ... on User {
              ...managePeopleUserAffiliateFields
            }
          }
        }
        hasPendingAffiliations
      }
      ... on ErrorResult {
        ...errorResultFields
      }
    }
  }
  ${ManagePeopleClubAffiliatesFieldsFragmentDoc}
  ${InstructorProfileFieldsFragmentDoc}
  ${ManagePeopleUserAffiliateFieldsFragmentDoc}
  ${ErrorResultFieldsFragmentDoc}
`

/**
 * __useGetChainAffiliatedInstructorQuery__
 *
 * To run a query within a React component, call `useGetChainAffiliatedInstructorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChainAffiliatedInstructorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChainAffiliatedInstructorQuery({
 *   variables: {
 *      input: // value for 'input'
 *      _cacheKey: // value for '_cacheKey'
 *   },
 * });
 */
export function useGetChainAffiliatedInstructorQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetChainAffiliatedInstructorQuery,
    GetChainAffiliatedInstructorQueryVariables
  >
) {
  return Apollo.useQuery<
    GetChainAffiliatedInstructorQuery,
    GetChainAffiliatedInstructorQueryVariables
  >(GetChainAffiliatedInstructorDocument, baseOptions)
}
export function useGetChainAffiliatedInstructorLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetChainAffiliatedInstructorQuery,
    GetChainAffiliatedInstructorQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    GetChainAffiliatedInstructorQuery,
    GetChainAffiliatedInstructorQueryVariables
  >(GetChainAffiliatedInstructorDocument, baseOptions)
}
export type GetChainAffiliatedInstructorQueryHookResult = ReturnType<
  typeof useGetChainAffiliatedInstructorQuery
>
export type GetChainAffiliatedInstructorLazyQueryHookResult = ReturnType<
  typeof useGetChainAffiliatedInstructorLazyQuery
>
export type GetChainAffiliatedInstructorQueryResult = Apollo.QueryResult<
  GetChainAffiliatedInstructorQuery,
  GetChainAffiliatedInstructorQueryVariables
>
export const GetChainInstructorRequestsDocument = gql`
  query getChainInstructorRequests(
    $input: GetChainInstructorAffiliatesInput!
    $_cacheKey: String
  ) {
    getChainInstructorAffiliates(input: $input, _cacheKey: $_cacheKey) {
      ... on GetChainInstructorAffiliatesResult {
        __typename
        requests {
          clubId
          clubName
          distance
          distanceUnit
          id
          pendingStatus
          profile {
            ... on UserProfileTeaching {
              ...instructorProfileFields
            }
          }
          requestedBy
          requestedDate
          status
          user {
            ... on User {
              ...managePeopleUserAffiliateFields
            }
          }
        }
        hasPendingAffiliations
      }
      ... on ErrorResult {
        ...errorResultFields
      }
    }
  }
  ${InstructorProfileFieldsFragmentDoc}
  ${ManagePeopleUserAffiliateFieldsFragmentDoc}
  ${ErrorResultFieldsFragmentDoc}
`

/**
 * __useGetChainInstructorRequestsQuery__
 *
 * To run a query within a React component, call `useGetChainInstructorRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChainInstructorRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChainInstructorRequestsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      _cacheKey: // value for '_cacheKey'
 *   },
 * });
 */
export function useGetChainInstructorRequestsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetChainInstructorRequestsQuery,
    GetChainInstructorRequestsQueryVariables
  >
) {
  return Apollo.useQuery<
    GetChainInstructorRequestsQuery,
    GetChainInstructorRequestsQueryVariables
  >(GetChainInstructorRequestsDocument, baseOptions)
}
export function useGetChainInstructorRequestsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetChainInstructorRequestsQuery,
    GetChainInstructorRequestsQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    GetChainInstructorRequestsQuery,
    GetChainInstructorRequestsQueryVariables
  >(GetChainInstructorRequestsDocument, baseOptions)
}
export type GetChainInstructorRequestsQueryHookResult = ReturnType<
  typeof useGetChainInstructorRequestsQuery
>
export type GetChainInstructorRequestsLazyQueryHookResult = ReturnType<
  typeof useGetChainInstructorRequestsLazyQuery
>
export type GetChainInstructorRequestsQueryResult = Apollo.QueryResult<
  GetChainInstructorRequestsQuery,
  GetChainInstructorRequestsQueryVariables
>
export const GetChainUserDocument = gql`
  query getChainUser($_cacheKey: String) {
    getChainUser(_cacheKey: $_cacheKey) {
      ... on GetChainUser {
        chainLocations {
          ...clubProfileFields
        }
        isChainUser
      }
      ... on ErrorResult {
        type
        message
      }
    }
  }
  ${ClubProfileFieldsFragmentDoc}
`

/**
 * __useGetChainUserQuery__
 *
 * To run a query within a React component, call `useGetChainUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChainUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChainUserQuery({
 *   variables: {
 *      _cacheKey: // value for '_cacheKey'
 *   },
 * });
 */
export function useGetChainUserQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetChainUserQuery,
    GetChainUserQueryVariables
  >
) {
  return Apollo.useQuery<GetChainUserQuery, GetChainUserQueryVariables>(
    GetChainUserDocument,
    baseOptions
  )
}
export function useGetChainUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetChainUserQuery,
    GetChainUserQueryVariables
  >
) {
  return Apollo.useLazyQuery<GetChainUserQuery, GetChainUserQueryVariables>(
    GetChainUserDocument,
    baseOptions
  )
}
export type GetChainUserQueryHookResult = ReturnType<
  typeof useGetChainUserQuery
>
export type GetChainUserLazyQueryHookResult = ReturnType<
  typeof useGetChainUserLazyQuery
>
export type GetChainUserQueryResult = Apollo.QueryResult<
  GetChainUserQuery,
  GetChainUserQueryVariables
>
export const GetChainUserClubListingsDocument = gql`
  query getChainUserClubListings(
    $input: GetChainUserClubListingsInput!
    $_cacheKey: String
  ) {
    getChainUserClubListings(input: $input, _cacheKey: $_cacheKey) {
      ... on GetChainUserClubListingsResult {
        singleListings {
          ... on ClubSingleListing {
            ...singleListingFields
          }
        }
        multiListings {
          ... on ClubMultiListing {
            ...multiListingFields
          }
        }
      }
      ... on ErrorResult {
        ...errorResultFields
      }
    }
  }
  ${SingleListingFieldsFragmentDoc}
  ${MultiListingFieldsFragmentDoc}
  ${ErrorResultFieldsFragmentDoc}
`

/**
 * __useGetChainUserClubListingsQuery__
 *
 * To run a query within a React component, call `useGetChainUserClubListingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChainUserClubListingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChainUserClubListingsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      _cacheKey: // value for '_cacheKey'
 *   },
 * });
 */
export function useGetChainUserClubListingsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetChainUserClubListingsQuery,
    GetChainUserClubListingsQueryVariables
  >
) {
  return Apollo.useQuery<
    GetChainUserClubListingsQuery,
    GetChainUserClubListingsQueryVariables
  >(GetChainUserClubListingsDocument, baseOptions)
}
export function useGetChainUserClubListingsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetChainUserClubListingsQuery,
    GetChainUserClubListingsQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    GetChainUserClubListingsQuery,
    GetChainUserClubListingsQueryVariables
  >(GetChainUserClubListingsDocument, baseOptions)
}
export type GetChainUserClubListingsQueryHookResult = ReturnType<
  typeof useGetChainUserClubListingsQuery
>
export type GetChainUserClubListingsLazyQueryHookResult = ReturnType<
  typeof useGetChainUserClubListingsLazyQuery
>
export type GetChainUserClubListingsQueryResult = Apollo.QueryResult<
  GetChainUserClubListingsQuery,
  GetChainUserClubListingsQueryVariables
>
export const GetClubBusinessSupportContentDocument = gql`
  query getClubBusinessSupportContent($input: GetClubByIdInput!) {
    getClubById(input: $input) {
      ... on UserProfileClub {
        businessSupport {
          ...BusinessSupportSectionContent
        }
      }
      ... on ErrorResult {
        type
        message
      }
    }
  }
  ${BusinessSupportSectionContentFragmentDoc}
`

/**
 * __useGetClubBusinessSupportContentQuery__
 *
 * To run a query within a React component, call `useGetClubBusinessSupportContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClubBusinessSupportContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClubBusinessSupportContentQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetClubBusinessSupportContentQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetClubBusinessSupportContentQuery,
    GetClubBusinessSupportContentQueryVariables
  >
) {
  return Apollo.useQuery<
    GetClubBusinessSupportContentQuery,
    GetClubBusinessSupportContentQueryVariables
  >(GetClubBusinessSupportContentDocument, baseOptions)
}
export function useGetClubBusinessSupportContentLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetClubBusinessSupportContentQuery,
    GetClubBusinessSupportContentQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    GetClubBusinessSupportContentQuery,
    GetClubBusinessSupportContentQueryVariables
  >(GetClubBusinessSupportContentDocument, baseOptions)
}
export type GetClubBusinessSupportContentQueryHookResult = ReturnType<
  typeof useGetClubBusinessSupportContentQuery
>
export type GetClubBusinessSupportContentLazyQueryHookResult = ReturnType<
  typeof useGetClubBusinessSupportContentLazyQuery
>
export type GetClubBusinessSupportContentQueryResult = Apollo.QueryResult<
  GetClubBusinessSupportContentQuery,
  GetClubBusinessSupportContentQueryVariables
>
export const GetClubInstructorAffiliatesDocument = gql`
  query getClubInstructorAffiliates(
    $input: GetClubInstructorAffiliatesInput!
    $_cacheKey: String
  ) {
    getClubInstructorAffiliates(input: $input, _cacheKey: $_cacheKey) {
      ... on GetClubInstructorAffiliatesResult {
        __typename
        affiliates {
          purchaseOrder
          actionedDate
          id
          requestedBy
          requestedDate
          status
          user {
            id
            phone
            email
            accountId
            market {
              name
              locale
              distanceUnit
            }
            lastName
            firstName
          }
          clubId
          profile {
            ... on UserProfileTeaching {
              ...instructorProfileFields
            }
          }
        }
        requests {
          id
          distance
          distanceUnit
          requestedDate
          requestedBy
          status
          pendingStatus
          user {
            id
            phone
            email
            accountId
            market {
              name
              locale
              distanceUnit
            }
            lastName
            firstName
          }
          clubId
          profile {
            ... on UserProfileTeaching {
              ...instructorProfileFields
            }
          }
        }
      }
      ... on ErrorResult {
        ...errorResultFields
      }
    }
  }
  ${InstructorProfileFieldsFragmentDoc}
  ${ErrorResultFieldsFragmentDoc}
`

/**
 * __useGetClubInstructorAffiliatesQuery__
 *
 * To run a query within a React component, call `useGetClubInstructorAffiliatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClubInstructorAffiliatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClubInstructorAffiliatesQuery({
 *   variables: {
 *      input: // value for 'input'
 *      _cacheKey: // value for '_cacheKey'
 *   },
 * });
 */
export function useGetClubInstructorAffiliatesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetClubInstructorAffiliatesQuery,
    GetClubInstructorAffiliatesQueryVariables
  >
) {
  return Apollo.useQuery<
    GetClubInstructorAffiliatesQuery,
    GetClubInstructorAffiliatesQueryVariables
  >(GetClubInstructorAffiliatesDocument, baseOptions)
}
export function useGetClubInstructorAffiliatesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetClubInstructorAffiliatesQuery,
    GetClubInstructorAffiliatesQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    GetClubInstructorAffiliatesQuery,
    GetClubInstructorAffiliatesQueryVariables
  >(GetClubInstructorAffiliatesDocument, baseOptions)
}
export type GetClubInstructorAffiliatesQueryHookResult = ReturnType<
  typeof useGetClubInstructorAffiliatesQuery
>
export type GetClubInstructorAffiliatesLazyQueryHookResult = ReturnType<
  typeof useGetClubInstructorAffiliatesLazyQuery
>
export type GetClubInstructorAffiliatesQueryResult = Apollo.QueryResult<
  GetClubInstructorAffiliatesQuery,
  GetClubInstructorAffiliatesQueryVariables
>
export const GetClubListingByIdDocument = gql`
  query getClubListingById($listingId: String!) {
    getClubListingById(listingId: $listingId) {
      ... on SearchClubJobListingsSingleResult {
        distance
        distanceUnit
        messageSentOn
        enquiredOn
        onWatchlist
        hasBeenReported
        listing {
          ... on ClubSingleListing {
            ...singleListingFields
          }
          ... on ClubMultiListing {
            ...multiListingFields
          }
        }
      }
      ... on ErrorResult {
        ...errorResultFields
      }
    }
  }
  ${SingleListingFieldsFragmentDoc}
  ${MultiListingFieldsFragmentDoc}
  ${ErrorResultFieldsFragmentDoc}
`

/**
 * __useGetClubListingByIdQuery__
 *
 * To run a query within a React component, call `useGetClubListingByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClubListingByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClubListingByIdQuery({
 *   variables: {
 *      listingId: // value for 'listingId'
 *   },
 * });
 */
export function useGetClubListingByIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetClubListingByIdQuery,
    GetClubListingByIdQueryVariables
  >
) {
  return Apollo.useQuery<
    GetClubListingByIdQuery,
    GetClubListingByIdQueryVariables
  >(GetClubListingByIdDocument, baseOptions)
}
export function useGetClubListingByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetClubListingByIdQuery,
    GetClubListingByIdQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    GetClubListingByIdQuery,
    GetClubListingByIdQueryVariables
  >(GetClubListingByIdDocument, baseOptions)
}
export type GetClubListingByIdQueryHookResult = ReturnType<
  typeof useGetClubListingByIdQuery
>
export type GetClubListingByIdLazyQueryHookResult = ReturnType<
  typeof useGetClubListingByIdLazyQuery
>
export type GetClubListingByIdQueryResult = Apollo.QueryResult<
  GetClubListingByIdQuery,
  GetClubListingByIdQueryVariables
>
export const GetClubListingsByClubIdDocument = gql`
  query getClubListingsByClubId(
    $input: GetClubListingsByClubIdInput!
    $_cacheKey: String
  ) {
    getClubListingsByClubId(input: $input, _cacheKey: $_cacheKey) {
      ... on GetClubListingsByClubIdResult {
        results {
          ... on ClubSingleListing {
            ...singleListingFields
          }
          ... on ClubMultiListing {
            ...multiListingFields
          }
        }
      }
      ... on ErrorResult {
        ...errorResultFields
      }
    }
  }
  ${SingleListingFieldsFragmentDoc}
  ${MultiListingFieldsFragmentDoc}
  ${ErrorResultFieldsFragmentDoc}
`

/**
 * __useGetClubListingsByClubIdQuery__
 *
 * To run a query within a React component, call `useGetClubListingsByClubIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClubListingsByClubIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClubListingsByClubIdQuery({
 *   variables: {
 *      input: // value for 'input'
 *      _cacheKey: // value for '_cacheKey'
 *   },
 * });
 */
export function useGetClubListingsByClubIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetClubListingsByClubIdQuery,
    GetClubListingsByClubIdQueryVariables
  >
) {
  return Apollo.useQuery<
    GetClubListingsByClubIdQuery,
    GetClubListingsByClubIdQueryVariables
  >(GetClubListingsByClubIdDocument, baseOptions)
}
export function useGetClubListingsByClubIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetClubListingsByClubIdQuery,
    GetClubListingsByClubIdQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    GetClubListingsByClubIdQuery,
    GetClubListingsByClubIdQueryVariables
  >(GetClubListingsByClubIdDocument, baseOptions)
}
export type GetClubListingsByClubIdQueryHookResult = ReturnType<
  typeof useGetClubListingsByClubIdQuery
>
export type GetClubListingsByClubIdLazyQueryHookResult = ReturnType<
  typeof useGetClubListingsByClubIdLazyQuery
>
export type GetClubListingsByClubIdQueryResult = Apollo.QueryResult<
  GetClubListingsByClubIdQuery,
  GetClubListingsByClubIdQueryVariables
>
export const GetClubSettingsDocument = gql`
  query getClubSettings($input: GetClubSettingsInput!, $_cacheKey: String) {
    getClubSettings(input: $input, _cacheKey: $_cacheKey) {
      ... on GetClubSettingsResult {
        id
        address {
          city
          state
          street
          country
          stateCode
          postalCode
          countryCode
          location {
            lat
            lon
          }
        }
        email {
          main
          affiliations
          jobListings
        }
        id
        name
        phone
      }
      ... on ErrorResult {
        ...errorResultFields
      }
    }
  }
  ${ErrorResultFieldsFragmentDoc}
`

/**
 * __useGetClubSettingsQuery__
 *
 * To run a query within a React component, call `useGetClubSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClubSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClubSettingsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      _cacheKey: // value for '_cacheKey'
 *   },
 * });
 */
export function useGetClubSettingsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetClubSettingsQuery,
    GetClubSettingsQueryVariables
  >
) {
  return Apollo.useQuery<GetClubSettingsQuery, GetClubSettingsQueryVariables>(
    GetClubSettingsDocument,
    baseOptions
  )
}
export function useGetClubSettingsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetClubSettingsQuery,
    GetClubSettingsQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    GetClubSettingsQuery,
    GetClubSettingsQueryVariables
  >(GetClubSettingsDocument, baseOptions)
}
export type GetClubSettingsQueryHookResult = ReturnType<
  typeof useGetClubSettingsQuery
>
export type GetClubSettingsLazyQueryHookResult = ReturnType<
  typeof useGetClubSettingsLazyQuery
>
export type GetClubSettingsQueryResult = Apollo.QueryResult<
  GetClubSettingsQuery,
  GetClubSettingsQueryVariables
>
export const GetContactUsContentDocument = gql`
  query getContactUsContent(
    $input: GetContactUsContentInput!
    $_cacheKey: String
  ) {
    getContactUsContent(input: $input, _cacheKey: $_cacheKey) {
      ... on GetContactUsContentResult {
        result {
          section
          content {
            title
            subHeading
            contentText
          }
        }
      }
      ... on ErrorResult {
        ...errorResultFields
      }
    }
  }
  ${ErrorResultFieldsFragmentDoc}
`

/**
 * __useGetContactUsContentQuery__
 *
 * To run a query within a React component, call `useGetContactUsContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactUsContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactUsContentQuery({
 *   variables: {
 *      input: // value for 'input'
 *      _cacheKey: // value for '_cacheKey'
 *   },
 * });
 */
export function useGetContactUsContentQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetContactUsContentQuery,
    GetContactUsContentQueryVariables
  >
) {
  return Apollo.useQuery<
    GetContactUsContentQuery,
    GetContactUsContentQueryVariables
  >(GetContactUsContentDocument, baseOptions)
}
export function useGetContactUsContentLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetContactUsContentQuery,
    GetContactUsContentQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    GetContactUsContentQuery,
    GetContactUsContentQueryVariables
  >(GetContactUsContentDocument, baseOptions)
}
export type GetContactUsContentQueryHookResult = ReturnType<
  typeof useGetContactUsContentQuery
>
export type GetContactUsContentLazyQueryHookResult = ReturnType<
  typeof useGetContactUsContentLazyQuery
>
export type GetContactUsContentQueryResult = Apollo.QueryResult<
  GetContactUsContentQuery,
  GetContactUsContentQueryVariables
>
export const GetCurrentUserDocument = gql`
  query getCurrentUser($_cacheKey: String) {
    getCurrentUser(_cacheKey: $_cacheKey) {
      ... on UserResult {
        ...fullUserField
      }
      ... on ErrorResult {
        ...errorResultFields
      }
    }
  }
  ${FullUserFieldFragmentDoc}
  ${ErrorResultFieldsFragmentDoc}
`

/**
 * __useGetCurrentUserQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserQuery({
 *   variables: {
 *      _cacheKey: // value for '_cacheKey'
 *   },
 * });
 */
export function useGetCurrentUserQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetCurrentUserQuery,
    GetCurrentUserQueryVariables
  >
) {
  return Apollo.useQuery<GetCurrentUserQuery, GetCurrentUserQueryVariables>(
    GetCurrentUserDocument,
    baseOptions
  )
}
export function useGetCurrentUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCurrentUserQuery,
    GetCurrentUserQueryVariables
  >
) {
  return Apollo.useLazyQuery<GetCurrentUserQuery, GetCurrentUserQueryVariables>(
    GetCurrentUserDocument,
    baseOptions
  )
}
export type GetCurrentUserQueryHookResult = ReturnType<
  typeof useGetCurrentUserQuery
>
export type GetCurrentUserLazyQueryHookResult = ReturnType<
  typeof useGetCurrentUserLazyQuery
>
export type GetCurrentUserQueryResult = Apollo.QueryResult<
  GetCurrentUserQuery,
  GetCurrentUserQueryVariables
>
export const GetCurrentUserPhotoUploadDataDocument = gql`
  query getCurrentUserPhotoUploadData($_cacheKey: String) {
    getCurrentUserPhotoUploadData(_cacheKey: $_cacheKey) {
      ... on GetCurrentUserPhotoUploadDataResult {
        url
        token
        __typename
      }
      ... on ErrorResult {
        ...errorResultFields
      }
    }
  }
  ${ErrorResultFieldsFragmentDoc}
`

/**
 * __useGetCurrentUserPhotoUploadDataQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserPhotoUploadDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserPhotoUploadDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserPhotoUploadDataQuery({
 *   variables: {
 *      _cacheKey: // value for '_cacheKey'
 *   },
 * });
 */
export function useGetCurrentUserPhotoUploadDataQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetCurrentUserPhotoUploadDataQuery,
    GetCurrentUserPhotoUploadDataQueryVariables
  >
) {
  return Apollo.useQuery<
    GetCurrentUserPhotoUploadDataQuery,
    GetCurrentUserPhotoUploadDataQueryVariables
  >(GetCurrentUserPhotoUploadDataDocument, baseOptions)
}
export function useGetCurrentUserPhotoUploadDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCurrentUserPhotoUploadDataQuery,
    GetCurrentUserPhotoUploadDataQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    GetCurrentUserPhotoUploadDataQuery,
    GetCurrentUserPhotoUploadDataQueryVariables
  >(GetCurrentUserPhotoUploadDataDocument, baseOptions)
}
export type GetCurrentUserPhotoUploadDataQueryHookResult = ReturnType<
  typeof useGetCurrentUserPhotoUploadDataQuery
>
export type GetCurrentUserPhotoUploadDataLazyQueryHookResult = ReturnType<
  typeof useGetCurrentUserPhotoUploadDataLazyQuery
>
export type GetCurrentUserPhotoUploadDataQueryResult = Apollo.QueryResult<
  GetCurrentUserPhotoUploadDataQuery,
  GetCurrentUserPhotoUploadDataQueryVariables
>
export const GetCurrentUserPortfolioUploadDataDocument = gql`
  query getCurrentUserPortfolioUploadData(
    $input: GetCurrentUserPortfolioUploadDataInput!
    $_cacheKey: String
  ) {
    getCurrentUserPortfolioUploadData(input: $input, _cacheKey: $_cacheKey) {
      ... on GetCurrentUserPortfolioUploadDataResult {
        items {
          url
          token
        }
      }
      ... on ErrorResult {
        ...errorResultFields
      }
    }
  }
  ${ErrorResultFieldsFragmentDoc}
`

/**
 * __useGetCurrentUserPortfolioUploadDataQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserPortfolioUploadDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserPortfolioUploadDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserPortfolioUploadDataQuery({
 *   variables: {
 *      input: // value for 'input'
 *      _cacheKey: // value for '_cacheKey'
 *   },
 * });
 */
export function useGetCurrentUserPortfolioUploadDataQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCurrentUserPortfolioUploadDataQuery,
    GetCurrentUserPortfolioUploadDataQueryVariables
  >
) {
  return Apollo.useQuery<
    GetCurrentUserPortfolioUploadDataQuery,
    GetCurrentUserPortfolioUploadDataQueryVariables
  >(GetCurrentUserPortfolioUploadDataDocument, baseOptions)
}
export function useGetCurrentUserPortfolioUploadDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCurrentUserPortfolioUploadDataQuery,
    GetCurrentUserPortfolioUploadDataQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    GetCurrentUserPortfolioUploadDataQuery,
    GetCurrentUserPortfolioUploadDataQueryVariables
  >(GetCurrentUserPortfolioUploadDataDocument, baseOptions)
}
export type GetCurrentUserPortfolioUploadDataQueryHookResult = ReturnType<
  typeof useGetCurrentUserPortfolioUploadDataQuery
>
export type GetCurrentUserPortfolioUploadDataLazyQueryHookResult = ReturnType<
  typeof useGetCurrentUserPortfolioUploadDataLazyQuery
>
export type GetCurrentUserPortfolioUploadDataQueryResult = Apollo.QueryResult<
  GetCurrentUserPortfolioUploadDataQuery,
  GetCurrentUserPortfolioUploadDataQueryVariables
>
export const GetDashboardDocument = gql`
  query getDashboard($role: UserRoleInput!, $_cacheKey: String) {
    __typename
    getDashboard(role: $role, _cacheKey: $_cacheKey) {
      __typename
      ... on DashboardPageInstructorResponse {
        id
        translation {
          title
        }
        socialMedia {
          title
          items {
            id
            url
            type
            createdAt
            createdAtLabel
            content {
              type
              value
            }
          }
        }
        links {
          id
          imageSet {
            id
            desktop {
              id
              alt
              url
            }
            mobile {
              id
              alt
              url
            }
          }
          title
          subtitle
          url {
            type
            value
          }
        }
        translation {
          title
        }
        certifications {
          id
          status
          active
          lmqLevel
          link {
            id
            url {
              type
              value
            }
            text
          }
          steps {
            id
            label
            status
            action {
              id
              url {
                value
                type
              }
              text
            }
          }
          program {
            id
            name
            code
            initials
          }
        }
        promotions {
          id
          title
          image {
            id
            desktop {
              id
              alt
              url
              width
              height
            }
            mobile {
              id
              alt
              url
              width
              height
            }
          }
          description
          link {
            id
            text
            url {
              value
              type
            }
          }
        }
      }
      ... on DashboardPageClubResponse {
        id
        links {
          id
          imageSet {
            id
            desktop {
              id
              alt
              url
            }
            mobile {
              id
              alt
              url
            }
          }
          title
          subtitle
          url {
            type
            value
          }
        }
        promotions {
          id
          title
          image {
            id
            desktop {
              id
              alt
              url
              width
              height
            }
            mobile {
              id
              alt
              url
              width
              height
            }
          }
          description
          link {
            id
            text
            url {
              value
              type
            }
          }
        }
        partnership {
          ... on ClubPartnershipProgramStats {
            ...ClubDashboardProgramStats
          }
          ... on ClubPartnershipStandardContent {
            ...ClubDashboardStandardContent
          }
          ... on ClubPartnershipBusinessSupportContent {
            ...ClubDashboardBusinessSupportContent
          }
          ... on ClubPartnershipBusinessSupportContent {
            ...ClubDashboardBusinessSupportContent
          }
        }
        myTools {
          id
          imageSet {
            id
            desktop {
              id
              alt
              url
            }
            mobile {
              id
              alt
              url
            }
          }
          title
          subtitle
          url {
            type
            value
          }
        }
      }
      ... on ErrorResult {
        ...errorResultFields
      }
    }
  }
  ${ClubDashboardProgramStatsFragmentDoc}
  ${ClubDashboardStandardContentFragmentDoc}
  ${ClubDashboardBusinessSupportContentFragmentDoc}
  ${ErrorResultFieldsFragmentDoc}
`

/**
 * __useGetDashboardQuery__
 *
 * To run a query within a React component, call `useGetDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDashboardQuery({
 *   variables: {
 *      role: // value for 'role'
 *      _cacheKey: // value for '_cacheKey'
 *   },
 * });
 */
export function useGetDashboardQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetDashboardQuery,
    GetDashboardQueryVariables
  >
) {
  return Apollo.useQuery<GetDashboardQuery, GetDashboardQueryVariables>(
    GetDashboardDocument,
    baseOptions
  )
}
export function useGetDashboardLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDashboardQuery,
    GetDashboardQueryVariables
  >
) {
  return Apollo.useLazyQuery<GetDashboardQuery, GetDashboardQueryVariables>(
    GetDashboardDocument,
    baseOptions
  )
}
export type GetDashboardQueryHookResult = ReturnType<
  typeof useGetDashboardQuery
>
export type GetDashboardLazyQueryHookResult = ReturnType<
  typeof useGetDashboardLazyQuery
>
export type GetDashboardQueryResult = Apollo.QueryResult<
  GetDashboardQuery,
  GetDashboardQueryVariables
>
export const GetEqualOpportunitiesPolicyDocument = gql`
  query getEqualOpportunitiesPolicy(
    $input: GetEqualOpportunitiesPolicyInput!
    $_cacheKey: String
  ) {
    getEqualOpportunitiesPolicy(input: $input, _cacheKey: $_cacheKey) {
      ... on GetEqualOpportunitiesPolicyResult {
        result {
          section
          content {
            title
            subHeading
            contentText
          }
        }
      }
      ... on ErrorResult {
        ...errorResultFields
      }
    }
  }
  ${ErrorResultFieldsFragmentDoc}
`

/**
 * __useGetEqualOpportunitiesPolicyQuery__
 *
 * To run a query within a React component, call `useGetEqualOpportunitiesPolicyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEqualOpportunitiesPolicyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEqualOpportunitiesPolicyQuery({
 *   variables: {
 *      input: // value for 'input'
 *      _cacheKey: // value for '_cacheKey'
 *   },
 * });
 */
export function useGetEqualOpportunitiesPolicyQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetEqualOpportunitiesPolicyQuery,
    GetEqualOpportunitiesPolicyQueryVariables
  >
) {
  return Apollo.useQuery<
    GetEqualOpportunitiesPolicyQuery,
    GetEqualOpportunitiesPolicyQueryVariables
  >(GetEqualOpportunitiesPolicyDocument, baseOptions)
}
export function useGetEqualOpportunitiesPolicyLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetEqualOpportunitiesPolicyQuery,
    GetEqualOpportunitiesPolicyQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    GetEqualOpportunitiesPolicyQuery,
    GetEqualOpportunitiesPolicyQueryVariables
  >(GetEqualOpportunitiesPolicyDocument, baseOptions)
}
export type GetEqualOpportunitiesPolicyQueryHookResult = ReturnType<
  typeof useGetEqualOpportunitiesPolicyQuery
>
export type GetEqualOpportunitiesPolicyLazyQueryHookResult = ReturnType<
  typeof useGetEqualOpportunitiesPolicyLazyQuery
>
export type GetEqualOpportunitiesPolicyQueryResult = Apollo.QueryResult<
  GetEqualOpportunitiesPolicyQuery,
  GetEqualOpportunitiesPolicyQueryVariables
>
export const GetFrequentlyAskedQuestionsDocument = gql`
  query getFrequentlyAskedQuestions(
    $input: GetFrequentlyAskedQuestionsInput!
    $_cacheKey: String
  ) {
    getFrequentlyAskedQuestions(input: $input, _cacheKey: $_cacheKey) {
      ... on GetFrequentlyAskedQuestionsResult {
        result {
          section
          content {
            title
            subHeading
            contentText
          }
        }
      }
      ... on ErrorResult {
        ...errorResultFields
      }
    }
  }
  ${ErrorResultFieldsFragmentDoc}
`

/**
 * __useGetFrequentlyAskedQuestionsQuery__
 *
 * To run a query within a React component, call `useGetFrequentlyAskedQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFrequentlyAskedQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFrequentlyAskedQuestionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      _cacheKey: // value for '_cacheKey'
 *   },
 * });
 */
export function useGetFrequentlyAskedQuestionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetFrequentlyAskedQuestionsQuery,
    GetFrequentlyAskedQuestionsQueryVariables
  >
) {
  return Apollo.useQuery<
    GetFrequentlyAskedQuestionsQuery,
    GetFrequentlyAskedQuestionsQueryVariables
  >(GetFrequentlyAskedQuestionsDocument, baseOptions)
}
export function useGetFrequentlyAskedQuestionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetFrequentlyAskedQuestionsQuery,
    GetFrequentlyAskedQuestionsQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    GetFrequentlyAskedQuestionsQuery,
    GetFrequentlyAskedQuestionsQueryVariables
  >(GetFrequentlyAskedQuestionsDocument, baseOptions)
}
export type GetFrequentlyAskedQuestionsQueryHookResult = ReturnType<
  typeof useGetFrequentlyAskedQuestionsQuery
>
export type GetFrequentlyAskedQuestionsLazyQueryHookResult = ReturnType<
  typeof useGetFrequentlyAskedQuestionsLazyQuery
>
export type GetFrequentlyAskedQuestionsQueryResult = Apollo.QueryResult<
  GetFrequentlyAskedQuestionsQuery,
  GetFrequentlyAskedQuestionsQueryVariables
>
export const GetHeaderContentDocument = gql`
  query getHeaderContent($input: GetHeaderInput!, $_cacheKey: String) {
    getHeaders(input: $input, _cacheKey: $_cacheKey) {
      ... on GetHeaderResult {
        __typename
        results {
          image {
            id
            desktop {
              id
              alt
              url
            }
            mobile {
              id
              alt
              url
            }
          }
          key
          title
          subHeading
        }
      }
      ... on ErrorResult {
        ...errorResultFields
      }
    }
  }
  ${ErrorResultFieldsFragmentDoc}
`

/**
 * __useGetHeaderContentQuery__
 *
 * To run a query within a React component, call `useGetHeaderContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHeaderContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHeaderContentQuery({
 *   variables: {
 *      input: // value for 'input'
 *      _cacheKey: // value for '_cacheKey'
 *   },
 * });
 */
export function useGetHeaderContentQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetHeaderContentQuery,
    GetHeaderContentQueryVariables
  >
) {
  return Apollo.useQuery<GetHeaderContentQuery, GetHeaderContentQueryVariables>(
    GetHeaderContentDocument,
    baseOptions
  )
}
export function useGetHeaderContentLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetHeaderContentQuery,
    GetHeaderContentQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    GetHeaderContentQuery,
    GetHeaderContentQueryVariables
  >(GetHeaderContentDocument, baseOptions)
}
export type GetHeaderContentQueryHookResult = ReturnType<
  typeof useGetHeaderContentQuery
>
export type GetHeaderContentLazyQueryHookResult = ReturnType<
  typeof useGetHeaderContentLazyQuery
>
export type GetHeaderContentQueryResult = Apollo.QueryResult<
  GetHeaderContentQuery,
  GetHeaderContentQueryVariables
>
export const GetInStudioManageOptionsDocument = gql`
  query getInStudioManageOptions($input: GetPickListInput!) {
    getPickLists(input: $input) {
      ... on GetPickListResult {
        __typename
        ...InStudioManageOptions
      }
      ... on ErrorResult {
        __typename
        ...errorResultFields
      }
    }
  }
  ${InStudioManageOptionsFragmentDoc}
  ${ErrorResultFieldsFragmentDoc}
`

/**
 * __useGetInStudioManageOptionsQuery__
 *
 * To run a query within a React component, call `useGetInStudioManageOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInStudioManageOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInStudioManageOptionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetInStudioManageOptionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetInStudioManageOptionsQuery,
    GetInStudioManageOptionsQueryVariables
  >
) {
  return Apollo.useQuery<
    GetInStudioManageOptionsQuery,
    GetInStudioManageOptionsQueryVariables
  >(GetInStudioManageOptionsDocument, baseOptions)
}
export function useGetInStudioManageOptionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetInStudioManageOptionsQuery,
    GetInStudioManageOptionsQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    GetInStudioManageOptionsQuery,
    GetInStudioManageOptionsQueryVariables
  >(GetInStudioManageOptionsDocument, baseOptions)
}
export type GetInStudioManageOptionsQueryHookResult = ReturnType<
  typeof useGetInStudioManageOptionsQuery
>
export type GetInStudioManageOptionsLazyQueryHookResult = ReturnType<
  typeof useGetInStudioManageOptionsLazyQuery
>
export type GetInStudioManageOptionsQueryResult = Apollo.QueryResult<
  GetInStudioManageOptionsQuery,
  GetInStudioManageOptionsQueryVariables
>
export const GetUserAccountDocument = gql`
  query getUserAccount(
    $input: GetUserByIdInput!
    $role: UserRoleInput!
    $_cacheKey: String
  ) {
    __typename
    getUserAccount(input: $input, role: $role, _cacheKey: $_cacheKey) {
      __typename
      ... on UserAccountSettingsResult {
        id
        address {
          ...addressFields
        }
        email
        firstName
        lastName
        outlinks {
          url
          title
          _metadata {
            urlSource
          }
        }
        phone
      }
      ... on ErrorResult {
        ...errorResultFields
      }
    }
  }
  ${AddressFieldsFragmentDoc}
  ${ErrorResultFieldsFragmentDoc}
`

/**
 * __useGetUserAccountQuery__
 *
 * To run a query within a React component, call `useGetUserAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserAccountQuery({
 *   variables: {
 *      input: // value for 'input'
 *      role: // value for 'role'
 *      _cacheKey: // value for '_cacheKey'
 *   },
 * });
 */
export function useGetUserAccountQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetUserAccountQuery,
    GetUserAccountQueryVariables
  >
) {
  return Apollo.useQuery<GetUserAccountQuery, GetUserAccountQueryVariables>(
    GetUserAccountDocument,
    baseOptions
  )
}
export function useGetUserAccountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUserAccountQuery,
    GetUserAccountQueryVariables
  >
) {
  return Apollo.useLazyQuery<GetUserAccountQuery, GetUserAccountQueryVariables>(
    GetUserAccountDocument,
    baseOptions
  )
}
export type GetUserAccountQueryHookResult = ReturnType<
  typeof useGetUserAccountQuery
>
export type GetUserAccountLazyQueryHookResult = ReturnType<
  typeof useGetUserAccountLazyQuery
>
export type GetUserAccountQueryResult = Apollo.QueryResult<
  GetUserAccountQuery,
  GetUserAccountQueryVariables
>
export const GetInstructorEnquiriesDocument = gql`
  query getInstructorEnquiries(
    $role: UserRoleInput!
    $filter: UserEnquiriesFilter!
    $_cacheKey: String
  ) {
    getUserEnquiries(role: $role, filter: $filter, _cacheKey: $_cacheKey) {
      ... on GetUserEnquiriesResult {
        enquiries {
          listing {
            ... on EnquiryClubListingSingleResult {
              distance
              distanceUnit
              messageSentOn
              enquiredOn
              onWatchlist
              hasBeenReported
              listing {
                ... on ClubSingleListing {
                  __typename
                  clubInfo {
                    id
                    name
                    hiring
                    address {
                      ...addressFields
                    }
                    profileImage {
                      url
                    }
                    programs {
                      ... on ClubProgram {
                        name
                      }
                    }
                  }
                  ...singleListingFields
                }
                ... on ClubMultiListing {
                  __typename
                  clubInfo {
                    id
                    name
                    hiring
                    address {
                      ...addressFields
                    }
                    profileImage {
                      url
                    }
                    programs {
                      ... on ClubProgram {
                        name
                      }
                    }
                  }
                  ...multiListingFields
                }
                ... on ClubListingUnknown {
                  __typename
                  clubInfo {
                    id
                    name
                    hiring
                    address {
                      ...addressFields
                    }
                    profileImage {
                      url
                    }
                    programs {
                      ... on ClubProgram {
                        name
                      }
                    }
                  }
                  id
                }
              }
            }
          }
          message {
            clubId
            clubName
            id
            listingId
            message
            profileId
            readAt
            requestedBy
            sentAt
          }
        }
      }
      ... on ErrorResult {
        ...errorResultFields
      }
    }
  }
  ${AddressFieldsFragmentDoc}
  ${SingleListingFieldsFragmentDoc}
  ${MultiListingFieldsFragmentDoc}
  ${ErrorResultFieldsFragmentDoc}
`

/**
 * __useGetInstructorEnquiriesQuery__
 *
 * To run a query within a React component, call `useGetInstructorEnquiriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstructorEnquiriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstructorEnquiriesQuery({
 *   variables: {
 *      role: // value for 'role'
 *      filter: // value for 'filter'
 *      _cacheKey: // value for '_cacheKey'
 *   },
 * });
 */
export function useGetInstructorEnquiriesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetInstructorEnquiriesQuery,
    GetInstructorEnquiriesQueryVariables
  >
) {
  return Apollo.useQuery<
    GetInstructorEnquiriesQuery,
    GetInstructorEnquiriesQueryVariables
  >(GetInstructorEnquiriesDocument, baseOptions)
}
export function useGetInstructorEnquiriesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetInstructorEnquiriesQuery,
    GetInstructorEnquiriesQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    GetInstructorEnquiriesQuery,
    GetInstructorEnquiriesQueryVariables
  >(GetInstructorEnquiriesDocument, baseOptions)
}
export type GetInstructorEnquiriesQueryHookResult = ReturnType<
  typeof useGetInstructorEnquiriesQuery
>
export type GetInstructorEnquiriesLazyQueryHookResult = ReturnType<
  typeof useGetInstructorEnquiriesLazyQuery
>
export type GetInstructorEnquiriesQueryResult = Apollo.QueryResult<
  GetInstructorEnquiriesQuery,
  GetInstructorEnquiriesQueryVariables
>
export const GetInstructorFacilitiesDocument = gql`
  query getInstructorFacilities(
    $input: GetInstructorClubAffiliatesInput!
    $_cacheKey: String
  ) {
    getInstructorClubAffiliates(input: $input, _cacheKey: $_cacheKey) {
      ... on GetInstructorClubAffiliatesResult {
        __typename
        affiliations {
          actionedDate
          clubId
          distance
          distanceUnit
          id
          profile {
            ... on UserProfileClub {
              ...clubProfileFields
            }
          }
          requestedDate
          requestedBy
          status
          pendingStatus
          isDigitalOnly
        }
      }
      ... on ErrorResult {
        ...errorResultFields
      }
    }
  }
  ${ClubProfileFieldsFragmentDoc}
  ${ErrorResultFieldsFragmentDoc}
`

/**
 * __useGetInstructorFacilitiesQuery__
 *
 * To run a query within a React component, call `useGetInstructorFacilitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstructorFacilitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstructorFacilitiesQuery({
 *   variables: {
 *      input: // value for 'input'
 *      _cacheKey: // value for '_cacheKey'
 *   },
 * });
 */
export function useGetInstructorFacilitiesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetInstructorFacilitiesQuery,
    GetInstructorFacilitiesQueryVariables
  >
) {
  return Apollo.useQuery<
    GetInstructorFacilitiesQuery,
    GetInstructorFacilitiesQueryVariables
  >(GetInstructorFacilitiesDocument, baseOptions)
}
export function useGetInstructorFacilitiesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetInstructorFacilitiesQuery,
    GetInstructorFacilitiesQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    GetInstructorFacilitiesQuery,
    GetInstructorFacilitiesQueryVariables
  >(GetInstructorFacilitiesDocument, baseOptions)
}
export type GetInstructorFacilitiesQueryHookResult = ReturnType<
  typeof useGetInstructorFacilitiesQuery
>
export type GetInstructorFacilitiesLazyQueryHookResult = ReturnType<
  typeof useGetInstructorFacilitiesLazyQuery
>
export type GetInstructorFacilitiesQueryResult = Apollo.QueryResult<
  GetInstructorFacilitiesQuery,
  GetInstructorFacilitiesQueryVariables
>
export const GetInstructorPortfolioDocument = gql`
  query getInstructorPortfolio($_cacheKey: String) {
    getCurrentUser(_cacheKey: $_cacheKey) {
      ... on UserResult {
        __typename
        profiles {
          ... on UserProfileTeaching {
            media {
              id
              url
            }
          }
          ... on UserProfileClub {
            media {
              id
              url
            }
          }
        }
      }
      ... on ErrorResult {
        ...errorResultFields
      }
    }
  }
  ${ErrorResultFieldsFragmentDoc}
`

/**
 * __useGetInstructorPortfolioQuery__
 *
 * To run a query within a React component, call `useGetInstructorPortfolioQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstructorPortfolioQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstructorPortfolioQuery({
 *   variables: {
 *      _cacheKey: // value for '_cacheKey'
 *   },
 * });
 */
export function useGetInstructorPortfolioQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetInstructorPortfolioQuery,
    GetInstructorPortfolioQueryVariables
  >
) {
  return Apollo.useQuery<
    GetInstructorPortfolioQuery,
    GetInstructorPortfolioQueryVariables
  >(GetInstructorPortfolioDocument, baseOptions)
}
export function useGetInstructorPortfolioLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetInstructorPortfolioQuery,
    GetInstructorPortfolioQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    GetInstructorPortfolioQuery,
    GetInstructorPortfolioQueryVariables
  >(GetInstructorPortfolioDocument, baseOptions)
}
export type GetInstructorPortfolioQueryHookResult = ReturnType<
  typeof useGetInstructorPortfolioQuery
>
export type GetInstructorPortfolioLazyQueryHookResult = ReturnType<
  typeof useGetInstructorPortfolioLazyQuery
>
export type GetInstructorPortfolioQueryResult = Apollo.QueryResult<
  GetInstructorPortfolioQuery,
  GetInstructorPortfolioQueryVariables
>
export const GetInstructorWatchlistDocument = gql`
  query getInstructorWatchlist($role: UserRoleInput!, $_cacheKey: String) {
    getInstructorWatchlist(role: $role, _cacheKey: $_cacheKey) {
      ... on ErrorResult {
        ...errorResultFields
      }
      ... on SearchClubListingsResult {
        total
        results {
          ... on SearchClubJobListingsSingleResult {
            distance
            distanceUnit
            messageSentOn
            enquiredOn
            onWatchlist
            hasBeenReported
            listing {
              ... on ClubSingleListing {
                ...singleListingFields
              }
              ... on ClubMultiListing {
                ...multiListingFields
              }
            }
          }
          ... on SearchClubProfileSingleResult {
            distance
            distanceUnit
            onWatchlist
            hasBeenReported
            profile {
              ...clubProfileFields
            }
          }
        }
      }
    }
  }
  ${ErrorResultFieldsFragmentDoc}
  ${SingleListingFieldsFragmentDoc}
  ${MultiListingFieldsFragmentDoc}
  ${ClubProfileFieldsFragmentDoc}
`

/**
 * __useGetInstructorWatchlistQuery__
 *
 * To run a query within a React component, call `useGetInstructorWatchlistQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstructorWatchlistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstructorWatchlistQuery({
 *   variables: {
 *      role: // value for 'role'
 *      _cacheKey: // value for '_cacheKey'
 *   },
 * });
 */
export function useGetInstructorWatchlistQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetInstructorWatchlistQuery,
    GetInstructorWatchlistQueryVariables
  >
) {
  return Apollo.useQuery<
    GetInstructorWatchlistQuery,
    GetInstructorWatchlistQueryVariables
  >(GetInstructorWatchlistDocument, baseOptions)
}
export function useGetInstructorWatchlistLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetInstructorWatchlistQuery,
    GetInstructorWatchlistQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    GetInstructorWatchlistQuery,
    GetInstructorWatchlistQueryVariables
  >(GetInstructorWatchlistDocument, baseOptions)
}
export type GetInstructorWatchlistQueryHookResult = ReturnType<
  typeof useGetInstructorWatchlistQuery
>
export type GetInstructorWatchlistLazyQueryHookResult = ReturnType<
  typeof useGetInstructorWatchlistLazyQuery
>
export type GetInstructorWatchlistQueryResult = Apollo.QueryResult<
  GetInstructorWatchlistQuery,
  GetInstructorWatchlistQueryVariables
>
export const GetJobListingAvailableLocationsDocument = gql`
  query getJobListingAvailableLocations(
    $input: GetClubsAvailabilityOnListingInput!
    $_cacheKey: String
  ) {
    getClubsAvailabilityOnListing(input: $input, _cacheKey: $_cacheKey) {
      ... on GetClubsAvailabilityOnListingResult {
        clubsWithExistingListing {
          ...locations
        }
        allClubs {
          ...locations
        }
      }
      ... on ErrorResult {
        type
        message
      }
    }
  }
  ${LocationsFragmentDoc}
`

/**
 * __useGetJobListingAvailableLocationsQuery__
 *
 * To run a query within a React component, call `useGetJobListingAvailableLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobListingAvailableLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobListingAvailableLocationsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      _cacheKey: // value for '_cacheKey'
 *   },
 * });
 */
export function useGetJobListingAvailableLocationsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetJobListingAvailableLocationsQuery,
    GetJobListingAvailableLocationsQueryVariables
  >
) {
  return Apollo.useQuery<
    GetJobListingAvailableLocationsQuery,
    GetJobListingAvailableLocationsQueryVariables
  >(GetJobListingAvailableLocationsDocument, baseOptions)
}
export function useGetJobListingAvailableLocationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetJobListingAvailableLocationsQuery,
    GetJobListingAvailableLocationsQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    GetJobListingAvailableLocationsQuery,
    GetJobListingAvailableLocationsQueryVariables
  >(GetJobListingAvailableLocationsDocument, baseOptions)
}
export type GetJobListingAvailableLocationsQueryHookResult = ReturnType<
  typeof useGetJobListingAvailableLocationsQuery
>
export type GetJobListingAvailableLocationsLazyQueryHookResult = ReturnType<
  typeof useGetJobListingAvailableLocationsLazyQuery
>
export type GetJobListingAvailableLocationsQueryResult = Apollo.QueryResult<
  GetJobListingAvailableLocationsQuery,
  GetJobListingAvailableLocationsQueryVariables
>
export const GetNavigationDocument = gql`
  query getNavigation($input: GetNavigationInput!, $_cacheKey: String) {
    getNavigation(input: $input, _cacheKey: $_cacheKey) {
      __typename
      ... on Navigation {
        __typename
        appMenu {
          id
          name
          items {
            icon
            id
            label
            analyticsEvent
            url {
              type
              value
            }
            items {
              id
              label
              analyticsEvent
              url {
                type
                value
              }
            }
          }
        }
        userMenu {
          icon
          id
          label
          analyticsEvent
          url {
            type
            value
          }
          items {
            id
            label
            analyticsEvent
            url {
              type
              value
            }
          }
        }
      }
      ... on ErrorResult {
        ...errorResultFields
      }
    }
  }
  ${ErrorResultFieldsFragmentDoc}
`

/**
 * __useGetNavigationQuery__
 *
 * To run a query within a React component, call `useGetNavigationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNavigationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNavigationQuery({
 *   variables: {
 *      input: // value for 'input'
 *      _cacheKey: // value for '_cacheKey'
 *   },
 * });
 */
export function useGetNavigationQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetNavigationQuery,
    GetNavigationQueryVariables
  >
) {
  return Apollo.useQuery<GetNavigationQuery, GetNavigationQueryVariables>(
    GetNavigationDocument,
    baseOptions
  )
}
export function useGetNavigationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetNavigationQuery,
    GetNavigationQueryVariables
  >
) {
  return Apollo.useLazyQuery<GetNavigationQuery, GetNavigationQueryVariables>(
    GetNavigationDocument,
    baseOptions
  )
}
export type GetNavigationQueryHookResult = ReturnType<
  typeof useGetNavigationQuery
>
export type GetNavigationLazyQueryHookResult = ReturnType<
  typeof useGetNavigationLazyQuery
>
export type GetNavigationQueryResult = Apollo.QueryResult<
  GetNavigationQuery,
  GetNavigationQueryVariables
>
export const GetNotificationsDocument = gql`
  query getNotifications(
    $filter: DateTimeFilterInput!
    $role: UserRoleInput!
    $_cacheKey: String
  ) {
    getNotifications(filter: $filter, role: $role, _cacheKey: $_cacheKey) {
      ... on GetNotificationsResult {
        ...notificationsResult
      }
      ... on ErrorResult {
        ...errorResultFields
      }
    }
  }
  ${NotificationsResultFragmentDoc}
  ${ErrorResultFieldsFragmentDoc}
`

/**
 * __useGetNotificationsQuery__
 *
 * To run a query within a React component, call `useGetNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      role: // value for 'role'
 *      _cacheKey: // value for '_cacheKey'
 *   },
 * });
 */
export function useGetNotificationsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetNotificationsQuery,
    GetNotificationsQueryVariables
  >
) {
  return Apollo.useQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(
    GetNotificationsDocument,
    baseOptions
  )
}
export function useGetNotificationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetNotificationsQuery,
    GetNotificationsQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    GetNotificationsQuery,
    GetNotificationsQueryVariables
  >(GetNotificationsDocument, baseOptions)
}
export type GetNotificationsQueryHookResult = ReturnType<
  typeof useGetNotificationsQuery
>
export type GetNotificationsLazyQueryHookResult = ReturnType<
  typeof useGetNotificationsLazyQuery
>
export type GetNotificationsQueryResult = Apollo.QueryResult<
  GetNotificationsQuery,
  GetNotificationsQueryVariables
>
export const GetProfileDocument = gql`
  query getProfile(
    $input: GetProfileByIdInput!
    $role: UserRoleInput!
    $_cacheKey: String
  ) {
    getProfileById(input: $input, role: $role, _cacheKey: $_cacheKey) {
      ... on GetProfileByIdResult {
        profile {
          ... on UserProfileTeaching {
            ...instructorProfileFields
          }
          ... on UserProfileClub {
            ...clubProfileFields
          }
        }
        hasBeenReported
        withinDistance
        lastMessageIn48HoursSentAt
        hasRecentlyDeclinedAffiliation
        hasExistingAffiliation
        onWatchlist
        instructorAffiliation {
          id
          clubId
          pendingStatus
          actionedDate
          requestedDate
          requestedBy
          role
          userId
          status
        }
        profileUser {
          id
          email
          market {
            name
            locale
            distanceUnit
            programs {
              id
              name
              code
              initials
            }
          }
          lastName
          firstName
          accountId
          phone
        }
      }
      ... on ErrorResult {
        ...errorResultFields
      }
    }
  }
  ${InstructorProfileFieldsFragmentDoc}
  ${ClubProfileFieldsFragmentDoc}
  ${ErrorResultFieldsFragmentDoc}
`

/**
 * __useGetProfileQuery__
 *
 * To run a query within a React component, call `useGetProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProfileQuery({
 *   variables: {
 *      input: // value for 'input'
 *      role: // value for 'role'
 *      _cacheKey: // value for '_cacheKey'
 *   },
 * });
 */
export function useGetProfileQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetProfileQuery,
    GetProfileQueryVariables
  >
) {
  return Apollo.useQuery<GetProfileQuery, GetProfileQueryVariables>(
    GetProfileDocument,
    baseOptions
  )
}
export function useGetProfileLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetProfileQuery,
    GetProfileQueryVariables
  >
) {
  return Apollo.useLazyQuery<GetProfileQuery, GetProfileQueryVariables>(
    GetProfileDocument,
    baseOptions
  )
}
export type GetProfileQueryHookResult = ReturnType<typeof useGetProfileQuery>
export type GetProfileLazyQueryHookResult = ReturnType<
  typeof useGetProfileLazyQuery
>
export type GetProfileQueryResult = Apollo.QueryResult<
  GetProfileQuery,
  GetProfileQueryVariables
>
export const GetProfileMediaDocument = gql`
  query getProfileMedia(
    $input: GetProfileByIdInput!
    $role: UserRoleInput!
    $_cacheKey: String
  ) {
    getProfileById(input: $input, role: $role, _cacheKey: $_cacheKey) {
      ... on GetProfileByIdResult {
        profile {
          ... on UserProfileTeaching {
            media {
              ...imageFields
            }
          }
          ... on UserProfileClub {
            media {
              ...imageFields
            }
          }
        }
      }
      ... on ErrorResult {
        ...errorResultFields
      }
    }
  }
  ${ImageFieldsFragmentDoc}
  ${ErrorResultFieldsFragmentDoc}
`

/**
 * __useGetProfileMediaQuery__
 *
 * To run a query within a React component, call `useGetProfileMediaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProfileMediaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProfileMediaQuery({
 *   variables: {
 *      input: // value for 'input'
 *      role: // value for 'role'
 *      _cacheKey: // value for '_cacheKey'
 *   },
 * });
 */
export function useGetProfileMediaQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetProfileMediaQuery,
    GetProfileMediaQueryVariables
  >
) {
  return Apollo.useQuery<GetProfileMediaQuery, GetProfileMediaQueryVariables>(
    GetProfileMediaDocument,
    baseOptions
  )
}
export function useGetProfileMediaLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetProfileMediaQuery,
    GetProfileMediaQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    GetProfileMediaQuery,
    GetProfileMediaQueryVariables
  >(GetProfileMediaDocument, baseOptions)
}
export type GetProfileMediaQueryHookResult = ReturnType<
  typeof useGetProfileMediaQuery
>
export type GetProfileMediaLazyQueryHookResult = ReturnType<
  typeof useGetProfileMediaLazyQuery
>
export type GetProfileMediaQueryResult = Apollo.QueryResult<
  GetProfileMediaQuery,
  GetProfileMediaQueryVariables
>
export const GetProfilesDocument = gql`
  query getProfiles($_cacheKey: String) {
    getCurrentUser(_cacheKey: $_cacheKey) {
      ... on UserResult {
        id
        __typename
        profiles {
          ... on UserProfileTeaching {
            ...instructorProfileFields
          }
          ... on UserProfileClub {
            ...clubProfileFields
          }
        }
      }
      ... on ErrorResult {
        ...errorResultFields
      }
    }
  }
  ${InstructorProfileFieldsFragmentDoc}
  ${ClubProfileFieldsFragmentDoc}
  ${ErrorResultFieldsFragmentDoc}
`

/**
 * __useGetProfilesQuery__
 *
 * To run a query within a React component, call `useGetProfilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProfilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProfilesQuery({
 *   variables: {
 *      _cacheKey: // value for '_cacheKey'
 *   },
 * });
 */
export function useGetProfilesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetProfilesQuery,
    GetProfilesQueryVariables
  >
) {
  return Apollo.useQuery<GetProfilesQuery, GetProfilesQueryVariables>(
    GetProfilesDocument,
    baseOptions
  )
}
export function useGetProfilesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetProfilesQuery,
    GetProfilesQueryVariables
  >
) {
  return Apollo.useLazyQuery<GetProfilesQuery, GetProfilesQueryVariables>(
    GetProfilesDocument,
    baseOptions
  )
}
export type GetProfilesQueryHookResult = ReturnType<typeof useGetProfilesQuery>
export type GetProfilesLazyQueryHookResult = ReturnType<
  typeof useGetProfilesLazyQuery
>
export type GetProfilesQueryResult = Apollo.QueryResult<
  GetProfilesQuery,
  GetProfilesQueryVariables
>
export const GetSavedInstructorSearchDataDocument = gql`
  query GetSavedInstructorSearchData(
    $input: GetSavedInstructorSearchDataInput!
    $_cacheKey: String
  ) {
    getSavedInstructorSearchData(input: $input, _cacheKey: $_cacheKey) {
      ... on GetSavedInstructorSearchDataResult {
        results {
          ...savedInstructorSearch
        }
      }
      ... on ErrorResult {
        ...errorResultFields
      }
    }
  }
  ${SavedInstructorSearchFragmentDoc}
  ${ErrorResultFieldsFragmentDoc}
`

/**
 * __useGetSavedInstructorSearchDataQuery__
 *
 * To run a query within a React component, call `useGetSavedInstructorSearchDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSavedInstructorSearchDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSavedInstructorSearchDataQuery({
 *   variables: {
 *      input: // value for 'input'
 *      _cacheKey: // value for '_cacheKey'
 *   },
 * });
 */
export function useGetSavedInstructorSearchDataQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetSavedInstructorSearchDataQuery,
    GetSavedInstructorSearchDataQueryVariables
  >
) {
  return Apollo.useQuery<
    GetSavedInstructorSearchDataQuery,
    GetSavedInstructorSearchDataQueryVariables
  >(GetSavedInstructorSearchDataDocument, baseOptions)
}
export function useGetSavedInstructorSearchDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSavedInstructorSearchDataQuery,
    GetSavedInstructorSearchDataQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    GetSavedInstructorSearchDataQuery,
    GetSavedInstructorSearchDataQueryVariables
  >(GetSavedInstructorSearchDataDocument, baseOptions)
}
export type GetSavedInstructorSearchDataQueryHookResult = ReturnType<
  typeof useGetSavedInstructorSearchDataQuery
>
export type GetSavedInstructorSearchDataLazyQueryHookResult = ReturnType<
  typeof useGetSavedInstructorSearchDataLazyQuery
>
export type GetSavedInstructorSearchDataQueryResult = Apollo.QueryResult<
  GetSavedInstructorSearchDataQuery,
  GetSavedInstructorSearchDataQueryVariables
>
export const GetSharedNavigationDocument = gql`
  query getSharedNavigation($_cacheKey: String) {
    getSharedNavigation(_cacheKey: $_cacheKey) {
      ... on SharedNavigation {
        instructorNav {
          role
          navItems {
            key
            title
            description
            url {
              type
              value
            }
            image {
              id
              url
              alt
              height
              width
            }
          }
        }
        clubNav {
          role
          navItems {
            key
            title
            description
            url {
              type
              value
            }
            image {
              id
              url
              alt
              height
              width
            }
          }
        }
        websiteLink {
          type
          value
        }
      }
      ... on ErrorResult {
        ...errorResultFields
      }
    }
  }
  ${ErrorResultFieldsFragmentDoc}
`

/**
 * __useGetSharedNavigationQuery__
 *
 * To run a query within a React component, call `useGetSharedNavigationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSharedNavigationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSharedNavigationQuery({
 *   variables: {
 *      _cacheKey: // value for '_cacheKey'
 *   },
 * });
 */
export function useGetSharedNavigationQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetSharedNavigationQuery,
    GetSharedNavigationQueryVariables
  >
) {
  return Apollo.useQuery<
    GetSharedNavigationQuery,
    GetSharedNavigationQueryVariables
  >(GetSharedNavigationDocument, baseOptions)
}
export function useGetSharedNavigationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSharedNavigationQuery,
    GetSharedNavigationQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    GetSharedNavigationQuery,
    GetSharedNavigationQueryVariables
  >(GetSharedNavigationDocument, baseOptions)
}
export type GetSharedNavigationQueryHookResult = ReturnType<
  typeof useGetSharedNavigationQuery
>
export type GetSharedNavigationLazyQueryHookResult = ReturnType<
  typeof useGetSharedNavigationLazyQuery
>
export type GetSharedNavigationQueryResult = Apollo.QueryResult<
  GetSharedNavigationQuery,
  GetSharedNavigationQueryVariables
>
export const GetClubInstructorShortlistDocument = gql`
  query getClubInstructorShortlist(
    $input: GetProfileByIdInput!
    $role: UserRoleInput!
    $_cacheKey: String
  ) {
    getProfileById(input: $input, role: $role, _cacheKey: $_cacheKey) {
      ... on GetProfileByIdResult {
        profile {
          ... on UserProfileClub {
            shortlist {
              id
              profile {
                ...instructorProfileFields
              }
              user {
                id
                lastName
                firstName
              }
              lastMessageIn48HoursSentAt
              distanceUnit
              distance
              hasExistingAffiliation
              hasRecentlyDeclinedAffiliation
              instructorAffiliation {
                id
                clubId
                pendingStatus
                actionedDate
                requestedDate
                requestedBy
                role
                userId
                status
              }
            }
          }
        }
      }
      ... on ErrorResult {
        ...errorResultFields
      }
    }
  }
  ${InstructorProfileFieldsFragmentDoc}
  ${ErrorResultFieldsFragmentDoc}
`

/**
 * __useGetClubInstructorShortlistQuery__
 *
 * To run a query within a React component, call `useGetClubInstructorShortlistQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClubInstructorShortlistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClubInstructorShortlistQuery({
 *   variables: {
 *      input: // value for 'input'
 *      role: // value for 'role'
 *      _cacheKey: // value for '_cacheKey'
 *   },
 * });
 */
export function useGetClubInstructorShortlistQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetClubInstructorShortlistQuery,
    GetClubInstructorShortlistQueryVariables
  >
) {
  return Apollo.useQuery<
    GetClubInstructorShortlistQuery,
    GetClubInstructorShortlistQueryVariables
  >(GetClubInstructorShortlistDocument, baseOptions)
}
export function useGetClubInstructorShortlistLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetClubInstructorShortlistQuery,
    GetClubInstructorShortlistQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    GetClubInstructorShortlistQuery,
    GetClubInstructorShortlistQueryVariables
  >(GetClubInstructorShortlistDocument, baseOptions)
}
export type GetClubInstructorShortlistQueryHookResult = ReturnType<
  typeof useGetClubInstructorShortlistQuery
>
export type GetClubInstructorShortlistLazyQueryHookResult = ReturnType<
  typeof useGetClubInstructorShortlistLazyQuery
>
export type GetClubInstructorShortlistQueryResult = Apollo.QueryResult<
  GetClubInstructorShortlistQuery,
  GetClubInstructorShortlistQueryVariables
>
export const GetTranslationsDocument = gql`
  query getTranslations($_cacheKey: String) {
    getAllTranslations(_cacheKey: $_cacheKey) {
      ... on GetAllTranslationsResult {
        result
      }
      ... on ErrorResult {
        ...errorResultFields
      }
    }
  }
  ${ErrorResultFieldsFragmentDoc}
`

/**
 * __useGetTranslationsQuery__
 *
 * To run a query within a React component, call `useGetTranslationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTranslationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTranslationsQuery({
 *   variables: {
 *      _cacheKey: // value for '_cacheKey'
 *   },
 * });
 */
export function useGetTranslationsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetTranslationsQuery,
    GetTranslationsQueryVariables
  >
) {
  return Apollo.useQuery<GetTranslationsQuery, GetTranslationsQueryVariables>(
    GetTranslationsDocument,
    baseOptions
  )
}
export function useGetTranslationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetTranslationsQuery,
    GetTranslationsQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    GetTranslationsQuery,
    GetTranslationsQueryVariables
  >(GetTranslationsDocument, baseOptions)
}
export type GetTranslationsQueryHookResult = ReturnType<
  typeof useGetTranslationsQuery
>
export type GetTranslationsLazyQueryHookResult = ReturnType<
  typeof useGetTranslationsLazyQuery
>
export type GetTranslationsQueryResult = Apollo.QueryResult<
  GetTranslationsQuery,
  GetTranslationsQueryVariables
>
export const GetUserDocument = gql`
  query getUser($_cacheKey: String) {
    getCurrentUser(_cacheKey: $_cacheKey) {
      ... on UserResult {
        id
        __typename
        distance
        distanceUnit
        user {
          id
          email
          market {
            name
            locale
            distanceUnit
            programs {
              id
              name
              code
              initials
            }
          }
          lastName
          firstName
          accountId
          phone
          signedAgreements {
            type
            signedOn
            version
          }
        }
        settings {
          locale
        }
        profiles {
          ... on UserProfileTeaching {
            id
            __typename
          }
          ... on UserProfileClub {
            id
            __typename
          }
        }
      }
      ... on ErrorResult {
        ...errorResultFields
      }
    }
  }
  ${ErrorResultFieldsFragmentDoc}
`

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *      _cacheKey: // value for '_cacheKey'
 *   },
 * });
 */
export function useGetUserQuery(
  baseOptions?: Apollo.QueryHookOptions<GetUserQuery, GetUserQueryVariables>
) {
  return Apollo.useQuery<GetUserQuery, GetUserQueryVariables>(
    GetUserDocument,
    baseOptions
  )
}
export function useGetUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetUserQuery, GetUserQueryVariables>
) {
  return Apollo.useLazyQuery<GetUserQuery, GetUserQueryVariables>(
    GetUserDocument,
    baseOptions
  )
}
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>
export type GetUserQueryResult = Apollo.QueryResult<
  GetUserQuery,
  GetUserQueryVariables
>
export const GetVideoGuidelinesDocument = gql`
  query getVideoGuidelines($_cacheKey: String) {
    getVideoGuidelines(_cacheKey: $_cacheKey) {
      ... on GetVideoGuidelinesResult {
        result {
          section
          content {
            title
            subHeading
            contentText
          }
        }
        contactUsEmail
      }
      ... on ErrorResult {
        ...errorResultFields
      }
    }
  }
  ${ErrorResultFieldsFragmentDoc}
`

/**
 * __useGetVideoGuidelinesQuery__
 *
 * To run a query within a React component, call `useGetVideoGuidelinesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVideoGuidelinesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVideoGuidelinesQuery({
 *   variables: {
 *      _cacheKey: // value for '_cacheKey'
 *   },
 * });
 */
export function useGetVideoGuidelinesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetVideoGuidelinesQuery,
    GetVideoGuidelinesQueryVariables
  >
) {
  return Apollo.useQuery<
    GetVideoGuidelinesQuery,
    GetVideoGuidelinesQueryVariables
  >(GetVideoGuidelinesDocument, baseOptions)
}
export function useGetVideoGuidelinesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetVideoGuidelinesQuery,
    GetVideoGuidelinesQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    GetVideoGuidelinesQuery,
    GetVideoGuidelinesQueryVariables
  >(GetVideoGuidelinesDocument, baseOptions)
}
export type GetVideoGuidelinesQueryHookResult = ReturnType<
  typeof useGetVideoGuidelinesQuery
>
export type GetVideoGuidelinesLazyQueryHookResult = ReturnType<
  typeof useGetVideoGuidelinesLazyQuery
>
export type GetVideoGuidelinesQueryResult = Apollo.QueryResult<
  GetVideoGuidelinesQuery,
  GetVideoGuidelinesQueryVariables
>
export const GetWalkthroughContentDocument = gql`
  query getWalkthroughContent($role: UserRoleInput!, $_cacheKey: String) {
    getWalkthrough(role: $role, _cacheKey: $_cacheKey) {
      ... on Walkthrough {
        pages {
          title
          body
          image {
            desktop {
              ...imageFields
            }
            mobile {
              ...imageFields
            }
          }
        }
      }
      ... on ErrorResult {
        ...errorResultFields
      }
    }
  }
  ${ImageFieldsFragmentDoc}
  ${ErrorResultFieldsFragmentDoc}
`

/**
 * __useGetWalkthroughContentQuery__
 *
 * To run a query within a React component, call `useGetWalkthroughContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWalkthroughContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWalkthroughContentQuery({
 *   variables: {
 *      role: // value for 'role'
 *      _cacheKey: // value for '_cacheKey'
 *   },
 * });
 */
export function useGetWalkthroughContentQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetWalkthroughContentQuery,
    GetWalkthroughContentQueryVariables
  >
) {
  return Apollo.useQuery<
    GetWalkthroughContentQuery,
    GetWalkthroughContentQueryVariables
  >(GetWalkthroughContentDocument, baseOptions)
}
export function useGetWalkthroughContentLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetWalkthroughContentQuery,
    GetWalkthroughContentQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    GetWalkthroughContentQuery,
    GetWalkthroughContentQueryVariables
  >(GetWalkthroughContentDocument, baseOptions)
}
export type GetWalkthroughContentQueryHookResult = ReturnType<
  typeof useGetWalkthroughContentQuery
>
export type GetWalkthroughContentLazyQueryHookResult = ReturnType<
  typeof useGetWalkthroughContentLazyQuery
>
export type GetWalkthroughContentQueryResult = Apollo.QueryResult<
  GetWalkthroughContentQuery,
  GetWalkthroughContentQueryVariables
>
export const IncrementViewClubListingCountDocument = gql`
  mutation incrementViewClubListingCount(
    $input: IncrementViewClubListingCountInput!
    $_cacheKey: String
  ) {
    incrementViewClubListingCount(input: $input, _cacheKey: $_cacheKey) {
      ... on ClubListingResult {
        results {
          ... on ClubSingleListing {
            ...singleListingFields
          }
          ... on ClubMultiListing {
            ...multiListingFields
          }
        }
      }
      ... on ErrorResult {
        ...errorResultFields
      }
    }
  }
  ${SingleListingFieldsFragmentDoc}
  ${MultiListingFieldsFragmentDoc}
  ${ErrorResultFieldsFragmentDoc}
`
export type IncrementViewClubListingCountMutationFn = Apollo.MutationFunction<
  IncrementViewClubListingCountMutation,
  IncrementViewClubListingCountMutationVariables
>

/**
 * __useIncrementViewClubListingCountMutation__
 *
 * To run a mutation, you first call `useIncrementViewClubListingCountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIncrementViewClubListingCountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [incrementViewClubListingCountMutation, { data, loading, error }] = useIncrementViewClubListingCountMutation({
 *   variables: {
 *      input: // value for 'input'
 *      _cacheKey: // value for '_cacheKey'
 *   },
 * });
 */
export function useIncrementViewClubListingCountMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IncrementViewClubListingCountMutation,
    IncrementViewClubListingCountMutationVariables
  >
) {
  return Apollo.useMutation<
    IncrementViewClubListingCountMutation,
    IncrementViewClubListingCountMutationVariables
  >(IncrementViewClubListingCountDocument, baseOptions)
}
export type IncrementViewClubListingCountMutationHookResult = ReturnType<
  typeof useIncrementViewClubListingCountMutation
>
export type IncrementViewClubListingCountMutationResult =
  Apollo.MutationResult<IncrementViewClubListingCountMutation>
export type IncrementViewClubListingCountMutationOptions =
  Apollo.BaseMutationOptions<
    IncrementViewClubListingCountMutation,
    IncrementViewClubListingCountMutationVariables
  >
export const InitApplicationDocument = gql`
  query initApplication($featureFlags: [String!]!, $_cacheKey: String) {
    getUser: getCurrentUser(_cacheKey: $_cacheKey) {
      ... on UserResult {
        ...fullUserField
      }
      ... on ErrorResult {
        ...errorResultFields
      }
    }
    getAllTranslations(_cacheKey: $_cacheKey) {
      ... on GetAllTranslationsResult {
        result
        locale
      }
      ... on ErrorResult {
        ...errorResultFields
      }
    }
    getFeatureFlag(
      input: { featureFlags: $featureFlags }
      _cacheKey: $_cacheKey
    ) {
      ... on FeatureFlagResult {
        flags {
          featureFlag
          enabled
        }
      }
      ... on ErrorResult {
        ...errorResultFields
      }
    }
  }
  ${FullUserFieldFragmentDoc}
  ${ErrorResultFieldsFragmentDoc}
`

/**
 * __useInitApplicationQuery__
 *
 * To run a query within a React component, call `useInitApplicationQuery` and pass it any options that fit your needs.
 * When your component renders, `useInitApplicationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInitApplicationQuery({
 *   variables: {
 *      featureFlags: // value for 'featureFlags'
 *      _cacheKey: // value for '_cacheKey'
 *   },
 * });
 */
export function useInitApplicationQuery(
  baseOptions: Apollo.QueryHookOptions<
    InitApplicationQuery,
    InitApplicationQueryVariables
  >
) {
  return Apollo.useQuery<InitApplicationQuery, InitApplicationQueryVariables>(
    InitApplicationDocument,
    baseOptions
  )
}
export function useInitApplicationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    InitApplicationQuery,
    InitApplicationQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    InitApplicationQuery,
    InitApplicationQueryVariables
  >(InitApplicationDocument, baseOptions)
}
export type InitApplicationQueryHookResult = ReturnType<
  typeof useInitApplicationQuery
>
export type InitApplicationLazyQueryHookResult = ReturnType<
  typeof useInitApplicationLazyQuery
>
export type InitApplicationQueryResult = Apollo.QueryResult<
  InitApplicationQuery,
  InitApplicationQueryVariables
>
export const ManagePeopleCreateAffiliationsDocument = gql`
  mutation managePeopleCreateAffiliations(
    $input: CreateAffiliationsInput!
    $_cacheKey: String
  ) {
    createAffiliations(input: $input, _cacheKey: $_cacheKey) {
      ... on ChainAffiliationsResult {
        successfulAffiliations {
          actionedDate
          clubId
          id
          latestActionInitiator
          pendingStatus
          requestedBy
          requestedDate
          role
          status
          userId
        }
      }
      ... on ErrorResult {
        ...errorResultFields
      }
    }
  }
  ${ErrorResultFieldsFragmentDoc}
`
export type ManagePeopleCreateAffiliationsMutationFn = Apollo.MutationFunction<
  ManagePeopleCreateAffiliationsMutation,
  ManagePeopleCreateAffiliationsMutationVariables
>

/**
 * __useManagePeopleCreateAffiliationsMutation__
 *
 * To run a mutation, you first call `useManagePeopleCreateAffiliationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useManagePeopleCreateAffiliationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [managePeopleCreateAffiliationsMutation, { data, loading, error }] = useManagePeopleCreateAffiliationsMutation({
 *   variables: {
 *      input: // value for 'input'
 *      _cacheKey: // value for '_cacheKey'
 *   },
 * });
 */
export function useManagePeopleCreateAffiliationsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ManagePeopleCreateAffiliationsMutation,
    ManagePeopleCreateAffiliationsMutationVariables
  >
) {
  return Apollo.useMutation<
    ManagePeopleCreateAffiliationsMutation,
    ManagePeopleCreateAffiliationsMutationVariables
  >(ManagePeopleCreateAffiliationsDocument, baseOptions)
}
export type ManagePeopleCreateAffiliationsMutationHookResult = ReturnType<
  typeof useManagePeopleCreateAffiliationsMutation
>
export type ManagePeopleCreateAffiliationsMutationResult =
  Apollo.MutationResult<ManagePeopleCreateAffiliationsMutation>
export type ManagePeopleCreateAffiliationsMutationOptions =
  Apollo.BaseMutationOptions<
    ManagePeopleCreateAffiliationsMutation,
    ManagePeopleCreateAffiliationsMutationVariables
  >
export const ManagePeopleRemoveAffiliationsDocument = gql`
  mutation managePeopleRemoveAffiliations(
    $input: DeleteAffiliationsInput!
    $_cacheKey: String
  ) {
    removeAffiliations(input: $input, _cacheKey: $_cacheKey) {
      ... on ChainAffiliationsRemoveRresult {
        receivedAffiliationIds
        removedAffiliationIds
        removedUserId
      }
      ... on ErrorResult {
        ...errorResultFields
      }
    }
  }
  ${ErrorResultFieldsFragmentDoc}
`
export type ManagePeopleRemoveAffiliationsMutationFn = Apollo.MutationFunction<
  ManagePeopleRemoveAffiliationsMutation,
  ManagePeopleRemoveAffiliationsMutationVariables
>

/**
 * __useManagePeopleRemoveAffiliationsMutation__
 *
 * To run a mutation, you first call `useManagePeopleRemoveAffiliationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useManagePeopleRemoveAffiliationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [managePeopleRemoveAffiliationsMutation, { data, loading, error }] = useManagePeopleRemoveAffiliationsMutation({
 *   variables: {
 *      input: // value for 'input'
 *      _cacheKey: // value for '_cacheKey'
 *   },
 * });
 */
export function useManagePeopleRemoveAffiliationsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ManagePeopleRemoveAffiliationsMutation,
    ManagePeopleRemoveAffiliationsMutationVariables
  >
) {
  return Apollo.useMutation<
    ManagePeopleRemoveAffiliationsMutation,
    ManagePeopleRemoveAffiliationsMutationVariables
  >(ManagePeopleRemoveAffiliationsDocument, baseOptions)
}
export type ManagePeopleRemoveAffiliationsMutationHookResult = ReturnType<
  typeof useManagePeopleRemoveAffiliationsMutation
>
export type ManagePeopleRemoveAffiliationsMutationResult =
  Apollo.MutationResult<ManagePeopleRemoveAffiliationsMutation>
export type ManagePeopleRemoveAffiliationsMutationOptions =
  Apollo.BaseMutationOptions<
    ManagePeopleRemoveAffiliationsMutation,
    ManagePeopleRemoveAffiliationsMutationVariables
  >
export const MarkNotificationsAsReadDocument = gql`
  mutation markNotificationsAsRead(
    $id: [ID!]!
    $role: UserRoleInput!
    $_cacheKey: String
  ) {
    toggleNotificationsRead(
      input: { id: $id, read: true }
      role: $role
      _cacheKey: $_cacheKey
    ) {
      __typename
      ... on ToggleNotificationReadResult {
        __typename
        success
        failure
      }
      ... on ErrorResult {
        ...errorResultFields
      }
    }
  }
  ${ErrorResultFieldsFragmentDoc}
`
export type MarkNotificationsAsReadMutationFn = Apollo.MutationFunction<
  MarkNotificationsAsReadMutation,
  MarkNotificationsAsReadMutationVariables
>

/**
 * __useMarkNotificationsAsReadMutation__
 *
 * To run a mutation, you first call `useMarkNotificationsAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkNotificationsAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markNotificationsAsReadMutation, { data, loading, error }] = useMarkNotificationsAsReadMutation({
 *   variables: {
 *      id: // value for 'id'
 *      role: // value for 'role'
 *      _cacheKey: // value for '_cacheKey'
 *   },
 * });
 */
export function useMarkNotificationsAsReadMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MarkNotificationsAsReadMutation,
    MarkNotificationsAsReadMutationVariables
  >
) {
  return Apollo.useMutation<
    MarkNotificationsAsReadMutation,
    MarkNotificationsAsReadMutationVariables
  >(MarkNotificationsAsReadDocument, baseOptions)
}
export type MarkNotificationsAsReadMutationHookResult = ReturnType<
  typeof useMarkNotificationsAsReadMutation
>
export type MarkNotificationsAsReadMutationResult =
  Apollo.MutationResult<MarkNotificationsAsReadMutation>
export type MarkNotificationsAsReadMutationOptions = Apollo.BaseMutationOptions<
  MarkNotificationsAsReadMutation,
  MarkNotificationsAsReadMutationVariables
>
export const MarkNotificationsAsUnreadDocument = gql`
  mutation markNotificationsAsUnread(
    $id: [ID!]!
    $role: UserRoleInput!
    $_cacheKey: String
  ) {
    toggleNotificationsRead(
      input: { id: $id, read: false }
      role: $role
      _cacheKey: $_cacheKey
    ) {
      ... on ToggleNotificationReadResult {
        __typename
        success
        failure
      }
      ... on ErrorResult {
        ...errorResultFields
      }
    }
  }
  ${ErrorResultFieldsFragmentDoc}
`
export type MarkNotificationsAsUnreadMutationFn = Apollo.MutationFunction<
  MarkNotificationsAsUnreadMutation,
  MarkNotificationsAsUnreadMutationVariables
>

/**
 * __useMarkNotificationsAsUnreadMutation__
 *
 * To run a mutation, you first call `useMarkNotificationsAsUnreadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkNotificationsAsUnreadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markNotificationsAsUnreadMutation, { data, loading, error }] = useMarkNotificationsAsUnreadMutation({
 *   variables: {
 *      id: // value for 'id'
 *      role: // value for 'role'
 *      _cacheKey: // value for '_cacheKey'
 *   },
 * });
 */
export function useMarkNotificationsAsUnreadMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MarkNotificationsAsUnreadMutation,
    MarkNotificationsAsUnreadMutationVariables
  >
) {
  return Apollo.useMutation<
    MarkNotificationsAsUnreadMutation,
    MarkNotificationsAsUnreadMutationVariables
  >(MarkNotificationsAsUnreadDocument, baseOptions)
}
export type MarkNotificationsAsUnreadMutationHookResult = ReturnType<
  typeof useMarkNotificationsAsUnreadMutation
>
export type MarkNotificationsAsUnreadMutationResult =
  Apollo.MutationResult<MarkNotificationsAsUnreadMutation>
export type MarkNotificationsAsUnreadMutationOptions =
  Apollo.BaseMutationOptions<
    MarkNotificationsAsUnreadMutation,
    MarkNotificationsAsUnreadMutationVariables
  >
export const GetAtHomeItemsDocument = gql`
  query getAtHomeItems($input: GetClubByIdInput!, $_cacheKey: String) {
    getClubById(input: $input, _cacheKey: $_cacheKey) {
      ... on UserProfileClub {
        atHomeProducts {
          active {
            ...AtHomeProductTile
          }
          inactive {
            ...AtHomeProductTile
          }
        }
      }
      ... on ErrorResult {
        type
        message
      }
    }
  }
  ${AtHomeProductTileFragmentDoc}
`

/**
 * __useGetAtHomeItemsQuery__
 *
 * To run a query within a React component, call `useGetAtHomeItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAtHomeItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAtHomeItemsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      _cacheKey: // value for '_cacheKey'
 *   },
 * });
 */
export function useGetAtHomeItemsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAtHomeItemsQuery,
    GetAtHomeItemsQueryVariables
  >
) {
  return Apollo.useQuery<GetAtHomeItemsQuery, GetAtHomeItemsQueryVariables>(
    GetAtHomeItemsDocument,
    baseOptions
  )
}
export function useGetAtHomeItemsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAtHomeItemsQuery,
    GetAtHomeItemsQueryVariables
  >
) {
  return Apollo.useLazyQuery<GetAtHomeItemsQuery, GetAtHomeItemsQueryVariables>(
    GetAtHomeItemsDocument,
    baseOptions
  )
}
export type GetAtHomeItemsQueryHookResult = ReturnType<
  typeof useGetAtHomeItemsQuery
>
export type GetAtHomeItemsLazyQueryHookResult = ReturnType<
  typeof useGetAtHomeItemsLazyQuery
>
export type GetAtHomeItemsQueryResult = Apollo.QueryResult<
  GetAtHomeItemsQuery,
  GetAtHomeItemsQueryVariables
>
export const GetExploreProgramsPageDocument = gql`
  query getExploreProgramsPage($role: UserRoleInput!, $_cacheKey: String) {
    getExploreProgramsPage(role: $role, _cacheKey: $_cacheKey) {
      ... on ExploreProgramsPage {
        products {
          ...ExploreProgramTile
        }
      }
      ... on ErrorResult {
        type
        message
      }
    }
  }
  ${ExploreProgramTileFragmentDoc}
`

/**
 * __useGetExploreProgramsPageQuery__
 *
 * To run a query within a React component, call `useGetExploreProgramsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExploreProgramsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExploreProgramsPageQuery({
 *   variables: {
 *      role: // value for 'role'
 *      _cacheKey: // value for '_cacheKey'
 *   },
 * });
 */
export function useGetExploreProgramsPageQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetExploreProgramsPageQuery,
    GetExploreProgramsPageQueryVariables
  >
) {
  return Apollo.useQuery<
    GetExploreProgramsPageQuery,
    GetExploreProgramsPageQueryVariables
  >(GetExploreProgramsPageDocument, baseOptions)
}
export function useGetExploreProgramsPageLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetExploreProgramsPageQuery,
    GetExploreProgramsPageQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    GetExploreProgramsPageQuery,
    GetExploreProgramsPageQueryVariables
  >(GetExploreProgramsPageDocument, baseOptions)
}
export type GetExploreProgramsPageQueryHookResult = ReturnType<
  typeof useGetExploreProgramsPageQuery
>
export type GetExploreProgramsPageLazyQueryHookResult = ReturnType<
  typeof useGetExploreProgramsPageLazyQuery
>
export type GetExploreProgramsPageQueryResult = Apollo.QueryResult<
  GetExploreProgramsPageQuery,
  GetExploreProgramsPageQueryVariables
>
export const GetExploreProgramsPageDetailedProgramDocument = gql`
  query getExploreProgramsPageDetailedProgram(
    $role: UserRoleInput!
    $programName: ProgramName
    $_cacheKey: String
  ) {
    getExploreProgramsPage(
      role: $role
      programName: $programName
      _cacheKey: $_cacheKey
    ) {
      ... on ExploreProgramsPage {
        products {
          ...DetailedExploreProgramTile
        }
      }
      ... on ErrorResult {
        type
        message
      }
    }
  }
  ${DetailedExploreProgramTileFragmentDoc}
`

/**
 * __useGetExploreProgramsPageDetailedProgramQuery__
 *
 * To run a query within a React component, call `useGetExploreProgramsPageDetailedProgramQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExploreProgramsPageDetailedProgramQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExploreProgramsPageDetailedProgramQuery({
 *   variables: {
 *      role: // value for 'role'
 *      programName: // value for 'programName'
 *      _cacheKey: // value for '_cacheKey'
 *   },
 * });
 */
export function useGetExploreProgramsPageDetailedProgramQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetExploreProgramsPageDetailedProgramQuery,
    GetExploreProgramsPageDetailedProgramQueryVariables
  >
) {
  return Apollo.useQuery<
    GetExploreProgramsPageDetailedProgramQuery,
    GetExploreProgramsPageDetailedProgramQueryVariables
  >(GetExploreProgramsPageDetailedProgramDocument, baseOptions)
}
export function useGetExploreProgramsPageDetailedProgramLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetExploreProgramsPageDetailedProgramQuery,
    GetExploreProgramsPageDetailedProgramQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    GetExploreProgramsPageDetailedProgramQuery,
    GetExploreProgramsPageDetailedProgramQueryVariables
  >(GetExploreProgramsPageDetailedProgramDocument, baseOptions)
}
export type GetExploreProgramsPageDetailedProgramQueryHookResult = ReturnType<
  typeof useGetExploreProgramsPageDetailedProgramQuery
>
export type GetExploreProgramsPageDetailedProgramLazyQueryHookResult =
  ReturnType<typeof useGetExploreProgramsPageDetailedProgramLazyQuery>
export type GetExploreProgramsPageDetailedProgramQueryResult =
  Apollo.QueryResult<
    GetExploreProgramsPageDetailedProgramQuery,
    GetExploreProgramsPageDetailedProgramQueryVariables
  >
export const RemoveFromShortlistDocument = gql`
  mutation removeFromShortlist(
    $input: RemoveFromShortlistInput!
    $role: UserRoleInput!
    $_cacheKey: String
  ) {
    removeFromShortlist(input: $input, role: $role, _cacheKey: $_cacheKey) {
      ... on RemoveFromShortlistResult {
        shortlist {
          id
          profile {
            ...instructorProfileFields
          }
          user {
            id
            lastName
            firstName
          }
          lastMessageIn48HoursSentAt
          distanceUnit
          distance
        }
      }
      ... on ErrorResult {
        ...errorResultFields
      }
    }
  }
  ${InstructorProfileFieldsFragmentDoc}
  ${ErrorResultFieldsFragmentDoc}
`
export type RemoveFromShortlistMutationFn = Apollo.MutationFunction<
  RemoveFromShortlistMutation,
  RemoveFromShortlistMutationVariables
>

/**
 * __useRemoveFromShortlistMutation__
 *
 * To run a mutation, you first call `useRemoveFromShortlistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveFromShortlistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeFromShortlistMutation, { data, loading, error }] = useRemoveFromShortlistMutation({
 *   variables: {
 *      input: // value for 'input'
 *      role: // value for 'role'
 *      _cacheKey: // value for '_cacheKey'
 *   },
 * });
 */
export function useRemoveFromShortlistMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveFromShortlistMutation,
    RemoveFromShortlistMutationVariables
  >
) {
  return Apollo.useMutation<
    RemoveFromShortlistMutation,
    RemoveFromShortlistMutationVariables
  >(RemoveFromShortlistDocument, baseOptions)
}
export type RemoveFromShortlistMutationHookResult = ReturnType<
  typeof useRemoveFromShortlistMutation
>
export type RemoveFromShortlistMutationResult =
  Apollo.MutationResult<RemoveFromShortlistMutation>
export type RemoveFromShortlistMutationOptions = Apollo.BaseMutationOptions<
  RemoveFromShortlistMutation,
  RemoveFromShortlistMutationVariables
>
export const ReportClubListingDocument = gql`
  mutation reportClubListing(
    $input: ReportClubListingInput!
    $_cacheKey: String
  ) {
    reportClubListing(input: $input, _cacheKey: $_cacheKey) {
      __typename
      ... on ErrorResult {
        ...errorResultFields
      }
    }
  }
  ${ErrorResultFieldsFragmentDoc}
`
export type ReportClubListingMutationFn = Apollo.MutationFunction<
  ReportClubListingMutation,
  ReportClubListingMutationVariables
>

/**
 * __useReportClubListingMutation__
 *
 * To run a mutation, you first call `useReportClubListingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportClubListingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportClubListingMutation, { data, loading, error }] = useReportClubListingMutation({
 *   variables: {
 *      input: // value for 'input'
 *      _cacheKey: // value for '_cacheKey'
 *   },
 * });
 */
export function useReportClubListingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ReportClubListingMutation,
    ReportClubListingMutationVariables
  >
) {
  return Apollo.useMutation<
    ReportClubListingMutation,
    ReportClubListingMutationVariables
  >(ReportClubListingDocument, baseOptions)
}
export type ReportClubListingMutationHookResult = ReturnType<
  typeof useReportClubListingMutation
>
export type ReportClubListingMutationResult =
  Apollo.MutationResult<ReportClubListingMutation>
export type ReportClubListingMutationOptions = Apollo.BaseMutationOptions<
  ReportClubListingMutation,
  ReportClubListingMutationVariables
>
export const ReportClubProfileDocument = gql`
  mutation reportClubProfile(
    $input: ReportClubProfileInput!
    $_cacheKey: String
  ) {
    reportClubProfile(input: $input, _cacheKey: $_cacheKey) {
      __typename
      ... on ErrorResult {
        ...errorResultFields
      }
    }
  }
  ${ErrorResultFieldsFragmentDoc}
`
export type ReportClubProfileMutationFn = Apollo.MutationFunction<
  ReportClubProfileMutation,
  ReportClubProfileMutationVariables
>

/**
 * __useReportClubProfileMutation__
 *
 * To run a mutation, you first call `useReportClubProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportClubProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportClubProfileMutation, { data, loading, error }] = useReportClubProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *      _cacheKey: // value for '_cacheKey'
 *   },
 * });
 */
export function useReportClubProfileMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ReportClubProfileMutation,
    ReportClubProfileMutationVariables
  >
) {
  return Apollo.useMutation<
    ReportClubProfileMutation,
    ReportClubProfileMutationVariables
  >(ReportClubProfileDocument, baseOptions)
}
export type ReportClubProfileMutationHookResult = ReturnType<
  typeof useReportClubProfileMutation
>
export type ReportClubProfileMutationResult =
  Apollo.MutationResult<ReportClubProfileMutation>
export type ReportClubProfileMutationOptions = Apollo.BaseMutationOptions<
  ReportClubProfileMutation,
  ReportClubProfileMutationVariables
>
export const RevertAppMetadataDocument = gql`
  mutation revertAppMetadata(
    $input: RevertAppMetadataInput!
    $_cacheKey: String
  ) {
    revertAppMetadata(input: $input, _cacheKey: $_cacheKey) {
      ... on AppMetadataResult {
        isSuccess
      }
      ... on ErrorResult {
        ...errorResultFields
      }
    }
  }
  ${ErrorResultFieldsFragmentDoc}
`
export type RevertAppMetadataMutationFn = Apollo.MutationFunction<
  RevertAppMetadataMutation,
  RevertAppMetadataMutationVariables
>

/**
 * __useRevertAppMetadataMutation__
 *
 * To run a mutation, you first call `useRevertAppMetadataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevertAppMetadataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revertAppMetadataMutation, { data, loading, error }] = useRevertAppMetadataMutation({
 *   variables: {
 *      input: // value for 'input'
 *      _cacheKey: // value for '_cacheKey'
 *   },
 * });
 */
export function useRevertAppMetadataMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RevertAppMetadataMutation,
    RevertAppMetadataMutationVariables
  >
) {
  return Apollo.useMutation<
    RevertAppMetadataMutation,
    RevertAppMetadataMutationVariables
  >(RevertAppMetadataDocument, baseOptions)
}
export type RevertAppMetadataMutationHookResult = ReturnType<
  typeof useRevertAppMetadataMutation
>
export type RevertAppMetadataMutationResult =
  Apollo.MutationResult<RevertAppMetadataMutation>
export type RevertAppMetadataMutationOptions = Apollo.BaseMutationOptions<
  RevertAppMetadataMutation,
  RevertAppMetadataMutationVariables
>
export const SearchClubListingsDocument = gql`
  query searchClubListings(
    $filter: SearchClubListingsFilter!
    $options: SearchClubListingsOptions
    $_cacheKey: String
  ) {
    searchClubListings(
      filter: $filter
      options: $options
      _cacheKey: $_cacheKey
    ) {
      ... on ErrorResult {
        ...errorResultFields
      }
      ... on SearchClubListingsResult {
        total
        results {
          ... on SearchClubJobListingsSingleResult {
            distance
            distanceUnit
            messageSentOn
            enquiredOn
            onWatchlist
            hasBeenReported
            listing {
              ... on ClubSingleListing {
                ...singleListingFields
              }
              ... on ClubMultiListing {
                ...multiListingFields
              }
            }
          }
          ... on SearchClubProfileSingleResult {
            distance
            distanceUnit
            onWatchlist
            hasBeenReported
            profile {
              ...clubProfileFields
            }
          }
        }
      }
    }
  }
  ${ErrorResultFieldsFragmentDoc}
  ${SingleListingFieldsFragmentDoc}
  ${MultiListingFieldsFragmentDoc}
  ${ClubProfileFieldsFragmentDoc}
`

/**
 * __useSearchClubListingsQuery__
 *
 * To run a query within a React component, call `useSearchClubListingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchClubListingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchClubListingsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      options: // value for 'options'
 *      _cacheKey: // value for '_cacheKey'
 *   },
 * });
 */
export function useSearchClubListingsQuery(
  baseOptions: Apollo.QueryHookOptions<
    SearchClubListingsQuery,
    SearchClubListingsQueryVariables
  >
) {
  return Apollo.useQuery<
    SearchClubListingsQuery,
    SearchClubListingsQueryVariables
  >(SearchClubListingsDocument, baseOptions)
}
export function useSearchClubListingsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SearchClubListingsQuery,
    SearchClubListingsQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    SearchClubListingsQuery,
    SearchClubListingsQueryVariables
  >(SearchClubListingsDocument, baseOptions)
}
export type SearchClubListingsQueryHookResult = ReturnType<
  typeof useSearchClubListingsQuery
>
export type SearchClubListingsLazyQueryHookResult = ReturnType<
  typeof useSearchClubListingsLazyQuery
>
export type SearchClubListingsQueryResult = Apollo.QueryResult<
  SearchClubListingsQuery,
  SearchClubListingsQueryVariables
>
export const SearchClubsDocument = gql`
  query searchClubs(
    $filter: SearchClubsFilter!
    $options: SearchClubsOptions
    $_cacheKey: String
  ) {
    searchClubs(filter: $filter, options: $options, _cacheKey: $_cacheKey) {
      ... on ErrorResult {
        ...errorResultFields
      }
      ... on SearchClubsResult {
        total
        results {
          ... on SearchClubsSingleResult {
            clubId
            profile {
              ...clubProfileFields
            }
            instructorAffiliation {
              id
              userId
              clubId
              requestedBy
              actionedDate
              status
              pendingStatus
              requestedDate
              latestActionInitiator
            }
            distance
            distanceUnit
          }
        }
      }
    }
  }
  ${ErrorResultFieldsFragmentDoc}
  ${ClubProfileFieldsFragmentDoc}
`

/**
 * __useSearchClubsQuery__
 *
 * To run a query within a React component, call `useSearchClubsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchClubsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchClubsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      options: // value for 'options'
 *      _cacheKey: // value for '_cacheKey'
 *   },
 * });
 */
export function useSearchClubsQuery(
  baseOptions: Apollo.QueryHookOptions<
    SearchClubsQuery,
    SearchClubsQueryVariables
  >
) {
  return Apollo.useQuery<SearchClubsQuery, SearchClubsQueryVariables>(
    SearchClubsDocument,
    baseOptions
  )
}
export function useSearchClubsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SearchClubsQuery,
    SearchClubsQueryVariables
  >
) {
  return Apollo.useLazyQuery<SearchClubsQuery, SearchClubsQueryVariables>(
    SearchClubsDocument,
    baseOptions
  )
}
export type SearchClubsQueryHookResult = ReturnType<typeof useSearchClubsQuery>
export type SearchClubsLazyQueryHookResult = ReturnType<
  typeof useSearchClubsLazyQuery
>
export type SearchClubsQueryResult = Apollo.QueryResult<
  SearchClubsQuery,
  SearchClubsQueryVariables
>
export const SearchInstructorsDocument = gql`
  query searchInstructors(
    $filter: SearchInstructorsFilter!
    $options: SearchInstructorsOptions
    $role: UserRoleInput!
    $_cacheKey: String
  ) {
    searchInstructors(
      filter: $filter
      options: $options
      role: $role
      _cacheKey: $_cacheKey
    ) {
      ... on SearchInstructorsResult {
        ...searchInstructorsResult
      }
      ... on ErrorResult {
        ...errorResultFields
      }
    }
  }
  ${SearchInstructorsResultFragmentDoc}
  ${ErrorResultFieldsFragmentDoc}
`

/**
 * __useSearchInstructorsQuery__
 *
 * To run a query within a React component, call `useSearchInstructorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchInstructorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchInstructorsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      options: // value for 'options'
 *      role: // value for 'role'
 *      _cacheKey: // value for '_cacheKey'
 *   },
 * });
 */
export function useSearchInstructorsQuery(
  baseOptions: Apollo.QueryHookOptions<
    SearchInstructorsQuery,
    SearchInstructorsQueryVariables
  >
) {
  return Apollo.useQuery<
    SearchInstructorsQuery,
    SearchInstructorsQueryVariables
  >(SearchInstructorsDocument, baseOptions)
}
export function useSearchInstructorsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SearchInstructorsQuery,
    SearchInstructorsQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    SearchInstructorsQuery,
    SearchInstructorsQueryVariables
  >(SearchInstructorsDocument, baseOptions)
}
export type SearchInstructorsQueryHookResult = ReturnType<
  typeof useSearchInstructorsQuery
>
export type SearchInstructorsLazyQueryHookResult = ReturnType<
  typeof useSearchInstructorsLazyQuery
>
export type SearchInstructorsQueryResult = Apollo.QueryResult<
  SearchInstructorsQuery,
  SearchInstructorsQueryVariables
>
export const SendMessageDocument = gql`
  mutation sendMessage($input: SendMessageInput!, $_cacheKey: String) {
    sendMessage(input: $input, _cacheKey: $_cacheKey) {
      ... on SendMessageResult {
        sentAt
      }
      ... on ErrorResult {
        ...errorResultFields
      }
    }
  }
  ${ErrorResultFieldsFragmentDoc}
`
export type SendMessageMutationFn = Apollo.MutationFunction<
  SendMessageMutation,
  SendMessageMutationVariables
>

/**
 * __useSendMessageMutation__
 *
 * To run a mutation, you first call `useSendMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendMessageMutation, { data, loading, error }] = useSendMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *      _cacheKey: // value for '_cacheKey'
 *   },
 * });
 */
export function useSendMessageMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SendMessageMutation,
    SendMessageMutationVariables
  >
) {
  return Apollo.useMutation<SendMessageMutation, SendMessageMutationVariables>(
    SendMessageDocument,
    baseOptions
  )
}
export type SendMessageMutationHookResult = ReturnType<
  typeof useSendMessageMutation
>
export type SendMessageMutationResult =
  Apollo.MutationResult<SendMessageMutation>
export type SendMessageMutationOptions = Apollo.BaseMutationOptions<
  SendMessageMutation,
  SendMessageMutationVariables
>
export const SetClubSettingsDocument = gql`
  mutation setClubSettings($input: SetClubSettingsInput!, $_cacheKey: String) {
    setClubSettings(input: $input, _cacheKey: $_cacheKey) {
      ... on SetClubSettingsResult {
        id
        address {
          ...addressFields
        }
        email {
          main
          affiliations
          jobListings
        }
        id
        name
        phone
      }
      ... on ErrorResult {
        ...errorResultFields
      }
    }
  }
  ${AddressFieldsFragmentDoc}
  ${ErrorResultFieldsFragmentDoc}
`
export type SetClubSettingsMutationFn = Apollo.MutationFunction<
  SetClubSettingsMutation,
  SetClubSettingsMutationVariables
>

/**
 * __useSetClubSettingsMutation__
 *
 * To run a mutation, you first call `useSetClubSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetClubSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setClubSettingsMutation, { data, loading, error }] = useSetClubSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *      _cacheKey: // value for '_cacheKey'
 *   },
 * });
 */
export function useSetClubSettingsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetClubSettingsMutation,
    SetClubSettingsMutationVariables
  >
) {
  return Apollo.useMutation<
    SetClubSettingsMutation,
    SetClubSettingsMutationVariables
  >(SetClubSettingsDocument, baseOptions)
}
export type SetClubSettingsMutationHookResult = ReturnType<
  typeof useSetClubSettingsMutation
>
export type SetClubSettingsMutationResult =
  Apollo.MutationResult<SetClubSettingsMutation>
export type SetClubSettingsMutationOptions = Apollo.BaseMutationOptions<
  SetClubSettingsMutation,
  SetClubSettingsMutationVariables
>
export const SetInstructorAvailabilityDocument = gql`
  mutation setInstructorAvailability(
    $input: SetInstructorAvailabilityInput!
    $_cacheKey: String
  ) {
    setInstructorAvailability(input: $input, _cacheKey: $_cacheKey) {
      ... on InstructorAvailability {
        value
        availableToSubstitute
      }
      ... on ErrorResult {
        ...errorResultFields
      }
    }
  }
  ${ErrorResultFieldsFragmentDoc}
`
export type SetInstructorAvailabilityMutationFn = Apollo.MutationFunction<
  SetInstructorAvailabilityMutation,
  SetInstructorAvailabilityMutationVariables
>

/**
 * __useSetInstructorAvailabilityMutation__
 *
 * To run a mutation, you first call `useSetInstructorAvailabilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetInstructorAvailabilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setInstructorAvailabilityMutation, { data, loading, error }] = useSetInstructorAvailabilityMutation({
 *   variables: {
 *      input: // value for 'input'
 *      _cacheKey: // value for '_cacheKey'
 *   },
 * });
 */
export function useSetInstructorAvailabilityMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetInstructorAvailabilityMutation,
    SetInstructorAvailabilityMutationVariables
  >
) {
  return Apollo.useMutation<
    SetInstructorAvailabilityMutation,
    SetInstructorAvailabilityMutationVariables
  >(SetInstructorAvailabilityDocument, baseOptions)
}
export type SetInstructorAvailabilityMutationHookResult = ReturnType<
  typeof useSetInstructorAvailabilityMutation
>
export type SetInstructorAvailabilityMutationResult =
  Apollo.MutationResult<SetInstructorAvailabilityMutation>
export type SetInstructorAvailabilityMutationOptions =
  Apollo.BaseMutationOptions<
    SetInstructorAvailabilityMutation,
    SetInstructorAvailabilityMutationVariables
  >
export const SetInstructorWatchlistDocument = gql`
  mutation setInstructorWatchlist(
    $input: SetInstructorWatchlistInput!
    $role: UserRoleInput!
    $_cacheKey: String
  ) {
    setInstructorWatchlist(input: $input, role: $role, _cacheKey: $_cacheKey) {
      ... on InstructorWatchlist {
        watchlist {
          clubId
          listingId
        }
      }
      ... on ErrorResult {
        ...errorResultFields
      }
    }
  }
  ${ErrorResultFieldsFragmentDoc}
`
export type SetInstructorWatchlistMutationFn = Apollo.MutationFunction<
  SetInstructorWatchlistMutation,
  SetInstructorWatchlistMutationVariables
>

/**
 * __useSetInstructorWatchlistMutation__
 *
 * To run a mutation, you first call `useSetInstructorWatchlistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetInstructorWatchlistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setInstructorWatchlistMutation, { data, loading, error }] = useSetInstructorWatchlistMutation({
 *   variables: {
 *      input: // value for 'input'
 *      role: // value for 'role'
 *      _cacheKey: // value for '_cacheKey'
 *   },
 * });
 */
export function useSetInstructorWatchlistMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetInstructorWatchlistMutation,
    SetInstructorWatchlistMutationVariables
  >
) {
  return Apollo.useMutation<
    SetInstructorWatchlistMutation,
    SetInstructorWatchlistMutationVariables
  >(SetInstructorWatchlistDocument, baseOptions)
}
export type SetInstructorWatchlistMutationHookResult = ReturnType<
  typeof useSetInstructorWatchlistMutation
>
export type SetInstructorWatchlistMutationResult =
  Apollo.MutationResult<SetInstructorWatchlistMutation>
export type SetInstructorWatchlistMutationOptions = Apollo.BaseMutationOptions<
  SetInstructorWatchlistMutation,
  SetInstructorWatchlistMutationVariables
>
export const SetSavedInstructorSearchDataDocument = gql`
  mutation SetSavedInstructorSearchData(
    $input: SetSavedInstructorSearchDataInput!
    $_cacheKey: String
  ) {
    setSavedInstructorSearchData(input: $input, _cacheKey: $_cacheKey) {
      ... on SetSavedInstructorSearchDataResult {
        results {
          ...savedInstructorSearch
        }
      }
      ... on ErrorResult {
        ...errorResultFields
      }
    }
  }
  ${SavedInstructorSearchFragmentDoc}
  ${ErrorResultFieldsFragmentDoc}
`
export type SetSavedInstructorSearchDataMutationFn = Apollo.MutationFunction<
  SetSavedInstructorSearchDataMutation,
  SetSavedInstructorSearchDataMutationVariables
>

/**
 * __useSetSavedInstructorSearchDataMutation__
 *
 * To run a mutation, you first call `useSetSavedInstructorSearchDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetSavedInstructorSearchDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setSavedInstructorSearchDataMutation, { data, loading, error }] = useSetSavedInstructorSearchDataMutation({
 *   variables: {
 *      input: // value for 'input'
 *      _cacheKey: // value for '_cacheKey'
 *   },
 * });
 */
export function useSetSavedInstructorSearchDataMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetSavedInstructorSearchDataMutation,
    SetSavedInstructorSearchDataMutationVariables
  >
) {
  return Apollo.useMutation<
    SetSavedInstructorSearchDataMutation,
    SetSavedInstructorSearchDataMutationVariables
  >(SetSavedInstructorSearchDataDocument, baseOptions)
}
export type SetSavedInstructorSearchDataMutationHookResult = ReturnType<
  typeof useSetSavedInstructorSearchDataMutation
>
export type SetSavedInstructorSearchDataMutationResult =
  Apollo.MutationResult<SetSavedInstructorSearchDataMutation>
export type SetSavedInstructorSearchDataMutationOptions =
  Apollo.BaseMutationOptions<
    SetSavedInstructorSearchDataMutation,
    SetSavedInstructorSearchDataMutationVariables
  >
export const SetSignedAgreementDataDocument = gql`
  mutation setSignedAgreementData(
    $input: SetSignedAgreementDataInput!
    $_cacheKey: String
  ) {
    setSignedAgreementData(input: $input, _cacheKey: $_cacheKey) {
      ... on AgreementDocumentResult {
        agreementType: type
        signedOn
        version
      }
      ... on ErrorResult {
        ...errorResultFields
      }
    }
  }
  ${ErrorResultFieldsFragmentDoc}
`
export type SetSignedAgreementDataMutationFn = Apollo.MutationFunction<
  SetSignedAgreementDataMutation,
  SetSignedAgreementDataMutationVariables
>

/**
 * __useSetSignedAgreementDataMutation__
 *
 * To run a mutation, you first call `useSetSignedAgreementDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetSignedAgreementDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setSignedAgreementDataMutation, { data, loading, error }] = useSetSignedAgreementDataMutation({
 *   variables: {
 *      input: // value for 'input'
 *      _cacheKey: // value for '_cacheKey'
 *   },
 * });
 */
export function useSetSignedAgreementDataMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetSignedAgreementDataMutation,
    SetSignedAgreementDataMutationVariables
  >
) {
  return Apollo.useMutation<
    SetSignedAgreementDataMutation,
    SetSignedAgreementDataMutationVariables
  >(SetSignedAgreementDataDocument, baseOptions)
}
export type SetSignedAgreementDataMutationHookResult = ReturnType<
  typeof useSetSignedAgreementDataMutation
>
export type SetSignedAgreementDataMutationResult =
  Apollo.MutationResult<SetSignedAgreementDataMutation>
export type SetSignedAgreementDataMutationOptions = Apollo.BaseMutationOptions<
  SetSignedAgreementDataMutation,
  SetSignedAgreementDataMutationVariables
>
export const SetWalkthroughToSeenDocument = gql`
  mutation setWalkthroughToSeen($role: UserRoleInput!, $_cacheKey: String) {
    setWalkthroughToSeen(role: $role, _cacheKey: $_cacheKey) {
      ... on SetWalkthroughToSeenResult {
        success
      }
      ... on ErrorResult {
        ...errorResultFields
      }
    }
  }
  ${ErrorResultFieldsFragmentDoc}
`
export type SetWalkthroughToSeenMutationFn = Apollo.MutationFunction<
  SetWalkthroughToSeenMutation,
  SetWalkthroughToSeenMutationVariables
>

/**
 * __useSetWalkthroughToSeenMutation__
 *
 * To run a mutation, you first call `useSetWalkthroughToSeenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetWalkthroughToSeenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setWalkthroughToSeenMutation, { data, loading, error }] = useSetWalkthroughToSeenMutation({
 *   variables: {
 *      role: // value for 'role'
 *      _cacheKey: // value for '_cacheKey'
 *   },
 * });
 */
export function useSetWalkthroughToSeenMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetWalkthroughToSeenMutation,
    SetWalkthroughToSeenMutationVariables
  >
) {
  return Apollo.useMutation<
    SetWalkthroughToSeenMutation,
    SetWalkthroughToSeenMutationVariables
  >(SetWalkthroughToSeenDocument, baseOptions)
}
export type SetWalkthroughToSeenMutationHookResult = ReturnType<
  typeof useSetWalkthroughToSeenMutation
>
export type SetWalkthroughToSeenMutationResult =
  Apollo.MutationResult<SetWalkthroughToSeenMutation>
export type SetWalkthroughToSeenMutationOptions = Apollo.BaseMutationOptions<
  SetWalkthroughToSeenMutation,
  SetWalkthroughToSeenMutationVariables
>
export const UpdateAffiliateBillingDocument = gql`
  mutation updateAffiliateBilling(
    $input: PayForCertificationInput!
    $_cacheKey: String
  ) {
    payForCertification(input: $input, _cacheKey: $_cacheKey) {
      ... on PayForCertificationResult {
        results {
          certificate {
            active
            billedClubId
            id
            lastPurchase
            lmqLevel
            pricePerQuarter {
              amount
              currency
            }
            program {
              code
              id
              initials
              name
            }
            transactionStatus
            releaseStatus
            status
          }
          instructorName
        }
      }
      ... on ErrorResult {
        ...errorResultFields
      }
    }
  }
  ${ErrorResultFieldsFragmentDoc}
`
export type UpdateAffiliateBillingMutationFn = Apollo.MutationFunction<
  UpdateAffiliateBillingMutation,
  UpdateAffiliateBillingMutationVariables
>

/**
 * __useUpdateAffiliateBillingMutation__
 *
 * To run a mutation, you first call `useUpdateAffiliateBillingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAffiliateBillingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAffiliateBillingMutation, { data, loading, error }] = useUpdateAffiliateBillingMutation({
 *   variables: {
 *      input: // value for 'input'
 *      _cacheKey: // value for '_cacheKey'
 *   },
 * });
 */
export function useUpdateAffiliateBillingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateAffiliateBillingMutation,
    UpdateAffiliateBillingMutationVariables
  >
) {
  return Apollo.useMutation<
    UpdateAffiliateBillingMutation,
    UpdateAffiliateBillingMutationVariables
  >(UpdateAffiliateBillingDocument, baseOptions)
}
export type UpdateAffiliateBillingMutationHookResult = ReturnType<
  typeof useUpdateAffiliateBillingMutation
>
export type UpdateAffiliateBillingMutationResult =
  Apollo.MutationResult<UpdateAffiliateBillingMutation>
export type UpdateAffiliateBillingMutationOptions = Apollo.BaseMutationOptions<
  UpdateAffiliateBillingMutation,
  UpdateAffiliateBillingMutationVariables
>
export const UpdateAffiliationDocument = gql`
  mutation updateAffiliation(
    $input: UpdateAffiliationInput!
    $role: UserRoleInput!
    $_cacheKey: String
  ) {
    updateAffiliation(input: $input, role: $role, _cacheKey: $_cacheKey) {
      ... on AffiliationAsyncResult {
        status
        hasPendingAffiliations
      }
      ... on ErrorResult {
        ...errorResultFields
      }
    }
  }
  ${ErrorResultFieldsFragmentDoc}
`
export type UpdateAffiliationMutationFn = Apollo.MutationFunction<
  UpdateAffiliationMutation,
  UpdateAffiliationMutationVariables
>

/**
 * __useUpdateAffiliationMutation__
 *
 * To run a mutation, you first call `useUpdateAffiliationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAffiliationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAffiliationMutation, { data, loading, error }] = useUpdateAffiliationMutation({
 *   variables: {
 *      input: // value for 'input'
 *      role: // value for 'role'
 *      _cacheKey: // value for '_cacheKey'
 *   },
 * });
 */
export function useUpdateAffiliationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateAffiliationMutation,
    UpdateAffiliationMutationVariables
  >
) {
  return Apollo.useMutation<
    UpdateAffiliationMutation,
    UpdateAffiliationMutationVariables
  >(UpdateAffiliationDocument, baseOptions)
}
export type UpdateAffiliationMutationHookResult = ReturnType<
  typeof useUpdateAffiliationMutation
>
export type UpdateAffiliationMutationResult =
  Apollo.MutationResult<UpdateAffiliationMutation>
export type UpdateAffiliationMutationOptions = Apollo.BaseMutationOptions<
  UpdateAffiliationMutation,
  UpdateAffiliationMutationVariables
>
export const UpdateClubListingDocument = gql`
  mutation updateClubListing(
    $input: UpdateClubListingInput!
    $_cacheKey: String
  ) {
    updateClubListing(input: $input, _cacheKey: $_cacheKey) {
      ... on ClubListingResult {
        results {
          ... on ClubSingleListing {
            ...singleListingFields
          }
          ... on ClubMultiListing {
            ...multiListingFields
          }
        }
      }
      ... on ErrorResult {
        ...errorResultFields
      }
    }
  }
  ${SingleListingFieldsFragmentDoc}
  ${MultiListingFieldsFragmentDoc}
  ${ErrorResultFieldsFragmentDoc}
`
export type UpdateClubListingMutationFn = Apollo.MutationFunction<
  UpdateClubListingMutation,
  UpdateClubListingMutationVariables
>

/**
 * __useUpdateClubListingMutation__
 *
 * To run a mutation, you first call `useUpdateClubListingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClubListingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClubListingMutation, { data, loading, error }] = useUpdateClubListingMutation({
 *   variables: {
 *      input: // value for 'input'
 *      _cacheKey: // value for '_cacheKey'
 *   },
 * });
 */
export function useUpdateClubListingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateClubListingMutation,
    UpdateClubListingMutationVariables
  >
) {
  return Apollo.useMutation<
    UpdateClubListingMutation,
    UpdateClubListingMutationVariables
  >(UpdateClubListingDocument, baseOptions)
}
export type UpdateClubListingMutationHookResult = ReturnType<
  typeof useUpdateClubListingMutation
>
export type UpdateClubListingMutationResult =
  Apollo.MutationResult<UpdateClubListingMutation>
export type UpdateClubListingMutationOptions = Apollo.BaseMutationOptions<
  UpdateClubListingMutation,
  UpdateClubListingMutationVariables
>
export const UpdateClubProfileDocument = gql`
  mutation updateClubProfile(
    $input: UpdateClubProfileInput!
    $_cacheKey: String
  ) {
    updateClubProfile(input: $input, _cacheKey: $_cacheKey) {
      ... on UserResult {
        ...fullUserField
      }
      ... on ErrorResult {
        ...errorResultFields
      }
    }
  }
  ${FullUserFieldFragmentDoc}
  ${ErrorResultFieldsFragmentDoc}
`
export type UpdateClubProfileMutationFn = Apollo.MutationFunction<
  UpdateClubProfileMutation,
  UpdateClubProfileMutationVariables
>

/**
 * __useUpdateClubProfileMutation__
 *
 * To run a mutation, you first call `useUpdateClubProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClubProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClubProfileMutation, { data, loading, error }] = useUpdateClubProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *      _cacheKey: // value for '_cacheKey'
 *   },
 * });
 */
export function useUpdateClubProfileMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateClubProfileMutation,
    UpdateClubProfileMutationVariables
  >
) {
  return Apollo.useMutation<
    UpdateClubProfileMutation,
    UpdateClubProfileMutationVariables
  >(UpdateClubProfileDocument, baseOptions)
}
export type UpdateClubProfileMutationHookResult = ReturnType<
  typeof useUpdateClubProfileMutation
>
export type UpdateClubProfileMutationResult =
  Apollo.MutationResult<UpdateClubProfileMutation>
export type UpdateClubProfileMutationOptions = Apollo.BaseMutationOptions<
  UpdateClubProfileMutation,
  UpdateClubProfileMutationVariables
>
export const FinishPortfolioUpdateDocument = gql`
  mutation finishPortfolioUpdate(
    $input: UpdateCurrentUserPortfolioUploadInput!
    $role: UserRoleInput!
    $_cacheKey: String
  ) {
    updateCurrentUserPortfolioUpload(
      input: $input
      role: $role
      _cacheKey: $_cacheKey
    ) {
      ... on UpdateCurrentUserPortfolioUploadResult {
        url
        profile {
          ... on UserProfileTeaching {
            ...instructorProfileFields
          }
          ... on UserProfileClub {
            ...clubProfileFields
          }
        }
      }
      ... on ErrorResult {
        ...errorResultFields
      }
    }
  }
  ${InstructorProfileFieldsFragmentDoc}
  ${ClubProfileFieldsFragmentDoc}
  ${ErrorResultFieldsFragmentDoc}
`
export type FinishPortfolioUpdateMutationFn = Apollo.MutationFunction<
  FinishPortfolioUpdateMutation,
  FinishPortfolioUpdateMutationVariables
>

/**
 * __useFinishPortfolioUpdateMutation__
 *
 * To run a mutation, you first call `useFinishPortfolioUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinishPortfolioUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finishPortfolioUpdateMutation, { data, loading, error }] = useFinishPortfolioUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *      role: // value for 'role'
 *      _cacheKey: // value for '_cacheKey'
 *   },
 * });
 */
export function useFinishPortfolioUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    FinishPortfolioUpdateMutation,
    FinishPortfolioUpdateMutationVariables
  >
) {
  return Apollo.useMutation<
    FinishPortfolioUpdateMutation,
    FinishPortfolioUpdateMutationVariables
  >(FinishPortfolioUpdateDocument, baseOptions)
}
export type FinishPortfolioUpdateMutationHookResult = ReturnType<
  typeof useFinishPortfolioUpdateMutation
>
export type FinishPortfolioUpdateMutationResult =
  Apollo.MutationResult<FinishPortfolioUpdateMutation>
export type FinishPortfolioUpdateMutationOptions = Apollo.BaseMutationOptions<
  FinishPortfolioUpdateMutation,
  FinishPortfolioUpdateMutationVariables
>
export const UpdateTeachingProfileDocument = gql`
  mutation updateTeachingProfile(
    $input: UpdateTeachingProfileInput!
    $_cacheKey: String
  ) {
    updateTeachingProfile(input: $input, _cacheKey: $_cacheKey) {
      ... on UserResult {
        ...fullUserField
      }
      ... on ErrorResult {
        ...errorResultFields
      }
    }
  }
  ${FullUserFieldFragmentDoc}
  ${ErrorResultFieldsFragmentDoc}
`
export type UpdateTeachingProfileMutationFn = Apollo.MutationFunction<
  UpdateTeachingProfileMutation,
  UpdateTeachingProfileMutationVariables
>

/**
 * __useUpdateTeachingProfileMutation__
 *
 * To run a mutation, you first call `useUpdateTeachingProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTeachingProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTeachingProfileMutation, { data, loading, error }] = useUpdateTeachingProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *      _cacheKey: // value for '_cacheKey'
 *   },
 * });
 */
export function useUpdateTeachingProfileMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateTeachingProfileMutation,
    UpdateTeachingProfileMutationVariables
  >
) {
  return Apollo.useMutation<
    UpdateTeachingProfileMutation,
    UpdateTeachingProfileMutationVariables
  >(UpdateTeachingProfileDocument, baseOptions)
}
export type UpdateTeachingProfileMutationHookResult = ReturnType<
  typeof useUpdateTeachingProfileMutation
>
export type UpdateTeachingProfileMutationResult =
  Apollo.MutationResult<UpdateTeachingProfileMutation>
export type UpdateTeachingProfileMutationOptions = Apollo.BaseMutationOptions<
  UpdateTeachingProfileMutation,
  UpdateTeachingProfileMutationVariables
>
export const UpdateUserAccountDocument = gql`
  mutation updateUserAccount(
    $input: UpdateUserAccountInput!
    $_cacheKey: String
  ) {
    updateUserAccount(input: $input, _cacheKey: $_cacheKey) {
      ... on UserAccountSettingsResult {
        address {
          ...addressFields
        }
        email
        firstName
        id
        lastName
        phone
        outlinks {
          url
          title
        }
      }
      ... on ErrorResult {
        ...errorResultFields
      }
    }
  }
  ${AddressFieldsFragmentDoc}
  ${ErrorResultFieldsFragmentDoc}
`
export type UpdateUserAccountMutationFn = Apollo.MutationFunction<
  UpdateUserAccountMutation,
  UpdateUserAccountMutationVariables
>

/**
 * __useUpdateUserAccountMutation__
 *
 * To run a mutation, you first call `useUpdateUserAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserAccountMutation, { data, loading, error }] = useUpdateUserAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *      _cacheKey: // value for '_cacheKey'
 *   },
 * });
 */
export function useUpdateUserAccountMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateUserAccountMutation,
    UpdateUserAccountMutationVariables
  >
) {
  return Apollo.useMutation<
    UpdateUserAccountMutation,
    UpdateUserAccountMutationVariables
  >(UpdateUserAccountDocument, baseOptions)
}
export type UpdateUserAccountMutationHookResult = ReturnType<
  typeof useUpdateUserAccountMutation
>
export type UpdateUserAccountMutationResult =
  Apollo.MutationResult<UpdateUserAccountMutation>
export type UpdateUserAccountMutationOptions = Apollo.BaseMutationOptions<
  UpdateUserAccountMutation,
  UpdateUserAccountMutationVariables
>
export const UpdateUserPhotoDocument = gql`
  mutation updateUserPhoto($input: UpdateUserPhotoInput!, $_cacheKey: String) {
    updateUserPhoto(input: $input, _cacheKey: $_cacheKey) {
      ... on UpdateUserPhotoResult {
        profile {
          ... on UserProfileTeaching {
            ...instructorProfileFields
          }
          ... on UserProfileClub {
            ...clubProfileFields
          }
        }
        url
      }
      ... on ErrorResult {
        ...errorResultFields
      }
    }
  }
  ${InstructorProfileFieldsFragmentDoc}
  ${ClubProfileFieldsFragmentDoc}
  ${ErrorResultFieldsFragmentDoc}
`
export type UpdateUserPhotoMutationFn = Apollo.MutationFunction<
  UpdateUserPhotoMutation,
  UpdateUserPhotoMutationVariables
>

/**
 * __useUpdateUserPhotoMutation__
 *
 * To run a mutation, you first call `useUpdateUserPhotoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserPhotoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserPhotoMutation, { data, loading, error }] = useUpdateUserPhotoMutation({
 *   variables: {
 *      input: // value for 'input'
 *      _cacheKey: // value for '_cacheKey'
 *   },
 * });
 */
export function useUpdateUserPhotoMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateUserPhotoMutation,
    UpdateUserPhotoMutationVariables
  >
) {
  return Apollo.useMutation<
    UpdateUserPhotoMutation,
    UpdateUserPhotoMutationVariables
  >(UpdateUserPhotoDocument, baseOptions)
}
export type UpdateUserPhotoMutationHookResult = ReturnType<
  typeof useUpdateUserPhotoMutation
>
export type UpdateUserPhotoMutationResult =
  Apollo.MutationResult<UpdateUserPhotoMutation>
export type UpdateUserPhotoMutationOptions = Apollo.BaseMutationOptions<
  UpdateUserPhotoMutation,
  UpdateUserPhotoMutationVariables
>
export const FinalizeUploadDocument = gql`
  mutation finalizeUpload($input: FinalizeUploadInput!, $_cacheKey: String) {
    finalizeUpload(input: $input, _cacheKey: $_cacheKey) {
      ... on FinalizeUploadResult {
        isSuccess
        comment
        playback {
          playbackUrl
          token
        }
      }
      ... on ErrorResult {
        message
      }
    }
  }
`
export type FinalizeUploadMutationFn = Apollo.MutationFunction<
  FinalizeUploadMutation,
  FinalizeUploadMutationVariables
>

/**
 * __useFinalizeUploadMutation__
 *
 * To run a mutation, you first call `useFinalizeUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinalizeUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finalizeUploadMutation, { data, loading, error }] = useFinalizeUploadMutation({
 *   variables: {
 *      input: // value for 'input'
 *      _cacheKey: // value for '_cacheKey'
 *   },
 * });
 */
export function useFinalizeUploadMutation(
  baseOptions?: Apollo.MutationHookOptions<
    FinalizeUploadMutation,
    FinalizeUploadMutationVariables
  >
) {
  return Apollo.useMutation<
    FinalizeUploadMutation,
    FinalizeUploadMutationVariables
  >(FinalizeUploadDocument, baseOptions)
}
export type FinalizeUploadMutationHookResult = ReturnType<
  typeof useFinalizeUploadMutation
>
export type FinalizeUploadMutationResult =
  Apollo.MutationResult<FinalizeUploadMutation>
export type FinalizeUploadMutationOptions = Apollo.BaseMutationOptions<
  FinalizeUploadMutation,
  FinalizeUploadMutationVariables
>
export const GetPresignedUrlDocument = gql`
  query getPresignedUrl($input: GetPresignedUrlInput!, $_cacheKey: String) {
    getPresignedUrl(input: $input, _cacheKey: $_cacheKey) {
      ... on GetPresignedUrlResult {
        partSignedUrlList {
          partNumber
          url
        }
      }
      ... on ErrorResult {
        message
      }
    }
  }
`

/**
 * __useGetPresignedUrlQuery__
 *
 * To run a query within a React component, call `useGetPresignedUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPresignedUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPresignedUrlQuery({
 *   variables: {
 *      input: // value for 'input'
 *      _cacheKey: // value for '_cacheKey'
 *   },
 * });
 */
export function useGetPresignedUrlQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetPresignedUrlQuery,
    GetPresignedUrlQueryVariables
  >
) {
  return Apollo.useQuery<GetPresignedUrlQuery, GetPresignedUrlQueryVariables>(
    GetPresignedUrlDocument,
    baseOptions
  )
}
export function useGetPresignedUrlLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPresignedUrlQuery,
    GetPresignedUrlQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    GetPresignedUrlQuery,
    GetPresignedUrlQueryVariables
  >(GetPresignedUrlDocument, baseOptions)
}
export type GetPresignedUrlQueryHookResult = ReturnType<
  typeof useGetPresignedUrlQuery
>
export type GetPresignedUrlLazyQueryHookResult = ReturnType<
  typeof useGetPresignedUrlLazyQuery
>
export type GetPresignedUrlQueryResult = Apollo.QueryResult<
  GetPresignedUrlQuery,
  GetPresignedUrlQueryVariables
>
export const InitializeUploadDocument = gql`
  mutation initializeUpload(
    $input: InitializeUploadInput!
    $_cacheKey: String
  ) {
    initializeUpload(input: $input, _cacheKey: $_cacheKey) {
      ... on InitializeUploadResult {
        uploadId
      }
      ... on ErrorResult {
        message
      }
    }
  }
`
export type InitializeUploadMutationFn = Apollo.MutationFunction<
  InitializeUploadMutation,
  InitializeUploadMutationVariables
>

/**
 * __useInitializeUploadMutation__
 *
 * To run a mutation, you first call `useInitializeUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitializeUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initializeUploadMutation, { data, loading, error }] = useInitializeUploadMutation({
 *   variables: {
 *      input: // value for 'input'
 *      _cacheKey: // value for '_cacheKey'
 *   },
 * });
 */
export function useInitializeUploadMutation(
  baseOptions?: Apollo.MutationHookOptions<
    InitializeUploadMutation,
    InitializeUploadMutationVariables
  >
) {
  return Apollo.useMutation<
    InitializeUploadMutation,
    InitializeUploadMutationVariables
  >(InitializeUploadDocument, baseOptions)
}
export type InitializeUploadMutationHookResult = ReturnType<
  typeof useInitializeUploadMutation
>
export type InitializeUploadMutationResult =
  Apollo.MutationResult<InitializeUploadMutation>
export type InitializeUploadMutationOptions = Apollo.BaseMutationOptions<
  InitializeUploadMutation,
  InitializeUploadMutationVariables
>

export interface PossibleTypesResultData {
  possibleTypes: {
    [key: string]: string[]
  }
}
const result: PossibleTypesResultData = {
  possibleTypes: {
    AddClubListingResponse: ['ClubListingResult', 'ErrorResult'],
    AddEmergencyContactResponse: ['AddEmergencyContactResult', 'ErrorResult'],
    AddToShortlistResponse: ['AddToShortlistResult', 'ErrorResult'],
    AddTrainingOutcomeResponse: ['AddTrainingOutcomeResult', 'ErrorResult'],
    AffiliationAsyncResponse: ['AffiliationAsyncResult', 'ErrorResult'],
    AgreementDocumentResponse: ['AgreementDocumentResult', 'ErrorResult'],
    AppMetadataResponse: ['AppMetadataResult', 'ErrorResult'],
    BookEventResponse: ['BookEventResult', 'ErrorResult'],
    BookedEventResponse: ['BookedEventResult', 'ErrorResult'],
    BookedEventsResponse: ['BookedEventsResult', 'ErrorResult'],
    ChainAffiliationsRemoveResponse: [
      'ChainAffiliationsRemoveRresult',
      'ErrorResult',
    ],
    ChainAffiliationsResponse: ['ChainAffiliationsResult', 'ErrorResult'],
    ChainUserResponse: ['GetChainUser', 'ErrorResult'],
    ClubListing: ['ClubSingleListing', 'ClubMultiListing'],
    ClubListingCommon: ['ClubMultiListing', 'ClubSingleListing'],
    ClubProgramContent: ['ClubProgram', 'ClubProgramInStudioEmptyState'],
    CreateClubListingsResponse: ['CreateClubListingsResult', 'ErrorResult'],
    CreateInstructorAccountResponse: [
      'CreateInstructorAccountResult',
      'ErrorResult',
    ],
    DateTimeFilteredResponse: ['GetNotificationsResult'],
    DeleteClubListingResponse: ['DeleteClubListingResult', 'ErrorResult'],
    DeleteClubListingsResponse: ['DeleteClubListingsResult', 'ErrorResult'],
    DeleteCurrentUserPortfolioImageResponse: [
      'DeleteCurrentUserPortfolioImageResult',
      'ErrorResult',
    ],
    DeleteNotificationResponse: ['DeleteNotificationResult', 'ErrorResult'],
    DynamoMigrateResponse: ['DynamoMigrateResult', 'ErrorResult'],
    EnquireAboutExploreProgramsResponse: [
      'EnquireAboutExploreProgramsResult',
      'ErrorResult',
    ],
    EnquireAboutInStudioProgramsResponse: [
      'EnquireAboutInStudioProgramsResult',
      'ErrorResult',
    ],
    EnquireAboutOnlineProgramResponse: [
      'EnquireAboutOnlineProgramResult',
      'ErrorResult',
    ],
    EnquireAboutProgramResponse: ['EnquireAboutProgramResult', 'ErrorResult'],
    EnquiryHistoryClubListing: [
      'ClubMultiListing',
      'ClubSingleListing',
      'ClubListingUnknown',
    ],
    EnsureUserProfileExistsResponse: ['UserResult', 'ErrorResult'],
    EventDetailsResponse: ['EventDetailsResult', 'ErrorResult'],
    FeatureFlagResponse: ['FeatureFlagResult', 'ErrorResult'],
    FinalizeUploadResponse: ['FinalizeUploadResult', 'ErrorResult'],
    GetAccountSettingsResponse: ['UserAccountSettingsResult', 'ErrorResult'],
    GetAllTranslationsResponse: ['GetAllTranslationsResult', 'ErrorResult'],
    GetChainAffiliationsResponse: ['GetChainAffiliationsResult', 'ErrorResult'],
    GetChainInstructorAffiliatesResponse: [
      'GetChainInstructorAffiliatesResult',
      'ErrorResult',
    ],
    GetChainUserClubListingsResponse: [
      'GetChainUserClubListingsResult',
      'ErrorResult',
    ],
    GetClubAffiliationsResponse: ['ClubAffiliationsResult', 'ErrorResult'],
    GetClubByIdResponse: ['UserProfileClub', 'ErrorResult'],
    GetClubInstructorAffiliatesResponse: [
      'GetClubInstructorAffiliatesResult',
      'ErrorResult',
    ],
    GetClubListingByIdResponse: [
      'SearchClubJobListingsSingleResult',
      'ErrorResult',
    ],
    GetClubListingsByClubIdResponse: [
      'GetClubListingsByClubIdResult',
      'ErrorResult',
    ],
    GetClubNotificationsResponse: ['GetClubNotificationsResult', 'ErrorResult'],
    GetClubSettingsResponse: ['GetClubSettingsResult', 'ErrorResult'],
    GetClubsAvailabilityOnListingResponse: [
      'GetClubsAvailabilityOnListingResult',
      'ErrorResult',
    ],
    GetContactUsContentResponse: ['GetContactUsContentResult', 'ErrorResult'],
    GetCurrentUserPhotoUploadDataResponse: [
      'GetCurrentUserPhotoUploadDataResult',
      'ErrorResult',
    ],
    GetCurrentUserPortfolioUploadDataResponse: [
      'GetCurrentUserPortfolioUploadDataResult',
      'ErrorResult',
    ],
    GetDashboardResponse: [
      'DashboardPageInstructorResponse',
      'DashboardPageClubResponse',
      'ErrorResult',
    ],
    GetEqualOpportunitiesPolicyResponse: [
      'GetEqualOpportunitiesPolicyResult',
      'ErrorResult',
    ],
    GetExploreProgramsPageResult: ['ExploreProgramsPage', 'ErrorResult'],
    GetFrequentlyAskedQuestionsResponse: [
      'GetFrequentlyAskedQuestionsResult',
      'ErrorResult',
    ],
    GetHeaderResponse: ['GetHeaderResult', 'ErrorResult'],
    GetInstructorClubAffiliatesResponse: [
      'GetInstructorClubAffiliatesResult',
      'ErrorResult',
    ],
    GetNavigationResponse: ['Navigation', 'ErrorResult'],
    GetNotificationResponse: ['Notification', 'ErrorResult'],
    GetNotificationsResponse: ['GetNotificationsResult', 'ErrorResult'],
    GetPickListResponse: ['GetPickListResult', 'ErrorResult'],
    GetPresignedUrlResponse: ['GetPresignedUrlResult', 'ErrorResult'],
    GetPrivacySettingValuesResponse: [
      'GetPrivacySettingValuesResult',
      'ErrorResult',
    ],
    GetProfileByIdResponse: ['GetProfileByIdResult', 'ErrorResult'],
    GetSavedInstructorSearchDataResponse: [
      'GetSavedInstructorSearchDataResult',
      'ErrorResult',
    ],
    GetSharedNavigation: ['SharedNavigation', 'ErrorResult'],
    GetUserEnquiriesResponse: ['GetUserEnquiriesResult', 'ErrorResult'],
    GetUserResponse: ['UserResult', 'ErrorResult'],
    GetUserSessionResponse: ['GetUserSessionResult', 'ErrorResult'],
    GetVideoGuidelinesResponse: ['GetVideoGuidelinesResult', 'ErrorResult'],
    GetWalkthroughResponse: ['Walkthrough', 'ErrorResult'],
    IncrementViewClubListingCountResponse: ['ClubListingResult', 'ErrorResult'],
    InitializeUploadResponse: ['InitializeUploadResult', 'ErrorResult'],
    PartnershipContent: [
      'ClubPartnershipProgramStats',
      'ClubPartnershipStandardContent',
      'ClubPartnershipBusinessSupportContent',
    ],
    PayForCertificationResponse: ['PayForCertificationResult', 'ErrorResult'],
    ProgramInterface: ['ClubProgram', 'Program'],
    RemoveFromShortlistResponse: ['RemoveFromShortlistResult', 'ErrorResult'],
    ReportClubListingResponse: [
      'ClubSingleListing',
      'ClubMultiListing',
      'ErrorResult',
    ],
    ReportClubProfileResponse: ['ClubProfile', 'ErrorResult'],
    RequestForExtensionResponse: ['RequestForExtensionResult', 'ErrorResult'],
    ResendPasswordResetEmailResponse: [
      'ResendPasswordResetEmailResult',
      'ErrorResult',
    ],
    SearchClubListingsResponse: ['SearchClubListingsResult', 'ErrorResult'],
    SearchClubListingsResultCommon: [
      'EnquiryClubListingSingleResult',
      'SearchClubJobListingsSingleResult',
      'SearchClubProfileSingleResult',
    ],
    SearchClubListingsSingleResult: [
      'SearchClubJobListingsSingleResult',
      'SearchClubProfileSingleResult',
    ],
    SearchClubsResponse: ['SearchClubsResult', 'ErrorResult'],
    SearchEventsResponse: ['EventsResult', 'ErrorResult'],
    SearchInstructorsResponse: ['SearchInstructorsResult', 'ErrorResult'],
    SeedRandomAccountsResponse: ['SeedRandomAccountsResult', 'ErrorResult'],
    SendMessageResponse: ['SendMessageResult', 'ErrorResult'],
    SetClubSettingsResponse: ['SetClubSettingsResult', 'ErrorResult'],
    SetInstructorAvailabilityResponse: [
      'InstructorAvailability',
      'ErrorResult',
    ],
    SetInstructorTravelPreferencesResponse: [
      'InstructorPreferences',
      'ErrorResult',
    ],
    SetInstructorWatchlistResponse: ['InstructorWatchlist', 'ErrorResult'],
    SetPrivacySettingsResponse: ['SetPrivacySettingsResult', 'ErrorResult'],
    SetSavedClubSearchDataResponse: [
      'SetSavedClubSearchDataResult',
      'ErrorResult',
    ],
    SetSavedInstructorSearchDataResponse: [
      'SetSavedInstructorSearchDataResult',
      'ErrorResult',
    ],
    SetWalkthroughToSeenResponse: ['SetWalkthroughToSeenResult', 'ErrorResult'],
    Step: [
      'AttendTrainingStep',
      'PreworkStep',
      'ReceivedCertificationOutcomeStep',
      'ReceivedTrainingOutcomeStep',
      'SubmitCertificationVideoStep',
      'SubmitOutcomeTrackStep',
      'TrainingBookedStep',
    ],
    TestPostUpsertClubResponse: ['TestPostUpsertClubResult', 'ErrorResult'],
    TestPostUpsertUserResponse: ['TestPostUpsertUserResult', 'ErrorResult'],
    ToggleNotificationReadResponse: [
      'ToggleNotificationReadResult',
      'ErrorResult',
    ],
    TrainerBookingResponse: ['TrainerBookingResult', 'ErrorResult'],
    TrainerBookingsResponse: ['TrainerBookingsResult', 'ErrorResult'],
    TrainingJourneyResponse: ['TrainingJourneyResult', 'ErrorResult'],
    TrainingJourneysResponse: ['TrainingJourneysResult', 'ErrorResult'],
    TrainingStep: [
      'TrainingBookedStep',
      'PreworkStep',
      'AttendTrainingStep',
      'SubmitOutcomeTrackStep',
      'ReceivedTrainingOutcomeStep',
      'SubmitCertificationVideoStep',
      'ReceivedCertificationOutcomeStep',
      'CertifiedStep',
      'ContactUsStep',
    ],
    UpdateAccountSettingsResponse: ['UserAccountSettingsResult', 'ErrorResult'],
    UpdateClubListingResponse: ['ClubListingResult', 'ErrorResult'],
    UpdateClubProfileResponse: ['UserResult', 'ErrorResult'],
    UpdateCurrentUserPortfolioUploadResponse: [
      'UpdateCurrentUserPortfolioUploadResult',
      'ErrorResult',
    ],
    UpdateProfileResponse: ['UserResult', 'ErrorResult'],
    UpdateTeachingProfileResponse: ['UserResult', 'ErrorResult'],
    UpdateUserPhotoResponse: ['UpdateUserPhotoResult', 'ErrorResult'],
    UpsertAgreementResponse: ['UpsertAgreementResult', 'ErrorResult'],
    UpsertClubResponse: ['UpsertClubResult', 'ErrorResult'],
    UpsertPricebookResponse: ['UpsertPricebookResult', 'ErrorResult'],
    UpsertUserResponse: ['UpsertUserResult', 'ErrorResult'],
    UserProfile: ['UserProfileTeaching', 'UserProfileClub'],
  },
}
export default result
